import { clone, res, state, ui, prefs, live } from './stores.js';
import { get } from 'svelte/store';
import { displayMemo, isDisplaying } from './displaymemo.js';
import { doAction, getMarketCards, getCard, logText, moveTo, allCards, getPlayerIndex, checkForReactions, getNeutralZone, shuffle, getDeckForCard, getDeck, badlands, freeOrderActions, genCard, updateState, isBadlands, getP } from './game.js';
import { choose, info, waitMillis, cc, cn, chooseCards, changeView, skipIfCan, withTurnHeld, clearSelection, cancel, pause, pushChoice, choicesToLoad, backupChoice, restoreChoice, currentPlayer, activePlayer } from './ui.js';
import { canActivate, inHand, canPlay, getLocation, matches, allActions, inPlay, typeOfGain, canBeamTo, cardsInPlay, cardMessage, myOrbiting, isInPlay, duty, canJunk, myAway, theirAway, canControlLocation, canGainControl, hasNeutralJunkAccess, reshuffleDeck, hasDrones, checkFromJunk, beamedHost, possArray, faceupDraw, inPlayLocations, numExpendableDrones, scalarIfOne, tableEffectsActive, trackTypes, allAway, drones, allResourceTypes, allTokenTypes, setHidden, allDrones, oneOffMessage, countShips, removableAway, atPool, hasMurf, isInPlayMarketNZ } from './card_actions.js';
import { manualCards, manualGoals, committed } from './manual.js';
import { pegParse, parseChunks } from './pegparse.js';
import { synonyms, verbMatches } from './bind_prev.js'; // shared with the compile-time binder
import { pushFrame, popFrame, unitOfEffects, unitNeedingFrame, setLoopObj, recordSlot, resolveFrameBinding, resolveFrameCount, currentFrames } from './frames.js';
import { namedTraits, pickWCCandidates } from './wildcard.js';
import { changePlayer, isMe, handover, offerEffect } from './net.js';
import { allBeamed, allScoreableCards } from './scores.js';
import { canPay } from './costs.js';
import { countableTraits, isUtilityTrait } from './newcards/types.js';
import { botValue, bestAwayDestinations, bestShipDestinations, botFavouriteCards, countAllTokens, countPlayerTokens, countSpecificTokens, allLocationTokenTypes, namesBadlands } from './bot.js';
import * as Comlink from 'comlink';
import { collectableTraits } from './khan.js';
import { tick } from 'svelte';
import { perfCount, perfMeasure, perfSampleMeasure } from './perf.js';
import { canBurn } from './turns.js';


export function parseCardsOld(cards){
    //w.postMessage('test');
    pegged = [];
    for(let c of cards){
        parseCardText(c);
    }

    let success = pegged.filter(p => p.response != 'error');
    let failed = pegged.filter(p => p.response == 'error')
}

let pegged = [];

export function sanitize(s){
    // '#newline' is a display-only line break (see ui.js); it isn't grammar
    s = s.replaceAll(/\s*#newline\s*/g, ' ');
    // Live Culluh Ship row has a source preposition typo.
    s = s.replaceAll('[[ally]] form the Bot Discard pile', '[[ally]] from the Bot Discard pile');
    // Card 4: express the two dismissals as one coordinated cost.
    s = s.replaceAll('you may dismiss this card to dismiss an opponent [[borg]]/[[xb]] to gain 1 [[glory]]',
        'you may dismiss this card and dismiss an opponent [[borg]]/[[xb]] to gain 1 [[glory]]');
    //s = s.replaceAll('[[action]] Activation:', 'Activation: Spend an [[action]].');
   // s = s.replaceAll(`@you take an [[incident]]/@ and take an [[incident]]`, `@you take an [[incident]]/@ and bot takes an [[incident]]`)
    
   // Q bot fixes
   s = s.replaceAll(`it warps`, `warp it`);

   s = s.replaceAll(`Flip your [[captain]] and teleport him.`, `Flip your [[captain]] and teleport your [[captain]].`)

   s = s.replaceAll(`including the Junk`, `including from Junk`)
   // Parasitic lifeforms
   s = s.replaceAll(`You are forced to either:`, `You must choose:`);
    // BQ bot
    s = s.replaceAll(`if able and [[sync]] is 2+`, `if [[sync]] is 2+, if able`)
    s = s.replaceAll(`If Bot is [[`, `If Bot [[captain]] is [[`)

    // Dukat bot
    s = s.replaceAll(`and then continue resolution`, `and continue resolution`)
    //s = s.replaceAll(`If 6+ [[dilithium]],`, 'If Bot has 6+ [[dilithium]],')

    // Eddington cycle rule
    s = s.replaceAll(`If no cards are shuffled into your deck from your Discard pile when cycling it`, `If your Discard pile is empty when you cycle your deck`)

    // Eddington mission
    s = s.replaceAll(`Have a [[person]] each at 3 different controlled [[location]]`, `Have 3 controlled [[location]], each with a [[person]] present`)
    // BQ surprise
    
    s = s.replaceAll(`from opponent or neutral /@[[location]]`, `from opponent [[location]] or neutral /@[[location]]`);
    s = s.replaceAll('@from neutral or Bot controlled/@ ', '@from neutral [[location]] or Bot controlled/@ ');
    s = s.replaceAll(`is at your controlled [[location]]`, `is at a your controlled [[location]]`)

    // Borg Probe – otherwise it just won't work
    s = s.replaceAll(`gain a [[person]] and log the gained card. If your [[captain]] is [[borg]], assimilate it instead.`, `gain a [[person]] and log the gained card. If your [[captain]] is [[borg]], gain a [[person]] and assimilate it instead.`)

    // Other box 3
    s = s.replaceAll(`You take a card of the same suit, from the top of the corresponding Market deck.`, `You take a card of the same suit from the top of the corresponding Market deck.`)
    s = s.replaceAll(`Log a controlled [[location]] to deploy this [[ship]]`, `Log a controlled [[location]] to deploy this ship`)

    // Duty & Honor
    s = s.replaceAll(`When you would enlist a Development while your Reserve deck is not empty`, `When you would enlist a Development, if your Reserve deck is not empty`)
    s = s.replaceAll(`If you have 2+ [[away team]] at the *Badlands* and/or here`, `If you have a total of 2+ [[away team]] at the *Badlands* and here`)
    s = s.replaceAll(`If the Bot now has`, `If the Bot has`)
    // Bot row: secured-location condition folds into an if-able take-control cost
    s = s.replaceAll(`and has secured a neutral [[location]], take control of it,`, `and if able, take control of a secured [[location]],`)
    s = s.replaceAll(`If you warped to`, `If it is at`)
    s = s.replaceAll(`If the card is found in your Reserve deck, take an [[incident]]. If the discarded card was [[cargo]]/[[business]] you may free play *SS Xhosa*.`, `If the card was found in your Reserve deck, take an [[incident]]. If the discarded card is [[cargo]]/[[business]] you may free play *SS Xhosa*.`)
    s = s.replaceAll(`per every`, 'for each');
    s = s.replaceAll(`free play it. If you do, look at 2 additional [[encounter]] before choosing one to take.`, `free play it, looking at 2 additional [[encounter]] before choosing one to take.`)
    s = s.replaceAll(`Rafaella of House Musiker`, `Raffaela of House Musiker`);
    s = s.replaceAll(`Have 4 total deployed [[ship]] 1 or more neutral [[location]]`, `Have 4 total deployed [[ship]] at 1 or more neutral [[location]]`)
    s = s.replaceAll(`shuffle the Bot Discard pile and this card into the Bot deck`, `discard this card and shuffle the Bot Discard pile into the Bot deck`);
    s = s.replaceAll(`When you would enlist a Development while your Reserve`, `When you would enlist a Development, if your Reserve`)
    s = s.replaceAll(`*Requires your Reserve deck to be empty.*`, `Requires that your Reserve deck is empty.`);
    s = s.replaceAll(`whenever an operation gains you [[influence]]`, `whenever you gain [[influence]]`);
    s = s.replaceAll(`whenever an operation gains you [[military]]`, `whenever you gain [[military]]`);
    s = s.replaceAll(`This operation applies to the bot as well`,`This operation applies to the Bot as well`);

    s = s.replaceAll(/\/@\[\[([A-Za-z 0-9\-]+)\]\]@/g, `[[$1]]`)
    s = s.replaceAll(/\/@\[\[([A-Za-z 0-9\-]+)\]\]/g, `[[$1]]`)
    s = s.replaceAll(`/$`,'');
    s = s.replaceAll('^', ''); // No need to keep the emphasis marker
    //s = s.replaceAll(`^`, '');
    //s = s.replaceAll(`/@`,'');
    s = s.replaceAll(`$`,'');
    s = s.replaceAll(`, /@`, `/@, `)
    s = s.replaceAll(`./@`, `/@. `)
    s = s.replaceAll(`. /@`, `/@. `)
    s = s.replaceAll('. .', '.')
    s = s.replaceAll(' (deployed and/or beamed) ', ' ')
    s = s.replaceAll(`. If discarding an [[infiltration]], you may ignore the sabotage operation`, ', optionally ignoring any Sabotage operation on it')
    s = s.replaceAll(`Skill icon and trait`, 'trait and Skill icon');
    s = s.replaceAll(`Dismiss this card at the end of your Control Step`, `At the end of your Control Step, dismiss this card`)
    //s = s.replaceAll('Devlopment', 'Development')
    //s = s.replaceAll(`of  [[cargo]] or of [[ally]]`, `of [[cargo]]/[[ally]]`);
    //s = s.replaceAll(`If this ship is dismissed in either player's Control Step`,`When this ship is dismissed in either player's Control Step`)

   // s = s.replaceAll(`a [[cargo]] and a [[starfleet]] (one or two cards)`, `a [[cargo]] and a [[starfleet]] (one or two cards) `)
    //s = s.replaceAll('(if able) put that card', 'put that ');

    // Boldly Go temporary:
    s = s.replaceAll(`Find a [[person]], excluding your Reserve`, `Find a [[person]], except in your Reserve deck`);

    // TosKirk temporary:
    s = s.replaceAll(`Beam a beamed card to another card to gain 2 [[dilithium]]. The target must be a deployed [[ship]], or a [[location]] with 1+ beamed cards.`, `Beam a beamed card to a deployed [[ship]] or a [[location]] with 1+ beamed cards to gain 2 [[dilithium]].`);
    s = s.replaceAll(`for each [[res-skill]]/[[wild-skill]] your cards have`, `for each [[res-skill]]/[[wild-skill]] you have`);

    // Cullah:
    s = s.replaceAll(`After resolving its control operation, `, '') // it's a noop basically

    // RIF commons temporary:
    s = s.replaceAll(`If your [[captain]] has [[Borg]] this card scores [[0vp]] during scoring instead.`, `During scoring, if your [[captain]] has [[borg]] this card scores [[0vp]] instead.`)
    s = s.replaceAll(`return the other to the bottom of the deck`, `return the other to the bottom of its deck`); // so BQ Resistance is Futile works correctly

    // BQ temporary until I work out how to handle respectively:
    s = s.replaceAll(`Expend 3 or 5 [[drone]] to gain 1 or 2 [[action]] (respectively).`, `Expend 3/5 [[drone]] to gain 1/2 [[action]] (respectively).`)
    s = s.replaceAll(`top 2 [[mission]] from`, `top 2 [[mission]] of`)
    s = s.replaceAll(`you have an [[away team]] on.`, `with 1+ [[away team]].`)
    

    // Archer temporary awaiting text fix:
    s = s.replaceAll(`you and your opponent both take an [[incident]] (this is not an ATTACK )`, `you and your opponent take an [[incident]]. This is not an ATTACK.`)

    // other Q
    s = s.replaceAll(`When a [[qsuit]], except your [[captain]], is dismissed`, `When a [[qsuit]] excluding your [[captain]] is dismissed`)
    // 'them' is the dismissed [[qsuit]]: as a bare plural it picked up everything else dismissed in the same Control step (e.g. ships)
    s = s.replaceAll(`is dismissed during your Control step, log them.`, `would be dismissed during your Control step, log it instead.`)
    s = s.replaceAll(`When you duplicate an operation in your Log`, `When you duplicate an operation of a card in your Log`)
    s = s.replaceAll(`If your [[captain]] is ^not^ a [[qsuit]] and this card is in your hand at the beginning of your turn`, `At the beginning of your turn, if your [[captain]] is ^not^ a [[qsuit]] and this card is in your hand`);
    s = s.replaceAll(`draw up to your hand size`, `draw back up to your hand size`)
    // Q temporary awaiting text fix:
    s = s.replaceAll(`Score [[2vp]] (max 10) for each of your non-logged [[person]] cards, excluding [[human]]/[[transcendent]]`, `Score [[2vp]] for each of your non-logged [[person]] cards, excluding [[human]]/[[transcendent]] (max [[10vp]])`)
    s = s.replaceAll(`Dismiss any cards beamed here`, `Dismiss all cards beamed here`)
    s = s.replaceAll(`Gain all resource tokens`, 'Gain all resources')
    s = s.replaceAll(`If this card would be dismissed for any reason, trigger the resupply operation instead`, `When this card would be dismissed for any reason, trigger its Resupply operation instead`)
    s = s.replaceAll(`When you accept this,`, `When you accept this [[mission]],`);
    //s = s.replaceAll(`excluding your staging area`, `excluding cards in your staging area`),
    //s = s.replaceAll(`visiting cards, excluding your play area`, `visiting neutral or opponent cards`)

    //General
    s = s.replaceAll(`up to each of`, `any number of`);
    s = s.replaceAll('[[cards]]', 'cards');
    s = s.replaceAll('(No [[glory]] compensation is given for removed tokens.)', '');
    s = s.replaceAll(`After resolving its play operation, p`, 'P')
    s = s.replaceAll(`either *Neelix* or a [[doctor]]`, `either a [[doctor]] or *Neelix*`)
    s = s.replaceAll(`(Name the species before starting the scan.)`, '')
    s = s.replaceAll(`Name the trait before starting the scan.)`, '')
    s = s.replaceAll(`(Name the species before scanning.)`, '')
    s = s.replaceAll(`you may draw a card from your Draw deck and/or a card from your Discard pile`, `you may draw a card from your Draw deck and you may draw a card from your Discard pile`);
    s = s.replaceAll(`This card has 1 [[wild-skill]] (max 3) for each [[away team]] here`, `This card has 1 [[wild-skill]] for each [[away team]] here (max 3)`)
    s = s.replaceAll(`While this mission is active, `, '')
    s = s.replaceAll(`For each [[ship]] your opponent has in play, draw and reveal a card`, `Draw and reveal a card for each [[ship]] your opponent has in play.`)
    s = s.replaceAll(`Requires your Reserve deck to be`, `Requires that your Reserve deck is`)
    s = s.replaceAll(`Gain an [[anomaly]] including from the Junk. If you have 3 [[scientist]] in play you may scan for it instead.`, `If you have 3 [[scientist]] in play, gain an [[anomaly]] including from the Junk OR scan for [[anomaly]]. Otherwise gain an [[anomaly]] including from the Junk.`)
    s = s.replaceAll(`You may enlist a Development. If you do, draw 2 cards. If you don't, warp *U.S.S. Voyager* and gain 1 [[research]]/[[influence]]/[[military]]`, `Choose: enlist a Development and draw 2 cards OR warp *U.S.S. Voyager* and gain 1 [[research]]/[[influence]]/[[military]]`)
    s = s.replaceAll(`duplicate a different Resupply operation you have in play`, `duplicate a Resupply operation of a different card you have in play`)
    s = s.replaceAll('send it to a neutral [[location]]', 'send an [[away team]] to a neutral [[location]]');
    s = s.replaceAll('all of your [[person]] cards with [[doctor]] are additionally treated', 'all of your [[person]]  with [[doctor]] are additionally treated'); // Until 'cards' disappears from Protocol 12
    s = s.replaceAll('Each of your [[mil-skill]] are treated as [[res-skill]] instead.', 'All of your [[mil-skill]] are treated as [[res-skill]] instead.')
    s = s.replaceAll('If you have more [[res-skill]] in play than [[mil-skill]]', 'If you have more [[res-skill]] than [[mil-skill]] in play')
    s = s.replaceAll('add an [[away team]] token from the supply to the Bot [[captain]] card (max 6 [[away team]] total)', 'if bot [[away team]] < 6, add an [[away team]] token from the supply to the Bot [[captain]] card')
    s = s.replaceAll('add an [[away team]] token from the supply to the Bot [[captain]] card (max. 6 [[away team]] total)', 'if bot [[away team]] < 6, add an [[away team]] token from the supply to the Bot [[captain]] card')
    s = s.replaceAll('(an additional) ', '');
    s = s.replaceAll('If Duty Officer is not [[vulcan]], log Duty Officer.', 'If Duty Officer is not [[vulcan]] then log Duty Officer.')
    //s = s.replaceAll(`@`,'');
   /* for(let show of ['TNG (movie)', 'TOS (movie)', 'ENT','TNG','LDS','DS9','DIS','TOS','VOY','PIC','SNW','PRO']){
        s = s.replaceAll(`Development cost: ${show}`, '');
    }*/
    s = s.replaceAll('Reaction: When you would discard a card during your Action Step, beam the discarded card here instead.', 'Reaction: When you would discard a card during your Action Step, beam it here instead.')
    s = s.replaceAll('all your remaining', 'all your')
    s = s.replaceAll('After dismissing a [[ship]], discard a [[directive]] to draw it', 'After dismissing a [[ship]], discard a [[directive]] to draw the [[ship]]');
    s = s.replaceAll('/@[[ship]]@, if able./@', '[[ship]], if able/@.')
    s = s.replaceAll('to the same neutral [[location]] where either of you', 'to a neutral [[location]] where either of you')
    s = s.replaceAll("(of any suit) ", '');
    s = s.replaceAll(`send the same number of [[away team]] to the same [[location]]`, `send the same number of [[away team]] to a [[location]]`)
    s = s.replaceAll('You must choose:', 'You');
    s = s.replaceAll('Requires you to', 'Requires that you');
    s = s.replaceAll('you may draw a card from your Draw deck and/or your Discard pile', 'you may draw a card from your Draw deck and you may draw a card from your Discard pile')
    s = s.replaceAll(`[[ally].`, `[[ally]].`)
    s = s.replaceAll(`deploy it and it engages`,'deploy it and engage');
    s = s.replaceAll(`deploy it and it explore`,'deploy it and explore');
    s = s.replaceAll(`resolving either activation operation of`, `you activate`)
    s = s.replaceAll(`Play: You and your opponent may return an [[incident]] from their (respective) hand or Discard pile. If you both do, draw 2 cards.`, `Play: Both players may return an [[incident]] from their hand or Discard pile. If both do, draw 2 cards.`)
    s = s.replaceAll('(respective) ', '');
    s = s.replaceAll(`After you log an [[attack]] or a card with [[mil-skill]]/[[mil-focus]]`, `After you log an [[attack]]/[[mil-skill]]/[[mil-focus]]`)
    s = s.replaceAll(`Enlist your entire Reserve deck`, `Enlist all your Reserves`)
    s = s.replaceAll(`. Put them on the top`, ' and put them on the top')
    s = s.replaceAll(`[[mil-skill] `, `[[mil-skill]] `)
    //s = s.replaceAll(`force them to either:`, `they must either`); // Is this right??
    //s = s.replaceAll(`force them to either`, `they must either`); // Is this right??
    s = s.replaceAll(`(from your hand) into your opponent's log`, `into your opponent's log`)
    s = s.replaceAll(`Enlist a Reserve or a Development`, `Enlist a Reserve or enlist a Development`)
    s = s.replaceAll(`enlist a Reserve or a Development`, `enlist a Reserve or enlist a Development`)
    s = s.replaceAll(`warp all your deployed ships`, `warp all your deployed [[ship]]s`)
    s = s.replaceAll(`[[hologram]] on`, `[[hologram]] beamed to`);
    s = s.replaceAll(`When one of your [[ship]] is dismissed`, `After one of your [[ship]] is dismissed`)
    s = s.replaceAll(`When the *La Sirena* is dismissed, take an [[incident]] to draw it.`,`After the *La Sirena* is dismissed, take an [[incident]] to draw *La Sirena*.`)
    s = s.replaceAll(`[[action]] Play: Gain 1 [[influence]] OR gain 1 [[military]]. You may discard an [[incident]] to do both instead.`, `[[action]] Play: Gain 1 [[influence]] OR gain 1 [[military]] OR discard an [[incident]] to do both.`)
    s = s.replaceAll(`Force your opponent to find and log a card`, `Force your opponent to find a card and force your opponent to log the found card`);
    s = s.replaceAll(`Take an [[incident]]. Own *Captain Terrell* or *Pavel Chekov*.`, `Take an [[incident]], own *Captain Terrell* or *Pavel Chekov*.`)
    s = s.replaceAll(`[[location]] from the Neutral Zone`, `neutral [[location]]`)
    s = s.replaceAll(`dismiss a card beamed to *Devastated Ceti Alpha V* Reaction`, `dismiss a card beamed to *Devastated Ceti Alpha V*. Reaction`)
    s = s.replaceAll(`your opponent takes (excluding being given) an [[incident]]`, `your opponent takes an [[incident]]`);
    s = s.replaceAll(`ignoring opponent [[ship]]s. The [[ship]]`, `ignoring opponent [[ship]]s, then the [[ship]]`, )
    s = s.replaceAll(`Gain 1 [[research]]/[[influence]]/[[military]] (whichever is lower) twice`, `Bot gains 1 [[research]]/[[influence]]/[[military]] (whichever is lower). Bot gains 1 [[research]]/[[influence]]/[[military]] (whichever is lower)`)
    s = s.replaceAll(`[[any species]] (excluding cards with [[borg]])`, `non-[[borg]] [[any species]]`)
    s = s.replaceAll(`of an assimilated [[person]] or [[ally]]`, `of a [[person]] or [[ally]] you have assimilated`)
    s = s.replaceAll(`] with [`, `] that has [`)
    s = s.replaceAll(`Both you and your opponent`, 'You and your opponent')
    s = s.replaceAll(`Have 3 [[different species]] on the same [[ship]], exclude cards with [[starfleet]]`, `Have 3 [[different species]] (excluding cards with [[starfleet]]) on the same [[ship]]`)
    //s = s.replaceAll(`beamed card with [[any species]] and without [[borg]]`, `non-[[borg]] card that is [[any species]] beamed to any card`)
    //s = s.replaceAll(`[[location]]s`, `[[locations]]`)
    //s = s.replaceAll(`crank`, 'exhaust');
    //s = s.replaceAll(`Scan either for`, 'Scan for either')
    //s = s.replaceAll(`scan either for`, 'scan for either')
    s = s.replaceAll(`neutral [[location]], that has`, `neutral [[location]] that has`);
    s = s.replaceAll(`Each [[alien]] and each [[transcendent]] counts as a different one`, `Each [[alien]]/[[transcendent]] counts as a different one`);
    s = s.replaceAll(`excluding your [[captain]]`, `excluding [[captain]]`)
    s = s.replaceAll('they must dismiss one, or they take', 'they must dismiss one of them. Otherwise they take')
    s = s.replaceAll(`When your Duty Officer would be dismissed by an attack, dismiss a card beamed here instead to ignore the negative effect`, `When an attack would dismiss your Duty Officer, dismiss a card beamed here instead to ignore the effect`)
    s = s.replaceAll(`[[ship]] (excluding ones with [[cloak]])`, `[[ship]] without [[cloak]]`)
    s = s.replaceAll('a [[kelpien]] on the same [[ship]], and [[research]] at 5+ ', 'a [[kelpien]] on the same [[ship]], and [[research]] at 5+. ')
    s = s.replaceAll(`OR remove up to 2 opponent [[away team]] from a [[location]]. Gain 1 [[glory]] for each`,`OR remove up to 2 opponent [[away team]] from a [[location]] and gain 1 [[glory]] for each`)
    s = s.replaceAll('After gaining an [[ally]], you may discard a card. If you do, gain 1 [[glory]]', 'After gaining an [[ally]], you may discard a card, if you do, gain 1 [[glory]]')
    s = s.replaceAll('have a [[weapon]] in your hand and a [[weapon]] in play', 'have a [[weapon]] in your hand and you have a [[weapon]] in play')
    s = s.replaceAll(/add (an|\d+) (Away Teams?) at/ig, 'send $1 $2 to');
    s = s.replaceAll(/take (\d+) \[\[glory\]\]/ig, 'gain $1 [[glory]]');
    s = s.replaceAll(/of the \[\[encounter\]\]\./ig, 'of the [[encounter]] deck.');
    s = s.replaceAll(/the action area/ig, 'your action area');
    s = s.replaceAll(/theses /ig, "these ");
    s = s.replaceAll(/#VALUE!/ig, '');
    s = s.replaceAll(/for each non-\*Redshirt\* \[\[person\]\] here/ig, 'for each non-*Redshirt* [[person]] beamed here');
    s = s.replaceAll('Develop. You may ignore 1 [[dilithium]]/[[latinum]] cost for each [[starbase]] you have in play', 'Develop, reducing the cost by 1 [[dilithium]] or 1 [[latinum]] for each [[starbase]] you have in play')
    s = s.replace("You may discard a card to free play the same card", "You may discard a card to free play the found card");
    s = s.replace("If you do, draw a card, and for every 4th card in your captain's log (round down) gain 1 [[military]]/[[influence]]/[[research]].", "If you do, draw a card, and gain 1 [[military]]/[[influence]]/[[research]] for every 4 cards in your captain's log (rounded down).");
    if(s.includes("for every card in your captain's log gain 1 [[dilithium]]")){
        console.log('found!', s, s.replace("for every card in your captain's log gain 1 [[dilithium]]", "you gain 1 [[dilithium]] for every card in your captain's log"));
    }
    s = s.replace("to one of your [[ship]]'s [[location]]", "to a [[location]] where you have a [[ship]]")
    s = s.replace("for every card in your captain's log gain 1 [[dilithium]]", "you gain 1 [[dilithium]] for every card in your captain's log");
    s = s.replace('Away Teams to to ', 'Away Teams to ');
    s = s.replace('If they do so', 'If they do');
    s = s.replace('When an effect would allow you to return', 'When you would return');
    s = s.replace('Gain 1 [[dilithium]], and 2 [[dilithium]] for each','Gain 1 [[dilithium]]. Gain 2 [[dilithium]] for each');
    s = s.replace("Goal: Have 2 [[encounter]] here, and [[research]] at 4+ ", "Goal: Have 2 [[encounter]] here, and [[research]] at 4+. ");
    s = s.replace(', otherwise', '. Otherwise')
    s = s.replace('You may place an [[away team]] on a [[location]]', 'You may send an [[away team]] to a [[location]]')
    //s = s.replace('Discard the top card of your reserve deck', 'Gain the top card of your reserve deck');
    s = s.replace('{Engineering team} Reaction: After playing or beaming an [[engineer]], free play an [[incident]] to gain 2 [[dilithium]]', '{Engineering team} Reaction: After playing or beaming an [[engineer]], free play an [[incident]] to gain 2 [[dilithium]].')
    s = s.replace('put this card and on the bottom', 'put this card on the bottom');
    s = s.replace('Goal: Goal:', 'Goal:');
    s = s.replace('..', '.');
    s = s.replace('} Promote', '} Activation: Promote');
    s = s.replace('if able, dismiss a [[spy]]', 'dismiss a [[spy]], if able');
    s = s.replace(`After drawing cards due to *Rebner*'s operations, draw 2 cards. If`, `After drawing cards due to *Rebner*'s operations, draw 2 cards, and if`)
    s = s.replace('Activation: After you play a [[cloak]] gain 1 [[latinum]]', 'Reaction: After you play a [[cloak]] gain 1 [[latinum]]')
    s = s.replace('Remove 2 [[away team]] from the same [[location]]', 'Remove 2 [[away team]] from one [[location]]');
    s = s.replace('draw a a card', 'draw a card');
    s = s.replace('Reveal your hand', 'your opponent looks at all cards in your hand');
    s = s.replace('reveal your hand', 'your opponent looks at all cards in your hand');
    s = s.replace('Force your opponent to reveal their hand', `you look at all cards in your opponent's hand`);
    s = s.replace('force your opponent to reveal their hand', `you look at all cards in your opponent's hand`);
    s = s.replace('to force your opponent to reveal their hand', `to look at all cards in your opponent's hand`);
    s = s.replace(`Your opponent must reveal two cards to you`, `Your opponent must select two cards. You look at them`);
    s = s.replace('{First Contact Specialist} Reaction: After gaining an [[ally]] (including via scan), discard a card to gain 1 [[glory]]. You may beam', '{First Contact Specialist} Reaction: After gaining an [[ally]] (including via scan), discard a card to gain 1 [[glory]], and you may beam')
    s = s.replace('{Gaining Sentience} Reaction: When playing a card with [[synthetic]] gain 1 [[glory]]. When playing a card with [[hologram]] draw a card. If a card has both, gain both rewards.', "{Gaining Sentience} Reaction: When playing a [[synthetic]] that has [[android]], gain 1 [[glory]] and draw a card. When playing a card with [[synthetic]] gain 1 [[glory]]. When playing a card with [[hologram]] draw a card.")
    s = s.replace('If the gained card has both traits, gain both rewards.', '');
    s = s.replace('After playing a [[scientist]] or promoting a [[scientist]] to Duty Officer', 'After playing or promoting a [[scientist]]')
    s = s.replace('If your [[influence]] is 7+', 'If you have 7+ [[influence]]');
    s = s.replace('to the [[location]] you warped to', 'to its new [[location]]')
    s = s.replace('Force your opponent to either', 'Your opponent is forced to either')
    s = s.replace('(including this card)', '');
    s = s.replace('including this card, ', '');
    s = s.replace('(the card remains exhausted) ', '');
    s = s.replace('You may refresh your [[captain]] and/or a Duty Officer', 'You may refresh your [[captain]] and a Duty Officer')
    //s = s.replace('from your hand or the top of your', 'from your hand or your')
    s = s.replace('draw the top 2 [[location]] to take control of one of them', 'draw the top 2 [[location]], take control of one of them')
    s = s.replace('place the gained card in your', 'put the gained card in your')
    s = s.replaceAll(/\*Requires\s+[^:.]+(:|\.)\*?/gi, (match, p1) => {
        match = match.replace(/^\*R/i, 'R');
        match = match.replaceAll('* :', ':');
        match = match.replaceAll(': *', ':');
        match = match.replaceAll('*:', ':');
        match = match.replaceAll(':*', ':');
        match = match.replaceAll('*[', '[');
        match = match.replaceAll(']*', ']');
        match = match.replaceAll('* [', '[');
        match = match.replaceAll('] *', ']');
        match = match.replaceAll('.*', '.');
        match = match.replaceAll('*.', '.');
        console.log('replaced requires', match);
        return match;
    });
    //s = s.replace('Control: no effect A', 'Control: no effect. A');
    if(s.trim().endsWith('shuffle the other card back')){
        s = s.trim() + '.';
    }
    if(s.trim().endsWith('no effect')){
        s = s.trim() + '.';
    }
    return s;
}

function parseCardText(card){
    let toParse = ['allText'];// ['playText', 'ongoingText', 'reward', 'goal'];
    let possChunks = get(res).possChunks

    let parsedEntry = {};

    for(let t of toParse){
        if(!card[t]) continue;
        //if(card.id.startsWith('Picard')) console.log(card);
        

        parsedEntry = {
            origText: card[t],
            ...pegParse(sanitize(card[t]).trim(), {inApp: true, botCard: card.botCard, stardate: card.stardate, card})
        }; // .toLowerCase()

        if(!parsedEntry.effects && parsedEntry.text){
            continue;
            let bits = parseChunks(parsedEntry.text.trim());
            if(!bits.effects){
                continue;
            }
            parsedEntry.effects = [];
            for(let t of bits.effects){
                if(t.text){
                    parsedEntry.effects.push(pegParse(t.text));
                }
            }
        }
        continue;
    }

    //if(card.goal) parsedEntry.goal = parseGoal(card.goal);
    res.update(r => {
        r.parsedCardText[card.id] = parsedEntry;
        return r;
    })
    /*if(Object.keys(parsedEntry).some(k => !Array.isArray(parsedEntry[k]) && parsedEntry[k].effect.includes('incomplete'))){
        // Only if there was some success
        //console.log("some!")
        res.update(r => {
            r.parsedCardText[card.id] = parsedEntry;
            return r;
        })
    }*/
}

export function upperInitial(s){
    if(!s) return ''
    return s[0].toUpperCase()+s.slice(1);
}

export function validEffect(c, e, p, backupType = false){
    //console.log('Validity check', e)
    //let action = e.action.toLowerCase();
    if(c.inactive) return false; // for rules of acquisition
    if(c.facedown) return false;

    let type = e.type || backupType;
    
    if(p.bot){
        if(type && type.toLowerCase() == 'special' && c.special_vp) return true;
        if(e.botToo) return true; // to handle 'This operation applies to the Bot as well' type things.
        return false;
    }

   /* if(type == 'action' || type == 'free action'){
        //console.log('play type')
        if(ongoingEffects(c, 'play_limit').some(l => l.type == 'unplayable')){
            cardMessage(c, `Cannot play card`);
            return false;
        }
        if(ongoingEffects(c, 'play_limit').some(l => l.type == 'needs_ownership')){
            if(!checkOwnership(p, c, ongoingEffects(c, 'play_limit').find(l => l.type == 'needs_ownership'))){
                cardMessage(c, `Cannot play card: play condition not met`);
                return false;
            }
        }    
    }*/
    
    if(!type || type.toLowerCase() == 'special') return true;
    if(type.toLowerCase() == 'accept' && !c.complete) return true;
    if(type.toLowerCase() == 'support'){
        if(p.decks.hand.some(cd => cd.uniqueID == c.uniqueID)) return true; // Only if in hand
        return false;
    }
    if(type.toLowerCase() == 'play_boost'){
        if(currentCard() == c.uniqueID) return true; // Valid for cards currently being played
    }
    if(type /*&& type.toLowerCase() == 'passive'*/){ // Not just passive, because anything is in the same boat except special
        // Only when properly in play
        // Dec 2025 hoping this manages for endgames too like BQ
        if(c && c.suits && c.suits.includes('mission') && c.rewarding) return false; // Complete missions now don't
        let info = get(state).cardLog[c.uniqueID];
        if(!info) return false; // Not in game at present
        if(info.area == 'commons' && info.deck == 'neutral_zone' && type == 'resupply' && !canGainControl(c)) return true;
        // !! Why does the below not refer back to tableEffectsActive or inPlay??
        if(info.deck == 'missions' || info.deck == 'passives' || info.deck == 'locations' || info.deck == 'fleet' || info.deck == 'duty' || info.deck == 'captain') return true;
        if(info.deck == 'play' && ['cleanup', 'resupply'].includes(type)) return true; // These trigger always
        // 'staging_duty': [[person]] in the Staging Area are treated as on duty
        if(info.deck == 'play' && matches(c, 'person') && hasStagingDuty(p)) return true;
        return false;
    }
}

export function expandSkills(p, skill){
    let conv = ongoingPlayer(p, 'skill_conversion') || [];
    let skills = [skill];
    for(let c of conv){
        if(c.from && c.from.startsWith(skill.slice(0, 3))) skills.push(c.to);
    }
    return Array.from(new Set(skills));
}

export function numConvertibleSkills(c, p){
    let conv = ongoingPlayer(p, 'skill_conversion') || [];
    let count = 0;
    if(!c.values) return 0;
    for(let v of conv){
        count += c.values.filter(val => val == v.from);
    }
    return count;
}

function checkCardCondition(p, card, condition){
    if(Array.isArray(condition)){
        // Currently only supports 'and' types, so needs all
        for(let c of condition){
            if(!checkCardCondition(p, card, c)) return false;
        }
        return true;
    }
    if(condition.place){
        return resolvePlace(p, condition.place, 'ongoing_check', false).some(cd => cd.uniqueID == card.uniqueID);
    /*}if(condition == 'in_staging'){
        return p.decks.play.some(c => c.uniqueID == card.uniqueID);*/
    }else if(condition == 'exhausted'){
        return card.activated;
    }else if(condition.loc_condition){
        let eligible = resolveLocCondition(card, condition.loc_condition.cond, p, []);
        let count = 0;
        for(let c of eligible){
            count += matches(c, condition.loc_condition.types);
        }
        if(testNum(condition.loc_condition.num, count)) return true;
    }else if(condition == 'smaller_hand_than_beamed_traits'){
        let beamed = card.beamed || [];
        let traitCount = beamed.reduce((a,c) => a + countableTraits(c.traits).length, 0);
        if(p.decks.hand.length < traitCount) return true;
    }
        /*else if(condition.duty){
        let count = 0;
        for(let d of p.decks.duty){
            count += matches(d, condition.duty.types);
        }
        if(testNum(condition.duty.num, count)) return true;
    }*/
    return false;
}


export function nonCardListPrep(verb){
    // Nov 2025: verbs that don't use to/from for card lists
    // so that these preps should be saved in interimPrev
    // ouch, this is really gross...!
    let verbs = ['warp', 'gain_tokens', 'move', 'away', 'send_murf', 'send_murf_at', 'remove_away', 'expend', 'teleport'];
    // What about dismiss? dismiss from a neutral location? Does that come up?
    return verbs.some(v => v.includes(verb));
}


export function ongoingEffects(c, type = 'ongoing', override = false){
    // Called ~450k times a game, so time one in every 1000 rather than all of them.
    return perfSampleMeasure('trawl.ongoingEffects', 1000, () => ongoingEffectsInner(c, type, override));
}

function ongoingEffectsInner(c, type = 'ongoing', override = false){
    if(!c) return [];
    let p = cardOwner(c);
    //if(p.bot) return []; // Bot ignores all such effects
    // svelte's get() is a subscribe/unsubscribe round trip, not a property read, and
    // this runs ~500k times a game. Read the store once; it can't change mid-function.
    let r = get(res);
    if(!r.cachedTrawls){
        res.update(r => {
            r.cachedTrawls = {};
            return r;
        })
        r = get(res);
    }
    let cached = r.cachedTrawls[c.id];
    if(cached) cached = cached[type];
    if(!cached){
        let possible = r.parsedCardText[c.id];
        if(!possible || !possible.effects){
            return [];
        }
        let lastType = false;
        cached = [];
        let somethingFound = false;
        for(let e of possible.effects){
            if(e.type) lastType = e.type;
            let ongoing = [...trawlFor(e, type)];
            let addToCache = {
                type: lastType,
                effect: e,
                ongoing
            };
            if(e.conditional_ongoings && e.conditional_ongoings.ongoings['_'+type]){
                //console.log('conditional ongoing', e)
                somethingFound = true;
                addToCache.conditional = {
                    condition: e.conditional_ongoings.condition,
                    ongoing: [...possArray(e.conditional_ongoings.ongoings['_'+type])]
                };
                
            }
            if(ongoing.length > 0) somethingFound = true;
            cached = [...cached, addToCache]; // so don't always add it

            //if((validEffect(c, e, p, lastType) || override) && meetsThreshold(p, e)) ongoing = [...ongoing, e];
        }
        if(!somethingFound) cached = -1; // set to zero
        
        res.update(r => {
            if(!r.cachedTrawls[c.id]) r.cachedTrawls[c.id] = {};
            r.cachedTrawls[c.id][type] = cached;
            return r;
        })
    }

    if(cached == -1) return []; // empty

    let ongoing = [];
    for(let item of cached){
        if((override || validEffect(c, item.effect, p, item.type)) && meetsThreshold(p, item.effect)){
            ongoing = [...ongoing, ...item.ongoing];
            if(item.conditional){
                //console.log('conditional ongoing', item)
                if(override || checkCardCondition(p, c, item.conditional.condition)) ongoing = [...ongoing, ...item.conditional.ongoing]
            }
        }
    }
    return ongoing;
    //let ongoing = trawlFor(possible.effects.filter(e => (validEffect(c, e, p) || override) &&  meetsThreshold(p, e)), type);
    //console.log('ongoing', ongoing, possible.effects);
    //return trawlFor(ongoing, type);
}

let inStagingDuty = false;

// Parsed effects as a string, cached per parsed card, for cheap "could this card
// ever give X?" checks before doing a full validity-checked trawl.
const effectsTextCache = new WeakMap();
export function effectsText(possible){
    if(!possible || !possible.effects) return '';
    let s = effectsTextCache.get(possible);
    if(s === undefined){
        let seen = new WeakSet();
        s = JSON.stringify(possible.effects, (k, v) => {
            if(v && typeof v == 'object'){
                if(seen.has(v)) return undefined;
                seen.add(v);
            }
            return v;
        }) || '';
        effectsTextCache.set(possible, s);
    }
    return s;
}

// Could any card in the game grant 'staging_duty'? Location-independent (every
// player card, dashboard card and beamed card), so it is a superset of what
// ongoingPlayer() can see for any player. Recomputed after any state/res change.
let stagingDutyGen = 0;
let stagingDutyCache = {gen: -1, value: true};
state.subscribe(() => stagingDutyGen++);
res.subscribe(() => stagingDutyGen++);
function gameMayHaveStagingDuty(){
    if(stagingDutyCache.gen === stagingDutyGen) return stagingDutyCache.value;
    let pt = get(res).parsedCardText;
    let s = get(state);
    let mentions = c => c && typeof c == 'object' && (effectsText(pt[c.id]).includes('staging_duty') || (c.beamed || []).some(mentions));
    let value = (s.players || []).some(pl =>
        Object.values(pl.decks || {}).some(d => Array.isArray(d) && d.some(mentions)) ||
        [...((pl.dashboard && pl.dashboard.missions) || []), ...possArray((pl.dashboard && pl.dashboard.passives) || [])].some(mentions)
    ) || ['neutral_zone', 'locations'].some(k => s.commons && Array.isArray(s.commons[k]) && s.commons[k].some(c => c && (c.beamed || []).some(mentions)));
    stagingDutyCache = {gen: stagingDutyGen, value};
    return value;
}

// 'staging_duty': [[person]] in the Staging Area count as on duty.
// Called from matches()/validEffect(), which ongoingEffects() itself calls, so
// guard against reentering.
// ponytail: reentrancy flag, not a real fixpoint – fine while no card's ongoing
// condition counts Duty Officers
export function hasStagingDuty(p){
    if(!p || inStagingDuty) return false;
    // Cheap pre-check: this runs for every validEffect() on a person in the Staging
    // Area (hundreds of thousands of times an action), and a full ongoingPlayer()
    // each time is what made Worf+Raffi take seconds per action.
    if(!gameMayHaveStagingDuty()) return false;
    inStagingDuty = true;
    try {
        return ongoingPlayer(p).includes('staging_duty');
    } finally {
        inStagingDuty = false;
    }
}

export function ongoingPlayer(p, type = 'ongoing', override = false){
    if(isDisplaying() && p && p.captain) return displayMemo(`ongoingPlayer|${p.captain}|${type}|${override}`, () => ongoingPlayerUnmemoised(p, type, override));
    return ongoingPlayerUnmemoised(p, type, override);
}

function ongoingPlayerUnmemoised(p, type, override){
    return perfSampleMeasure('trawl.ongoingPlayer', 100, () => ongoingPlayerInner(p, type, override));
}

function ongoingPlayerInner(p, type = 'ongoing', override = false){
    let effects = [];

    let possibleCards = [...allScoreableCards(p), ...p.decks.missions, ...p.dashboard.missions.filter(c => c.complete), ...(p.dashboard.passives || [])];
    //if(p.bot) possibleCards = possibleCards.filter(c => c.special_vp);
   
    //for(let c of cardsInPlay(p, false).filter(c => !p.decks.play.includes(c))){
    for(let c of possibleCards){//cardsInPlay(p, false).filter(c => !p.decks.play.includes(c))){
        effects = [...effects, ...ongoingEffects(c, type, override)];
    }
    if(effects.includes('copy_passive')){
        console.log('may copy passive')
        // Add those of other players' duty people
        for(let player of get(state).players.filter(pl => pl != p)){
            for(let c of player.decks.duty){
                effects = [...effects, ...ongoingEffects(c, type, override)];
            }
        }
    }
    return effects;
}

export function ongoingPlayerWithCards(p, type = 'ongoing', override = false){
    let effects = [];

    let possibleCards = [...allScoreableCards(p), ...p.decks.missions, ...p.dashboard.missions.filter(c => c.complete), ...(p.dashboard.passives || [])];
    //if(p.bot) possibleCards = possibleCards.filter(c => c.special_vp);
   
    //for(let c of cardsInPlay(p, false).filter(c => !p.decks.play.includes(c))){
    for(let c of possibleCards){//cardsInPlay(p, false).filter(c => !p.decks.play.includes(c))){
        let o = ongoingEffects(c, type, override);
        if(o.length == 0) continue;
        effects = [...effects, {
            card: c,
            effects: o
        }];
    }
    if(effects.some(e => e.effects.includes('copy_passive'))){
        console.log('may copy passive')
        // Add those of other players' duty people
        for(let player of get(state).players.filter(pl => pl != p)){
            for(let c of player.decks.duty){
                let o = ongoingEffects(c, type, override);
                if(o.length == 0) continue;
                effects = [...effects, {
                    card: c,
                    effects: o
                }];
            }
        }
    }
    return effects;
}

export function trawlFor(e, key, keepGoing = false, level = 0){
    // Keepgoing = keep looking once you've found one
    let ret = [];
    if(!e || typeof e == 'number' || typeof e == 'string' || typeof e == 'boolean' || typeof e == 'function') return [];
    if(Array.isArray(e)){
        let ret = [];
        for(let el of e){
            ret = [...ret, ...trawlFor(el, key, keepGoing, level+1)];
        }
        return ret;
    }else if(e.hasOwnProperty(key)){
        if(keepGoing){
            for(let k of Object.keys(e).filter(k => k != key)){
                ret = [...ret, ...trawlFor(e[k], key, keepGoing, level+1)];
            }
        }
        let add = e[key];
        if(!Array.isArray(add)) add = [add];
        
        ret = [...ret, ...add];
    }else if(typeof e == 'object'){
        for(let k of Object.keys(e)){
            ret = [...ret, ...trawlFor(e[k], key, keepGoing, level+1)];
        }
    }else{
        return [];
    }
    return ret;
}

export function meetsThreshold(p, e){
    let t = e.threshold;
    if(!t) return true;
    let thresholds = {
        res: 'research',
        mil: 'military',
        inf: 'influence',
        treachery: 'treachery',
        collective: 'collective'
    }
    //console.log(p, t)
    let type = thresholds[t.type];
    if(!type){
        alert('Unrecognised threshold type: '+t.type+'. Report this as a bug!');
        return true;
    }
    if(p[type] >= t.num) return true;
    // If it's not met, try other options
    // NB has to be like this because we can't use ongoingPlayer/ongoingEffects since
    // they call meetsThreshold!
    // Two full cardsInPlay scans, each re-trawling every card, per unmet threshold.
    // Counted because bots sit on low tracks, so this branch may run a lot.
    // Only cards that could carry one of the three relevant ongoings can make any of
    // the scans below pass, so skip the (uncached, validEffect-heavy) scans otherwise.
    let pt = get(res).parsedCardText;
    let inPlay = cardsInPlay(p, false, true).filter(c => /collective_threshold|no_restrictions|whim_threshold/.test(effectsText(pt[c.id])));
    if(inPlay.length == 0) return false;
    perfCount('threshold.unmetScan');
    if(inPlay.some(c => {
        let possible = get(res).parsedCardText[c.id];
        if(!possible || !possible.effects){
            return false;
        }
        let ongoing = trawlFor(possible.effects.filter(e => (validEffect(c, e, p))), 'ongoing');
        if(ongoing.includes('collective_threshold')) return true;
        return false;
    })){
        if(p.collective >= t.num * 2) return true;// !! TODO it's a hardcoded number, so if the base changes, then this needs to change too
    }else if(inPlay.some(c => {
        let possible = get(res).parsedCardText[c.id];
        if(!possible || !possible.effects){
            return false;
        }
        let ongoing = trawlFor(possible.effects.filter(e => (validEffect(c, e, p))), 'ongoing');
        if(ongoing.includes('no_restrictions')) return true;
        return false;
    })){
        return true;
    }else if(inPlay.some(c => {
        let possible = get(res).parsedCardText[c.id];
        if(!possible || !possible.effects){
            return false;
        }
        let ongoing = trawlFor(possible.effects.filter(e => (validEffect(c, e, p))), 'ongoing');
        if(ongoing.includes('whim_threshold')){
            let e = trawlFor(possible.effects.filter(e => (validEffect(c, e, p))), 'whim_threshold');
            //console.log('checking whim', e, p, t);
            if(e.some(n => (p.whim * n) >= t.num)){
                //console.log('whim met');
                return true; // if you're above the threshold
            }
        } 
    })){
        return true;
    }
    return false;
}

export function cannotDoOp(card, type, p){
    type = verbKeys[type];
    
    let poss = ongoingPlayer(p, 'no_owner_ops');
    for(let o of poss){
        if(matches(card, o.types) && o.ops.includes(type)) return true;
    }
    return false;
}

export function hintNames(card, type, name, action){
    //console.log(action)
    if(!action) return [];
    if(!Array.isArray(action)) action = [ action ];
    let ret = [];
    let p = get(state).players[get(state).activePlayer];
    for(let a of action){
        //console.log(a)
        if(!a.effect) continue;
        if(!meetsThreshold(p, a)) continue;
        if(a.captainRestriction && !p.decks.captain.some(c => matches(c, a.captainRestriction))) continue; // [[cpt-*]] only offered to matching captain
        if(ongoingPlayer(p).includes('no_attack') && a.attack) continue;
        if(cannotDoOp(card, type, p)) continue;
        ret.push({
            name: name,
            list: a.effect.map(e => hn(e)).join(', '),
            text: a.text,
            effects: a.effect,
            action: type,
            attack: a.attack,
            actionCost: a.actionCost,
            droneCost: a.droneCost
        });
    }
    ret.push(...addOpReplacement(p, card, name, type));
    return ret;
}

export function hn(e){
    if(Array.isArray(e)) return e.map(c => hn(c)).join(' and ');
    if(e.type == 'incomplete') return 'card actions';
    if(e.type == 'choice') return e.choices.map(c => hn(c)).join(' OR ');
    let name = e.name || e.verb || e.text;
    if(e.type == 'cost'){
        //console.log(e)
        name = `${hn(e.cost)} to ${hn(e.action)}`
    }else if(e.cost){
        name = `${e.cost.name} to ${name}`;
    }
    if(e.optional) name = `may ${name}`;
    return name;
}

function filterDuplicates(list, key = 'text'){
    let filtered = [];
    for(let e of list){
        if(!filtered.some(f => f[key] == e[key])) filtered.push(e);
    }
    return filtered;
}

export function getAllPlayEffects(card){
    let possible = get(res).parsedCardText[card.id];
    //console.log(possible);
    if(!possible || !possible.effects){
        //console.log('no parsed text');
        return [];
    }
    return filterDuplicates([...hintNames(card, 'play', 'Play', possible.effects.filter(p => p.name == 'action')), ...hintNames(card, 'freeplay', 'Free play', possible.effects.filter(p => p.name == 'free action'))], 'text');
    // filter duplicate text
}

let verbKeys = {
    play: 'action',
    freeplay: 'free action',
    activate: 'activation',
    support: 'support',
    control: 'control',
    start: 'start',
    endgame: 'endgame',
    cleanup: 'cleanup',
    resupply: 'resupply',
    surprise: 'surprise',
    accept: 'accept'
}

export function getHints(card, verb = false, paidActions = false){
    return perfSampleMeasure('hints.getHints', 20, () => getHintsInner(card, verb, paidActions));
}

function getHintsInner(card, verb = false, paidActions = false){
    if(!card) return false;
    
    let p = get(state).players[get(state).activePlayer];
    //  Check for drones and disable if so
    let owner = cardOwner(card);
    if(!owner) owner = p;
    //if(matches(card, 'location') && hasDrones(card) && owner.captain != 'Borg Queen') return false; // Can't use operations with a drone present
    if(ongoingPlayer(p).includes('freeplay_cards') && ongoingPlayer(p, 'freeplay_cards').some(t => matches(card, t))){
        // All actions on this card are free!
        paidActions = true;
    }
    
    let possible = get(res).parsedCardText[card.id];
    //console.log(possible);
    if(!possible || !possible.effects){
        //console.log('no parsed text', possible, verb);
        if(card && card.suits && card.suits.includes('mission')) return [{
            name: 'Complete', text: card.rewardText, error: 'text not parsed yet',
            list: 'card actions',
            action: 'complete',
        }];
        return false;
    }

    possible = possible.effects;

    

    if(card.suits.includes('mission') && (!verb || verb == 'reward' || verb.includes('play'))){
        //console.log(hintNames(card, 'complete', 'Complete', possible.filter(p => p.name == 'reward')));
        return hintNames(card, 'complete', 'Complete', possible.filter(p => p.name == 'reward'));
    }

    if(verb == 'action') verb = 'all_play';

    if(Object.values(verbKeys).includes(verb)) verb = Object.keys(verbKeys).find(k => verbKeys[k] == verb);

    if(verb == 'all_play'){
        return filterDuplicates([...hintNames(card, 'freeplay', 'Play', possible.filter(p => p.name == 'free action')), ...hintNames(card, 'play', 'Play', possible.filter(p => p.name == 'action'))], 'text');
    }

    if(verb && possible.some(p => Object.values(verbKeys).includes(p.name))) return hintNames(card, verb, upperInitial(verb), possible.filter(p => p.name == verbKeys[verb])); // TODO for free play!
    
    

    if(canActivate(card, p)){
        //console.log('activate?');
        if(possible.some(p => p.name == 'activation')) return hintNames(card, 'activate', 'Activate', possible.filter(e => {
            if(e.name != 'activation') return false;
            if(paidActions) return true; // for free play
            if(e.actionCost){
                let available = p.actions;
                if(p.whim && ongoingPlayer(p).includes('whim_action')) available += p.whim;
                if(available < e.actionCost) return false;
            }
            if(e.droneCost){
                if(numExpendableDrones(p).length < e.droneCost) return false;
            }
            return true;
        })); // Only list those not costing action
    }
    //console.log(getLocation(c));
    if(inHand(card) || paidActions){ // allow for free playing from discard etc.
        //console.log('in hand?');
        let play = canPlay(p, card) || paidActions;
        //console.log('can play?', play);
        
        if(play && card.suits.includes('mission')){
            return hintNames(card, 'play', 'Start', possible.filter(p => p.name == 'start'));
        }else if(play){
            //console.log('free')
            let ret = filterDuplicates([...hintNames(card, 'play', 'Play', possible.filter(p => p.name == 'action')), ...hintNames(card, 'freeplay', 'Play', possible.filter(p => p.name == 'free action'))], 'text');  
            return ret;
        }
        console.log('cannot play')
    }
    if(getLocation(card).deck == 'locations'){
        // Neutral zone? Shouldn't really be able to do this though
        if(canControlLocation(p, card)){
            return hintNames(card, 'control', 'Take control', possible.filter(p => p.name == 'control'));
        }
    }

    return false;
}

export function checkOwnership(p, c, a){
    let count = resolveCountTypes(p, c, {...a.obj, owner: p.bot ? 'bot' : 'you'}, 'ownership', {...a});
    let num = syncNum(a.num);
    let should_do = false;
    console.log('running test', count, num, testNum(num, count))
    if(testNum(num, count)){
        should_do = true;
    }
    if(a.neg) should_do = !should_do;
    return should_do;
}

export function checkMission(p, m){
    //console.log('checking mission', m.name);
    let goals = getCardEffect(m, 'goal');
    //let matchedAll = true;
    let ret = [];
   // console.log(goals);

   /*state.update(s => {
        if(!s.cache) s.cache = {};
        s.cache.wildcardsUsed = 0;
        return s;
   })*/

   let cache = {
    wildcardsUsed: 0
   };

   // Clear cache to avoid infecting other stuff
   
   

   if(m.complete){
    return {
        complete: true,
        total: 0,
        count: 0,
        left: 0,
        percent: 0,
        ticked: true
    }
   }
   
   let savedCache = clone(get(state).cache);
   //console.log('Clearing cache', get(state).cache, savedCache);

   // Sep 2025 added below to avoid missions corrupting main cache
   // The only potential issue is with missions running debounced, 
   // but since they have no async within them and thus don't yield between
   // start and finish I'm hoping it'll work ok?
   // If not then roll back the below calls
   let resetCache = false;
   if(Object.keys(savedCache).length > 0){
    resetCache = true;
    state.update(s => {
        s.cache = {};
        return s;
    })
   }
   /*state.update(s => {
    s.cache = {};
    return s;
   })*/

    for(let g of goals.flat(2).flatMap(g => g.effect).flat(2)){
        // These are all the conditions
        //console.log(g);
        if(g.type == 'have'){
            ret.push(...checkMissionHave(p, m, g, g.elements, cache))
        }
    }

    if(resetCache){
        //console.log('restoring cache', savedCache);
        state.update(s => {
            s.cache = savedCache;
            return s;
        })
    }
    

    if(ret.length == 0){
        // Mission not parsed
        return {
            complete: false,
            total: 0,
            count: 0,
            left: 0,
            percent: 0,
            unparsed: true
        }
    }

    let count = ret.reduce((a,r) => a + r.count, 0);
    let total = ret.reduce((a,r) => a +  r.total, 0);
    let left  = total - count;
    if(count >= total) left = 0;
    let result = {
        complete: ret.every(r => r.met),
        total,
        count, 
        left,
        percent: Math.round(count / total * 100),
        elements: ret,
        others: cache.otherChoices || false,
        numMet: cache.numMet || 0
    }

    /*state.update(s => {
        if(!s.cache) s.cache = {};
        delete s.cache.wildcardsUsed;
        return s;
   })*/

    //let savedCache = clone(get(state).cache);
   

    return result;
}

function checkSecuredBy(p, c, securedBy){
    if(!canControlLocation(p, c)) return false;
    if(!securedBy.some(s => s == 'away') && myAway(p, c)) return false; // Only if allowed (drones count as away teams)
    let allowedShips = securedBy.filter(s => s != 'away');
    if(c.orbiting){
        for(let o of c.orbiting){
            let ship = getCard(o.card);
            if(cardOwner(ship) && cardOwner(ship).captain && cardOwner(ship).captain != p.captain) continue; // Only check your own ships
            if(allowedShips.some(s => matches(ship, s))) return true; // Now it's inclusive, not exclusive
        }   
    }
    return false;
}

function filterToExternalVisitors(p, eligible){
    return eligible.filter(e => e.whereAmI && !cardsInPlay(p, false, true).some(cd => getCard(e.whereAmI).uniqueID == cd.uniqueID));
}


function checkMissionHave(p, card, g, elements, cache){
    let ret = [];
    if(elements.choice){
        let maxRet = [{left: Infinity}];
        let all = [];
        if(g.subset){
            maxRet = [];
            let bestRets = [];
            let numMet = 0;
            for(let e of elements.choice){
                let ret = checkMissionHave(p, card, g, e, cache);
                all.push(ret);
                if(ret.every(r => r.met)) numMet++;
                if(bestRets.length < g.subset){
                    bestRets.push(ret);
                }else{
                    let toReplace = bestRets.find(r => r.reduce((a, r) => a + (r.left || 0), 0) > ret.reduce((a, r) => a + (r.left || 0), 0));
                    if(toReplace){
                        bestRets = bestRets.filter(r => r != toReplace);
                        bestRets.push(ret);
                    }
                }
            }
            cache.numMet = numMet;
            // Now consolidate
            maxRet = bestRets.flat(2);
            // NB should automatically result in the met elements being added if there are some, since they will have left == 0
        }else{
            for(let e of elements.choice){
                let ret = checkMissionHave(p, card, g, e, cache);
                //console.log(ret);
                if(ret.every(r => r.met)) return ret; // First match should be returned
                if(ret.reduce((a, r) => a + (r.left || 0), 0) < maxRet.reduce((a, r) => a + (r.left || 0), 0)) maxRet = ret; // One which is closest
                all.push(ret);    
            }
        }
        if(!cache.otherChoices) cache.otherChoices = [];
        cache.otherChoices.push(...all.filter(a => a != maxRet));
        //console.log(maxRet)
        return maxRet; /*[
            ...maxRet,
            others: all.filter(a => a != maxRet)
        ]; // Otherwise return the closest*/
    }
    // TODO handle ship situation: if g.ships
    let eligibleShips = false;
    if(g.ships){
        eligibleShips = p.decks.fleet.filter(c => matches(c, 'ship'));
    }
    let eligibleLocs = false;
    if(g.loc_limits){
        eligibleLocs = [...p.decks.locations, ...getNeutralZone().filter(c => countPlayerTokens(c, p) > 0)]; // only count if you have some presence there
        // above added April 2025: maybe change to countShips?
    }
    let shipsChecked = [];
    let matchedShips = [];
    let ship = false;

    let locsChecked = [];
    let matchedLocs = [];
    let loc = false;
    let savedCache = cache; // to pass back later
    do{
        cache = {...savedCache}; // copy cache for each loop through so that you don't overwrite it when it changes
        if(eligibleShips){
            let subset = eligibleShips.filter(s => !shipsChecked.some(c => c.uniqueID == s.uniqueID));
            if(subset.length == 0){
                ship = false;
            }else{
                ship = subset[0];
            }
            
            matchedShips = [[], ...matchedShips];
        }
        if(eligibleLocs){
            let subset = eligibleLocs.filter(l => !locsChecked.some(c => c.uniqueID == l.uniqueID));
            if(subset.length == 0){
                loc = false;
            }else{
                loc = subset[0];
            }
            
            matchedLocs = [[], ...matchedLocs];
        }
        for(let e of elements){
            let target = e.target;
            let max = false;
            //console.log(e);
            if(typeof target != 'number'){
                if(target.max) max = target.max;
                if(target.min) target = target.min;
                if(target.num && !target.min){
                    if(target.max){
                        target = 1;
                    }else{
                        target = target.num;
                    }
                    
                }
                // !!!TODO how to handle max?
            }
            let entry = {
                target: target,
                text: e.text,
                eligible: [],
                cache, // to save this version of the cache
                max
            }
            if(ship) entry.ship = ship.uniqueID;
            if(loc) entry.loc = loc.uniqueID;
            if(e.type == 'type_count'){
                entry.total = target;
                let count;
                let info = {};
                let priorWildcards = cache.wildcardsUsed;
                let exclude = e.obj.exclude || e.exclude;
                let ejt = e.obj.excludeJustTraits || e.excludeJustTraits;
                if(e.obj.types == 'different-species' || e.obj.types == 'different species' || Array.isArray(e.obj.types) && e.obj.types[0] == 'different-species' || Array.isArray(e.obj.types) && e.obj.types[0] == 'different species'){
                    entry.lookingFor = 'different-species';
                    let species = get(res).species;
                    let eligible = allScoreableCards(p);
                    if(e.securedBy) eligible = getNeutralZone().filter(c => checkSecuredBy(p, c, e.securedBy)); // Check how locations are secured where necessary
                    if(e.visitingOther) eligible = filterToExternalVisitors(p, eligible);
                    if(e.ship){
                        if(e.ship.exclude){
                            eligible = resolveExclude(card, [ship], e.ship.exclude, p);
                            if(eligible.length > 0){
                                if(ship && (e.ship.ship == 'same_ship' || matches(ship, e.ship.ship))){
                                    eligible = [ship];
                                    if(ship.beamed) eligible = [...eligible, ...ship.beamed];
                                } 
                            }
                        }else if(ship && (e.ship == 'same_ship' || matches(ship, e.ship))){
                            eligible = [ship];
                            if(ship.beamed) eligible = [...eligible, ...ship.beamed];
                        }else{
                            eligible = []; // Because this ship doesn't match
                        }
                    }
                    if(e.loc_limit){
                        if(loc && (matches(loc, e.loc_limit))){
                            eligible = [...cardsAtLocation(loc, p)]
                        }else{
                            eligible = []; // Because this loc doesn't match
                        }
                    }
                    if(e.obj.location) eligible = resolveLocCondition(card, e.obj.location, p, eligible, e.obj, 'type_count', true);
                    //console.log(eligible);
                    if(exclude && !ejt) eligible = eligible.filter(c => !matches(c, exclude, false)); // Double-check this does the array thing ok
                    //if(e.obj.exclude) eligible = eligible.filter(c => !matches(c, e.obj.exclude, false)); // Double-check this does the array thing ok
                    
                    // Cards visited by a [[qsuit]] count for their traits (Eat any good books lately?) even when the bot owns them
                    let visitedForTraits = ongoingPlayer(p).includes('count_traits_on_visited_cards') ? visitedCards(p).map(c => c.uniqueID) : [];
                    eligible = eligible.filter(e => !cardOwner(e) || cardOwner(e).captain == p.captain || visitedForTraits.includes(e.uniqueID)); // !!! TODO to stop ships counting if they shouldn't
                    
                    // !! TODO add handling of possibleWildCards here if we want missions to cope with any species too
                    if(!cache.hasOwnProperty('wildcardsLeft')){
                        let wcl = eligible.filter(c => c.traits).reduce((a,c) => a + c.traits.filter(t => t == 'wildcard').length, 0)
                        // April 2025: only add if it exists, to prevent overriding of other situations 
                        if(wcl > 0) wcl = cache.wildcardsLeft = wcl;
                    }
                    let each_diff = g.each_diff || [];
                    if(!Array.isArray(each_diff)) each_diff = [each_diff];
                    entry.each_diff = each_diff;
                    let allSpecies = eligible.flatMap(c => c.traits).filter(t => species.includes(t));
                    if(exclude && ejt){
                        let ex = exclude;
                        if(!Array.isArray(ex)) ex = [ex];
                        allSpecies = allSpecies.filter(s => !ex.includes(s));
                    }
                    // April 2025 moved below to filter out non-matching from eligible list. Check it works!
                    info.eligible = eligible.filter(c => c.traits.some(t => allSpecies.includes(t)));  
                    let diffs  = allSpecies.filter(t => each_diff.includes(t));
                    let dNums = diffs.length;
                    allSpecies = Array.from(new Set(allSpecies.filter(t => !each_diff.includes(t))));
                    let asNums = allSpecies.length;
                    let wildCards = eligible.flatMap(c => c.traits).filter(t => t == 'wildcard');
                    let wcNums = wildCards.length - cache.wildcardsUsed;
                    count = asNums + dNums + wcNums;
                    info.eligibleTypes = [...allSpecies, ...diffs, ...wildCards];
                    entry.eligibleTypes = info.eligibleTypes;
                    
                    if(count > target){
                        let diff = count - target;
                        wcNums -= diff; // So as not to overuse
                        if(wcNums < 0) wcNums = 0; 
                    }
                    entry.wildCards = wcNums;
                    // TODO at the mo it always adds wildcards to eligible list because the player may optionally want to dismiss them instead
                    //if(wildCards > 0){
                        // add wildcards to eligible list
                        info.eligible = [...info.eligible, ...eligible.filter(c => !info.eligible.some(cd => cd.uniqueID == c.uniqueID) && c.traits && c.traits.some(t => t == 'wildcard'))]
                        //entry.eligibleTypes = entry.eligibleTypes.filter(t => t != 'wildcard')
                    //}
                    cache.wildcardsUsed += wcNums;
                    //console.log('checking species', count, allSpecies, diffs, wildCards,eligible)
                }else if(e.obj.types == 'same-species' || e.obj.types == 'same species'){
                    let eligible = allScoreableCards(p);
                    if(e.securedBy) eligible = getNeutralZone().filter(c => checkSecuredBy(p, c, e.securedBy)); // Check how locations are secured where necessary
                    if(e.visitingOther) eligible = filterToExternalVisitors(p, eligible);
                    if(e.ship){
                        if(ship && (e.ship == 'same_ship' || matches(ship, e.ship))){
                            eligible = [ship];
                            if(ship.beamed) eligible = [...eligible, ...ship.beamed];
                        }else{
                            eligible = []; // Because this ship doesn't match
                        }
                    }
                    if(e.loc_limit){
                        if(loc && (matches(loc, e.loc_limit))){
                            eligible = [...cardsAtLocation(loc, p)]
                        }else{
                            eligible = []; // Because this loc doesn't match
                        }
                    }
                    if(e.obj.location) eligible = resolveLocCondition(card, e.obj.location, p, eligible, e.obj, 'type_count', true);
                    //console.log(eligible);
                    if(exclude && !ejt) eligible = eligible.filter(c => !matches(c, exclude, false)); // Double-check this does the array thing ok
                    //if(e.obj.exclude) eligible = eligible.filter(c => !matches(c, e.obj.exclude, false)); // Double-check this does the array thing ok
                    count = 0;
                    for(let s of get(res).species){
                        if(ejt && exclude){
                            if(!Array.isArray(exclude)) exclude = [exclude];
                            if(exclude.includes(s)) continue; // Skip this one
                        }
                        let amount = eligible.filter(c => matches(c, s)).length;
                        if(amount > count){
                            count = amount;
                            info.eligibleTypes = [s];
                            info.eligible = [...eligible.filter(c => matches(c, s))];
                        }
                    }
                    if(count < target && cache.hasOwnProperty('wildcardsLeft') && cache.wildcardsLeft + count >= target){
                        let diff = target - count;
                        count += diff;
                        info.eligibleTypes.push('wildcard')
                        info.eligible.push(...eligible.filter(c => matches(c, 'wildcard')));
                        cache.wildcardsLeft -= cache.wildcardsLeft;
                        cache.wildcardsUsed += diff;
                    }
                }else if(e.obj.card && e.obj.card.type == 'prev_obj' && e.obj.location){
                    // It's a 'X of them at X location' type check on previous matches
                    let allEligible = ret.flatMap(r => r.eligible);
                    console.log('allEligible', allEligible);
                    let loc = resolveLocCondition(card, e.obj.location, p);
                    count = loc.filter(l => allEligible.some(e => e.uniqueID == l.uniqueID)).length;
                }else{
                    let eligible = allScoreableCards(p);
                    if(e.obj.location) eligible = resolveLocCondition(card, e.obj.location, p, eligible, e.obj, 'type_count', true);
                    if(e.obj.types && ['away', 'drone', 'q', 'murf', 'secured neutral location'].some(t => possArray(e.obj.types).includes(t))){
                        eligible = [...eligible, ...getMarketCards(), ...getNeutralZone()]; // Jun 2025 to fix Boimler mission issue – see if it breaks other things
                    }
                    
                    if(e.securedBy) eligible = getNeutralZone().filter(c => checkSecuredBy(p, c, e.securedBy)); // Check how locations are secured where necessary
                    if(e.visitingOther) eligible = filterToExternalVisitors(p, eligible);
                    if(e.ship){
                        if(ship && (e.ship == 'same_ship' || matches(ship, e.ship))){
                            eligible = [ship];
                            if(ship.beamed) eligible = [...eligible, ...ship.beamed];
                        }else{
                            eligible = []; // Because this ship doesn't match
                        }
                    }
                    if(e.loc_limit){
                        if(loc && (matches(loc, e.loc_limit))){
                            eligible = [...cardsAtLocation(loc, p)]
                        }else{
                            eligible = []; // Because this loc doesn't match
                        }
                    }
                    if(e.loc_all){
                        // Jan 2026: 'at every neutral location' etc.
                        eligible = [];
                        if(e.loc_all == 'on_nz'){
                            eligible = [...getNeutralZone()];
                            eligible = eligible.filter(c => testNum(e.target, resolveCountTypes(p, card, e.obj, 'mission', {...g, ...e}, [], cache, [c])))
                            count = eligible.length;
                            target = getNeutralZone().length;
                            info.eligible = eligible;
                            cache.target = target;
                            entry.target = target;
                            entry.total = target;
                        }else if(e.loc_all == 'at_nz'){
                            eligible = [...getNeutralZone()];
                            eligible = eligible.filter(c => testNum(e.target, resolveCountTypes(p, card, e.obj, 'mission', {...g, ...e}, [], cache, [...cardsAtLocation(c)])))
                            count = eligible.length;
                            target = getNeutralZone().length;
                            entry.target = target;
                            entry.total = target;
                            cache.target = target;
                            info.eligible = eligible;
                        }else{
                            throw 'unknown loc_all!'
                        }
                    }else if(e.obj.types && e.obj.types.either_or){
                        // Pick the best one
                        info.eligible = [];
                        cache.target = target;
                        count = 0;
                        for(let t of e.obj.types.either_or){
                            let newCache = {...cache};
                            let newInfo = {eligible: []};
                            let thisCount = resolveCountTypes(p, card, {types: t}, 'mission', {...g, ...e, obj: {types: t}}, newInfo.eligible, newCache, eligible);
                            if(thisCount > count){
                                cache = newCache;
                                info.eligible = newInfo.eligible;
                                count = thisCount;
                            }
                        }
                    }else{
                         if(possArray(e.obj.types).includes('traits') && e.obj.diff){
                            entry.differentTraits = true;
                        }
                        info.eligible = [];
                        cache.target = target;
                        count = resolveCountTypes(p, card, e.obj, 'mission', {...g, ...e}, info.eligible, cache, eligible);
                    }
                   
                    //if(cache.wildcardsUsed) console.log('some WC used', cache);
                    //info.eligible = eligible;
                }
                // !!TODO handle 'with' conditions
                /*let withMet = true;
                if(e.extra){
                    let withC = e.extra;
                    //withMet = false;
                    if(withC.each){
                        
                    }else{
                        //withMet = false;
                        let eligible = allScoreableCards(p)
                        if(withC.obj && withC.obj.location) eligible = resolveLocCondition(card, withC.obj.location, p, eligible, withC.obj);
                        
                    }
                }*/
                if(e.extra){
                    if(e.extra.each){
                        if(e.extra.obj == 'prev_obj') e.extra.obj = e.obj;
                        if(e.extra.present){
                            let target = e.extra.target;
                            let max = target.max;
                            if(target.min) target = target.min;
                            if(target.max) max = target.max;                 
                            for(let c of info.eligible){
                                let num = cardsAtLocation(c, p).filter(c => matches(c, e.extra.obj.types));
                                if(num < target || (max && num > max)){
                                    count--;
                                    info.eligible = info.eligible.filter(cd => cd.uniqueID != c.uniqueID)
                                }
                                /*if(!c.orbiting){
                                    count--;
                                    info.eligible = info.eligible.filter(cd => cd.uniqueID != c.uniqueID)
                                }else{
                                    let ships = c.orbiting.map(o => getCard(o.card)).filter(c => matches(c, e.extra.obj.types));
                                    let num = countShips(ships);
                                    if(num < target || (max && num > max)){
                                        count--;
                                        info.eligible = info.eligible.filter(cd => cd.uniqueID != c.uniqueID)
                                    }
                            }    */
                            }
                        }else if(e.extra.obj.types == 'different-species' || Array.isArray(e.extra.obj.types) && e.extra.obj.types[0] == 'different-species' || e.extra.obj.types == 'different species' || Array.isArray(e.extra.obj.types) && e.extra.obj.types[0] == 'different species'){
                            // Presume 1 per item TODO is this right? I think so...
                            let species = [];
                            for(let c of info.eligible){
                                let canStay = false;
                                for(let t of c.traits){
                                    if(get(res).species.includes(t) && !species.includes(t)){
                                        species.push(t);
                                        canStay = true;
                                        break; // 
                                    }
                                }
                                if(!canStay){
                                    count--;
                                    info.eligible = info.eligible.filter(cd => cd.uniqueID != c.uniqueID);
                                }
                            }
                            
                        }else{
                            let target = e.extra.target;
                            // 'each card can satisfy only X requirements' will probably not interact well with this
                            let max = target.max;
                            if(target.max) max = target.max;
                            if(target.min) target = target.min;
                            if(e.extra.diff){
                                // each object has to be different
                                // So handle it by listing for each card, then filtering out gradually
                                // (Code below produced by ChatGPT based on a series of prompts, so let's see how it goes!)
                                // ...answer: not well! Let's replace it with human code
                                // Basic algorithm:
                                // sort by the smallest match number, i.e. if there is a type where only one card is relevant, use that

                                info.eligible = info.eligible.filter(c => matches(c, e.extra.obj.types)); // So that we only deal with relevant ones
                                let choosingFrom = [...info.eligible];
                                let matchesCount = (t) => choosingFrom.filter(c => matches(c, t)).length;
                                
                                let types = [...e.extra.obj.types].sort((a,b) => matchesCount(a) - matchesCount(b)); // so sorted by smallest count
                                let typesCount = (c) => types.filter(t => matches(c, t)).length;

                                let included = [];

                                
                                for(let t of types){
                                    let poss = choosingFrom.filter(c => matches(c, t) >= target && (!max || matches(c,t) <= max));
                                    if(poss.length > 0){
                                        poss = poss.sort((a, b) => typesCount(a) - typesCount(b));
                                        included.push(poss[0]);
                                        choosingFrom = choosingFrom.filter(c => c.uniqueID != poss[0].uniqueID);
                                    }
                                }

                                info.eligible = included;
                                let num = info.eligible.length;
                                count = Math.min(num, entry.target); // each = every one should tally, i.e. its a filter
                                
                                /*let cardMatcher = {};
                                for(let t of e.extra.obj.types){
                                    cardMatcher[t] = [];
                                }

                                for(let c of info.eligible){
                                    for(let t of e.extra.obj.types){
                                        if(matches(c, t)) cardMatcher[t].push(c.uniqueID);
                                    }
                                }

                                let canAssign = (required, cardMatcher, usedIndexes, depth) => {
                                    if(depth == required.length) return true;
                                    let test = required[depth];
                                    let possible = cardMatcher[test];

                                    let maxMatch = depth;

                                    for(const i of possible){
                                        if(usedIndexes.has(i)) continue;
                                        usedIndexes.add(i);
                                        if(canAssign(required, cardMatcher, usedIndexes, depth + 1)){
                                            return true;
                                        }
                                        usedIndexes.delete(i);

                                        if(result == required.length) return result;
                                        maxMatch = Math.max(maxMatch, result);
                                    }
                                    return maxMatch;
                                }
                                let num = canAssign(e.extra.obj.types, cardMatcher, new Set(), 0);
                                if(num < target || (max && num > max)){
                                    count--;
                                }*/
                            }else{
                                for(let c of info.eligible){
                                    let num = matches(c, e.extra.obj.types);
                                    /*if(num < target || (max && num > max)){
                                        count--;
                                    }*/
                                   count = Math.min(num, entry.target); // each = every one should tally, i.e. its a filter
                                }
                            }
                            
                        }
                    }else{
    
                    }
                    
                }

                if(e.all_restriction){
                    if(info.eligible.some(c => !matches(c, e.all_restriction))){
                        count = 0;
                        info.eligible = []; // All or nothing – could handle better later maybe? Like 'each with'?
                    }
                }

                //if(count < 0) alert(count);
                //if(e.exclude == 'this') count--; // Now replaced by proper handling. Recheck if something is overcounted
                entry.count = count;
                entry.eligible = info.eligible;
                let metEach = true;
                if(e.each_limit){
                    let num = syncNum(e.each_limit);
                    if(typeof num != 'number') num = 0;
                    for(let t of e.obj.types.flat(2)){
                        let matched = 0;
                        for(let c of info.eligible){
                            matched += matches(c, t);
                        }
                        if(!testNum(e.each_limit, matched)){
                            metEach = false;
                            break;
                        }
                    }
                }
                if(metEach && (entry.count >= target || max && !e.min) && (!max || entry.count <= max)){
                    entry.met = true;
                    if(entry.count >= target && priorWildcards < cache.wildcardsUsed){
                        let diff = entry.count - target; // leftover
                         
                        cache.wildcardsUsed -= diff; // don't overspend
                        if(cache.wildcardsUsed < 0){
                            diff += cache.wildcardsUsed; // 
                            cache.wildcardsUsed = 0;
                        }
                        if(!cache.wildcardsLeft) cache.wildcardsLeft = 0;
                        cache.wildcardsLeft += diff;
                    }
                    entry.wildCards = cache.wildcardsUsed - priorWildcards;
                    if(entry.wildCards == 0 && info.addedWildCards && info.addedWildCards.length > 0){
                        //entry.eligible = entry.eligible.filter(c => !info.addedWildcards.some(cd => cd.uniqueID == c.uniqueID)); // Filter out solely wildcard entries
                        // TODO removed above because the player may optionally want to dismiss those instead
                    }
                    entry.uncappedCount = entry.count; // For later adjustment – though wildcards might break here
                    entry.count = target;
                }else{
                    entry.left = target - entry.count;
                    if(!metEach) entry.eachMissing = e.each_limit;
                    if(max && entry.count > max){
                        // over limit, so 0
                        entry.count = 0;
                        entry.left = 1;
                    }
                }
            }else if(e.type == 'exhausted_check'){
                entry.target = 1;
                entry.total = 1;
                let card = resolveSpecificCard(p, e.obj, {}, 'exhausted_check');
                if(card.some(c => getCard(c).activated)){
                    entry.count = 1;
                    entry.met = true;
                }else{
                    entry.count = 0;
                    entry.met = false;
                    entry.left = 1;
                }
            }else if(e.type == 'collected_traits'){
                if(!p.collected_traits) p.collected_traits = [];
                //console.log('collected traits', p.collected_traits);
                entry.count = p.collected_traits.length;
                entry.total = e.target;
                if(entry.count >= entry.total){
                    entry.uncappedCount = entry.total;
                    entry.count = entry.total;
                    entry.met = true;
                }else{
                    entry.left = entry.total - entry.count;
                }
            }else if(e.type == 'empty_hand'){
                if(p.decks.hand.length == 0){
                    entry.count = 1;
                    entry.total = 1;
                    entry.met = true;
                }else{
                    entry.left = 1;
                    entry.met = false;
                    entry.total = 1;
                    entry.count = 0;
                }
            }else if(e.type == 'completion_check'){
                if(allScoreableCards(p).some(c => c.complete && matches(c, 'mission') && matches(c, e.missionType))){
                    entry.count = 1;
                    entry.total = 1;
                    entry.met = true;
                }else{
                    entry.left = 1;
                    entry.met = false;
                    entry.total = 1;
                    entry.count = 0;
                }
            }else if(e.type == 'type_comparison'){
                // presume in play, at least for now
                let eligible = cardsInPlay(p, true).filter(c => matches(c, e.type1, false) || matches(c, e.type2, false));
                let count1 = eligible.reduce((a, c) => a + matches(c, e.type1, false), 0);
                let count2 = eligible.reduce((a, c) => a + matches(c, e.type2, false), 0);
                let comp = (a,b) => a - b;
                let wc = eligible.reduce((a, c) => a + matches(c, 'wildcard', false), 0);
                let met = false;
                let gap = Infinity;
                let total = 0;
                let count = 0;
                for(let [a,b] of [[count1, count2], [count1 + wc, count2], [count1, count2 + wc]]){
                    if(comp(a, b) > 0){
                        met = true;
                        gap = 0;
                        total = a;
                        break;
                    }else{
                        let newGap = 1 - comp(a, b);
                        count = a;
                        if(newGap < gap){
                            gap = newGap;
                            total = b + 1;
                        }
                    }
                }
                entry.met = met;
                entry.eligible = eligible.filter(c => matches(c, e.type1, false));
                entry.total = count2 + 1;
                entry.count = Math.min(count, count2 + 1);
                //entry.target = count2 + 1;;
                if(!entry.met){
                    entry.left = gap;
                }
            }else if(e.type == 'visiting_check'){
                let visitor = resolveExactCard(e.visitor, 'mission', p)[0];
                if(visitor) visitor = getCard(visitor);
                entry.target = 1;
                entry.total = 1;
                if(visitor && visitor.whereAmI && matches(getCard(visitor.whereAmI), e.visitee)){
                    entry.count = 1;
                    entry.met = true;
                    entry.eligible = [visitor, getCard(visitor.whereAmI)];
                }else{
                    entry.met = false;
                    entry.count = 0;
                    entry.left = 1;
                    entry.eligible = [];
                }
            }else if(e.type == 'each_loc_check'){
                let locations = [];
                if(e.loc.filter == 'neutral'){
                    locations = [...getNeutralZone()];
                }else if(e.loc.filter == 'controlled'){
                    locations = [...p.decks.locations];
                }else{
                    locations = [...getNeutralZone(), ...p.decks.locations];
                }

                
                let eligible = [];

                let count = 0;
                for(let l of locations){
                    let atCards = cardsAtLocation(l, p);
                    // NB currently doesn't use wildcards, in future potentially could need to 
                    let num = atCards.reduce((a, c) => a + matches(c, e.each.types), 0);
                    if(testNum(e.each.num, num)){
                        eligible.push(l);
                        count++;
                    }
                }
                if(testNum(e.loc.num, count)){
                    entry.met = true;
                }else{
                    entry.met = false;
                }
                entry.eligible = eligible;
                entry.total = e.target;
                entry.count = count;
                //entry.target = e.target;
                if(!entry.met){
                    entry.left = e.target - count;
                }
            }else if(e.type == 'per'){
                
                throw 'not supported at present';
                /*entry.count = resolveCount(p, card, e.per);
                entry.total = e.target;
                if(entry.count >= entry.total){
                    entry.count = entry.total;
                    entry.met = true;
                }else{
                    entry.left = entry.total - entry.count;
                }*/
            }else if(e.type == 'track_count'){
                let numMatch = 0;
                let mult = e.multiple || 1;
                if(mult.num) mult = mult.num;
                entry.total = mult * target;
                let mulMax = false;
                if(typeof mult != 'number'){
                    
                    if(mult.max) mulMax = mult.max;
                    if(mult.min) mult = mult.min;
                    if(mult.num) mult = mult.num;
                    // !!!TODO how to handle max?
                }
                let types = e.tracks.types;
                let list = [];
                if(!Array.isArray(types)) types = [types];
                for(let t of types){
                    t = get(res).trackTypes.find(tr => tr.startsWith(t)) || t; // For full-length track name
                    if(p[t] >= target && (!max || p[t] <= max)){
                        numMatch++;
                        list.push(target);
                    }else{
                        list.push(p[t]);
                    }
                }
                let overall = list.sort((a,b) => b - a).slice(0, mult).reduce((a,c) => a+c, 0);
                //console.log(list, list.sort((a,b) => a - b), overall)
                entry.numTargets = e.multiple;
                entry.count = overall; // numMatch * target;
                if(entry.count > entry.total){
                    entry.uncappedCount = entry.count;
                    entry.count = entry.total;
                }
                if(numMatch >= mult && (!mulMax || numMatch <= mulMax)){
                    entry.met = true;
                }else{
                    entry.left = entry.total - overall;// was entry.target... (mult > 1 ? mult - numMatch : target)
                }
            }
            if(eligibleShips){
                matchedShips[0].push(entry);
            }else if(eligibleLocs){
                matchedLocs[0].push(entry);
            }else{
                for(let k of Object.keys(entry.cache)){
                    savedCache[k] = entry.cache[k]; 
                }
                ret.push(entry);
            }      
        }
        if(eligibleShips){
            shipsChecked.push(ship);
        }
        if(eligibleLocs){
            locsChecked.push(loc);
        }
    }while(
        (eligibleShips && eligibleShips.some(s => !shipsChecked.some(c => c.uniqueID == s.uniqueID))) ||
        (eligibleLocs && eligibleLocs.some(l => !locsChecked.some(c => c.uniqueID == l.uniqueID)))
    );

    let uid = (toProcess) => {
        for(let r of possArray(toProcess)){
            if(r.eligible) r.eligible = r.eligible.map(e => e.uniqueID);
        }
        return toProcess;
    }
    
    if(eligibleShips){
        let toReturn = [];
        for(let s of matchedShips){
            if(g.max_per_card) s = checkRequirementLimits(s, g.max_per_card, g.elements);
            if(toReturn.length == 0){
                toReturn.push(s);
            }else if(s.every(e => e.met)){
                toReturn = toReturn.filter(s => s.every(e => e.met))
                toReturn.push(s);
            }else if(!toReturn.some(s => s.every(e => e.met))){
                let current = toReturn[0].reduce((a, e) => a + (e.left || 0), 0);
                let next = s.reduce((a,e) => a + (e.left || 0), 0);
                if(next < current) toReturn = [s];
            }
        }

        if(toReturn.length > 1){
            toReturn[0][0].otherShips = toReturn.slice(1);
        }
        for(let k of Object.keys(toReturn[0][0].cache)){
            savedCache[k] = toReturn[0][0].cache[k]; 
        }
        return uid(toReturn[0]);
    }

    if(eligibleLocs){
        let toReturn = [];
        for(let s of matchedLocs){
            if(g.max_per_card) s = checkRequirementLimits(s, g.max_per_card, g.elements);
            if(toReturn.length == 0){
                toReturn.push(s);
            }else if(s.every(e => e.met)){
                toReturn = toReturn.filter(s => s.every(e => e.met))
                toReturn.push(s);
            }else if(!toReturn.some(s => s.every(e => e.met))){
                let current = toReturn[0].reduce((a, e) => a + (e.left || 0), 0);
                let next = s.reduce((a,e) => a + (e.left || 0), 0);
                if(next < current) toReturn = [s];
            }
        }

        if(toReturn.length > 1){
            toReturn[0][0].otherLocs = toReturn.slice(1);
        }
        for(let k of Object.keys(toReturn[0][0].cache)){
            savedCache[k] = toReturn[0][0].cache[k]; 
        }
        return uid(toReturn[0]);
    }

    if(g.max_per_card){
        ret = checkRequirementLimits(ret, g.max_per_card, g.elements);
    }

    return uid(ret);
}

function checkRequirementLimits(ret, max, elements){
    // NB todo may need some more wildcard handling
    // Needs to handle 'X different of' type wordings
    console.log('checking requirement limits', ret, max, elements);
    let cardCount = {};
    for(let e of ret){
        if(e.eligible){
            for(let c of e.eligible){
                if(!cardCount[c.uniqueID]) cardCount[c.uniqueID] = 0;
                cardCount[c.uniqueID]++;
            }
        }
    }
    if(Object.values(cardCount).every(v => v <= max)) return ret; // Requirements satisfied!
    // Otherwise there are some to sort out
    let toReduce = Object.keys(cardCount).filter(k => cardCount[k] > max);
    for(let id of toReduce){
        let relevantElements = ret.filter(e => e.eligible && e.eligible.some(c => c.uniqueID == id));
        // Presumes each contributes 1 to the overall tally – ok for now, possibly not if
        // sometimes this is 'res-skill' or similar, which would be silly
        relevantElements = relevantElements.sort((a,b) => {
            let aDiff = (a.uncappedCount || a.count) - (a.total || a.target);
            let bDiff = (b.uncappedCount || b.count) - (b.total || b.target);
            return bDiff - aDiff; // Largest surplus wins
        })
        let amountToLose = cardCount[id] - max;
        for(let e of relevantElements){
            let num = e.eligible.filter(c => c.uniqueID == id).length;
            let addBack = 0;
            if(num > amountToLose){
                addBack = num - amountToLose;
                num = amountToLose;
            }
            e.eligible = e.eligible.filter(c => c.uniqueID != id);
            while(addBack > 0){
                e.eligible = [...e.eligible, getCard(id)];
                addBack--;
            }
            if(e.uncappedCount){
                e.uncappedCount -= num;
                if(e.uncappedCount < e.count) e.count = e.uncappedCount;
            }else{
                e.count -= num;
            }
            amountToLose -= num;
            if(e.count < e.total){
                e.met = false;
                e.left = e.total - e.count;
            }
            if(amountToLose <= 0) break;
        }
    }
    return ret;
}

export function getCardEffect(c, type = 'action'){
    let possibleReactionAreas = ['reaction', 'passive', 'reward', 'special', 'support']
    if(type == 'all_reactions'){
        let collated = [];
        for(let t of possibleReactionAreas){
            collated.push(...getCardEffect(c, t));
        }
        return collated;
    }
    if(manualCards[c.id] && manualCards[c.id][type]){
        let ret = manualCards[c.id][type];
        if(!Array.isArray(ret)) ret = [ ret ];
        return ret;
    }
    if(get(res).parsedCardText[c.id] && get(res).parsedCardText[c.id].effects && get(res).parsedCardText[c.id].effects.some(e => e.type == type)){
        return get(res).parsedCardText[c.id].effects.filter(e => e.type == type)
    }
    return [];
}

export async function doReaction(effect, origP, p, card, type, params){
    if(effect.action){
        logText(`${origP.captain}'s action triggered card ${card.uniqueID}`);
        await effect.action(origP, p, card, type, params);
    }
}

export async function autoReaction(owner, p, card, effect, type, params, timing, attack){
    let savedRO = get(state).cache.reactionObj;
    if(true || await autoCheckReaction(owner, p, card, effect, type, params, timing)){ // !! Do we really need to recheck this??
        if(!params.noCheck && !allEffectsOptional(effect) && ['reaction', 'support'].includes(params.parentType)){ // If all effects are optional then no need to check before the first!
            let doIt = await choose(`Trigger the ${params.parentType == 'support' ? 'Support effect' : 'reaction'} from ${card.name} (${effect.text})?`, ['Yes', 'No']);
            if(doIt != 'Yes'){
                state.update(s => {
                    delete s.cache.reactionObj;
                    if(savedRO) s.cache.reactionObj = savedRO;
                    return s;
                })
                return;
            }
        }

        if(params.parentType == 'reaction'){
            //card.activated = true;
            // !! TODO to fix exhaust messing up prev_obj
            let savedCache = clone(get(state).cache);
            if(!card.activated) await doAction(p, 'exhaust', {obj: card.uniqueID});
            state.update(s => {
                s.cache = savedCache;
                return s;
            })
            // end !! TODO to fix exhaust messing up prev_obj
        }else if(params.parentType == 'support'){
            await moveTo(card, `players.play.${getPlayerIndex(p)}`, -1);
            let savedCache = clone(get(state).cache);
            await doAction(p, 'support', {obj: card.uniqueID}); // Just to allow put into play actions to trigger
            //await doAction(p, 'put_in_play', {obj: card.uniqueID});
            state.update(s => {
                s.cache = savedCache;
                return s;
            }) // !! savedCache to stop reactions triggering on the support effect itself
        }
    
        logText(`Triggered reaction from ${card.name}: ${effect.text}`);

        if(attack /*&& get(prefs).cancelWholeAttacks*/){
            await checkForReactions(p, 'attack', {...params, attacker: owner.captain}, 'before');
            if(get(state).cache && get(state).cache.replacedOriginal && get(state).cache.replacedOriginal != card.uniqueID){
                state.update(s => {
                    s.cache.replacedOriginal = false;
                    return s;
                })
                /*if(get(prefs).granularAttacks){
                    state.update(s => {
                        if(!s.cache) s.cache = {};
                        s.cache.attackCancelled = params.card;
                        return s;
                    })
                }else{
                    return;
                }*/
                return;
            }
        }

        // The reaction is a separate compilation unit: its slots must not land in the frame of
        // the effect that triggered it. `trigger` is the object the reaction fired on, which is
        // what "the gained card" in reaction text refers back to.
        let frame = pushFrame({
            unit: unitOfEffects(effect.action),
            card: card.uniqueID,
            trigger: (get(state).cache && get(state).cache.reactionObj) || params.obj || params.card,
            target: get(state).resolvingFrom
        });
        try{
            await resolveEffects(card, effect.action, attack);
        }finally{
            popFrame(frame);
        }

        if(attack){
            await checkForReactions(p, 'attack', {...params, attacker: owner.captain, cancelledAttack: get(state).cache && get(state).cache.attackCancelled}, 'after');
        }

        state.update(s => {
            delete s.cache.reactionObj;
            if(savedRO) s.cache.reactionObj = savedRO;
            return s;
        })

    }
}

// Where a card came from, for 'after putting X into play' triggers. A card already in play
// (the Staging Area logs as 'action_area' once promoted, the rest are in-play decks) is not being
// put into play; anything else – hand, discard, deck, log, reserve, Market, Junk – is.
export function fromOutOfPlay(deck){
    if(!deck) return false;
    if(typeof deck != 'string') return false; // a beamed card logs its host's uniqueID: already in play
    return deck != 'action_area' && deck != 'beamed' && !inPlayLocations.includes(deck);
}

export function checkConditionalMatch(c, types){
    let withWCs = matches(c, types);
    let withoutWCs = matches(c, types, false, false);
    return {
        noWCmatches: withoutWCs,
        WCMatches: withWCs
    }
}

function cardify(list){
    return possArray(list).map(l => {
        if(Array.isArray(l)) return cardify(l);
        if(typeof l == 'number') return getCard(l);
        return l;
    })
}

export async function autoCheckReaction(owner, p, card, effect, type, params, timing){
    //console.log('checking', effect, type, params, card, owner.captain, p.captain, get(state).cache);
    //if(matches(getCard(params.card), 'rebner')) console.log('rebner', params, effect)
    if(card.activated && params.parentType == 'reaction') return false; // Can't do twice in a turn for reaction type
    if(params.noReactions) return false; // So scan etc. can block reactions

    // Branching location checks now we have support and special cards
    if(params.parentType == 'support'){
        if(!p.decks.hand.includes(card)) return false;
    }else if(effect.cardCondition){
        if(!checkCardCondition(p, card, effect.cardCondition)) return false;
    }else if(effect.ifInStaging){
        if(!p.decks.play.some(c => c.uniqueID == card.uniqueID)) return false;
    } else if(params.parentType != 'special' && !cardsInPlay(owner, false, true).includes(card)){
        return false; // Can't react outside of play area except for Special
    }

    let results = []

    if(get(state).cardLog[card.uniqueID].area == 'beamed') return false;

    if(effect.interruptType == 'forced_interrupt'){
        // These should only trigger as the result of an attack
        console.log('checking forced interrupt', params.attack, p.captain, owner.captain)
        let attacker = isAttackEffect(p, params, getCard(params.card || currentCard()))
        if(!attacker || attacker.captain == owner.captain) return false;
        //if(!params.attack || p.captain == owner.captain) return false; // Owners can't trigger their own interrupts
    }


    
    let condition = effect.condition;
    let conditions = [condition];

    if(condition.type == 'multiple') conditions = condition.elements;

    let addDueToCache = false;

    for(let condition of conditions){

        let onlyTraits = false;
        let allowableStrings = ['attack', 'hand_empty', 'cycle', 'card_tokens', 'opponent_reaction', 'enlist_empty', 'glory_sub', 'spend_sub', 'opp_cleanup_interrupt', 'leaves_play', 'market_reveal', 'enters']
        if(!condition || typeof condition == 'string' && !allowableStrings.includes(condition)) continue; //return; // To weed out e.g. 'did_previous' checkers
        
        // Weed out phase and category limitations
        // if(condition.not_cleanup && (get(state).phase == 'cleanup' || currentPlayer().captain != owner.captain)) return false;
        
        for(let k of Object.keys(condition).filter(k => k.startsWith(`not_`))){
            let phase = k.split('_')[1];
            if(condition[k] && (get(state).phase == phase || currentPlayer().captain != owner.captain)) continue; //return false;
        }

        if(condition.only_action_step){
            if(get(state).phase != 'action') return false; 
            if(condition.only_action_step == 'your' && getPlayerIndex(owner) != get(state).currentPlayer) continue; //return false;
            if(condition.only_action_step == 'their' && getPlayerIndex(owner) == get(state).currentPlayer) continue; //return false;
        }
        // 
        if(condition.any_effect_except){
            if(!params.card) continue; //return false;
            // Check triggering card matches
            let sourceCard = getCard(params.card);
            if(matches(sourceCard, condition.any_effect_except)) continue; //return false;
        }
        if(condition.only_control_step) {
            if(get(state).phase != 'control') continue; //return false;
            if(condition.only_control_step == 'your' && getPlayerIndex(owner) != get(state).currentPlayer) continue; //return false;
        }
        if(condition.only_resupply_step) {
            if(get(state).phase != 'resupply') continue; //return false;
            if(condition.only_resupply_step == 'your' && getPlayerIndex(owner) != get(state).currentPlayer) continue; //return false;
        }
        if(condition.byAttack && !params.attack) continue; //return false; // is this the way? or isAttackEffect()?

        if(condition == 'opp_cleanup_interrupt'){
            if(type == 'opp_cleanup_interrupt' && currentPlayer().captain != owner.captain && get(state).phase == 'cleanup'){
                results.push('unconditional');
                continue;
            }
            continue; //return false;
        }

        // TODO below may not work if actors are wrong - check

        let actors = condition.actor || effect.actor;
        if(!Array.isArray(actors)) actors = [actors]
        let matched = false;
        for(let a of actors){
            if(a == 'they') a = get(state).cache.player || 'opponent'; //get(state).cachedPlayer || 'opponent';
            if(a == 'all') matched = true; // Anyone!
            if(a == 'default' || !a && (p.captain == owner.captain || condition == 'attack')) matched = true; // TODO better way of captain identity?
            if(condition == 'opponent_reaction' && p.captain != owner.captain && get(state).players[get(state).currentPlayer].captain == owner.captain) matched = true;
            if((a == 'you' || a == 'player') && !p.bot && p.captain == owner.captain) matched = true;
            if(a == 'opponent' && p.captain != owner.captain) matched = true;
            //if(a == 'bot' && owner.bot) matched = true; // !!! shouldn't be needed as bots never react
            if(type == 'attack' && params.card && cardOwner(getCard(params.card)) && cardOwner(getCard(params.card)).captain != owner.captain) matched = true;
            if(type == 'attack' && params.attacker){
                if(a == 'you' && params.attacker != owner.captain) matched = false;
                if(a == 'opponent' && params.attacker == owner.captain) matched = false;
            }
            if(effect.interruptType == 'forced_interrupt') matched = true; // see if this works
        }
        //console.log('checking actors', matched, actors, p, owner, p == owner);
        if(!matched) continue; //return false;
        matched = false;

        // these should probably be rewritten as if condition.type so it checks via card conditions rather than via verbs
        if(type == 'hand_empty'){
            if(effect.condition == 'hand_empty' && get(state).phase == 'action'){
                results.push('unconditional');
                continue;
            }
            continue; //return false;
        }

        if(type == 'glory_sub' || type == 'spend_sub'){
            if(effect.condition && effect.condition.type == type){
                let effTypes = params.subTypes;
                if(!Array.isArray(effTypes)) effTypes = [effTypes];
                let condTypes = effect.condition.subTypes; 
                if(!Array.isArray(condTypes)) condTypes = [condTypes];
                // What was spent, as well as what it stood in for. glory_sub predates the
                // general hook and names no payType, so it keeps meaning 'spent as glory'.
                let payType = effect.condition.payType || (type == 'glory_sub' ? 'glory' : false);
                if(payType && params.payType && payType != params.payType) continue;
                if(effTypes.some(t => condTypes.includes(t))){
                    results.push('unconditional');
                    continue;
                }
            }
            continue; //return false;
        }
        
        if(['cycle', 'enlist_empty', 'new_assimilate'].includes(type)){
            if(effect.condition && effect.condition.type == type){
                results.push('unconditional');
                continue;
            }
            continue; // return false;
        }

        if(type == 'market_reveal' && condition && condition.type == 'market_reveal'){
            let c = getCard(params.obj);
            if(c.uniqueID == card.uniqueID){
                results.push('unconditional');             
            }
            continue;
        }

        /*if(type == 'enlist_empty'){
            if(effect.condition && effect.condition.type == 'enlist_empty') return true;
            return false;
        }*/

        if(type == 'card_tokens'){
            if(effect.condition && effect.condition.type == 'card_tokens'){
                let c = getCard(params.obj);
                if(c.uniqueID != card.uniqueID) continue; //return false; // Only if they are the same card
                if(c[effect.condition.res] && testNum(effect.condition.num, c[effect.condition.res])){
                    results.push('unconditional');
                }
            }
            continue;
        }

        if(type == 'enters'){
            if(effect.condition && effect.condition.type == 'enters'){
                if(params.obj != card.uniqueID) continue;// return false; // Only if they are the same card (at least for now)
                if(effect.condition.place == params.place){
                    results.push('unconditional');
                }
            }
            continue;
        }
        
        if(condition && condition.type == 'leaves_play'){
            //if(type != 'leaves_play') return false;
            // Incomplete list below probably – check others
            if(!['hand', 'discard', 'dismiss', 'junk', 'log', 'top', 'bottom', 'give'].includes(type)) continue; // return false;
            let obj = await resolveObject(effect.condition.obj, 'reaction', {...params, card: card.uniqueID}, p, null, true);
            if(timing != 'before') throw `'X leaves play' reactions should always be 'before' triggers, not 'after' ones: flag this as a typo`;
            if(obj.some(o => isInPlay(getCard(o)) && possArray(params.obj).some(ob => o == ob))){
                results.push('unconditional');
            }
            continue;
            // fall through, should be oK?
        }

        

        /*if(condition == 'attack'){
            if(type == 'play' || type == 'freeplay' || type == 'activate' || type == 'control' || type == 'play_activate') return params.attack;
        }*/
        if(condition == 'attack' || condition.orAttack){
            if(type == 'attack'){
                if(condition.success && params.cancelledAttack) continue; //return false;
                results.push('unconditional');
                //return true; // TODO if this works, delete the above, and probably remove all the nested attack stuff too
            }
            continue;
        }

        if(condition == 'controlled_token_removal'){
            if(!params.attack && !params.forced) continue; return false; // enough?
            if(!['dismiss', 'log', 'recall', 'destroy', 'remove_away', 'remove_drones', 'warp'].includes(type)) continue; //return false;
            // next check objects
            //
        }

    
        if(condition.due){
            if(condition.due.card){
                if(!params.card || !matches(getCard(params.card), condition.due.card)) continue; //return false; // Specifically for things happening due to effect
            }
            addDueToCache = true;
        }

        let causingCard = getCard(params.card);
        // 'due to' effects target the _duplicated_ card where there is one
        // (so Borg Queen Alcoves destroys duplicated assimilated cards) Jan 2026
        // Nope, ruled the other way
        //if(get(state).resolvingFrom) causingCard = getCard(get(state).resolvingFrom);

        if(condition.dueType){
            
            if(condition.dueType.exclude){
                if(params.card && matches(causingCard, condition.dueType.exclude))  continue; //return false; // Specifically for things happening NOT due to effect
            }
            if(condition.dueType.types){
                if(!params.card || !matches(causingCard, condition.dueType.types))  continue; //return false; // Specifically for things happening due to effect
            }
            addDueToCache = true;
        }

        if(condition.notDue){
            if(condition.notDue.card){
                if(params.card && matches(causingCard, condition.notDue.card))  continue; //return false; // Specifically for things happening NOT due to effect
            }
            addDueToCache = true;
        }
        if(condition.verb){
            let verbs = [condition.verb];
            //console.log(timing)
            if(condition.extraVerbs){
                verbs = [...verbs, ...condition.extraVerbs.map(v => v.verb)]; // TODO check whether there are other bits
            }

            matched = false;
            for(let verb of verbs){
                if(verb == 'gain'){
                    if(type.startsWith('gain') && type != 'gain_control'){
                        // Check subtype!
                        matched = true;
                        break;
                    }else{
                        matched = false; 
                        continue;
                        //break; 
                    }
                }

                if(condition == 'opponent_reaction'){
                    if(type == 'reaction') return true; // Should be type, I think?
                }
                /*if(verb == 'control'){
                    if(!params.takingControl && params.auto) return false; //
                }*/
                
                // TODO below reinstated to fix Dykr cruiser, remove if it breaks
                /*if(type == 'deploy_warp'){
                    if(verb == 'deploy' || verb == 'warp'){
                        matched = true;
                        break;
                    }
                }*/
                if(verb == 'play' && (type == 'freeplay' || type == "play_activate" || type == 'free play')){
                    matched = true;
                    break;
                }
                if(verb == 'put' && condition.location && condition.location.place == 'action_area'){
                    // putting into staging area
                    if(type == 'support' || type == 'put_in_play' || type == 'put_in_staging'){
                        // using these types because they are atomic and thus anticipate the general 'play' actions 
                        // i.e. trigger before the op does, which is what we want
                        matched = true;
                        break;
                    }else{
                        return false;
                    }
                }
                
                if(verb == 'put_in_play' && (type == 'play' || type == 'freeplay' || (type == "play_activate" && params.actionDone && !['activate', 'refresh'].includes(params.actionDone)) || type == 'free play' || type == 'support' || (type == 'gain_control') || type == 'put_in_play' || type == 'duty' || (type == 'beam' && !condition.excBeam))){
                    
                    if(type == 'gain_control' && params.obj){
                        let someMatch = false;
                        for(let o of possArray(params.obj)){
                            if(getCard(o).deck == 'Locations') someMatch = true;
                        }
                        if(!someMatch) return false;
                    }
                    if(type == 'beam' && params.to){
                        // Check for the 'things beamed here are not in play' exception
                        let toCard = getCard(params.to);
                        if(ongoingEffects(toCard).includes('things_beamed_here_are_not_in_play')){
                            matched = false;
                            continue;
                            //return false;
                        }
                    }
                    if(['duty', 'beam'].includes(type)){
                        // Only counts as 'putting into play' if the card wasn't already in play:
                        // promoting out of the Staging Area (logged as 'action_area') or shuffling
                        // between in-play decks doesn't, but hand, discard, deck, log, reserve,
                        // the Market and so on all do. Was a hand/discard whitelist, which missed
                        // e.g. promoting a card gained to the top of your deck (Soji Asha).
                        let someMatch = false;
                        if(timing == 'before' && params.obj){
                            for(let o of possArray(params.obj)){
                                if(get(state).cardLog[o]){
                                    let deck = get(state).cardLog[o].deck;
                                    if(fromOutOfPlay(deck)) someMatch = true;
                                }
                            }
                        }else if(timing == 'after' && params.obj){
                            if(type == 'duty' && get(state).cache && get(state).cache.promotedFrom && get(state).cache.promotedFrom.some(f => fromOutOfPlay(f))){
                                someMatch = true;
                            }
                            if(type == 'beam' && get(state).cache && get(state).cache.beamedFrom && get(state).cache.beamedFrom.some(f => fromOutOfPlay(f))){
                                someMatch = true;
                            }
                        }
                        if(!someMatch){
                            matched = false;
                            continue;
                            //return false;
                        }
                    }
                    matched = true;
                    break;
                }

                if(verb == 'away' && awayAction(type)){
                    matched = true;
                    break;
                }

                if(verb == type || synonyms[verb] == type){
                    matched = true;
                    break;
                }
            }
            //console.log('checking verbs', matched, verbs, type);
            if(!matched) continue;//return false;
        }

        
        
        if(condition.parentType){
            if(!params.params || params.params.parentType != condition.parentType) return false;
        }
        
        if(condition.from){
            if(condition.from.place && params.verb == 'gain_card'){
                if(params.gainedFrom == condition.from.place){
                    matched = true;
                }else{
                    matched = false;
                    continue; // add to avoid wasting time
                }
            }else if(type == 'remove_away'){
                let from = params.from || params.obj || params.card;
                if(condition.from.types){
                    from = cardify(from).flat(2);
                    if(from.some(c => matches(c, condition.from.types))){
                        matched = true;
                    }else{
                        matched = false;
                        continue;
                    }
                }else if(condition.from.card){
                    let eligible = await resolveSpecificCard(p, condition.from, condition, condition.verb);
                    from = cardify(from).flat(2);
                    if(eligible.some(e => from.some(f => f.uniqueID == e.uniqueID))){
                        matched = true;
                    }else{
                        matched = false;
                        continue;
                    }
                }
            }else if(condition.from.card && condition.from.card.placement == 'top' && condition.from.card.place == 'deck'){
                // e.g. 'when this card would be logged from the top of the Bot deck': only matches while
                // the card is still on top of a deck, not when it's logged from play by its own resolution
                let obj = await resolveObject(effect.condition.obj, 'reaction', {...params, card: card.uniqueID}, owner, null, true);
                let decks = get(state).players.filter(pl => condition.from.card.owner != 'bot' || pl.bot).map(pl => pl.decks.deck);
                if(obj.some(o => decks.some(d => d && d.length > 0 && d[0].uniqueID == o))){
                    matched = true;
                }else{
                    matched = false;
                    continue;
                }
            }else if(/*type == 'dismiss' &&*/ (condition.from.location || condition.from.place)){
                // Not sure why it was restricted to dismiss! Hopefully now will work for resolve too
                // only works for before currently, but might work for after using preafter. Hopefully will
                if(!timing == 'before') alert(`Condition checking 'from' position after effect has executed: save and report as a bug`);
                let obj = await resolveObject(effect.condition.obj, 'reaction', {...params, card: card.uniqueID}, owner, null, true);
                // Pass the whole 'from': it carries either .location or .place, and resolveLocCondition
                // handles both. Passing .location alone fed undefined in for place-only conditions
                // ('junk a card from the market'), which threw on l.location in the loop.
                let loc = resolveLocCondition(card, condition.from, owner, []);
                if(obj.some(o => loc.some(l => cardsAtLocation(l, owner).some(c => c.uniqueID == o)))){
                    matched = true;
                }else{
                    matched = false;
                    continue;
                }
            }
        }

        let conditionalMatches;
    
        if(condition.obj){
            let obj = condition.obj;
            if(!Array.isArray(obj)) obj = [obj];
            matched = false;
            for(let o of obj){
                if(o.types){
                    let types = o.types;
                    let qualifier = false;
                    if(o.qualifier) qualifier = o.qualifier;
                    if(types == 'incidents') types = 'incident';
                    if(types == 'encounters') types = 'encounter';
                   
                    if(types == 'away' || types == 'opp_away'){
                        // !! Not sure whether this is still needed? Struggling to think of the situation for it.
                        if(condition.to){
                            let checkObj = params.on || params.to;
                            let types = condition.to.types;
                            if(!Array.isArray(checkObj)) checkObj = [checkObj];
                            //console.log('checking away', checkObj, types);
                            checkObj = await resolveFilters(p, condition.to, {...condition, card: card.uniqueID}, checkObj.filter(c => c).map(c => getCard(c)), type, owner);
                            for(let c of checkObj){
                                if(!c) continue;
                                //if(typeof c == 'number') c = getCard(c);
                                //if(matches(c, types)) matched = true;
                                let cond = checkConditionalMatch(c, types);
                                if(cond.noWCmatches) matched = cond.noWCmatches;
                                if(cond.WCMatches && !matched){ // only if need be
                                    matched = cond.WCMatches;
                                    conditionalMatches = true;
                                }
                                console.log('checking away to', matched, c, types)
                            }
                            
                            if(!matched) continue; //return false;
                        }else{
                            matched = true;
                            return true; // I don't think anything else needs matching?
                        }
                    }
                    if(!Array.isArray(types)) types = [types];
                    if(params.obj && params.obj.types){
                        let oTypes = params.obj.types;
                        if(!Array.isArray(oTypes)) oTypes = [oTypes];
                        if(types.some(t => oTypes.includes(t))){
                            if(condition.obj.num && params.obj.num){
                                if(testNum(condition.obj.num, params.obj.num))  matched = true;
                            }else{
                                matched = true;
                            }
                            state.update(s => {
                                if(!s.cache) s.cache = {};
                                s.cache.reactionTypes = oTypes;
                                return s;
                            })
                            break;
                        }
                        if(oTypes.some(t => t.endsWith('ship') || t.endsWith('location'))){
                            if(types.some(t => oTypes.some(o => o.endsWith(t)))){
                                // Don't be picky about controlled location or deployed ship
                                matched = true;
                                break;
                            }
                        }
                    }
                    if(types.some(t => allResourceTypes().includes(t)) || types.some(t => t == 'resource' || t == 'token' )){
                        if(!params.obj && (params.specific || params.token) && params.amount) params.obj = {types: params.specific || params.token, num: params.amount};
                        let checkObj = params.obj;
                        if(!Array.isArray(checkObj)) checkObj = [checkObj];
                        let sum = 0;
                        for(let o of checkObj){
                            if(types.some(t => t == params.token || o && t == o.specific || o && (t == o.types || t == o.type))){
                                sum += o.num || 0;
                                /*if(condition.obj.num && checkObj.some(o => o.num)){
                                    let matched = checkObj.filter(o => o.types == t || o.specific == t);
                                    let red = matched.reduce((a,m) => a + m.num || 0, 0)
                                    if(testNum(condition.obj.num, red))  matched = true;
                                }else{
                                    matched = true;
                                }*/
                            }
                            if(types.some(t => t == 'resource' || t == 'token') && o && (allResourceTypes().includes(o.types) || allResourceTypes().includes(o.type))){
                                /*if(condition.obj.num && checkObj.some(o => o.num)){
                                    let red = matched.reduce((a,m) => a + m.num || 0, 0)
                                    if(testNum(condition.obj.num, red))  matched = true;
                                }else{
                                    matched = true;
                                }*/
                               sum += o.num || 0;
                            }
                        }
                        if(condition.obj.num){
                            if(testNum(condition.obj.num, sum))  matched = true;
                        }else if(sum > 0){
                            matched = true;
                        }
                    }else if(types.some(t => get(res).trackTypes.includes(t) || trackTypes(p).includes(t)) || types.some(t => t == 'track')){
                        if(!params.obj && params.track && params.amount) params.obj = {types: params.track, num: params.amount};
                        let checkObj = params.obj;
                        if(!Array.isArray(checkObj)) checkObj = [checkObj];
                        let sum = 0;
                        for(let o of checkObj){
                            if(types.some(t => t == params.track || o && t == o.specific || o && (t == o.types || t == o.type))){
                                sum += o.num || 0;
                                /*if(condition.obj.num && checkObj.some(o => o.num)){
                                     matched = checkObj.filter(o => o.types == t || o.specific == t);
                                    let red = matched.reduce((a,m) => a + m.num || 0, 0)
                                    if(testNum(condition.obj.num, red))  matched = true;
                                }else{
                                    matched = true;
                                }*/
                            }
                            if(types.some(t => t == 'track') && o && (get(res).trackTypes.includes(o.types) || get(res).trackTypes.includes(o.type))){
                                sum += o.num || 0;
                                /*if(condition.obj.num && params.obj && params.obj.num){
                                    if(testNum(condition.obj.num, params.obj.num))  matched = true;
                                }else{
                                    matched = true;
                                }*/
                            }
                        }
                        if(condition.obj.num){
                            if(testNum(condition.obj.num, sum))  matched = true;
                        }else if(sum > 0){
                            matched = true;
                        }
                    }else if(params.obj || !params.auto && params.card){
                        // What about mixed??
                        let another = o.another;
                        let checkObj = params.obj || params.card;
                        if(!Array.isArray(checkObj)) checkObj = [checkObj];
                        for(let co of checkObj){
                            if(!co) continue;
                            let c = co;
                            if(typeof co == 'number') c = getCard(co);
                            //checkObj = await resolveFilters(p, condition.to, {...condition, card}, checkObj.filter(c => c).map(c => getCard(c)), type, owner);
                            
                            let check = await resolveFilters(p, o, {...condition, card}, [c], type, owner);
                            if(check.length == 0) continue; // doesn't match
                            if(o.owner){
                                // Check that we own this card
                                let owner = cardOwner(c);
                                let checkOwner = resolveOwner(card, o.owner);
                                if(owner.captain != checkOwner.captain) continue;
                            }
                            if(another && c.uniqueID == card.uniqueID) continue;
                            if(qualifier && qualifier == 'not_this' && c.uniqueID == card.uniqueID){
                                //
                            }else if(qualifier && qualifier.type == 'subcondition'){
                                // 
                                let check = resolveSubCondition(p, qualifier.condition, [c], params, card);
                                if(check.length > 0) matched = true;
                            }else{
                                //if(matches(c, types)) matched = true;
                                let cond = checkConditionalMatch(c, types);
                                if(cond.noWCmatches) matched = cond.noWCmatches;
                                if(cond.WCMatches && !matched){ // only if need be
                                    matched = cond.WCMatches;
                                    conditionalMatches = true;
                                }
                            }
                        }
                    }
                }else if(o.card && (params.obj || !params.auto && params.card)){
                    // Check with
                    let obj = clone(params.obj || params.card);
                    // A wrapper action with no object of its own (gain_top hands the card to gain_card,
                    // which checks reactions itself) leaves [null] here: nothing to match
                    if(Array.isArray(obj)){
                        obj = obj.filter(c => c !== null && c !== undefined);
                        if(obj.length == 0) continue;
                    }
                    //console.log('checking with', params, obj, condition)
                    let check = await resolveFilters(p, o, {...condition, card}, possArray(obj).map(o => typeof o == 'number' ? getCard(o) : o), type, owner);
                    if(check.length == 0) continue; // doesn't match it 
                    if(condition.with){
                        if(condition.with.types){
                            if(typeof obj == 'number'){
                                let c = getCard(obj);
                                //if(!matches(c, condition.with.types)) obj = [];
                                let cond = checkConditionalMatch(c, condition.with.types);
                                if(cond.WCMatches && !cond.noWCmatches){ // only if need be
                                    conditionalMatches = true;
                                }else if(!cond.noWCmatches && !cond.WCMatches){
                                    obj = [];
                                }
                            }else if(Array.isArray(obj)){
                                obj = obj.filter(c => matches(c, condition.with.types));
                                let condObj = obj.filter(c => matches(c, condition.with.types, false, false));
                                if(condObj.length == 0) conditionalMatches = true;
                            }
                            if(obj.length == 0) return false; // No matches - !! why was this wrong before? Just unchecked?
                        }
                    }
                    if(o.card == 'card'){
                        if(typeof obj == 'number'){
                            matched = true; // !! TODO at the moment it doesn't handle 
                        }else if(Array.isArray(obj) && obj.every(o => typeof o == 'number')){
                            matched = true;
                        }else if(Array.isArray(obj)){
                            for(let o of obj){
                                if(typeof o == 'number'){
                                    matched = true;
                                    break;
                                }
                                if(o.type && (o.type == 'tokens' || o.type == 'track')) continue; // false
                                if(typeOfGain(o) == 'card') matched = true;
                            }
                        }else if(!Array.isArray(obj) && typeOfGain(obj) == 'card'){
                            matched = true;
                        }else if(Array.isArray(obj) && obj.every(o => typeOfGain(o) == 'card')){
                            matched = true;
                        }
                    }else if(o.card == 'cards'){ // TODO check that this works (hypothetical at present)
                        let num = 0;
                        if(typeof obj == 'number') num = 1;
                        if(Array.isArray(obj) && obj.every(o => typeof o == 'number')) num = obj.length;
                        if(!Array.isArray(obj) && typeOfGain(obj) == 'card') num = 1;
                        if(Array.isArray(obj) && obj.every(o => typeOfGain(o) == 'card')) num = obj.length;
                        if(num && testNum(o.num, num)) matched = true;
                    }else if(o.card == 'this card' || o.card == 'this ship'){
                        if(typeof obj == 'number' && obj == card.uniqueID) matched = true;
                        if(Array.isArray(obj) && obj.includes(card.uniqueID)) matched = true;
                        // TODO handle non-number cards
                    }else if(o.card == 'development' || o.card == 'reserve'){
                        for(let c of possArray(obj)){
                            if(typeof c == 'number') c = getCard(c);
                            if(c){
                                let info = get(state).cardLog[c.uniqueID];
                                if(info.deck == 'dev' && o.card == 'development' || info.deck == 'reserve' && o.card == 'reserve'){
                                    matched = true;
                                    break;
                                }
                            }
                        }
                    }else if(o.card.card){
                        if(typeof obj == 'number' && matches(getCard(obj), o.card.card)) matched = true;
                        if(Array.isArray(obj)){
                            for(let el of obj){
                                if(typeof el == 'number' && matches(getCard(el), o.card.card)){
                                    matched = true;
                                    break; // Only one has to match
                                }
                            }
                        }
                    }else if(o.card.place){
                        let resP = p;
                        if(o.card.owner) resP = resolveOwner(card, o.card.owner);
                        let place = resolvePlace(resP, o.card.place, type);
                        matched = false;
                        for(let o of possArray(obj)){
                            if(typeof o == 'number'){
                                if(place.some(c => c.uniqueID == o)){
                                    matched = true;
                                    break;
                                }
                            }    
                        }
                    }else if(typeof obj == 'number' || Array.isArray(obj) && obj.length > 0 && obj.every(o => typeof o == 'number')){
                        if(o.num == 1) matched = true;
                        if(obj.length >= o.num) matched = true;
                        if(o.num.min && obj.length >= o.num.min) matched = true;
                        if(o.num.max && obj.length <= o.num.max) matched = true;
                    }else if(obj.num){
                        let n = obj.num;
                        if(!typeof n == 'number'){
                            if(n == 'all' || n == 'any'){
                                n = 1;
                            }else if(n.min){
                                n = n.min;
                            }else if(n.max){
                                n = n.max;
                            }else{
                                n = 0;
                            }
                        }
                        if(o.num.min && n >= o.num.min) matched = true;
                        if(o.num.max && n <= o.num.max) matched = true;
                    }
                }else if(o.exclude){
                    // Added April 2025 to handle the construction 'putting a non-[[crossover]] into play' for Boimler
                    // i.e. no main type, just an exclusion type
                    matched = true;
                }
                // Handle filter for 'X that has Y'
                if(matched && o.filter){
                    let checkObj = params.obj || params.card;
                    if(typeof checkObj == 'number'){
                        if(!testFilterTypes(getCard(checkObj), o.filter)) matched = false;
                    }else if(Array.isArray(checkObj) && checkObj.every(o => typeof o == 'number')){
                        if(!checkObj.some(c => testFilterTypes(getCard(c), o.filter))) matched = false;
                    }
                }

                // Handle exclusions
                if(matched && o.exclude){
                    // April: maybe add resolveExclude
                    let checkObj = params.obj || params.card;
                    if(typeof checkObj == 'number'){
                        if(matches(getCard(checkObj), o.exclude)){
                            if(!matches(getCard(checkObj), o.exclude, false, false)){
                                conditionalMatches = true;
                            }else{
                                matched = false;
                            }
                        }
                    }else if(Array.isArray(checkObj) && checkObj.every(o => typeof o == 'number')){
                        if(checkObj.every(co => matches(getCard(co), o.exclude))){
                            if(!checkObj.every(co => matches(getCard(co), o.exclude, false, false))){
                                conditionalMatches = true;
                            }else{
                                matched = false;
                            }
                        }
                    }
                }
                if(matched && timing == 'before'){
                    // Prelog the object for effects
                    state.update(s => {
                        if(!s.cache.reactionObj) s.cache.reactionObj = [];
                        s.cache.reactionObj.push(params.obj || params.card);
                        return s;
                    })
                }
            }
        }

        if(condition.to){
            matched = false;
            if(params.to){
                let t = possArray(params.to);
                //t = await resolveFilters(p, condition.to, {...condition, card}, t.filter(c => c).map(c => getCard(c)), type, owner);             
                for(let to of t){
                    if(typeof to == 'number' && getCard(to)){
                        let filtered = await resolveFilters(p, condition.to, {...condition, card}, [getCard(to)], type, owner);
                        if(filtered.length == 0) continue;
                    }
                    if(condition.to.card){
                        // For now just for Serene Squall: where card was gained to
                        if(to.place && to.place == condition.to.card.place && to.placement == condition.to.card.placement) matched = true;
                        if(condition.to.card.card && typeof to == 'number' && getCard(to) && matches(getCard(to), condition.to.card.card)) matched = true;
                        
                    }
                    if(condition.to.types){
                        // Checking where things are beamed, for TosKirk support effects
                        if(typeof to == 'number' && getCard(to) && matches(getCard(to), condition.to.types)){
                            matched = true;
                            if(!matches(getCard(to), condition.to.types, false, false)) conditionalMatches = true;
                        }
                        if(to.types && inPossArray(to.types, condition.to.types)) matched = true;
                    }
                }
                
            }  
        }
        //console.log('checking '+card.name, condition, params, type, verbs, condition.obj, params.obj, matched);
        if(!matched) continue; // return false;
        results.push(conditionalMatches ? 'conditional' : 'unconditional');
        
    }
    if(results.length == 0) return false;

    if(effect.max_per_op){
        // if it's already happened once, then not again!
        if(get(state).cache.reactionsTriggered && get(state).cache.reactionsTriggered[`${card.uniqueID}-${params.card}`] >= effect.max_per_op) return false;
    }

    // Do I need to handle 'and' here?

    if(results.some(r => r == 'unconditional')){
        if(addDueToCache){
            // push params.card to reactionObj for later backreferences
            addCardsToCache([getCard(params.card)], 'trigger');
            state.update(s => {
                if(!s.cache.reactionObj) s.cache.reactionObj = [];
                s.cache.reactionObj = [params.card, ...s.cache.reactionObj];
                return s;
            })
        }
        if(effect.max_per_op){
            state.update(s => {
                if(!s.cache.reactionsTriggered) s.cache.reactionsTriggered = {};
                if(!s.cache.reactionsTriggered[`${card.uniqueID}-${params.card}`]) s.cache.reactionsTriggered[`${card.uniqueID}-${params.card}`] = 0;
                s.cache.reactionsTriggered[`${card.uniqueID}-${params.card}`]++;
                return s;
            })
        }
        return true;
    }

    // Only a wild card match: wild cards only count for the active player's own effects,
    // so an opponent's card can't be triggered by them (e.g. Ro Laren vs your [[wildcard]])
    if(get(state).players[get(state).activePlayer].captain != owner.captain) return false;

    let choiceText = `${effect.text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${effect.text}</div>` : ''}Commit a wild card and trigger this ${upperInitial(params.parentType)} effect?`;
    return {
        text: choiceText,
        func: () => {
            if(addDueToCache){
                // push params.card to cache for later backreferences
                addCardsToCache([getCard(params.card)], 'trigger');
                state.update(s => {
                    if(!s.cache.reactionObj) s.cache.reactionObj = [];
                    s.cache.reactionObj = [params.card, ...s.cache.reactionObj];
                    return s;
                })
            }
            if(effect.max_per_op){
                state.update(s => {
                    if(!s.cache.reactionsTriggered) s.cache.reactionsTriggered = {};
                    if(!s.cache.reactionsTriggered[`${card.uniqueID}-${params.card}`]) s.cache.reactionsTriggered[`${card.uniqueID}-${params.card}`] = 0;
                    s.cache.reactionsTriggered[`${card.uniqueID}-${params.card}`]++;
                    //s.cache.reactionsTriggered[`${card.uniqueID}-${params.card}`] = true;
                    return s;
                })
            }
        }
    }

    /*
    let doIt;
    // Load from cache if already selected
    if(get(state).cache && get(state).cache.hasOwnProperty(`${effect.text || ''}.${card.uniqueID}.${timing}.${type}.${params.text || ''}`)){
        doIt = get(state).cache[`${effect.text || ''}.${card.uniqueID}.${timing}.${type}.${params.text || ''}`];
    }else{
        doIt = await choose(`${effect.text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${effect.text}</div>` : ''}You need to commit a wild trait for this effect to trigger. Do you want to?`, ['Yes', 'No']);
        cacheItem(`${effect.text || ''}.${card.uniqueID}.${timing}.${type}.${params.text || ''}`, doIt)
    }
    if(doIt == 'Yes'){
        
        if(addDueToCache){
            // push params.card to cache for later backreferences
            addCardsToCache([getCard(params.card)], 'trigger');
            state.update(s => {
                if(!s.cache.reactionObj) s.cache.reactionObj = [];
                s.cache.reactionObj = [params.card, ...s.cache.reactionObj];
                return s;
            })
        }
        return true;
    }*/
            
}

function inPossArray(arr, e){
    return (arr == e || Array.isArray(arr) && arr.some(a => a == e) || Array.isArray(e) && e.some(el => inPossArray(arr, el)));
}

export function cardOwner(c){
    // One store read, not eleven: called once per ongoingEffects (~500k a game), and
    // svelte's get() subscribes and unsubscribes rather than reading a property.
    let s = get(state);
    if(!c) return s.players[s.activePlayer]; // Should almost never happen, but may with destroyed cards
    if(s.resolvingFrom && c.uniqueID == s.resolvingFrom && s.resolvingTo){
        //console.log(`resolving from ${s.resolvingFrom}, to ${s.resolvingTo}`);
        if(s.resolvingFrom != s.resolvingTo) return cardOwner(getCard(s.resolvingTo))
        //if(s.resolvingAs) return s.players[s.resolvingAs]; // you count as owning this
    }
    let info = s.cardLog[c.uniqueID];
    if(!info) return s.players[s.activePlayer];
    if(info.area == 'commons') return s.players[s.activePlayer];
    if(info.area == 'players') return s.players[info.player];
    if(info.area == 'player_dashboards') return s.players[info.player];
    if(info.area == 'beamed'){
        let card = getCard(info.deck);
        if(card) return cardOwner(card);
    }
    return s.players[s.activePlayer];
}

// Held so a skipped prompt can't move the turn on before the action resolves
export function autoActionButton(card){
    return withTurnHeld(() => autoActionButtonNow(card));
}

async function autoActionButtonNow(card){
    let backup = backupChoice();
    pushChoice({
        autoActionButton: card.uniqueID,
        //cn: get(ui).waiting.length > 0 ? get(ui).waiting[0].choiceNum : 0,
    });
    while(await skipIfCan());
    clearSelection();
    // TODO !!! add undo save here
    //console.log(card, hint)
    let p = get(state).players[get(ui).seat]; // in this case this is what we want...
    let hint = getHints(card).filter(h => meetsThreshold(p, h) && validEffect(card, h, p));
    if(hint.length == 0) return false;
    let action = hint[0].action;
    if(action == 'freeplay') action = 'play'; // So it doesn't auto-freeplay?
    if(ongoingEffects(card).includes('cannot_'+action)) cancel(card, 'Cannot do that action to this card!');
    
    let result = await doAction(p, action, {card: card.uniqueID, attack: hint[0].attack});
    console.log('auto action completed: result', result)
    if(result == 'cancelled'){
        restoreChoice(backup);
        updateState();
    }
    
}

export async function canAfford(p, e, card){
    if(!e) return true;
    if(Array.isArray(e)){
        return await canAfford(p, e[0], card); // Just first element
    }
    if(e.type != 'cost') return true; //  isPossible(p, e, card)//true; // need to fix checks in text first
    return(await canPay(p, e.cost, 'testing affordability'));
}

export async function filterToPossible(p, effects, card){
    let ret = [];
    for(let e of possArray(effects)){
        let ok = await canAfford(p, e, card);
        if(ok){
            try{
                ok = await isPossible(p, e, card);
            }catch(err){
                console.log('possibility check failed, assuming possible', err);
                ok = true;
            }
        }
        if(ok) ret = [...ret, e];
    }
    return ret;
}

export async function allArePossible(p, effects, card){

    for(let e of possArray(effects)){
        if(!await canAfford(p, e, card)) return false;
        if(!await isPossible(p, e, card)) return false;
    }
    return true;
}

export async function isPossible(p, e, card){
    if(Array.isArray(e)) return await allArePossible(p, e, card);
    /*if(e.verb == 'dismiss' && e.obj && e.obj.card && e.obj.card.place == 'duty' && ['they', 'opponent'].includes(e.obj.card.owner)){
        return p.decks.duty.length > 0;
    }
    if(['dismiss', 'recall'].includes(e.verb) || e.verb == 'log' && e.from && e.from.place == 'play'){
        let cards = allScoreableCards(p).filter(c => inPlay(c));
        let length = cards.length
        if(e.obj && e.obj.types){
            length = cards.filter(c => matches(c, e.obj.types)).length;
        }
        return length > (e.obj.num || e.num || 1);
    }*/
   // Below would be great if I could remove the checks via justAssess!
    if(e.obj){
        if(!JSON.stringify(e.obj).includes('prev_obj') ){
            let params = {...e};
            params.card = card ? card.id : currentCard() || false; // for autoCardActions etc.
            let obj = await resolveObject(e.obj, e.verb, params, p, null, true);
            if(!obj || obj.filter(o => o).length == 0) return false; // Nothing there to go for
        }
    }

    return true;
}

function hasCancelEffect(e){
    if(!e) return false;
    if(Array.isArray(e)){
        return e.some(f => hasCancelEffect(f));
    }
    if(e.replace && (!e.actor || e.actor == 'you')) return true;
    return false;
}

export function addOpReplacement(p, card, name, type = 'play'){
    let added = [];
    if(ongoingPlayer(p).includes('replace_op')){
        let poss = cardsInPlay(p, false, true).flatMap(c => ongoingEffects(c, 'replace_op'));
        for(let r of poss){
            if(!r.op.includes(type) && !type.includes(r.op)) continue; // only matching ops
            if(matches(card, r.type)){
                let newHint = {};
                let parsed = pegParse(r.effect, {botCard: card.botCard, stardate: card.stardate});
                if(!parsed.effects || parsed.effects.length == 0){
                    console.log(`Unable to parse suggested replacement text! You'll have to do it manually...`);
                    continue;
                }
                let a =  parsed.effects[0];
                newHint = {
                    effects: a.effect,
                    name,
                    text: a.text,
                    //action: type,
                    attack: a.attack,
                    list: a.effect.map(e => hn(e)).join(', '),
                    actionCost: a.actionCost,
                    droneCost: a.droneCost

                }
                if(Object.values(verbKeys).includes(a.type)){
                    let v = Object.values(verbKeys).find(v => v == a.type);
                    newHint.action = Object.keys(verbKeys).find(k => verbKeys[k] == v);
                }else{
                    console.log('Replacement play effect type not found for card '+card.name+'!', parsed);
                    alert('Replacement play effect type not found!')
                    continue;
                }
                added.push(newHint);
            }
        }
    }
    return added;
}

/*export async function checkPlayReplacement(p, card, hint){
    if(ongoingPlayer(p).includes('replace_play')){
        let poss = cardsInPlay(p).flatMap(c => ongoingEffects(c, 'replace_play'));
        for(let r of poss){
            if(matches(card, r.type)){
                let replace = await choose(`You may replace ${cc(card.uniqueID)}'s play effect with "${r.effect}". Do you want to?`, ['Yes', 'No']);
                if(replace == 'Yes'){
                    let parsed = pegParse(r.effect);
                    if(parsed.effects && parsed.effects[0] && parsed.effects[0].type == 'action'){
                        hint.action = 'play';
                    }else if(parsed.effects && parsed.effects[0] && parsed.effects[0].type == 'free action'){
                        hint.action = 'freeplay';
                    }else{
                        await pause(`Type of replacement action not recognised: action costs may be incorrect!`)
                    }
                    if(parsed.effects){
                        hint.effects = parsed.effects.map(e => e.effect);
                    }else{
                        await info(`Unable to parse replacement text! You'll have to do it manually...`);
                    }
                    return true;
                }
            }
        }
    }
}
*/
export async function autoCardActions(card, hint, paidActions = false, resolving = false){

    clearSelection();
    //console.log(card, hint)
    let p = cardOwner(card);//get(state).players[get(ui).seat];

    if(!hint){
        hint = getHints(card, false, paidActions);
        console.log(card, hint, paidActions)
        if(!hint){
            if(paidActions){
                await moveTo(card, `players.play.${get(ui).seat}`, -1);
                await doAction(p, `put_in_staging`, {obj: card.uniqueID}); // just to trigger specific reactions
            }
            await info(`No valid parsed text: complete the actions on ${cc(card.uniqueID)} manually then press OK`, {forceView: true});
            return;
        }
        hint = hint.filter(h => meetsThreshold(p, h) && validEffect(card, h, p) && !h.error)
    }

    if(ongoingPlayer(p).includes('freeplay_cards') && ongoingPlayer(p, 'freeplay_cards').some(t => matches(card, t))){
        // All actions on this card are free!
        paidActions = true;
        hint = hint.map(h => {
            return {
                ...h,
                actionCost: false
            }
        })
    }

    if(p.actions == 0 && (!p.whim || !ongoingPlayer(p).includes('whim_action')) && !paidActions){
        //hint = hint.filter(h => h.action != 'play');
        hint = hint.filter(h => !h.actionCost); // for activations too
    }

    if(numExpendableDrones(p) == 0 && !paidActions){
        hint = hint.filter(h => !h.droneCost);
    }

    if(ongoingEffects(card, 'play_limit').some(l => l.type == 'unplayable')){
        hint = hint.filter(h => h.action != 'play' && h.action != 'freeplay')
        //cardMessage(card, `Cannot play card`);
        //return;
    }

    if(ongoingPlayer(p).includes('verb_restrictions')){
        let restrictions = ongoingPlayer(p, 'verb_restrictions');
        for(let r of restrictions){
            if(r.verbs.includes('play') && matches(card, r.types)) hint = hint.filter(h => h.action != 'play' && h.action != 'freeplay');
        }
    }
    /*if(card.suits.includes('incident') && ongoingPlayer(get(state).players[get(state).currentPlayer]).includes('no_incident_return')){
        cardMessage(card, `Ongoing effect: cannot return incidents!`);
    }*/
    if(ongoingEffects(card, 'play_limit').some(l => l.type == 'needs_ownership')){
        if(!checkOwnership(p, card, ongoingEffects(card, 'play_limit').find(l => l.type == 'needs_ownership'))){
            hint = hint.filter(h => h.action != 'play' && h.action != 'freeplay')
            //cardMessage(card, `Cannot play card: play condition not met`);
            //return;
        }
    }

    if(hint.length == 0){
        cardMessage(card, `No valid effects on card`);
        return;
    }


    if(!matches(card, 'location') && hint.every(h => h.name.toLowerCase().endsWith('play')) && !resolving){
        await moveTo(card, `players.play.${get(ui).seat}`, -1);
        await doAction(p, `put_in_staging`, {obj: card.uniqueID}); // just to trigger specific reactions
    }

    cacheItem('cardID', card.uniqueID);

    if(hint.length == 1){
        hint = hint[0];
    }else if(hint.length > 0){
        let choices = [];
        for(let h of hint){
            choices.push(`${await canAfford(p, h.effects, card) ? '' : '!'}${h.text}`);
        }
        if(get(state).avoidNextChoice){
            for(let i = 0; i < choices.length; i++){
                let s = choices[i];
                if(choices[i].startsWith('!')) s = choices[i].slice(1);
                let saveS = s;
                if(get(state).avoidNextChoice.includes(s)){
                    s = '!'+s;
                    choices[i] = s;
                    /*state.update(st => {
                        st.avoidNextChoice = st.avoidNextChoice.filter(ch => ch != saveS);
                        if(st.avoidNextChoice.length == 0) delete st.avoidNextChoice;
                        return st;
                    })*/
                }
            }
        }
        if(card.name == 'Utilize' && ongoingPlayer(p).includes('double_utilize') && p.actions >= 2){
            choices.push('Do both (spending an [[action]] for each)');
        }
        if(get(state).canStopActionChoices){
            choices.push('Finish choosing');
        }
        let choice = await choose(`Which action to take?`, choices, {cancellable: true});
        if(choice == 'Finish choosing') return 'stop';
        if(!choice || choice == 'cancelled') throw 'cancelled';
        if(!card.chosenOptions) card.chosenOptions = {};
        if(!card.chosenOptions[choice]) card.chosenOptions[choice] = 0;
        state.update(s => {
            s.lastChoice = choice;
            return s;
        })
        if(choice == 'Do both (spending an [[action]] for each)'){
            // TODO rather messy doing this all here...
            p.actions -= 2;
            if(get(state).cardLog[card.uniqueID].deck != 'play'){
                await moveTo(card, `players.play.${get(ui).seat}`, -1);
                await doAction(p, `put_in_staging`, {obj: card.uniqueID}); // just to trigger specific reactions
            }
            for(let h of hint){
                console.log('resetting cache')
                state.update(s => {
                    s.cache = {
                        allPrev: [],
                    };
                    return s;
                })
            let frame = pushFrame({unit: unitOfEffects(h.effects), card: (resolving || card).uniqueID, target: get(state).resolvingFrom});
            try{
                    await resolveEffects(resolving || card, h.effects, h.attack);
            } catch(e){
                    if(e == 'cancelled' || e == 'continue_resolution') throw e;
                    console.log(e)
                    await choose(`Oops! Card effect failed with error: ${e}. Complete card actions manually.`, ['OK'], {forceChoose: true});
                    if(get(res).BvB) oneOffMessage(p, `Card effect failed with error: ${e}.`, alert);
                }finally{
                    popFrame(frame);
                }
            }
            if(get(ui).viewing != getPlayerIndex(p)) await changeView(getPlayerIndex(p));

            if(get(prefs).pauseAtEnd){
                await choose('Card actions completed: press to continue', ['OK'], {forceChoose: true});
            }else{
                await doActionPause(); // An extra one at the end
            }
            clearSelection();
            return;
        }
        let i = -1;
        let runningIndex = 0;
        for(let h of hint){
            if(choice == `${await canAfford(p, h.effects, card) ? '' : '!'}${h.text}`){
                i = runningIndex;
                break;
            }
            runningIndex++;
        }
        hint = hint[i];
        card.chosenOptions[choice]++;
    }else{
        hint = {};
    }
    
    if((hint.name == 'Play' || hint.name == 'Free play') && !resolving){
        // Feb 2026: removed !matches(c, 'location') because 
        // play effects on locations should also move them to staging
        if(get(state).cardLog[card.uniqueID].deck != 'play'){
            await moveTo(card, `players.play.${get(ui).seat}`, -1);
            await doAction(p, `put_in_staging`, {obj: card.uniqueID}); // just to trigger specific reactions
        }
    }
    let actionCost = false;
    let droneCost = false;

    /*if(hint.action == 'play' || hint.action == 'freeplay'){
        if(!replaced) replaced = await checkPlayReplacement(p, card, hint);
        if(ongoingPlayer(p).includes('replace_play')){
            let poss = cardsInPlay(p).flatMap(c => ongoingEffects(c, 'replace_play'));
            for(let r of poss){
                if(matches(card, r.type)){
                    let replace = await choose(`You may replace ${cc(card.uniqueID)}'s play effect with "${r.effect}". Do you want to?`, ['Yes', 'No']);
                    if(replace == 'Yes'){
                        let parsed = pegParse(r.effect);
                        if(parsed.effects && parsed.effects[0] && parsed.effects[0].type == 'action'){
                            hint.action = 'play';
                        }else if(parsed.effects && parsed.effects[0] && parsed.effects[0].type == 'free action'){
                            hint.action = 'freeplay';
                        }else{
                            await pause(`Type of replacement action not recognised: action costs may be incorrect!`)
                        }
                        if(parsed.effects){
                            hint.effects = parsed.effects.map(e => e.effect);
                        }else{
                            await info(`Unable to parse replacement text! You'll have to do it manually...`);
                        }
                    }
                }
            }
        }
    }*/

    if(hint.actionCost && !paidActions){
        console.log('spending action on '+card.name);
        actionCost = true;
        await doAction(p, 'spend', {obj: {num: 1, type: 'tokens', specific: 'action'}}); // So reactions trigger!
        //p.actions--;
        delete p.firstAction; // Specifically for 'as your first action of turn' effects
    }

    if(hint.droneCost && !paidActions){
        console.log('expending '+hint.droneCost+' drone(s) on '+card.name);
        droneCost = hint.droneCost;
        await doAction(p, 'expend', {obj: {num: hint.droneCost}});
        delete p.firstAction; // Specifically for 'as your first action of turn' effects
    }

    /*if(hint.action == 'activate' && hint.actionCost && !paidActions){
        // TODO note: really ought to be for all effects, but just for now to avoid compatibility issue with actions
        console.log('spending action on '+card.name);
        actionCost = true;
        p.actions--;
        delete p.firstAction; // Specifically for 'as your first action of turn' effects
    }*/

    //console.log(hint)
    let effects = hint.effects;
    //console.log(hint, hint.effects, effects)

    

    if(!effects){
        await choose(`No valid actions found: complete any manual actions on ${cc(card.uniqueID)} then press OK`,['OK'], {forceChoose: true});
        return;
    }

    let savedCache;
    

    if(get(state).cache && resolving){ // Specifically only for resolving cards, I think
        console.log('Cloning cache');
        // !! NB alternative would be to leave cache unless it was empty before (and if so, wipe it). 
        // This would allow inner cards in a referential nest to be referred to by outer cards (e.g. if this action caused you to discard a card...) but could get quite messy
        savedCache = clone(get(state).cache);
    }
    
    console.log('resetting cache')
    state.update(s => {
        s.cache = {
            allPrev: [],
            actionCost,
            droneCost
        };
        return s;
    })
    
    // TODO: resolveEffects here instead

    if(ongoingPlayer(p).includes('no_attack') && card.traits && card.traits.includes('attack')){
        cancel(card, `No attacks allowed!`);
    }

    if(hint.attack && get(prefs).cancelWholeAttacks){
        // TODO the non-attack parts of the effect should still go through... how to do this?
        await checkForReactions(p, 'attack', {card: card.uniqueID, attacker: p.captain}, 'before');
        if(get(state).cache && get(state).cache.replacedOriginal && get(state).cache.replacedOriginal != card.uniqueID){
            state.update(s => {
                s.cache.replacedOriginal = false;
                return s;
            })
            return;
        }
    }

    // One frame per compilation unit in flight (docs/prev-obj-static-binding-plan.md §3.4).
    // `card` owns the effects being resolved even when `resolving` is the card copying them,
    // so the unit comes from the tree itself and `self` from the card the text is printed on.
    let frame = pushFrame({unit: unitOfEffects(effects), card: (resolving || card).uniqueID, target: get(state).resolvingFrom});
    try{
        if(p.bot){
            await resolveEffects(resolving || card, effects, hint.attack, false, 'bot');
        }else{
            await resolveEffects(resolving || card, effects, hint.attack);
        }
        
    }catch(e){
        if(e == 'cancelled' || e == 'continue_resolution') throw e;
        console.log(e)
        await choose(`Oops! Card effect failed with error: ${e}. Complete card actions manually then press OK.`, ['OK'], {forceChoose: true});
    }finally{
        popFrame(frame);
    }

    if(hint.attack){
        await checkForReactions(p, 'attack', {attacker: p.captain}, 'after');
    }

    if(get(ui).viewing != getPlayerIndex(p)) changeView(getPlayerIndex(p));

    if(savedCache){
        console.log('Restoring cache');
        state.update(s => {
            s.cache = savedCache;
            return s;
        })
    }

    if(get(prefs).pauseAtEnd){
        await choose('Card actions completed: press to continue', ['OK'], {forceChoose: true});
    }else{
        await doActionPause(); // An extra one at the end
    }
    

    clearSelection();
    return;

}

export function logDid(card, did, overrideKey){
    if(card && typeof card != 'number') card = card.uniqueID;
    if(!card && currentCard()) card = currentCard();
    state.update(s => {
        if(!s.cache) s.cache = {};
        if(!s.cache.did) s.cache.did = {};
        if(!s.cache.did[card]) s.cache.did[card] = [];
        if(s.cache[overrideKey]){
            delete s.cache[overrideKey];
        }else{
            if(!s.cache.did_previous) s.cache.did_previous = {};
            s.cache.did_previous[card] = did;
        }
        
        s.cache.did[card] = [...s.cache.did[card], did];
        return s;
    })
    console.log('logDid', get(state).cache)
}

export function cacheItem(key, val, stackPrevious = true){
    state.update(s => {
        if(!s.cache) s.cache = {};
        if(s.cache[key] && stackPrevious){
            // push into saved caches
            // NB this will not save between cache refreshes, so it won't transfer between separate card actions
            // But I think that's to be desired to avoid cruft
            // the function stack handles saving of caches for duplicate and similar effects
            if(!s.cache.saved) s.cache.saved = {};
            if(!s.cache.saved[key]) s.cache.saved[key] = [];
            s.cache.saved[key] = [s.cache[key], ...s.cache.saved[key]];
        }
        s.cache[key] = val;
        return s;
    })
    console.log('cached item', key, get(state).cache[key])
}

export function clearCacheItem(key, restorePrevious = true){
    state.update(s => {
        if(s.cache){
            delete s.cache[key];
            if(s.cache.saved && s.cache.saved[key]){
                s.cache[key] = s.cache.saved[key][0];
                s.cache.saved[key] = s.cache.saved[key].slice(1);
            }
        }
        return s;
    })
    console.log('cleared cached item', key);
}

// Game-relevant state only: bookkeeping (cache, logs, RNG) changes even when an action does nothing
function gameFingerprint(){
    let {cache, log, workingLog, cardLog, subLog, replaceLog, random, playerMessage, payingCost, choices, ...game} = get(state);
    return JSON.stringify(game);
}

async function singleAction(card, a, attack, forced = false){
    console.log('single action', a)
    //cacheItem('cardID', card.uniqueID);
    if(!a.verb) return;
    let verb = a.verb;
    // 'If able to do both': any part not happening, for whatever reason, fails the whole thing
    let strict = card && get(state).cache.throwUncompleted == card.uniqueID;
    let before = strict && gameFingerprint();
    if(a.optional == true /*&& !forced*/){ // Removed forced check so Species 8472 works ('force X, you may Y'). Otherwise can do based on card owner check
        if(a.extraVerbs){
            let choices = [a.verb, ...a.extraVerbs.map(v => v.verb)];
            let chosen = await choose(`${upperInitial(a.text) || 'You may '+choices.join(' or ')}. What would you like to do?`, [...choices, 'Do nothing']);
            if(chosen == 'Do nothing'){
                if(strict) throw 'uncompleted';
                logDid(card, false)
                return; // Give up!
            }//else 
            verb = chosen;
            logDid(card, true, 'uncompleted')
        }else{
            let chosen = await choose(`${upperInitial(a.text) || 'You may '+a.verb}. Proceed?`, ['Yes', 'No']);
            if(chosen == 'No'){
                if(strict) throw 'uncompleted';
                logDid(card, false)
                return; // Give up!
            }//else 
            logDid(card, true, 'uncompleted')
        }
    }else if(a.extraVerbs){
        //else if for 'opponent' and 'anyone' or whatever it is worded as now
        // Give them a choice
        let choices = [a.verb, ...a.extraVerbs.map(v => v.verb)];
        let chosen = await choose(`${upperInitial(a.text) || 'You must '+choices.join(' or ')}. Which would you like to do?`, [...choices]);
        if(!chosen || chosen == 'cancelled') throw 'cancelled';
        verb = chosen;
    }
    await parsedAction(verb, {...a, verb, card: card ? card.uniqueID : null, ...a.params, attack, forcedEffect: forced || a.forced}); // TODO needs rationalising... put everything in params, or not?   
    if(strict && (get(state).cache.cancelled || gameFingerprint() == before)) throw 'uncompleted';
    logDid(card, !get(state).cache.cancelled)
    //clearCacheItem('cardID');
    clearCacheItem('cancelled');
    await doActionPause();
}

export function joinText(c){
    if(Array.isArray(c)) return c.map(c => joinText(c)).filter(c => c).join(' and ');
    
    return c.text;
}

function abbrevTrack(t){
    return get(res).trackTypes.find(tr => tr.startsWith(t));
}

export function testNum(test, realNum){
    // !!!TODO handle all/any better!
    //if(test == 'any' || test == 'all') return true;
    //if(realNum === undefined) return false; // Never 
    if(test == 'any'){
        if(realNum >= 1) return true;
        return false;
    }
    if(test == 'all'){
        if(realNum >= 1) return true;
        return false;
    }
    if(test == 'none'){
        if(realNum == 0) return true;
        return false;
    }
    if(typeof test == 'number'){
        if(test == 0){
            return realNum == test; // Why specify 0 if you don't want it to be exact??
        }else{
            return realNum >= test; // TODO presumption is that having more than the test number satisfies condition. Is this always ok?
        }
    }else if(!test){
        // null/undefined, so presume it's 1
        return realNum >= 1;
    }
    if(test.hasOwnProperty('exactly')) return realNum == test.exactly;
    if(test.hasOwnProperty('min')) return realNum >= test.min;
    if(test.hasOwnProperty('max')) return realNum <= test.max;
    return realNum == test;
}

function resolveComparison(count1, count2, comp){
    if(count1 > count2 && comp.includes('more')) return true;
    if(count1 == count2 && comp.includes('equal')) return true;
    if(count1 < count2 && (comp.includes('less') || comp.includes('fewer'))) return true;
    return false;
}

export function addCardsToCache(cards, verb = false, otherParams = {}){
    if(!cards) return;
    if(!Array.isArray(cards)) cards = [cards];
    
    state.update(s => {
        s.cache.prev_obj = cards.map(c => typeof c == 'number' ? c : c.uniqueID);
        if(!s.cache.allPrev) s.cache.allPrev = [];
        if(!s.cache.interimPrev) s.cache.interimPrev = [];
        
        s.cache.allPrev = [s.cache.prev_obj, ...s.cache.allPrev];
        s.cache.interimPrev = [s.cache.prev_obj, ...s.cache.interimPrev].flat(2);
        if(verb){
            if(!s.cache.prevVerbs) s.cache.prevVerbs = [];
            s.cache.prevVerbs = [{verb, obj: s.cache.prev_obj, num: cards.length, ...otherParams}, ...s.cache.prevVerbs];
        }
        
        return s;
    });
}

function renderTypes(t){
    return possArray(t).map(o => `[[${o}]]`).join('/')
}

function enableWildChecks(){
    let prev;
    state.update(s => {
        prev = s.cache.checkWCs;
        s.cache.checkWCs = true;
        return s;
    })
    return prev;
}

export function shouldCheckWCs(){
    return get(state).cache && get(state).cache.checkWCs
}

export function cacheWC(c, trait){
    let wildcardTraits = possibleWildCards(trait);
    state.update(s => {
        let done = false;
        if(s.cache.cardWCs[c.uniqueID]){
            for(let i = 0; i < c.traits.length; i++){
                if(wildcardTraits.includes(c.traits[i]) && !s.cache.cardWCs[c.uniqueID][i]){
                    s.cache.cardWCs[c.uniqueID].push(trait);
                    done = true;
                }else if(c.traits[i].startsWith('any species') && c.traits[i].includes('!') &&  !s.cache.cardWCs[c.uniqueID][i]){
                    let except = c.traits[i].split('!')[1];
                    if(trait != except){
                        s.cache.cardWCs[c.uniqueID].push(trait);
                        done = true;
                    }
                }
            }
            if(!done) throw 'should not be possible to cache empty wildcard';
        }else{
            s.cache.cardWCs[c.uniqueID] = [];
            s.cache.cardWCs[c.uniqueID].push(trait);
        }
        return s;
    })
    console.log('WCs', get(state).cardWCs);
}

export function currentTraits(c){
    let traits = [...c.traits];
    if(get(state).cache && get(state).cache.cardWCs && get(state).cache.cardWCs[c.uniqueID]){
        let toAdd = [...get(state).cache.cardWCs[c.uniqueID]]
        for(let i = 0; i < c.traits.length; i++){
            if(toAdd.length == 0) break;
            if(['any species', 'wildcard'].includes(traits[i])){
                traits[i] = toAdd[0];
                toAdd = toAdd.slice(1);
            }else if(traits[i].startsWith('any species') && traits[i].includes('!')){
                let except = traits[i].split('!')[1];
                if(toAdd[0] != except){
                    traits[i] = toAdd[0];
                    toAdd = toAdd.slice(1);
                }
            }
        }
        console.log('altered traits', traits);
    }
    return traits;
}

function resetWildChecks(prev){
    state.update(s => {
        s.cache.checkWCs = prev;
        return s;
    })
}

function possID(card){
    if(typeof card == 'number') return card;
    if(card.uniqueID) return card.uniqueID;
    return undefined;
}

export async function resolveCondition(p, card, a, attack, forced = false){
    let should_do = false;
    state.update(s => {
        s.overrideDidPrevious = true;
        return s;
    }) // To allow conditions to fire
    if(a.condition == 'fail'){
        should_do = false; // For stopgaps e.g. non-borg
    }else if(a.condition == 'weekday'){
        let day = a.day;
        let weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        let dayIndex = weekdays.indexOf(day);
        if(new Date().getDay() == dayIndex) should_do = true;
    }else if(a.condition == 'during_step'){
        if(get(state).phase == a.step) should_do = true;
    }else if(a.condition == 'did_previous'){
        should_do = get(state).cache.did_previous ? get(state).cache.did_previous[card.uniqueID] : false;
        console.log('checking did_previous', should_do);
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'goal'){
        // Reuse goal assessment
        let cache = {
            wildcardsUsed: 0
        };
        let check = checkMissionHave(p, card, a.goal, a.goal.elements, cache);
        if(check.every(c => c.met)) should_do = true;
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'opp_away_removed'){
        let num = 0;
        for(let v of getPrevVerbs('remove_away')){
            let obj = v.obj;
            if(!Array.isArray(obj)) obj = [obj];
            obj = obj.filter(o => typeof o == 'number' && cardOwner(getCard(o)).captain != p.captain); // opponent places
            num += v.num * obj.length;
        }
        should_do = testNum(a.num, num);
    }else if(a.condition == 'negative_previous'){
        console.log('negative_previous', get(state).cache);
        
        if(a.otherwise){
            console.log('Checking for otherwise', get(state).cache)
            if(get(state).cache && get(state).cache.otherwise){
                // Then a previous otherwise has fired, so ignore this!
                logText('Otherwise not firing because previous otherwise in chain has already fired')
                should_do = false;
            }else{
                if(!get(state).cache || !get(state).cache.did_previous){
                    state.update(s => {
                        if(!s.cache) s.cache = {};
                        s.cache.did_previous = {};
                        return s;
                    })
                }
                if(!get(state).cache.didLastCost){
                    // If last cost was successful, this shouldn't trigger
                    should_do = !(get(state).cache.did_previous ? get(state).cache.did_previous[card.uniqueID] : false);
                    state.update(s => {
                        if(!s.cache) s.cache = {}; // Probably not necessary
                        s.cache.otherwise = [get(state).cache.did_previous ? get(state).cache.did_previous[card.uniqueID] : false]; //
                        return s;
                    })
                }
            }
        }else if(a.any_fail){
            // Looking for situation where any previous choice failed
            // For Soval attack row
            // NB in very long texts this could get confused with fails prior to current sentence
            // - if this comes up, add reset at appropriate point
            if(!get(state).cache || !get(state).cache.did || !get(state).cache.did[card.uniqueID]){
                state.update(s => {
                    if(!s.cache) s.cache = {};
                    if(!s.cache.did) s.cache.did = {};
                    s.cache.did[card.uniqueID] = [];
                    return s;
                })
                should_do = true; // because nothing happened at all!
            }else{
                should_do = get(state).cache.did[card.uniqueID].some(d => !d); // If any failed at all
            }

        }else{
            if(!get(state).cache || !get(state).cache.did_previous){
                state.update(s => {
                    if(!s.cache) s.cache = {};
                    s.cache.did_previous = {};
                    return s;
                })
            }
            should_do = !(get(state).cache.did_previous ? get(state).cache.did_previous[card.uniqueID] : false);
        }
    }else if(a.condition == 'no_conditions_met'){
        if(!get(state).cache.conditions_met){
            should_do = true; // Edge case – what if nothing?
        }else{
            console.log('Checking previous conditions', get(state).cache.conditions_met)
            should_do = !get(state).cache.conditions_met.some(c => c);
        }
    }else if(a.condition == 'action_cost'){
        console.log('Checking action cost: placeholder because it interrupts before', get(state).cache.actionCost)
        /*if(get(state).cache.actionCost){
            should_do = true;
        }*/
    }else if(a.condition == 'did_all'){
        console.log('did_all', get(state).cache.did, card);
        should_do = get(state).cache.did && get(state).cache.did[card.uniqueID] &&  get(state).cache.did[card.uniqueID].every(k => k);
    }else if(a.condition == 'place_empty'){
        let place = resolvePlace(p, a.place, 'check_empty', false);
        should_do = (place.length == 0);
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'away_team_removal_place'){
        let ar = get(state).cache.awayRemovedDetails;
        for(let r of ar || []){
            let c = getCard(r.card);
            if(matches(c, `${a.place} location`)) should_do = true;
        }
    }else if(a.condition == 'captain_is'){
        if(p.decks.captain.some(c => matches(c, a.captain_is))) should_do = true;
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'end_triggered'){
        should_do = (get(state).gameEndTurn != -1);
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'none_beamed_here'){
        addCardsToCache(card, 'none_beamed_here');
        should_do = !card.beamed || card.beamed.length == 0;
    }else if(a.condition == 'multiple_species'){
        should_do = matches(card, 'multiple_species')
        addCardsToCache(card, 'multiple_species');
    }else if(a.condition == 'beamed_here'){
        let matchedCards = [...card.beamed];
        if(a.types) matchedCards = matchedCards.filter(c => matches(c, a.types));
        let count = matchedCards.length;
        recordSlot(a.subjectSlot, {obj: matchedCards.map(c => possID(c))});
        addCardsToCache(matchedCards, 'beamed_count', {card: possID(card)});
        if(testNum(a.num, count)) should_do = true;
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'snw_trigger'){
        let s = get(state);
        should_do = true;
        if(a.away !== false){
            if(s.cache && s.cache.awayRemoved){
                should_do = testNum(a.away, s.cache.awayRemoved);
            }else{
                should_do = false;
            }
        }
        if(should_do && a.ship !== false){
            if(s.cache && s.cache.shipsDismissed){
                should_do = testNum(a.ship, s.cache.shipsDismissed);
            }else{
                should_do = false;
            }
        }
        
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'at_removal_count'){
        let owner = getPlayerIndex(resolveOwner(card, a.owner));
        should_do = false;
        if(get(state).cache && get(state).cache.awayRemovedDetails){
            let consolidated = get(state).cache.awayRemovedDetails.filter(ad => ad.owner == owner);
            console.log('at details', get(state).cache.awayRemovedDetails.map(d => getCard(d.card)))
            let total = consolidated.reduce((a,c) => a + c.num, 0);
            should_do = testNum(a.num, total);
        }
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'wearing_check'){
        let wearer = await resolveObject(a.wearer, 'type_match', {card: card.uniqueID}, p);
        for(let c of wearer){
            let beamed = getCard(c).beamed;
            if(!beamed) continue;
            addCardsToCache(beamed, 'wearing_check')
            if(a.helmet.types){
                if(beamed && beamed.some(c => matches(c, a.helmet.types))) should_do = true;
            }else if(a.helmet.card && a.helmet.card.card){
                if(beamed && beamed.some(c => matches(c, a.helmet.card.card))) should_do = true;
            }
        }
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'exhausted'){
        let obj = await resolveObject(a.obj, 'type_match', {card: card.uniqueID}, p);  
        if(obj.length > 0){
            should_do = true;
            addCardsToCache(obj, 'exhausted_check')
            for(let c of obj){
                c = getCard(c);
                if(c && !c.activated){
                    should_do = false;
                    break;
                }
            }
            
        }else{
            should_do = false;
        }
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'claimed_location'){
        if(get(state).phase == 'control'){
            let obj = await resolveObject(a.obj, 'type_match', {card: card.uniqueID}, p);
            for(let c of obj){
                if(get(state).cache && get(state).cache.claimedLocations && get(state).cache.claimedLocations.includes(c)){
                    should_do = true; // It is a claimed location
                }
            }
        }
    }
    if(a.condition == 'check_state_flag'){
        let f = get(state)[a.flag] || 0;
        if(testNum(a.num, f)) should_do = true;
        if(a.neg) should_do = !should_do;
    }
    if(a.condition == 'secure_check'){
        let loc = await resolveObject(a.obj, 'type_match', {card: card.uniqueID}, p);
        let secured = false;
        if(loc && loc.length > 0){
            addCardsToCache(loc, 'secure_check'); 
            for(let c of loc){
                if(matches(c, "neutral location") && canControlLocation(p, getCard(c))) secured = true;
            }
            should_do = secured;
            if(a.neg) should_do = !should_do;
        }else{ // No location to look at!
            should_do = false;
        }
    }
    if(a.condition == 'mission_no_matches'){
        if(!get(state).missionContributors) throw 'uncompleted';
        let cards = get(state).missionContributors.map(c => getCard(c));
        if(!cards.some(c => matches(c, a.obj.types))){
            should_do = true;
        }else{
            should_do = false;
        }
        if(a.neg) should_do = !should_do;
    }
    /*if(a.condition == 'location_check'){
        let obj = await resolveObject(a.obj, 'type_match', {card: card.uniqueID}, p);
        let loc = await resolveLocCondition(card, a.location, p, )
    }*/
    if(a.condition == 'type_match'){
        console.log('matching types')
        // !! fix WILDCARD
        let cards = await resolveObject(a.obj, 'type_match', {card: card.uniqueID}, p);
        /*if(cards.length > 1){
            console.log('Too many cards to match!', cards); // TODO could sort this later...
        }*/
        let numMatched = 0;
        let matchedTypes = [];
        let matchedCards = [];

        // handle any exclusions
        if(a.exclude && !a.excludeJustTraits){
            cards = resolveExclude(card, cards, a.exclude, p);
        }
        
        let prev = enableWildChecks(); // Go back and make this work later
        let noSubject = false;
        if(cards.length == 0){
            console.log('No card!')
            numMatched = 0;
            // 'If the discarded card is X, ...; otherwise ...' with nothing discarded: there was nothing to test,
            // so a following 'otherwise' must not fire (T'Kumbra vs a non-human captain)
            if(a.obj && a.obj.card && a.obj.card.type == 'prev_obj'){
                // ...unless the subject was a claimed interaction with the Bot's hidden hand: the
                // card is notional, so the player decides whether it matches
                let lastVerb = (get(state).cache.prevVerbs || []).find(v => v && v.verb != 'type_match');
                if(lastVerb && lastVerb.claimed){
                    if(await choose(`The Bot's card is hidden: ${a.text || 'does it match'}?`, ['Yes', 'No'], {forceChoose: true}) == (a.match.neg ? 'No' : 'Yes')) numMatched = a.match_num || 1; // neg flips back below
                }else{
                    noSubject = true;
                }
            }
        }else{
            // Sep 2025: wondering why below is needed rather than the bit after the if/else, both cache stuff so why??
            // removing now to see
            //addCardsToCache(cards, 'type_match'); // For 'otherwise X it' type effects
            for(let c of cards){
                // Sep 2026: added possArray here for lists with separators, but it
                // might be better to collapse them earlier
                for(let type of possArray(a.match.type)){
                    let matched = matchesTypeClause(getCard(c), type);
                    if(a.exclude && a.excludeJustTraits){
                        // Don't think there is a card yet but just in case
                        // (basically this is for matching 'any species excluding X/Y/Z' but not 'excluding cards with'...)
                        matched = matches(getCard(c), {main: type.types, exclude: a.exclude});
                    }
                    if(matched){
                        if(type.filter && type.filter){
                            if(testFilterTypes(getCard(c), type.filter)){
                                numMatched++;
                                matchedCards.push(c);
                            }
                        }else{
                            numMatched++;
                            matchedCards.push(c);
                        }
                        if(Array.isArray(type.types)){
                            matchedTypes.push(...type.types.filter(t => matches(getCard(c), t)));
                        }else{
                            matchedTypes.push(type.types);
                        }
                    }
                }
                
            }
            
            resetWildChecks(prev);
            //console.log(a.obj, cards);
            /*cards = cards[0];
            should_do = matches(getCard(cards), a.match.type.types);
            if(should_do && a.match.type.filter){
                should_do = matches(getCard(cards), a.match.type.filter.types);
            }*/
            
        }
        let target = a.match_num || 1;
        //if(numMatched >= target) should_do = true;
        if(testNum(target, numMatched)) should_do = true;
        if(!should_do) matchedCards = cards; // So that if X is Y then do it, else do it works
        if(a.match.neg) should_do = !should_do;
        let prevTypes = Array.from(new Set(matchedTypes));
        if(prevTypes.length == 1) prevTypes = prevTypes[0];
        // Pseudo-action writer: a condition names an object its body can refer back to
        // ("if a [[person]] is in the Bot Discard pile, promote it"). The binder stamped the
        // slot on this node; record what the test actually resolved to.
        recordSlot(a.subjectSlot, {obj: matchedCards});
        state.update(s => {
            s.cache.prev_obj = [...matchedCards, {num: numMatched, types: prevTypes}]; // !!! NB matchedCards added, see if it breaks
            // NB now all cards checked are cached above too, see if that's an issue (needed for Pike Location effect)
            if(!s.cache.allPrev) s.cache.allPrev = [];
            if(!s.cache.interimPrev) s.cache.interimPrev = [];
            if(!s.cache.prevVerbs) s.cache.prevVerbs = [];
            s.cache.allPrev = [...s.cache.prev_obj, ...s.cache.allPrev];
            s.cache.interimPrev = [...s.cache.prev_obj, ...s.cache.interimPrev].flat(2);
            // !! TODO which card is this for?
            s.cache.prevVerbs = [{verb: 'type_match', obj:  [...matchedCards, {num: numMatched, types: prevTypes}]/*{num: numMatched, types: prevTypes}*/, num: numMatched || false, card: typeof card == 'number' ? card : card.uniqueID}, ...s.cache.prevVerbs];
            if(noSubject) s.cache.noSubjectCondition = true; else delete s.cache.noSubjectCondition;
            return s;
        })
    }else if(a.condition == 'beam_count'){
        let obj = await resolveObject(a.obj, 'beam_count', {card: card.uniqueID}, p, null, true);
        let count = 0;
        for(let o of possArray(obj)){
            if(typeof o == 'number') o = getCard(o);
            if(o && o.beamed){
                let cards = [...o.beamed];
                if(a.beamType && a.beamType != 'card') cards = cards.filter(c => matches(c, a.type));
                count += cards.length;
            }
        }
        if(testNum(a.num, count)) should_do = true;
    }else if(a.condition == 'shared_traits_beamed'){
        if(!card.beamed || card.beamed.length == 0){
            should_do = false;
        }else{
            let beamed = [...card.beamed];
            let inPlay = cardsInPlay(p);
            for(let c of beamed){
                if(inPlay.some(cd => cd.uniqueID != c.uniqueID && cd.traits.some(t => c.traits.includes(t)))){
                    should_do = true;
                    break;
                }
            }
        }
    }else if(a.condition == 'trait_match'){
        try{
            let card1 = await resolveObject({card:a.card1}, 'type_match', {card: card.uniqueID}, p);
            let card2 = await resolveObject({card:a.card2}, 'type_match', {card: card.uniqueID}, p);
            // Ask before spending a wildcard slot to make these share a trait.
            // Once offered we count committed slots only; if we couldn't build an
            // offer, keep the old speculative behaviour rather than drop a match.
            // Negated tests are asked too - whether matching helps the player is
            // not something the effect text tells us, so it is always their call.
            let useWC = !(await offerSharedWC(p, card1, card2, a.traits, a.except, card));
            if(a.card2.place == 'duty' && !a.card2.all && a.neg){
                // Only one needs not to match
                let matched = [];
                for(let c of card2){
                    if(!matchTraits(card1, c, a.traits, a.except, useWC)){
                        should_do = true;
                        matched.push(c);
                    }
                }
                if(matched.length > 0) addCardsToCache(matched, 'trait_match', {card: possID(card)});
            }else{
                should_do = matchTraits(card1, card2, a.traits, a.except, useWC);
                if(a.neg) should_do = !should_do;
            }
        }catch(e){
            if(e == 'uncompleted'){
                should_do = false;
            }else if(e != 'completed'){
                throw e;
            }
        }
        
    }else if(a.condition == 'card_is'){
        if(matches(card, a.name)) should_do = true;
        addCardsToCache(card, 'card_is', {card: possID(card)}); // !!TODO added
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'trait_count'){
        let cards = await resolveObject({card: a.card}, 'trait_count', {card: card.uniqueID}, p, null, true);
        let count = 0;
        for(let c of cards){
            count += countableTraits(getCard(c).traits).length;
        }
        if(testNum(a.num, count)) should_do = true;
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'value_count'){
        let cards = await resolveObject({card: a.card}, 'value_count', {card: card.uniqueID}, p, null, true);
        let count = 0;
        for(let c of cards){
            count += getCard(c).values.length;
        }
        if(testNum(a.num, count)) should_do = true;
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'next_action'){
        if(!p.hangingEffects) p.hangingEffects = [];
        p.hangingEffects = [...p.hangingEffects, {
            condition: a.next,
            action: a.action,
            timing: 'before',
            type: 'next_action' // other types might allow for end of turn, for example
        }];
    }else if(a.condition == 'found_place'){
        if(get(state).cache && get(state).cache.foundIn){
            let places = get(state).cache.foundIn;
            let l = a.place.toLowerCase();
            if(places.includes(l)) should_do = true;
        }
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'loc_test'){
        //console.log('testing location');
        let results = [];
        let obj = await resolveObject(a.obj, 'loc_test', {card: card.uniqueID}, p, null, true);
        // The location side of the test has its own card reference ('at the *Badlands*' parses as
        // {location: 'card_loc', card: 'badlands', card_itself: true}). Passing a.obj here made
        // 'card_loc' resolve the SUBJECT instead - so 'Warp a [[ship]]. If it is at the *Badlands*'
        // asked whether the ship was at its own location, which is always true. Merge the loc's own
        // card/card_itself over the subject so named-card tests look at the named card, while
        // subject-derived hints (types, locType) still reach the other branches.
        let locObj = a.loc.card ? {...a.obj, ...a.loc} : a.obj;
        let loc = resolveLocCondition(card, a.loc.location, p, [], locObj, 'loc_test');
        if(!Array.isArray(obj)) obj = [obj];
        let matchNum = 0;
        for(let o of obj){
            if(typeof o == 'number' && loc.some(c => c.uniqueID == o)){
                matchNum++;
                results.push(o);
            }
            if(typeof o == 'object' && loc.some(c => c.uniqueID == o.uniqueID)){
                matchNum++
                results.push(o.uniqueID);
            }
        }
        // and where each was found, for "... trigger that card's control operation"
        let foundAt = results.map(id => locationOfCard(getCard(id))).filter(l => l).map(l => l.uniqueID);
        recordSlot(a.subjectSlot, {obj: results, to: foundAt});
        let num = a.match_num;
        if(a.match_num == 'any') num = 1;
        if(!a.match_num) num = 1;
        if(a.match_num == 'all'){
            if(matchNum == obj.length) should_do = true;
        }else{
            if(testNum(a.match_num, matchNum)) should_do = true;
        }
        
        if(results.length > 0){
            //if(a.loc.location.loc_at){ 
                // Jan 2026: expanded this to other cases, for USS Phoenix
                // Need to add location to prev verbs as well 
                // !! TODO may need to expand this for other cases
                // Find location of card(s) and add to results list
                let toAdd = [];
                for(let r of results){
                    let c = getCard(r);
                    if(c.orbitingCard){
                        for(let id of Object.values(c.orbitingCard)){
                            toAdd.push(id);
                        }
                    }else if(allBeamed(p).some(cd => cd.uniqueID == c.uniqueID)){
                        let info = get(state).cardLog[c.uniqueID];
                        let bc = parseInt(info.deck);
                        toAdd.push(bc);
                    }
                }
                results.push(...toAdd);
            //}
            if(results.length == 1) results = results[0];
            state.update(s => {
                s.cache.prev_obj = results;
                if(!s.cache.allPrev) s.cache.allPrev = [];
                if(!s.cache.interimPrev) s.cache.interimPrev = [];
                if(!s.cache.prevVerbs) s.cache.prevVerbs = [];
                s.cache.allPrev = [s.cache.prev_obj, ...s.cache.allPrev];
                s.cache.interimPrev = [s.cache.prev_obj, ...s.cache.interimPrev].flat(2);
                s.cache.prevVerbs = [{verb: 'loc_test', obj: s.cache.prev_obj, num: matchNum, card: typeof card == 'number' ? card : card.uniqueID}, ...s.cache.prevVerbs];
                return s;
            })
        }
        
        console.log('added loc_test prev', get(state).cache.prevVerbs)
        
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'test_ownership'){
        console.log('testing ownership')
        //let p = resolveOwner(card, a.owner);
        let eligible = [];
        // !!! I think I ned to remove owner: a.owner below to fix Khan Devastated Ceti A V
        // !!! for now I have added filter to resolveLocCondition. Not sure if this is the best solution
        let count = resolveCountTypes(p, card, {...a.obj, owner: a.owner}, 'ownership', {...a}, eligible);
        let num = await resolveNum(a.num);
        // !!! I think I ned to remove owner: a.owner below to fix Khan Devastated Ceti A V
        // !!! for now I have added filter to resolveLocCondition. Not sure if this is the best solution
        let countWithoutWCs = resolveCountTypes(p, card, {...a.obj, owner: a.owner}, 'ownership', {...a}, false, {wildcardsLeft: 0});
        let doIt = 'Yes';
        // !! TODO: stop people choosing something they have already rejected later in operation
        if(testNum(num, count) && !testNum(num, countWithoutWCs) && a.obj.types){
            if(a.neg){
                doIt = await choose(`${a.text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${a.text}</div>` : ''}If you commit a wild trait ${a.obj.types ? `as ${possArray(a.obj.types).map(t => `[[${t}]]`).join('/')} ` : ''}, this effect will not trigger. Do you want to commit one?`, ['Yes', 'No']);
            }else{
                doIt = await choose(`${a.text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${a.text}</div>` : ''}You need to commit a wild trait ${a.obj.types ? `as ${possArray(a.obj.types).map(t => `[[${t}]]`).join('/')} ` : ''}for this effect to ${a.neg ? 'not ' : ''}trigger. Do you want to?`, ['Yes', 'No']);
            }
            
            // Load from cache if already selected
            /*if(get(state).cache && get(state).cache.hasOwnProperty(`${a.text || ''}.${card.uniqueID}`)){
                doIt = get(state).cache[`${a.text || ''}.${card.uniqueID}`];
            }else{
                doIt = await choose(`${a.text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${a.text}</div>` : ''}You need to commit a wild trait ${a.obj.types ? `as ${possArray(a.obj.types).map(t => `[[${t}]]`).join('/')} ` : ''}for this effect to ${a.neg ? 'not ' : ''}trigger. Do you want to?`, ['Yes', 'No']);
                cacheItem(`${a.text || ''}.${card.uniqueID}`, doIt)
            }*/
            if(doIt == 'Yes'){
                let amountToAdd = 1;
                while(!testNum(num, countWithoutWCs + amountToAdd)) amountToAdd++;
                console.log('el',eligible);
                for(let e of eligible){
                    let num = Math.min(amountToAdd, cardWCs(e, a.obj.types));
                    for(let _ of Array(num)) cacheWC(e, possArray(a.obj.types)[0]);
                    amountToAdd -= num;
                }
            }
        }
        if(doIt == 'Yes' && testNum(num, count)){
            should_do = true;
            if(get(state).cache && get(state).cache.countResults) recordSlot(a.subjectSlot, {obj: get(state).cache.countResults});
            if(get(state).cache && get(state).cache.countResults){
                state.update(s => {
                    // Aug 2025: remove ... from countResults so they remain grouped for subsequent stuff
                    s.cache.allPrev = [s.cache.countResults, ...s.cache.allPrev]; // TODO check this doesn't make anything blow up!!
                    if(!s.cache.prevVerbs) s.cache.prevVerbs = [];
                    s.cache.prevVerbs = [
                        {
                            verb: 'test_ownership',
                            obj: s.cache.countResults,
                            num: s.cache.countResults.length,
                            card: typeof card == 'number' ? card : card.uniqueID
                        },
                        ...s.cache.prevVerbs
                    ]
                    return s;
                })
            }
        }
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'collected_traits'){
        let count = p.collected_traits ? p.collected_traits.length : 0;
        let num = await resolveNum(a.num);
        if(testNum(num, count)){
            should_do = true;
        }
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'ownership_comparison'){
        // Currently always you (1) v opponent (2)
        let youCount = resolveCountTypes(p, card, {...a.obj, owner: p.bot ? 'bot' : 'you'}, 'ownership', {...a});
        if(get(state).cache && get(state).cache.countResults){
            state.update(s => {
                // Aug 2025: remove ... from countResults so they remain grouped for subsequent stuff
                s.cache.allPrev = [s.cache.countResults, ...s.cache.allPrev]; // TODO check this doesn't make anything blow up!!
                return s;
            })
        } // !! NB doubled because it's you and them
        let theyCount = resolveCountTypes(p, card, {...a.obj, owner: 'opponent'}, 'ownership', {...a});
        if(get(state).cache && get(state).cache.countResults){
            state.update(s => {
                // Aug 2025: remove ... from countResults so they remain grouped for subsequent stuff
                s.cache.allPrev = [s.cache.countResults, ...s.cache.allPrev]; // TODO check this doesn't make anything blow up!!
                return s;
            })
        }
        should_do = resolveComparison(youCount, theyCount, a.comp);
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'typecount_comparison'){
        state.update(s => {
            if(!s.cache) s.cache = {};
            if(!s.cache.prevConditions) s.cache.prevConditions = [];
            if(Array.isArray(a.action)){
                let result = [];
                for(let r of a.action.flat(2)){
                    if(r.verb != 'choose_any_option') result = [...result, {...r, attack: a.attack || false}];
                }
                if(result.length > 0) s.cache.prevConditions.push(result);
            }else{
                if(a.action && a.action.verb != 'choose_any_option') s.cache.prevConditions.push({...a.action, attack: a.attack});
            }
            
            return s;
        })
        // Need to also handle wildcards and wild-skills
        // !!TODO need to handle situation where you might count them for it to be equal
        let count1 = cardsInPlay(p, !a.excBeam).reduce((acc,c) => acc + matches(c, a.obj1, false, false), 0);
        let count2 = cardsInPlay(p, !a.excBeam).reduce((acc, c) => acc + matches(c, a.obj2, false, false), 0);
        let possibleWC = possibleWildCards([...possArray(a.obj1), ...possArray(a.obj2)]);
        let numWC = cardsInPlay(p, !a.excBeam).reduce((a,c) => a + c.traits.filter(t => possibleWC.includes(t)).length, 0);
        let numWS = cardsInPlay(p, !a.excBeam).reduce((a,c) => a + c.values.filter(t => t == 'wild').length, 0);
        if(ongoingPlayer(p).includes('skill_conversion')){
            console.log('need to handle partial skill conversions!! Dec 2025');
            // ...revisit using max/mins?
        }

        if(numWC > 0 && ![...possArray(a.obj1), ...possArray(a.obj2)].some(t => possibleWC.includes(t)) && (Math.abs(count1 - count2) - numWC <= 0)){
            // Possible outcomes
            let outcomes = []
            let def = count1 - count2;
            if(def < 0 && possArray(a.obj1).some(t => get(res).traits.includes(t))){
                outcomes.push({
                    name: `more ${renderTypes(a.obj2)} than ${renderTypes(a.obj1)}`,
                    result: def
                });
                outcomes.push({
                    name: `equal ${renderTypes(a.obj1)} and ${renderTypes(a.obj2)}`,
                    result: 0
                });
                if(numWC > Math.abs(def)){
                    outcomes.push({
                        name: `more ${renderTypes(a.obj1)} than ${renderTypes(a.obj2)}`,
                        result: numWC - def
                    })
                };
            }else if(def > 0 && possArray(a.obj2).some(t => get(res).traits.includes(t))){
                outcomes.push({
                    name: `more ${renderTypes(a.obj1)} than ${renderTypes(a.obj2)}`,
                    result: def
                });
                outcomes.push({
                    name: `equal ${renderTypes(a.obj1)} and ${renderTypes(a.obj2)}`,
                    result: 0
                });
                if(numWC > def){
                    outcomes.push({
                        name: `more ${renderTypes(a.obj2)} than ${renderTypes(a.obj1)}`,
                        result: def - numWC
                    });
                }
            }else if(def == 0){
                outcomes.push({
                    name: `equal ${renderTypes(a.obj1)} and ${renderTypes(a.obj2)}`,
                    result: def
                });
                if(possArray(a.obj1).some(t => get(res).traits.includes(t))){
                    outcomes.push({
                        name: `more ${renderTypes(a.obj1)} than ${renderTypes(a.obj2)}`,
                        result: numWC
                    });
                }
                if(possArray(a.obj2).some(t => get(res).traits.includes(t))){
                    outcomes.push({
                        name: `more ${renderTypes(a.obj2)} than ${renderTypes(a.obj1)}`,
                        result: -numWC
                    });
                }
            }
            if(outcomes.length > 1){
                let choice = await choose(`You have ${numWC} [[wildcard]] and can thus choose the outcome of this comparison: what should it be?`, outcomes.map(o => o.name), {cancellable: true});
                if(!choice || choice == 'cancelled') throw 'cancelled';
                let chosen = outcomes.find(o => o.name == choice);
                count1 = chosen;
                count2 = 0; // As basis for comparison
            }
        }else  if(numWS > 0 && ![...possArray(a.obj1), ...possArray(a.obj2)].some(t => t == 'wild-skill') && (Math.abs(count1 - count2) - numWS <= 0)){
            // !! TODO nb that you can't currently mix wild skills and wildcards
            let outcomes = []
            let def = count1 - count2;
            if(def < 0 && possArray(a.obj1).some(t => t.endsWith('-skill'))){
                outcomes.push({
                    name: `more ${renderTypes(a.obj2)} than ${renderTypes(a.obj1)}`,
                    result: def
                });
                outcomes.push({
                    name: `equal ${renderTypes(a.obj1)} and ${renderTypes(a.obj2)}`,
                    result: 0
                });
                if(numWS > Math.abs(def)){
                    outcomes.push({
                        name: `more ${renderTypes(a.obj1)} than ${renderTypes(a.obj2)}`,
                        result: numWS - def
                    })
                };
            }else if(def > 0 && possArray(a.obj2).some(t => t.endsWith('-skill'))){
                outcomes.push({
                    name: `more ${renderTypes(a.obj1)} than ${renderTypes(a.obj2)}`,
                    result: def
                });
                outcomes.push({
                    name: `equal ${renderTypes(a.obj1)} and ${renderTypes(a.obj2)}`,
                    result: 0
                });
                if(numWS > def){
                    outcomes.push({
                        name: `more ${renderTypes(a.obj2)} than ${renderTypes(a.obj1)}`,
                        result: def - numWS
                    });
                }
            }else if(def == 0){
                outcomes.push({
                    name: `equal ${renderTypes(a.obj1)} and ${renderTypes(a.obj2)}`,
                    result: def
                });
                if(possArray(a.obj1).some(t => t.endsWith('-skill'))){
                    outcomes.push({
                        name: `more ${renderTypes(a.obj1)} than ${renderTypes(a.obj2)}`,
                        result: numWS
                    });
                }
                if(possArray(a.obj2).some(t => t.endsWith('-skill'))){
                    outcomes.push({
                        name: `more ${renderTypes(a.obj2)} than ${renderTypes(a.obj1)}`,
                        result: -numWS
                    });
                }
            }
            if(outcomes.length > 1){
                let choice = await choose(`You have ${numWS} [[wild-skill]] and can thus choose the outcome of this comparison: what should it be?`, outcomes.map(o => o.name), {cancellable: true});
                if(!choice || choice == 'cancelled') throw 'cancelled';
                let chosen = outcomes.find(o => o.name == choice);
                if(chosen){
                    count1 = chosen.result;
                    count2 = 0; // As basis for comparison
                }
            }
        }

        should_do = resolveComparison(count1, count2, a.comp);
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'track_comparison'){
        let count1 = p[abbrevTrack(a.obj1)];
        let count2 = possArray(a.obj2).map(t => p[abbrevTrack(t)]);
        should_do = false;
        if(a.comp == 'more' && count1 > Math.max(...count2)) should_do = true;
        if((a.comp == 'fewer' || a.comp == 'less') && count1 < Math.min(...count2)) should_do = true;
        if(a.comp == 'equal' && count2.every(c => count1 == c)) should_do = true;
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'from_junk'){
        should_do = false;
        if(get(state).cache && get(state).cache.fromJunk && get(state).cache.fromJunk[a.verb]){
            let num = get(state).cache.fromJunk[a.verb].length;
            let test = a.obj.num;
            if(!a.obj.hasOwnProperty('num')) test = 1;
            should_do = testNum(test, num);
        }
    }else if(a.condition == 'promoted_from'){
        should_do = false;
        if(get(state).cache && get(state).cache.promotedFrom){
            if(possArray(a.where).some(w => get(state).cache.promotedFrom.some(f => f == w))) should_do = true;
        }
    }else if(a.condition == 'previous_verb'){
        let v = a.verb;
        if(synonyms[v]) v = synonyms[v];
        //console.log(get(state).cache.prevVerbs, v);
        if(get(state).cache && get(state).cache.prevVerbs && get(state).cache.prevVerbs.some(p => p && verbMatches(p.verb, v))){
            if(a.obj && a.obj.card && a.obj.card.num && a.obj.defaultNum){
                a.obj.num = a.obj.card.num;
                a.obj.defaultNum = false;
            }
            if(a.obj && a.obj.num && (a.obj.types || !a.obj.defaultNum)){ // why was defaultnum
                //let verb = get(state).cache.prevVerbs.filter(p => p && verbMatches(p.verb, v))
                let num = countWithBindings(a, resolvePrevCount(v, a.obj.types || false));
                if(testNum(await resolveNum(a.obj.num), num)){
                    should_do = true;
                }else{
                    should_do = false;
                }
            }else{
                should_do = true;
            }    
        }
    }else if(a.condition == 'previous_amount'){
        let num = resolvePrevCount(a.verb);
        //console.log(prev);
        /*if(prev.num){
            if(testNum(await resolveNum(a.num), prev.num)) should_do = true;
        }else if(prev.length){
            if(testNum(await resolveNum(a.num), prev.length)) should_do = true;
        }*/
        if(testNum(await resolveNum(a.num), num)) should_do = true;
        if(a.neg) should_do = !should_do;
    }else if(a.condition == 'num_action'){
        let v = a.verb;
        if(synonyms[v]) v = synonyms[v];
        if(get(state).cache && get(state).cache.prevVerbs){
            let count = get(state).cache.prevVerbs.filter(p => p && verbMatches(p.verb, v)).length;
            let num = await resolveNum(a.num);
            if(testNum(num, count)) should_do = true;
            
        }
        if(a.neg) should_do = !should_do;
    }
    return should_do;
}

function oppOwner(o){
    let opp = trawlFor(o, 'owner');
    if(opp.length == 0){
        if(o.actor == 'they' && get(state).cache.player != 'you') return true;
        if(o.actor == 'opponent') return true;
    }
    for(let o of opp){
        if(o == 'opponent') return true;
        if((o == 'they' || o == 'their') && get(state).cache.player != 'you') return true;
        //if(o == 'bot') return ()
        if(!get(state).players[get(state).currentPlayer].bot && o == 'bot') return true;
        if(get(state).players[get(state).currentPlayer].bot && (o == 'player' || o == 'you')) return true;
    }
}


function isAttackEffect(p, a, card){
    // returns attacker or false
    if(ongoingEffects(card).includes('not_attack')) return false;
    // feb 2026 - change below so self-rep mines isn't attack
    let currentP = cardOwner(card); //get(state).players[get(state).currentPlayer];
    if(!a.attack && a.takingControl) return false; // claiming
    if(a.forced) return otherPlayer(p); // 'force them to' = attack
    if(currentP != p && !a.optional && !(a.type == 'action' && a.verb == 'gain')) return currentP;
    if(a.verb == 'steal') return p;
    if(a.verb == 'give') return p;
    if((a.verb == 'remove_away'/*|| a.verb == 'remove'*/) && oppOwner(a.obj)) return p;
    if(a.verb == 'look at' && oppOwner(a)) return p;
    if(a.verb == 'take' && a.obj && a.obj.types == 'incident' && oppOwner(a)) return p;
    if((a.verb == 'discard' || a.verb == 'dismiss' || a.verb == 'recall' || a.verb == 'log') && (oppOwner(a))) return p;
    return false;
}

function isCostEffect(p, a, card){
    // No longer discard!
    // Jan 2026: except now it seems it is...!
    let costVerbs = ['discard', /*'log', 'top', 'bottom',*/ 'spend'/*, 'put_in_play'*/];
    if(costVerbs.includes(a.verb)) return true;
    return false;
}

// A claimed success on a bot-hand interaction means the action notionally happened even
// though we never touched the bot's hidden cards, so no real card gets recorded in
// prevVerbs. Record a tagged placeholder so "for each X returned" counters (e.g. Ziyal)
// count the claimed interaction, and so 'if the discarded card is X' conditions (T'Kumbra)
// can ask the player about the hidden card. No real card, so mark it claimed with the intended types.
function recordClaimedBotHand(a){
    if(!a || !a.verb || !a.obj) return;
    let types = a.obj.types || (typeof a.obj.card == 'string' ? a.obj.card : 'card');
    types = Array.isArray(types) ? types : [types];
    state.update(s => {
        if(!s.cache.prevVerbs) s.cache.prevVerbs = [];
        s.cache.prevVerbs = [{verb: a.verb, obj: [], claimed: true, claimedTypes: types, num: typeof a.obj.num == 'number' ? a.obj.num : 1}, ...s.cache.prevVerbs];
        return s;
    })
}

async function checkBotHand(e, a){
    if(get(state).cache.involvesBotHand && e == 'uncompleted' && get(state).cache.botHandAttack){
        // TBG attack rule: a Bot attack that does nothing (e.g. forced discard from a handless Bot) lets
        // the player either do nothing or put the top card of the Bot discard on top of its deck.
        // The player may instead judge the attack to have succeeded (e.g. to gain T'Kumbra's glory).
        let bot = get(state).players.find(pl => pl.bot);
        const SUCCEED = 'Attack succeeds', DECK = 'Put top card of discard on deck', NOTHING = 'Do nothing';
        let options = [SUCCEED, ...(bot && bot.decks.discard.length > 0 ? [DECK] : []), NOTHING];
        let choice = await choose(`The Bot has no hand to interact with. Judge the attack to have succeeded, do nothing${options.includes(DECK) ? ', or put the top card of the Bot discard on top of its deck' : ''}?`, options, {forceChoose: true});
        if(choice == DECK){
            await moveTo(bot.decks.discard[0], `players.deck.${getPlayerIndex(bot)}`, 0);
            e = 'completed'; // Choosing the deck option counts as the attack doing something
        }else if(choice == SUCCEED){
            e = 'completed';
            recordClaimedBotHand(a);
        }
        state.update(s => {
            delete s.cache.involvesBotHand;
            delete s.cache.botHandAttack;
            return s;
        })
        return e;
    }
    if(get(state).cache.involvesBotHand && e == 'uncompleted'){
        if(await choose(`Action involving bot hand/discard: Succeed or fail?`, ['Succeed', 'Fail'], {forceChoose: true}) == 'Succeed'){
            e = 'completed';
            recordClaimedBotHand(a);
        }
        state.update(s => {
            delete s.cache.involvesBotHand;
            return s;
        })
    }
    return e;
}

export async function resolveAction(p, card, a, attack, forced = false, ignoreCosts = false){
    // Direct callers (unspent actions, network reactions) skip resolveEffects: frame them too
    let unit = unitNeedingFrame(a);
    if(unit){
        let frame = pushFrame({unit, card: card && card.uniqueID !== undefined ? card.uniqueID : null, target: get(state).resolvingFrom});
        try{
            return await resolveAction(p, card, a, attack, forced, ignoreCosts);
        }finally{
            popFrame(frame);
        }
    }
    //let p = get(state).players[get(state).activePlayer];
    //let p = cardOwner(card);
    console.log('resolving action', a, p, get(state).cache.showCards, p.decks.log.map(c => c.name))
    if(a.forced) forced = true; // !TODO new
    let savedAction = {
        attack,
        forced,
        a: clone(a)
    };

    // Check for bot
    let currentP = get(state).players[get(state).currentPlayer];
    //if(currentP != p && !a.optional && !(a.type == 'action' && a.verb == 'gain')){   
    let attacker = isAttackEffect(p, a, card);
    let definitelyAttack = false;
    if(attacker){
        attacker = attacker.captain;
        if(attack || currentP.bot){
            // It's an attack!
            console.log('Attack identified', attacker)
            // Don't resolve effect if already cancelled
            // Check for reactions and/or already blocked
            if(get(state).cache && get(state).cache.attackCancelled){
                if(get(state).payingCost == card.uniqueID || get(state).cache.throwUncompleted == card.uniqueID) throw 'uncompleted'; // To prevent resultant effect
                return;
            } 
            await checkForReactions(p, 'attack', {card: card.uniqueID, attacker}, 'before');
            if(get(state).cache && get(state).cache.replacedOriginal && get(state).cache.replacedOriginal != card.uniqueID){
                state.update(s => {
                    s.cache.replacedOriginal = false;
                    return s;
                })
                /*if(get(prefs).granularAttacks || currentP.bot){
                    state.update(s => {
                        if(!s.cache) s.cache = {};
                        s.cache.attackCancelled = params.card;
                        return s;
                    })
                }*/
                return;
            }
            if(get(state).cache && get(state).cache.attackCancelled){
                if(get(state).payingCost == card.uniqueID || get(state).cache.throwUncompleted == card.uniqueID) throw 'uncompleted'; // To prevent resultant effect
                return;
            } 
            definitelyAttack = true;
            
        }
    }

    // Clear cached Otherwise if this is not an otherwise
    // This is to stop earlier otherwises from forming a chain.
    // Otherwises can only form a chain when they are adjacent.
    // !! Watch out for semicolons which could break this rule.
    // Added 25 March: didLastCost is here to stop otherwise
    // triggering on unsuccessful results from successful costs.
    // Only refers back to previous effect.
    // Added to make Sisko bot non-DO directive behave correctly
    // on impossible AT add: log person, don't trigger 'otherwise'.
    if(!a.otherwise){
        state.update(s => {
            if(!s.cache) return s;
            delete s.cache.otherwise;
            if(!s.cache.insideResult) delete s.cache.didLastCost;
            return s;
        })
    }

    try{
        if(a.type == 'choice'){
            //let choiceNames = a.choices.map(c => upperInitial(hn(c))); //  upperInitial(hn(c))
            if(!a.num){
                let origChoices = a.choices;
                if(a.different && get(state).cache.otherOptions){
                    // Reduce to available choices
                    origChoices = [...get(state).cache.otherOptions];
                }
                if(p.bot && a.forced){
                    origChoices = await filterToPossible(p, origChoices, card); //origChoices.filter(e => isPossible(p, e));
                    if(origChoices.length == 0){
                        logText('No choices are possible for the bot');
                        throw 'uncompleted';
                    }
                }
                let extras = {};
                if(get(state).players[get(state).currentPlayer].bot && get(state).players[get(state).activePlayer].bot &&get(state).players.some(p => !p.bot)){
                    // choice needs to be made by human player, since it's arising from bot chart
                    extras.forceChoose = true; // this way?
                }
                
                let choices = [];
                for(let c of origChoices.filter(c => joinText(c))){
                    choices.push(`${await canAfford(p, c, card)? '': '!'}${upperInitial(joinText(c))}`)
                }
                if(a.optional){
                    choices = [...choices, 'Do nothing'];
                }
                //let forceChoose = false;
                //if(!get(state).players[get(state).activePlayer].bot) forceChoose = true; // Don't auto-choose if the active player is
                let choice = await choose(`Choose action to take:`, choices, {cancellable: !forced, card: get(state).cache.showCards ? getCard(get(state).cache.showCards) : false, forced, ...extras});
                if(p.bot && hasCancelEffect(a.choices)){
                    // Bot may need to engage with cancellation
                    let chosen = a.choices.find(c => hasCancelEffect(c));
                    logText(`Bot having to respond to ${cc(card.uniqueID)}: opts for choice '${upperInitial(joinText(chosen))}'`);
                    await resolveEffects(card, chosen, attack, forced);
                    state.update(s => {
                        if(!s.cache) s.cache = {};
                        s.cache.replacedOriginal = false;
                        return s;
                    })
                    let next = a.choices.find(c => !hasCancelEffect(c));
                    //if(!Array.isArray(next)) next = [next];
                    /*next = next.flat(3); //?
                    for(let i = 0; i < next.length; i++){
                        if(n[i].type == 'cost'){
                            n[i] = n[i].action; // Just jump straight to the effect
                        }
                    }*/ 
                    
                    logText(`Bot has now dealt with ${cc(card.uniqueID)}, so taking action '${upperInitial(joinText(next))}, ignoring any cost if present`);
                    await resolveEffects(card, next, attack, forced, false, true);
                    state.update(s => {
                        if(!s.cache) s.cache = {};
                        s.cache.replacedOriginal = true;
                        return s;
                    })
                    return;
                }
                if(!choice || choice == 'cancelled') throw 'cancelled';
                if(choice == 'Do nothing'){
                    logText(`opted not to perform any action`);
                    logDid(card, false)
                    state.update(s => {
                        delete s.cache.showCards;
                        return s;
                    });
                    return;
                }
                if(!card.chosenOptions) card.chosenOptions = {};
                if(!card.chosenOptions[choice]) card.chosenOptions[choice] = 0;
                card.chosenOptions[choice]++;
                let chosen = null;
                for(let c of a.choices){
                    if(choice == `${await canAfford(p, c, card)? '': '!'}${upperInitial(joinText(c))}`) chosen = c;
                }
                let otherOptions = get(state).cache.otherOptions || [...a.choices];
                otherOptions = otherOptions.filter(c => JSON.stringify(chosen) != JSON.stringify(c));
                if(!Array.isArray(chosen)) chosen = [chosen];
                
                state.update(s => {
                    if(!s.cache) s.cache = {};
                    s.cache.otherOptions = otherOptions; // for 'do both'
                    s.cache.otherAttack = attack;
                    s.cache.otherForced = forced;
                    return s;
                })
                await resolveEffects(card, chosen, attack, forced);
            }else{
                let num = await resolveNum(a.num);
                let text = num.text || num.num || num;
                let max = num.max || num.num || num;
                // 'Choose 2' (plain number) means exactly 2; 'choose up to 2' or 'you may choose' lets you stop early
                let min = a.optional ? 0 : typeof num == 'number' ? Math.min(num, a.choices.length) : (num.min || 0);
                let count = 1;
                let choices = a.choices.map(c => upperInitial(joinText(c)));
                console.log(count, num);
                while(count <= max){
                    if(count > min && !choices.includes('Finish choosing')) choices = [...choices, 'Finish choosing'];
                    let extra = '';
                    if(ongoingEffects(card).includes('choose_all')) extra = ' (N.B. you may be able to choose more, based on conditions)';
                    let prompt = count > min ? `You may take ${text} of the following actions` : `Take ${text} of the following actions`;
                    let choice = await choose(`${prompt}${extra}. Choose action ${count} of ${text}:`,choices, {cancellable: !forced, card: get(state).cache.showCards ? getCard(get(state).cache.showCards) : false});
                    if(choice == 'Finish choosing') break;
                    if(!card.chosenOptions) card.chosenOptions = {};
                    if(!card.chosenOptions[choice]) card.chosenOptions[choice] = 0;
                    card.chosenOptions[choice]++;
                    choices = choices.filter(c => c != choice);
                    
                    let chosen = a.choices.find(c => choice == upperInitial(joinText(c)));
                    let otherOptions = get(state).cache.otherOptions || [...a.choices];
                    otherOptions = otherOptions.filter(c => JSON.stringify(chosen) != JSON.stringify(c));

                    if(!Array.isArray(chosen)) chosen = [chosen];
                    state.update(s => {
                        if(!s.cache) s.cache = {};
                        s.cache.otherOptions = otherOptions; // for 'do both'
                        s.cache.otherAttack = attack;
                        s.cache.otherForced = forced;
                        return s;
                    })
                    await resolveEffects(card, chosen, attack, forced);
                    count++;
                }
            }
            
        }else if(a.type == 'action'){     
            let count = 1; 
            let addedBothCost = false;
            let statePreAction;
            
            if(a.verb == 'junk' && a.obj && a.obj.num != 1){
                let per = {
                    format: 'simple_number',
                    num: clone(a.obj.num)
                };
                a.per = per;
                a.obj.num = 1; // This will actually convert it permanently – see if it works
                if(a.text) a.text = a.text.replace(/unk .+ cards/i, 'unk a card');
            }
            if(a.per){
                count = await resolveCount(p, card, {...a.per, text: a.text}, a.verb);
                if(a.per.max < a.baseNum){
                    alert('Maximum count less than given total: something is wrong with this card text');
                }else{
                    let toSubtract = (a.baseNum + count) - a.per.max;
                    if(toSubtract > 0) count -= toSubtract;
                }
            }
            let num = count;
            
            if(typeof count != 'number'){
                /*if(count.min && count.max){
                    let options = [];
                    for(let i = count.min; i <= count.max; i++){
                        options.push(`${i} times`)
                    }
                    let chosen = await choose(`How many times would you like to take the action?`, options, {cancellable: true});
                    if(chosen == 'cancelled') throw 'cancelled';
                    count = parseInt(chosen.split(' ')[0])
                }else{*/
                    if(count.max){
                        count = count.max; // Has to be one or the other...*/
                    }else if(count.min){
                        count = count.min;
                    }
                    
                //}
            }
            if(a.baseNum){
                // Do it once with the base number (for gain_per_plus type situations)
                let tempObj = {...a.obj, num: a.baseNum};
                await singleAction(card, {...a, obj: tempObj}, definitelyAttack, forced);
            }else if(a.baseObj){
                await singleAction(card, {...a, obj: a.baseObj}, definitelyAttack, forced);
            }
            console.log('counting for action', count, a.obj, a.verb)
            let mustRepeatVerbs = ['resolve', 'control', 'play', 'freeplay', 'activate', 'junk']
            if(!mustRepeatVerbs.includes(a.verb) && a.per && a.obj && a.obj.num && typeof a.obj.num == 'number'){
                // So that e.g. choices only fire once
                let num = a.obj.num * count;
                if(a.per && a.per.max && num > a.per.max) num = a.per.max; // Annoying to have to do this here again...
                if(a.per && a.per.min && num < a.per.min) num = a.per.min; // Annoying to have to do this here again...
                if(num > 0){
                    await singleAction(card, {...a, obj: {...a.obj, num}}, definitelyAttack, forced);
                }
            }else{
                for(let i = 0; i < count; i++){
                    if(count > 1){
                        ui.update(ui => {
                            ui.per = {
                                num: i+1,
                                max: count // was a.obj.num, but I'm not sure why, since count is what's actually being used here
                            }
                            return ui;
                        })
                    }
                    if((num.min && i >= num.min || (!num.min && num.max))){
                        if(!a.optional) a = {...a, optional: true};
                    }
                    if(a.obj && a.obj.num > 1 && a.obj.card && a.obj.card.placement && a.obj.card.place == 'deck'){
                        // To handle situations where deck may empty
                        for(let j = 0; j < a.obj.num; j++){
                            await singleAction(card, {...a, obj: {...a.obj, card: {...a.obj.card, num: 1}, num: 1}}, definitelyAttack, forced);
                        }
                    }else{
                        await singleAction(card, a, definitelyAttack, forced);
                    }
                    
                }
                ui.update(ui => {
                    ui.per = false;
                    return ui;
                })
                await tick();
            }
        }else if(a.type == 'condition'){
            let should_do = true;
            if(a.condition == 'multiple'){
                let allShoulds = [];
                let separator = 'and';
                if(a.num == 'any') separator = 'or'; 
                if(a.num == 'all') separator = 'and';
                for(let c of a.conditions){
                    allShoulds.push(await resolveCondition(p, card, {...a, ...c}, attack, forced));
                    /*if(should){
                        logText(`Condition ${count} met`);
                    }else{
                        logText(`Condition ${count} not met, so abandoning action ${a,acti}`);
                    }*/
                    if(['and', 'or'].includes(c.separator)) separator = c.separator;
                    if(c.separator == 'and' && allShoulds.some(s => !s)) break;
                }
                if(separator == 'and' && allShoulds.some(s => !s)) should_do = false;
                if(separator == 'or' && !allShoulds.some(s => s)) should_do = false;
            }else if(a.condition == 'multiple_alternatives'){
                should_do = false;
                for(let c of a.conditions){
                    should_do = await resolveCondition(p, card, {...a, ...c}, attack, forced);
                    /*if(should){
                        logText(`Condition ${count} met`);
                    }else{
                        logText(`Condition ${count} not met, so abandoning action ${a,acti}`);
                    }*/
                    if(should_do) break; // So it gives up as soon as one succeeds
                }
            }else{
                should_do = await resolveCondition(p, card, a, attack, forced);
            }

            if(should_do){
                logText(`Condition met: '${a.text}', so taking action '${joinText(a.action)}'`);
                await resolveEffects(card, a.action, attack, forced);
                //logDid(card, true, 'uncompleted') // !!TODO experiment to see if removing fixes
                // !!! NOTE that if errors happen look here
                state.update(s => {
                    /*if(!s.cache) s.cache = {};
                    if(!s.cache.did) s.cache.did = [];*/
                    if(!s.cache.conditions_met) s.cache.conditions_met = [];
                    delete s.overrideDidPrevious;
                    /*if(s.cache.uncompleted){
                        delete s.cache.uncompleted;
                    }else{
                        s.cache.did_previous = true;
                        s.cache.did = [...s.cache.did, true];
                        s.cache.conditions_met = [...s.cache.conditions_met, true];
                    }
                    delete s.overrideDidPrevious;*/
                    return s;
                })
            }else{
                logText(`Condition not met: '${a.text}', so not taking action '${joinText(a.action)}'`, true);
                // Note that the action was left undone
                logDid(card, false, 'otherwise')
                state.update(s => {
                    // The condition had nothing to test (e.g. nothing was discarded), so an adjacent 'otherwise' stands down
                    if(s.cache.noSubjectCondition){
                        s.cache.otherwise = [true];
                        delete s.cache.noSubjectCondition;
                    }
                    if(!s.cache.conditions_met) s.cache.conditions_met = [];
                    s.cache.previous_condition = true;
                    s.cache.conditions_met = [...s.cache.conditions_met, false];
                    delete s.overrideDidPrevious;
                    return s;
                })
            }
        }else if(a.type == 'action_per'){
            let count = await resolveCount(p, card, {...a.per, text: a.text});
            let po = [];
            let num = count;
            
            if(typeof count != 'number'){
                if(count.min) count = count.min;
                if(count.max) count = count.max; // Has to be one or the other...
            }
            if(a.per.format == 'type_count'){
                if(get(state).cache.countResults){
                    po = [...get(state).cache.countResults]; // 
                }
            }else{
                if(get(state).cache && get(state).cache.prev_obj && Array.isArray(get(state).cache.prev_obj)){
                    po = [...get(state).cache.prev_obj, ...get(state).cache.allPrev]; // for e.g. Aenar
                }
                let int = [];
                if(get(state).cache && get(state).cache.interimPrev && Array.isArray(get(state).cache.interimPrev)){
                    int = get(state).cache.interimPrev; // for e.g. Aenar
                }
                po = [...int, ...po];
            }
            let odp = get(state).overrideDidPrevious;
            let mustRepeatVerbs = ['resolve', 'control', 'play', 'freeplay', 'activate', 'junk']
            let savedLoop = null, loopSet = false;
            try{
            for(let i = 0; i < count; i++){
                if(po){
                    // The current item is what "for each X ... do something to it" refers to.
                    let loopObj = savedLoop;
                    loopObj = setLoopObj(typeof po[0] == 'number' ? po[0] : null);
                    if(!loopSet){ savedLoop = loopObj; loopSet = true; }
                    state.update(s => {
                        s.cache.allPrev = [po[0] || null];
                        s.overrideDidPrevious = true;
                        if(typeof po[0] == 'number') s.cache.showCards = [po[0]]; // TODO check these additions don't break stuff
                        s.cache.interimPrev = false;
                        return s;
                    })
                    po = po.slice(1);
                }
                if((num.min && i > 0 && i > num.min || num.max)){
                    let choice = await choose(`${a.text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${a.text}</div>` : ''}Repeating effect, time ${num.max ? `${i + 1} (of max. ${num.max})` : `${i + 1} (no limit)`}. Do you wish to continue with this effect?`, ['Yes', 'No']);
                    if(choice == 'No') break;
                }else if(count > 1){
                    ui.update(ui => {
                        ui.per = {
                            num: i+1,
                            max: count
                        }
                        return ui;
                    })
                }
                await resolveEffects(card, a.action, attack);
            }
            }finally{
                if(loopSet) setLoopObj(savedLoop); // loops nest: put back whatever was current
            }
            ui.update(ui => {
                ui.per = false;
                return ui;
            })
            state.update(s => {
                delete s.cache.showCards;
                if(odp){
                    s.overrideDidPrevious = odp;
                }else{
                    delete s.overrideDidPrevious;
                }
                return s;
            })
            await tick();
        }else if(a.type == 'cost'){
            console.log(a.cost)
            // Optional?
            let costPlayer = possArray(a.cost)[0].actor;
            let statePreCost = perfMeasure('clone.statePreCost', () => clone(get(state)));
            if(!ignoreCosts){
                if(possArray(a.cost)[0].optional){
                    let chosen = await choose(`${upperInitial(a.text) || 'You may '+a.cost[0].text}. Proceed?`, ['Yes', 'No']);
                    if(chosen == 'No'){
                        logDid(card, false);
                        return; // Give up!
                    }//else 
                }
                let didAllCost = true;
                state.update(s => {
                    s.payingCost = card.uniqueID; //a.cost;
                    return s;
                })
                let ableBoth = a.cost.some(c => c.ableBoth);
                if(ableBoth) cacheItem('throwUncompleted', card.uniqueID);
                try{
                    for(let c of a.cost){
                        await resolveEffects(card, {...c, optional: false}, attack, forced);
                    }
                    if(ableBoth) clearCacheItem('throwUncompleted');
                    
                    state.update(s => {
                        delete s.payingCost;
                        return s;
                    })
                }catch(e){
                    console.log(e);
                    e = await checkBotHand(e);
                    if(e == 'uncompleted'){
                        if(!get(state).players[get(state).activePlayer].bot && !ableBoth){
                            if(!forced && !a.cost.some(c => c.able) && !get(state).cache.skippedLog){
                                let choice = await choose(`You can't fulfil the cost of this effect. Cancel action (i.e. reset to beginning of operation), or simply continue and leave this effect incomplete (which is cheating, unless the cost effect was optional)?`, ['Cancel', 'Continue']);
                                if(choice == 'Cancel') throw 'cancelled';
                            }
                            cardMessage(card, `Unable to pay cost: rest of effect abandoned`);
                            state.update(s => {
                                delete s.payingCost;
                                return s;
                            })
                        }else{
                            state.update(s => {
                                return statePreCost;
                            })
                            logText('Cost impossible so rolling back pre-cost');
                        }
                        logText('Action not fully completed: abandoning.', true)
                        logDid(card, false)
                        state.update(s => {
                            s.cache.uncompleted = true;
                            delete s.payingCost;
                            return s;
                        })
                        ui.update(ui => {
                            delete ui.per;
                            return ui;
                        })
                        didAllCost = false;
                        return;
                    }else if(e == 'completed'){
                        logText('Action counted as fully completed');
                        logDid(card, true);
                    }else{
                        throw e;
                    }
                }
                    // Does cancelling bubble past here? hope so!
                    await doActionPause();
    
                if(!didAllCost){
                    if(a.optional || get(state).players[get(state).activePlayer].bot){
                        return; // Complete all or miss out on action
                    }else{
                        throw 'cancelled';
                    }
                }

                // Did all the cost, so log as such
                state.update(s => {
                    if(!s.cache) s.cache = {};
                    s.cache.didLastCost = true;
                    s.cache.insideResult = true;
                    return s;
                })
            }
            
            try{
                await resolveEffects(card, a.action, attack, false, costPlayer || (p.bot ? 'bot': 'you'));
            }catch(e){
                e = await checkBotHand(e);
                let rolledBack = false;
                if(e == 'uncompleted'){
                    // should below be a.action??
                    if(isCostEffect(p, a, card) && !get(state).players[get(state).currentPlayer].bot){
                        if(!forced && !a.able){
                            let choice = await choose(`You can't fulfil the cost of this effect. Cancel action (i.e. reset to beginning of operation), or simply continue and leave this effect incomplete (which is cheating, unless the cost effect was optional)?`, ['Cancel', 'Continue']);
                            if(choice == 'Cancel') throw 'cancelled';
                        }
                        cardMessage(card, `Unable to pay cost: rest of effect abandoned`);
                    }/*else if(activePlayer().bot && a.cost){
                        // Abandon whole action
                        state.update(s => {
                            return statePreCost;
                        })
                        rolledBack = true;
                    }*/
                    logText('Action not fully completed: abandoning.', true)
                    if(rolledBack){
                        logText('Action impossible, so cost abandoned too');
                    }
                    logDid(card, false)
                    //console.log('cache', s.cache);
                    state.update(s => {
                        s.cache.uncompleted = true;
                        return s;
                    })
                    ui.update(ui => {
                        delete ui.per;
                        return ui;
                    })
                }else if(e == 'completed'){
                    logText('Action counted as fully completed');
                    logDid(card, true);
                }else{
                    throw e;
                }
                
            }
            state.update(s => {
                delete s.cache.insideResult;
                return s;
            })
            // Does cancelling bubble past here? hope so!
            await doActionPause();
        }
        state.update(s => { // !!TODO if this effect recurs elsewhere, it might need more careful broadening out...
            if(s.payingCost != card.uniqueID && savedAction && savedAction.a && savedAction.a.verb != 'repeat_previous' && (!savedAction.a.action || !possArray(savedAction.a.action).some(ac => ac.verb == 'repeat_previous'))){ // So you don't just repeat the initial payment or repeat action!!
                if(!s.cache) s.cache = {};
                s.cache.prevAction = savedAction;
            }
            return s;
        })
    }catch(e){
        console.log(get(state));
        e = await checkBotHand(e, a);
        if(e == 'uncompleted' && get(state).payingCost != card.uniqueID){
            if(isCostEffect(p, a, card) && !forced && !get(state).players[get(state).activePlayer].bot){
                if(get(state).cache.throwUncompleted){
                    throw 'uncompleted';
                }else if(!forced && !a.able && !get(state).players[get(state).currentPlayer].bot){
                    let choice = await choose(`You can't fulfil the cost of this effect. Cancel action (i.e. reset to beginning of operation), or simply continue and leave this effect incomplete (which is cheating, unless the cost effect was optional)?`, ['Cancel', 'Continue']);
                    if(choice == 'Cancel') throw 'cancelled';
                }else if(get(state).cache.throwUncompleted){
                    throw 'uncompleted';
                }
                cardMessage(card, `Unable to pay cost: rest of effect abandoned`);
            }else if(get(state).cache.throwUncompleted){
                throw 'uncompleted'; // pass it down so the whole effect is abandoned
            }
            logText('Action not fully completed: abandoning.', true)
            logDid(card, false);
            state.update(s => {
                s.cache.uncompleted = true;
                return s;
            })
            ui.update(ui => {
                delete ui.per;
                return ui;
            })
        }else if(e == 'completed'){
            logText('Action counted as fully completed');
            logDid(card, true);
            ui.update(ui => {
                delete ui.per;
                return ui;
            })
        }else{
            throw e;
        }
        
    }

    if(definitelyAttack){
        await checkForReactions(p, 'attack', {card: card.uniqueID, attacker}, 'after');
    }
}

export async function doActionPause(){
    if(get(res).BvB) return; // No waiting
    if(get(live).paused) return;
    if(get(prefs).actionPause == -1){
        await choose('Press OK to continue card actions', ['OK'], {forceChoose: true});
    }else if(get(prefs).actionPause){
        let amount = get(prefs).actionPause;
        if(get(state).players[get(state).activePlayer].bot) amount = amount * 2; // Give the human a bit of time to read!!
        live.update(l => {
            l.paused = true;
            return l;
        })
        await waitMillis(amount);
        live.update(l => {
            l.paused = false;
            return l;
        })
    }
}

// useWildcards: when false, only slots the player has already committed count
// (currentTraits() supplies those), so an uncommitted [[wildcard]] does not
// silently share a trait. NB not named countWildcards – that is a function here.
function matchTraits(card1, card2, traits = "any traits", except = false, useWildcards = true){
    let count = 0;
    if(!card1 || !card2) throw 'uncompleted'; // So that 'matches no traits' doesn't trigger
    if(!Array.isArray(card1)) card1 = [card1];
    if(!Array.isArray(card2)) card2 = [card2];
    if(card1.length == 0 || card2.length == 0) throw 'uncompleted'; // So that 'matches no traits' doesn't trigger
    if(traits == "any traits" || traits == 'at least one trait' || traits == 'a trait' || traits == 'any trait'){
        for(let c1 of card1){
            for(let c2 of card2){
                //console.log(card1, c);
                for(let t of getCard(c1).traits){
                    if(t == 'wildcard' || t == 'any species') continue; // Handle later!
                    if(except && (except == t || Array.isArray(except) && except.includes(t))) continue;
                    count += matches(getCard(c2), t, useWildcards);
                }
                if(useWildcards){
                    let numWildcards = countWildcards([getCard(c1), getCard(c2)], traits);
                    if(numWildcards > 0) count += numWildcards;
                }
            }
        }   
        
        return count;
    }else{
        // Setting specific!
        // TODO check about num etc.
        traits = traits.types || traits;
        if(!Array.isArray(traits)) traits = [traits];
        for(let t of traits){
            if(t.startsWith('any species')){
                count += matchTraits(card1, card2, {types: get(res).species}, except, useWildcards);
            }else if(t == 'same-species' || t == 'same species'){
                // Return largest number of single species, I guess
                let mostSpecies = Math.max(...get(res).species.map(s => matchTraits(card1, card2, {types: [s]}, except, useWildcards)));
                console.log('Max species count: '+mostSpecies);
                count += mostSpecies;
            }else{
                for(let c1 of card1){
                    if(!matches(getCard(c1), t, useWildcards)) continue;
                    for(let c2 of card2){
                        count += matches(getCard(c2), t, useWildcards);
                    }
                }
            }
        }
    }
    return count;
}

// --- Optional wildcard matching ------------------------------------------------
// See docs/wildcard-optionality.md. A [[wildcard]]/[[any species]] trait is an
// empty slot; committing one is the owner's decision, so an executing effect
// asks before spending it. Declining writes nothing, which is what makes the
// decline per-clause: the slot is still free for the next test in the effect.

function activeOwns(c){
    let owner = cardOwner(c);
    if(!owner) return false; // market/neutral cards have no owner to spend a slot
    return get(state).players[get(state).activePlayer].captain == owner.captain;
}

// The concrete traits a slot could be committed to so that it matches `others`.
// Helper traits are never a valid commitment - only real traits.
function wcCandidateTraits(others, traits = false, except = false){
    let lists = possArray(others)
        .map(o => getCard(o))
        .filter(c => c && c.traits)
        .map(c => currentTraits(c));
    return pickWCCandidates(lists, get(res).traits, traits, except);
}

async function askWC(holder, cands, srcCard, message){
    let options = [...cands.map(t => `Treat as [[${t}]]`), 'No'];
    let rememberKey = srcCard && srcCard.id ? `${srcCard.id}|${[...cands].sort().join('/')}` : false;
    let choice = await choose(message, options, {card: [holder.uniqueID], rememberKey});
    if(!choice || choice == 'No' || choice == 'cancelled') return false;
    return cands.find(t => choice == `Treat as [[${t}]]`) || false;
}

// Offer to commit a slot so that `cards1` and `cards2` share a trait.
// Returns true when the caller may safely test with wildcards off, i.e. every
// relevant free slot has been offered. Returns false when a slot exists that we
// could not build an offer for, in which case the caller keeps the old
// speculative behaviour rather than silently dropping a match.
export async function offerSharedWC(p, cards1, cards2, traits, except, srcCard){
    if(namedTraits(traits) == 'unknown') return false; // shape we can't build an offer from
    try{
        if(matchTraits(cards1, cards2, traits, except, false) > 0) return true; // already shares without a slot
    }catch(e){
        if(e != 'uncompleted') throw e;
        return true; // nothing to match against
    }
    let sides = [
        {holders: possArray(cards1), others: cards2},
        {holders: possArray(cards2), others: cards1}
    ];
    for(let side of sides){
        for(let h of side.holders){
            let holder = getCard(h);
            if(!holder || !holder.traits) continue;
            let cands = wcCandidateTraits(side.others, traits, except);
            if(cands.length == 0) continue; // nothing it could usefully become
            if(cardWCs(holder, cands) == 0) continue; // no free slot on this card
            if(!activeOwns(holder)) continue; // not your slot to spend - it simply doesn't match
            let chosen = await askWC(holder, cands, srcCard, `Commit a wild trait on ${cc(holder.uniqueID)} so that it shares a trait${srcCard ? ` for ${cc(srcCard.uniqueID)}` : ''}?`);
            if(chosen){
                cacheWC(holder, chosen);
                return true; // one commitment is enough to share
            }
        }
    }
    return true;
}

function isInLocation(c, loc){
    let info = get(state).cardLog[c.uniqueID];
    if(info.deck == loc) return true;
    return false;
}

async function offerWCs(count, countWithoutWCs, eligible, text, types){
    let diff = count - countWithoutWCs;
    let options = [];
    for(let i = 0; i <= diff; i++){
        options.push(`${i} wildcards`);
    }
    if(Array.isArray(types)) options.push('Assign manually');
    if(diff == 1 && eligible.length == 1){
        // Just one, so do it differently
        options = ['Treat as nothing', ...possArray(types).map(t => `Treat as [[${t}]]`)]
        let choice = await choose(`${text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${text} (currently ${countWithoutWCs})</div>` : ''}Treat [[wildcard]] as ${types ? `as ${possArray(types).map(t => `[[${t}]]`).join('/')} ` : ''} for this effect?`, options, {card: [eligible[0].uniqueID]});
        if(choice == 'Treat as nothing') return countWithoutWCs;
        choice = possArray(types).find(t => choice == `Treat as [[${t}]]`);
        cacheWC(eligible[0], choice);
        return count;
    }
    let choice = await choose(`${text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${text} (currently ${countWithoutWCs})</div>` : ''}Choose how many [[wildcard]] traits to commit ${types ? `as ${possArray(types).map(t => `[[${t}]]`).join('/')} ` : ''} for this effect:`, options);
    if(choice == 'Assign manually'){
        count = countWithoutWCs;
        eligible = eligible.sort((a,b) => {
            if(a.traits.includes('any species') && !b.traits.includes('any species')) return -1;
            if(a.traits.includes('wildcard') && !b.traits.includes('wildcard')) return -1;
            if(b.traits.includes('any species') && !a.traits.includes('any species')) return 1;
            if(b.traits.includes('wildcard') && !a.traits.includes('wildcard')) return 1;
            return 0;
        })
        let i = 0;
        for(let e of eligible){
            i++;
            let possibleTypes = ['None'];
            if(e.traits.includes('wildcard')){
                possibleTypes = [...possibleTypes, ...types.map(t => `[[${t}]]`)];
            }else if(e.traits.includes('any species')){
                possibleTypes = [...possibleTypes, ...types.filter(t => get(res).species.includes(t)).map(t => `[[${t}]]`)];
                if(possibleTypes.length == 1) continue;
            }else if(e.traits.some(t => t.startsWith('any species') && t.includes('!'))){
                let except = e.traits.find(t => t.startsWith('any species') && t.includes('!')).split('!')[1];
                possibleTypes = [...possibleTypes, ...types.filter(t => t != except).map(t => `[[${t}]]`)];
                if(possibleTypes.length == 1) continue;
            }else{
                continue; // Can't select in that case
            }
            let t = await choose(`Choose type for ${cc(e.uniqueID)} (current count ${count}, ${i} of ${eligible.length}):`, possibleTypes, {card: [e.uniqueID]});
            if(t == 'None') continue;
            // I think currently presumes only one per card, but could be tweaked later
            count++;
            t = types.find(ty => t == `[[${ty}]]`);
            cacheWC(e, t);
        }
    }else{
        choice = parseInt(choice.split(' ')[0]);
        count = countWithoutWCs + choice;
        for(let e of eligible.sort((a,b) => {
            if(a.traits.includes('any species') && !b.traits.includes('any species')) return -1;
            if(a.traits.includes('wildcard') && !b.traits.includes('wildcard')) return -1;
            if(b.traits.includes('any species') && !a.traits.includes('any species')) return 1;
            if(b.traits.includes('wildcard') && !a.traits.includes('wildcard')) return 1;
            return 0;
        })){
            let num = Math.min(choice, cardWCs(e, types));
            for(let _ of Array(num)) cacheWC(e, possArray(types)[0]);
            choice -= num;
        }
        return count;
    }
    
}

export async function resolveCount(p, card, per, verb = 'action_per'){
    let count = 0;
    let max = false;
    let min = false;
    let divDone = false;
    if(per.format == 'multiple'){
        let total = 0;
        for(let e of per.elements){
            if(e.max) max = e.max;
            total += await resolveCount(p, card, e);
        }
        count = total;
    }else if(per.format == 'simple_number'){
        let num = await resolveNum(per.num);
        return num;
    }else if(per.format == 'type_count'){
        
        //p = resolveOwner(card, a.owner);
        let eligible = [];
        count = resolveCountTypes(p, card, per.obj, verb, {...per}, eligible);
        //if(per.exclude == 'this') count--; // Now handled within countTypes, properly
        divDone = true;
        // !! TODO: stop people choosing something they have already rejected later in operation
        let countWithoutWCs = resolveCountTypes(p, card, per.obj, verb, {...per}, false, {wildcardsLeft: 0});
        if(per.max && count > per.max) count = Math.max(per.max, countWithoutWCs); // don't offer wildcards past the max
        if(countWithoutWCs < count && per.obj){
            /*let diff = count - countWithoutWCs;
            let options = [];
            for(let i = 0; i <= diff; i++){
                options.push(`${i} wildcards`);
            }
            let choice = await choose(`${per.text ? `<div style="font-weight: bold; text-align: center; font-style: italic;">${per.text} (currently ${countWithoutWCs})</div>` : ''}Choose how many [[wildcard]] traits to commit ${per.obj.types ? `as ${possArray(per.obj.types).map(t => `[[${t}]]`).join('/')} ` : ''} for this effect:`, options);
            choice = parseInt(choice.split(' ')[0]);
            count = countWithoutWCs + choice;
            for(let e of eligible.sort((a,b) => {
                if(a.traits.includes('any species') && !b.traits.includes('any species')) return -1;
                if(a.traits.includes('wildcard') && !b.traits.includes('wildcard')) return -1;
                if(b.traits.includes('any species') && !a.traits.includes('any species')) return 1;
                if(b.traits.includes('wildcard') && !a.traits.includes('wildcard')) return 1;
                return 0;
            })){
                let num = Math.min(choice, cardWCs(e, per.obj.types));
                for(let _ of Array(num)) cacheWC(e, possArray(per.obj.types)[0]);
                choice -= num;
            }*/
            count = await offerWCs(count, countWithoutWCs, eligible, per.text, per.obj.types);
        }

        console.log('counting types', count)
    }else if(per.format == 'neutral_away'){
        for(let c of getNeutralZone()){
            count += myAway(p, c);
            if(per.both_players) count += theirAway(p, c);
        }
    }else if(per.format == 'action_spent'){
        if(get(state).cache && get(state).cache.lastSpend){
            count = get(state).cache.lastSpend.actions || 0;
        }else{
            count = 0;
        }
    }else if(per.format == 'beamed_assimilated'){
        if(get(state).cache && get(state).cache.beamed_assimilated){
            count =  get(state).cache.beamed_assimilated.length;
        }else{
            count = 0;
        }
    }else if(per.format == 'tokens'){
        let toCheck = [...getNeutralZone()];
        let i = per.tokenInfo;
        if(i.con){
            // Your own away teams on cards
            let player = p;
            if(i.opp) player = otherPlayer(p);
            toCheck = [...player.decks.locations.filter(c => matches(c, 'location'))];
        }else if(i.all){
            toCheck = [...getNeutralZone(), ...get(state).players.flatMap(p => p.decks.locations.filter(c => matches(c, 'location')))];
        }
        for(let c of toCheck){
            if(testNum(i.num, countSpecificTokens(c, p, i.tokenType))) count++;
        }
    }else if(per.format == 'card_token_count'){
        let cards = await resolveObject({card: per.card}, 'card_token_count', {card: card.uniqueID}, p, null, true);
        cards = cards.filter(c => inPlay(c) && get(state).cardLog[getCard(c).uniqueID].area != 'beamed');
        let types = per.types;
        let toAdd = 0;
        if(!Array.isArray(types)) types = [types];
        for(let cid of cards){
            let c = getCard(cid);
            for(let t of types){
                if(c[t]) toAdd += c[t];
            }
        }
        //if(per.div) toAdd = Math.floor(toAdd / per.div);
        count += toAdd;
    }else if(per.format == 'value_count'){
        let cards = await resolveObject({card: per.card}, 'value_count', {card: card.uniqueID}, p, null, true);
        cards = cards.filter(c => get(state).cardLog[getCard(c).uniqueID].area != 'beamed'); // Not beamed cards
        for(let cid of cards){
            let c = getCard(cid);
            if(per.values){
                count += matches(c, per.values);
            }else if(c.values){
                count += c.values.length;
            }
        }
    }else if(per.format == 'trait_count'){
        let cards = await resolveObject({card: per.card}, 'trait_count', {card: card.uniqueID}, p, null, true);
        //cards = cards.filter(c => get(state).cardLog[getCard(c).uniqueID].area != 'beamed'); // Not beamed cards
        for(let cid of cards){
            let c = getCard(cid);
            if(c.traits){
                count += countableTraits(c.traits).length;
            }
        }
    }else if(per.format == 'species_count'){
            let cards = await resolveObject({card: per.card}, 'trait_count', {card: card.uniqueID}, p, null, true);
            //cards = cards.filter(c => get(state).cardLog[getCard(c).uniqueID].area != 'beamed'); // Not beamed cards
            let species = [];
            for(let cid of cards){
                let c = getCard(cid);
                for(let t of c.traits){
                    if(get(res).species.includes(t) && !species.includes(t)){
                        species.push(t);
                        count++;
                    }else if(t == 'wildcard'){
                        count++;
                    }
                }
            }
    }else if(per.format == 'unique_traits'){
        let cards = resolveLocCondition(card, per.location, p, [], {}, '', true);
        if(per.subcondition) cards = resolveSubCondition(p, per.subcondition, cards, {}, card); // unlikely I guess?
        if(per.exclude && !per.excludeJustTraits){
            cards = resolveExclude(card, cards, per.exclude, p);
        }
        /* if you want wildcards to be wild:
        let allTraits = cards.flatMap(c => c.traits);
        let wc = allTraits.filter(t => t == 'wildcard');
        let nowc = Array.from(new Set(...allTraits.filter(t => t != 'wildcard)));
        count += wc.length + nowc.length; */
        let traits = [];
        for(let c of cards){
            if(c.traits){
                for(let t of countableTraits(c.traits)){
                    if(!traits.includes(t)) traits.push(t);
                }
            }
        }
        //let traits = Array.from(new Set(...cards.filter(c => c.traits).flatMap(c => c.traits)));
        if(per.excludeJustTraits){
            let ex = per.exclude;
            if(!Array.isArray(ex)) ex = [ex];
            traits = traits.filter(t => !ex.includes(t));
        }
        count += traits.length;
    }else if(per.format == 'skill_icons'){
        let cards = resolveLocCondition(card, per.location, p, []);
        let skills = cards.filter(c => c.values).flatMap(c => c.values);
        count += skills.length;
    }else if(per.format == 'operations'){
        // e.g. Unicomplex: "for each endgame operation you have assimilated". Read the parsed
        // text, not getHints, which offers other operations when a card has none of this kind
        let cards = resolveLocCondition(card, per.location, p, []);
        let name = verbKeys[per.opType] || per.opType;
        for(let c of cards){
            let parsed = get(res).parsedCardText[c.id];
            if(parsed && parsed.effects) count += parsed.effects.filter(e => e.name == name).length;
        }
    }else if(per.format == 'type_set'){
        let cards = allScoreableCards(p);
        if(per.non_log) cards = cards.filter(c => !isInLocation(c, 'log'));
        let counts = [];
        for(let t of per.types){
            let num = cards.filter(c => matches(c, t, false, false /*false because presumed scoring */)).length;
            counts.push(num);
        }
        if(per.wild){
            let wilds = cards.filter(c => matches(c, per.wild, false, false)).length;
            while(wilds > 0){
                let i = counts.indexOf(Math.min(...counts));
                counts[i]++;
                wilds--;
            }
        }
        count += Math.min(...counts);
    }else if(per.format == 'trait_value_count'){
        let cards = await resolveObject({card: per.card}, 'value_count', {card: card.uniqueID}, p, null, true);
        cards = cards.filter(c => get(state).cardLog[getCard(c).uniqueID].area != 'beamed'); // Not beamed cards
        for(let cid of cards){
            let c = getCard(cid);
            if(per.values){
                count += matches(c, per.values);
            }else if(c.values){
                count += c.values.length;
            }
        }
        cards = await resolveObject({card: per.card}, 'trait_count', {card: card.uniqueID}, p, null, true);
        //cards = cards.filter(c => get(state).cardLog[getCard(c).uniqueID].area != 'beamed'); // Not beamed cards
        for(let cid of cards){
            let c = getCard(cid);
            if(c.traits){
                count += countableTraits(c.traits).length;
            }
        }
    }else if(per.format == 'value_icons'){
        // For all in play
        let cards = cardsInPlay(p, false); // Beamed doesn't count
        for(let c of cards){
            //let c = getCard(cid);
            if(c.values) count += c.values.length;
        }
    }else if(per.format == 'discarded'){
       count = getPrevVerbs('discard').flatMap(v => v.obj).length;
    }else if(per.format == 'selected'){

        let equalObjs = [];
        let type = per.lastVerb;
        for(let v of getPrevVerbs(null)){
            if(!type) type = v.verb;
            if(v.verb == type){
                console.log('selected verb', v);
                equalObjs.push(v.obj);
            }
        }
        equalObjs = equalObjs.flat(2);
        return equalObjs.length;
    }else if(per.format == 'prev_num'){
        let eligible = per.actionType ? getPrevVerbs(per.actionType, card || -1) : getLastVerb(card || -1);
        let justCountTypes = ['drone', 'away'];
        if(per.obj && !justCountTypes.includes(per.obj)){
            console.log(eligible);
            // Filter by obj

            let cards = eligible.flatMap(v => v.obj).map(c => typeof c == 'number' ? getCard(c) : c)
            if(per.obj == 'trait/skill'){
                count = cards.reduce((a,c) => a + (c.traits ? countableTraits(c.traits).length : 0) + (c.values ? c.values.length : 0), 0);
            }else if(possArray(per.obj).some(o => allResourceTypes().includes(o))){
                count = cards.filter(c => possArray(per.obj).some(o => c.specific == o || c.token == o)).reduce((a,c) => a + c.num, 0);
            }else if(possArray(per.obj).some(o => trackTypes(p).includes(o))){
                count = cards.filter(c => possArray(per.obj).some(o => c.specific == o || c.track == o)).reduce((a,c) => a + c.num, 0);
            }else{
                count = cards.reduce((a,c) => a + (per.obj == 'card' ? 1 : matches(c, per.obj)), 0);
                let countWithoutWCs = cards.reduce((a,c) => a + (per.obj == 'card' ? 1 : matches(c, per.obj, false)), 0);
                if(countWithoutWCs < count && per.obj){
                    count = await offerWCs(count, countWithoutWCs, cards, per.text, per.obj);
                }
                
                // Add wildcard options
               // let countWithWCs = count = cards.reduce((a,c) => a + (per.obj == 'card' ? 1 : matches(c, per.obj)), 0);
            }
            //let countWithWCs = 
            //let WCs = cards.flatMap(c => c.traits).filter(c => )
        }else{
            count = eligible.reduce((a, v) => a + (v.num || 1), 0);
            //console.log(getPrevVerbs(per.type), count);
        }
        
    }else if(per.format == 'returned_incident'){
        let returns = getPrevVerbs('return');
        // Real incidents actually returned...
        count = returns.filter(c => c.obj).flatMap(c => c.obj).filter(c => getCard(c) && getCard(c).suits && getCard(c).suits.includes('incident')).length;
        // ...plus claimed-success returns from the bot's hidden hand (see checkBotHand).
        count += returns.filter(c => c.claimed && c.claimedTypes && c.claimedTypes.includes('incident')).reduce((a, c) => a + (c.num || 1), 0);
    }else if(per.format == 'count_tracks'){
        count = 0;
        for(let t of per.tracks){
            let type = get(res).trackTypes.find(tr => tr.startsWith(t));
            if(!type) continue;
            let num = p[type];
            if(testNum(per.threshold, num)) count++;
        }
    }else if(per.format == 'trait_match'){
        let card1 = await resolveObject({card: per.card1}, 'type_match', {card: card.uniqueID}, p, null, true);
        if(card1.length != 1) console.log('error! more than 1 card1!', per.card1, card1);
        card1 = card1[0];
        let card2 = await resolveObject({card: per.card2}, 'type_match', {card: card.uniqueID}, p, null, true);
        //if(card2.length != 1) console.log('error! more than 1 card2!', per.card2, card2);
        //card2 = card2[0];
        count = 0;
        /*for(let c of card2){
            //console.log(card1, c);
            for(let t of getCard(c).traits){
                count += matches(getCard(card1), t);
            }
        }*/
        count = matchTraits(card1, card2)
    }else if(per.format == 'trait_avoid'){
        let card1 = await resolveObject({card: per.card1}, 'type_match', {card: card.uniqueID}, p, null, true);
        let card2 = await resolveObject({card: per.card2}, 'type_match', {card: card.uniqueID}, p, null, true);
        count = 0;
       
        for(let c1 of card1){
            let matchedNone = true;
            for(let c2 of card2){
                for(let t of getCard(c2).traits){
                    if(matches(getCard(c1), t, false)) matchedNone = false;
                }
            }
            console.log('testing trait avoidance', getCard(c1), card2.map(c2 => getCard(c2)), matchedNone)
            if(matchedNone) count++;
        }
    }else if(per.format == 'tokensToClaim'){
        let obj = await resolveObject(per.obj, 'token_count', {}, p);
        for(let o of obj){
            let c = getCard(o);
            let loc = getLocation(c);
            if(loc && loc.area == 'commons' && canControlLocation(p, c)){
                // Not claimed yet
                count += countPlayerTokens(c, p, true);
            }else{
                // May already be claimed
                if(get(state).cache && get(state).cache.tokensToClaim){
                    let ttc = get(state).cache.tokensToClaim;
                    if(ttc[o]) count += ttc[o];
                }
            }
        }
    }else if(per.format == 'completed_missions'){
        let eligible = [...p.dashboard.missions, ...p.decks.log.filter(c => c.suits.includes('mission'))].filter(c => c.complete);
        if(p.decks.completed_missions) eligible = [...eligible, ...p.decks.completed_missions];
        //count = [...p.decks.missions, ...p.dashboard.missions].filter(c => c.complete).length;
        count = eligible.length;
    }
    if(per.div && !divDone) count = Math.floor(count / per.div);
    if(per.max) max = per.max; // So that multiple-element maxes cascade
    if(per.hasOwnProperty('min')) min = per.min;
    if(max && count > max) count = max;
    if(typeof min == 'number' && count < min) count = min;
    return count;
}

function getPrevVerbs(verb, card = -1){
    if(synonyms[verb]) verb = synonyms[verb];
    if(get(state).cache && get(state).cache.prevVerbs){
        if(!verb) return get(state).cache.prevVerbs;
        let matches = get(state).cache.prevVerbs.filter(v => verbMatches(v.verb, verb));
        if(card != -1) matches = matches.filter(m => m.card && m.card == card.uniqueID);
        return matches;
    }
    return [];
}

function getLastVerb(card = -1){
    if(get(state).cache && get(state).cache.prevVerbs){
        if(card == -1){
            return [get(state).cache.prevVerbs[0]];
        }else{
            let v = get(state).cache.prevVerbs.filter(vb => vb.card == card.uniqueID);
            if(v.length > 0) return [v[0]];
        }
        
    }
    return [];
}

export function allEffectsOptional(effects){
    let all = true;
    if(!Array.isArray(effects)) effects = [ effects ];
    for(let e of effects){
        if(Array.isArray(e)){
            if(!allEffectsOptional(e)){
                all = false;
                break;
            }
        }else{
            if(!e.optional){
                all = false;
                break;
            }
        }
    }
    return all;
}

export async function resolveEffects(card, effects, attack, forced = false, currentPlayer = false, ignoreCosts = false){
    // Triggers (enlist, log, clean-up, rule consequences, bot charts...) arrive here without a
    // frame of their own: give them one, so "it" binds to this card and this run's slots
    let unit = unitNeedingFrame(effects);
    if(unit){
        let frame = pushFrame({unit, card: card && card.uniqueID !== undefined ? card.uniqueID : null, target: get(state).resolvingFrom});
        try{
            return await resolveEffects(card, effects, attack, forced, currentPlayer, ignoreCosts);
        }finally{
            popFrame(frame);
        }
    }
    // Currentplayer is so that defaults carry over

    let outerLayer = false;

    if(!get(state).cache.cardWCs){
        outerLayer = true;
        
        state.update(s => {
            s.cache.cardWCs = {};
            return s;
        })
    }

    cacheItem('cardID', card.uniqueID);

    if(!Array.isArray(effects)) effects = [ effects ];
    let isBotAttack = false;
    let watchingForCancellation = false;
    let skipConnectedEffects = false;

    let savedEffects = {
        attack,
        forced,
        effects: clone(effects)
    };
    
    for(let e of effects){
        if(!e) continue;
        
        if(e.forced) forced = true;
        if(Array.isArray(e)){
            // nb isBotAttack throughout all this
            await resolveEffects(card, e, attack || isBotAttack, forced, currentPlayer);
            continue;
        }
        if(e.ableBoth && get(state).payingCost != card.uniqueID){
            let stateBeforeEffects = perfMeasure('clone.stateBeforeEffects', () => clone(get(state)));
            let i = effects.indexOf(e);
            let eff = effects.slice(i + 1); // attempting the rest of the effects in the chain
            cacheItem('throwUncompleted', card.uniqueID);
            try{
                await resolveEffects(card, [{...e, ableBoth: false}, ...eff], attack || isBotAttack, forced, currentPlayer);
            }catch(e){
                if(e == 'uncompleted'){
                    state.update(s => {
                        s = stateBeforeEffects;
                        return s;
                    })
                    logText(`Abandoning effects as not able to do both`);
                    logDid(card, false); // Sep 2026 for otherwise
                    break; // at this point we should be out of the effects loop?
                    //throw 'uncompleted';
                }else if(e != 'completed'){
                    throw e;
                }
            }
            clearCacheItem('throwUncompleted');
            break; // nested call already resolved e and the rest of the chain
        }
        if(e.botAttack){
            isBotAttack = true;
        }
        if(e.initialAble){
            watchingForCancellation = true;
        }
        // The below is to stop subsequent effects firing if the first in an implied chain fails
        // (t)
        if(skipConnectedEffects && e.separator && ['and', 'then', ','].includes(e.separator)){
            logText('Skipping subsequent effect because first in chain failed', true);
            continue;
        }
        if(!currentPlayer){
            currentPlayer = 'you';
            let p =  get(state).players[get(state).activePlayer];
            if(p.bot) currentPlayer = 'bot';
        }
        /*if(!e.actor && e.type == 'choice' && !e.explicitChoose && currentPlayer == 'bot'){ // Just for now just bot, could be wider
            currentPlayer = e.choices.flat(3)[0].actor; // Set to first option (slight bodge for bot)
        }*/
        let player =  e.actor || /* new Aug 2025 */ get(state).cache.player /*\new*/ || currentPlayer;
        if(!player || player == 'default') player = currentPlayer; // Check that this works?
        //let opps = get(state).players.filter((p, i) => i != get(state).activePlayer);
        let p = cardOwner(card);//get(state).players[get(state).activePlayer];
        //console.log(get(state));
        if(get(state).cache && get(state).cache.cardOwner && get(state).cache.cardOwner.hasOwnProperty(card.uniqueID)) p = get(state).players[get(state).cache.cardOwner[card.uniqueID]]; // Just in case card has been given over
        let opps = get(state).players.filter(o => o.captain != p.captain);
        // Save the cached player so a per-effect actor override (esp. actor:'all', which sets it to
        // 'opponent' while resolving each opponent) doesn't leak into the next effect. Without this, a
        // following no-actor effect (e.g. Ziyal's "For each incident returned: gain glory") reads the
        // stale 'opponent' and resolves under the bot instead of the controller.
        let priorCachePlayer = get(state).cache ? get(state).cache.player : undefined;
        //console.log(p, opps, player);
        /*if(e.obj && e.obj.choice){
            e.obj.owner = player;
            player = 'you'; // See if this works!
        }*/
        if(player == 'they') player = get(state).cache.player || 'opponent';
        /*if(player == 'all'){
            cacheItem('player', 'you');
        }*/
        if(get(state).players[get(state).activePlayer].captain != p.captain && player == 'opponent'){
             // Already right
            if(get(state).players[get(state).activePlayer].bot){
                player = 'bot';
            }else{
                player = 'you';
                p = get(state).players[get(state).activePlayer]; // to continue with correct player
            }
        }
        if(player == 'bot'){
            if(get(state).players[get(state).currentPlayer].bot){
                p = get(state).players[get(state).currentPlayer]; // Presuming the bot is the one doing stuff just now
            }else if(get(state).players.filter(p => p.bot).length == 1){
                p = get(state).players.find(p => p.bot);
            }else{
                throw `Can't find correct bot opponent`;
                //p = get(state).players[get(state).currentPlayer]; // Presuming the bot is the one doing stuff just now
            }
        }
        if(player == 'opponent' || p.bot && (player == 'you' || player == 'player')){
            if(get(state).practice){
                currentPlayer = player;
                if(e.verb == 'take' && e.obj && e.obj.types == 'incident'){
                    logText(`Opponent would take [[incident]], so you gain [[glory]] instead`);
                    let num = e.obj.num;
                    if(typeof num != 'number') num = 1;
                    await doAction(get(state).players[0], 'gain_tokens', {token: 'glory', amount: num, fromSupply: true})
                }      
                continue;
            }
            if(e.forcerOptional && e.type == 'action'){
                // 'You may force your opponent to ...': the card's owner decides, before the opponent is made active
                // (otherwise a bot opponent auto-answers its own prompt with Yes)
                await changePlayer(p);
                let chosen = await choose(`${upperInitial(e.text)}. Proceed?`, ['Yes', 'No']);
                if(chosen != 'Yes'){
                    logDid(card, false);
                    if(get(state).cache.throwUncompleted == card.uniqueID) throw 'uncompleted';
                    continue;
                }
                logDid(card, true, 'uncompleted');
                e = {...e, optional: false, forcerOptional: false};
            }
            for(let o of opps){
                if(isMe(o) || choicesToLoad()  && isMe(get(state).currentPlayer)){ // || choicesToLoad()  && isMe(get(state).currentPlayer) - choicesToLoad is added so that it catches up when an offer has happened
                    if(!isMe(o)) console.log('catchup choice', get(ui).loadedChoices);
                    await changePlayer(o);
                    await resolveAction(o, card, {...e, actor: o.bot ? 'bot' : 'you'}, attack || isBotAttack, forced, ignoreCosts); // Fix Lirpa with actor = you
                    await changePlayer(p);
                }else{
                    await offerEffect(o, p, card, e, attack);
                }
                
            }
        }else{
            await changePlayer(p); // Just to ensure that the right player is active
            if(player == 'all'){
                cacheItem('player', 'you');
            }
            if(isMe(p) || choicesToLoad()  && isMe(get(state).currentPlayer)){ // || choicesToLoad()  && isMe(get(state).currentPlayer)
                if(!isMe(p)) console.log('catchup choice', get(ui).loadedChoices);
                await resolveAction(p, card, e, attack || isBotAttack, forced, ignoreCosts); 
            }else{
                await offerEffect(p, otherPlayer(p), card, e, attack || isBotAttack);
            }
            
        }
        if(player == 'all'){
            for(let o of opps){
                cacheItem('player', 'opponent');
                if(get(state).practice){
                    currentPlayer = player;
                    continue;
                }
                if(isMe(o) || choicesToLoad()  && isMe(get(state).currentPlayer)){ //  || choicesToLoad() && isMe(get(state).currentPlayer)
                    if(!isMe(o)) console.log('catchup choice', get(ui).loadedChoices);
                    await changePlayer(o);
                    await resolveAction(o, card, e, attack || isBotAttack, forced, ignoreCosts); 
                    await changePlayer(p);
                }else{
                    await offerEffect(o, p, card, e, attack || isBotAttack);
                }
            }
        }
        // Restore the cached player to what it was before this effect, so an actor override here
        // doesn't bleed into subsequent effects (see priorCachePlayer above).
        state.update(s => {
            if(!s.cache) s.cache = {};
            s.cache.player = priorCachePlayer;
            return s;
        })
        currentPlayer = player;
        if(e.endBotAttack){
            isBotAttack = false;
            currentPlayer = 'bot';
        }
        if(watchingForCancellation && get(state).cache.uncompleted){
            skipConnectedEffects = true;
            state.update(s => {
                delete s.cache.uncompleted;
                return s;
            })
        }
    }


    if(effects.length > 1){
        // cache for prevEffects, to resolve chained effects
        state.update(s => {
            if(!s.cache) s.cache = {};
            s.cache.prevEffects = savedEffects;
            return s;
        })
    }else{
        state.update(s => {
            if(!s.cache) s.cache = {};
            delete s.cache.prevEffects;
            return s;
        })
    }
    

    clearCacheItem('cardID');

    if(outerLayer){
        state.update(s => {
            delete s.cache.cardWCs;
            return s;
        })
    }

}

function syncNum(num){
    if(!num) return 1;
    if(typeof num === 'number'){
        return num;
    }else if(typeof num === 'string'){
        if(num.startsWith('any')) return 'any';
        if(num == 'same'){
            return get(state).cache.previousNums;
        }
        if(num == 'all') return 'all';
    }else if(typeof num === 'object'){
        // Here is where to handle min, max, etc.
        if(num.min) num.text = `at least ${num.min}`;
        if(num.max) num.text = `up to ${num.max}`;
        return num;
    }
}

export async function resolveNum(num, action = false){
    if(!num) return 1;
    if(typeof num === 'number'){
        return num;
    }else if(typeof num === 'string'){
        if(num.startsWith('any')) return 'any';
        if(num == 'same'){
            return get(state).cache.previousNums;
        }
        if(num == 'all') return 'all';
        if(num == 'last') return 'last';
        if(num == 'none') return 'none';
        if(num.startsWith('all_bar_')) return num;
    }else if(Array.isArray(num)){
        // multiples based on previous choice, or new choice
        console.log('Multiple number possibilities', get(state).cache)
        if(get(state).cache.hasOwnProperty('previousNums')){
            return num[get(state).cache.previousNums]; // To match
        }else{
            let i = await choose(`Choose amount${action? ` to ${action}`: ''}:`, num.map(n => `${action ? `${upperInitial(action)} ` : ''}${n}`), {cancellable: true});
            if(i == undefined || i == 'cancelled') throw 'cancelled';
            let index = num.findIndex(x => i == `${action ? `${upperInitial(action)} ` : ''}${x}`);
            //i = parseInt(i);
            if(index != -1){
                state.update(s => {
                    s.cache.previousNums = index;
                    return s;
                })
                return num[index];
            }
            throw 'bad number';
        }
    }else if(typeof num === 'object'){
        // Here is where to handle min, max, etc.
        if(num.hasOwnProperty('min')) num.text = `at least ${num.min}`;
        if(num.max) num.text = `up to ${num.max}`;
        if(num.special){
            // Calculate special
            for(let k of Object.keys(num)){
                if(num[k] == 'x') num[k] = resolveSpecial(num.special);
            }
        }
        return num;
    }
}

function resolveSpecial(s){
    if(s == 'stardate_num'){
        return get(state).stardatePlayed + 1;
    }
}

// The printed pairing is a captain-dependent operation, not a player choice.
export function captainLogVerb(p){
    if(ongoingPlayer(p).includes('log_assimilate_or_destroy')) return 'log';
    if(p.captain == 'Borg Queen') return 'assimilate';
    if(p.decks.assimilated && ongoingPlayer(p).includes('log_expend')) return 'assimilate';
    return 'log';
}

// Bots have no normal hand. Unqualified logging targets come from play;
// explicit sources and references keep their own meaning.
export function botLogsFromPlay(p, action, obj, params = {}, prep = null){
    if(!p?.bot || action != 'log' || prep || params.from || params.from_duty || obj?.location || obj?.place || obj?.type == 'prev_obj') return false;
    if(obj?.card && obj.card != 'card' && obj.card != 'cards'){
        // Top-of-deck, Duty Officer, this card, and backreferences already
        // identify their source or target. A named card still needs a source.
        if(typeof obj.card != 'object' || obj.card.place || obj.card.location || obj.card.placement || obj.card.type?.startsWith('prev_') || !obj.card.card) return false;
    }
    return !!(obj?.types || obj?.card);
}

async function parsedAction(verb, params){
    console.log('parsed action', verb, params)
    let p = get(state).players[get(state).activePlayer];
    if(verb == 'log_assimilate'){
        verb = captainLogVerb(p);
        params = {...params, verb};
    }
    let origVerb = verb;

    /*if(verb == 'return' && ongoingPlayer(p).includes('no_incident_return')){
        // Cannot return incidents
        //logText(`Ongoing effect: player ignores all [[incident]] return effects`);
        //throw 'cancelled';
        cancel(params.card, `Ongoing effect: player ignores all incident return effects`);
    }*/
   
    if(!params.from && params.in && !verb.startsWith('find')){
        params.from = params.in; // to see if this fixes Q. Basically 'in' should always be 'from'...
    }

    if(verb == 'place' && params.obj && params.obj.on && params.obj.on.card && params.obj.on.card.placement) verb = 'put';
    if(verb == 'place' && params.obj && params.obj.location && params.obj.location.place) verb = 'put';
    if(verb == 'place' && params.obj && params.to && params.to.card && params.to.card.placement){
        verb = 'put';
        params.on = params.to;
    }
    if(verb == 'return' && params.to && params.to.card && params.to.card.placement){
        verb = 'put';
        params.on = params.to;
    }
    
    if(synonyms[verb]) verb = synonyms[verb];
    /*if(verb == 'dismiss'){
        if(params.obj && (params.obj.types == 'ship' || params.obj.types == 'ships')) verb = 'dismiss_ship'; // To allow for locations to be targeted
    }*/
    //if(verb == 'take' && params.obj && params.obj.types && params.obj.types != 'incident') verb = 'gain';


    let preps = ['to', 'from', 'in', 'at', 'with', 'by', 'into', 'on']
    // Convert each element
    let noObj = false;

    if(get(state).addParams && get(state).addParams[verb]){
        // add params to this action perhaps
        params = {...params, ...get(state).addParams[verb]};
        delete get(state).addParams[verb]; // one-off
        if(Object.keys(get(state).addParams).length == 0) delete get(state).addParams; // necesssary?
    }

    if(params.addParams){
        state.update(s => {
            if(!s.addParams) s.addParams = {};
            if(!s.addParams[params.addParams.verb]) s.addParams[params.addParams.verb] = {};
            s.addParams[params.addParams.verb] = {...s.addParams[params.addParams.verb], ...params.addParams.params}
            return s;
        })
    }

    if((verb == 'place' || verb == 'put') && params.obj && params.obj.location){
        params.location = params.obj.location;
       //delete params.obj.location;
    }

    if((verb == 'place' || verb == 'put') && params.obj && Array.isArray(params.obj) && params.obj.some(o => o.location)){
        params.location = params.obj.find(o => o.location).location;
    }

    if(['warp', 'beam', 'teleport'].includes(verb) && (!params.to || params.to.length == 0)){
        params.obj = clone(params.obj); // So that conversion is done each time
        
        // To handle the 'beam/warp a card here' construction which is otherwise nasty
        let o = params.obj;
        if(!Array.isArray(params.obj)) o = [o];
        for(let obj of o){
            if(!obj) continue;
            if(obj.location){
                // Only 'here' means this card. Anything else (e.g. 'there' -> prev_obj)
                // keeps the location so it resolves as a destination in its own right,
                // as the from branch below already does.
                params.to = obj.location == 'here' ? {num: 1, card: 'this card'} : {num: 1, card: 'card', location: obj.location};
                delete obj.location;
                //params.obj = {...params.obj, location: undefined}
                console.log('replaced for beam/warp', params.to, params.obj)
            }
        }
        params.from = clone(params.from);
        let f = params.from;
        if(!Array.isArray(params.from)) f = [f];
        for(let from of f){
            if(!from) continue;
            if(from.location){
                params.to = {num: 1, card: 'card', location: from.location};
                delete from.location;
                console.log('replaced from for beam', params.to, params.from)
            }
        }
        /*if(params.obj.location){
            params.to = {num: 1, card: 'card', location: params.obj.location};
            params.obj = {...params.obj, location: undefined}
            console.log('replaced for beam', params.to, params.obj)
        }else if(params.from && params.from.location){
            params.to = {num: 1, card: 'card', location: params.from.location};
            params.from = {...params.from, location: undefined}
            if(params.from.hasOwnProperty('0')){
                // remake as array
                let fromArray = [];
                for(let o of Object.keys(params.from)){
                    if(isNaN(parseInt(o))) continue;
                    fromArray[parseInt(o)] = params.from[o];
                }
                params.from = fromArray;
                console.log('replaced for beam', params.to, params.from)
            }
            
        }*/
        
        
    }
    //if(verb == 'develop' && params.free)
    if(verb == 'duty' && !params.obj){
        // Fill in the duty object
        params.obj = {
            num: 1,
            types: 'person'
        };
    }

    if(verb == 'take' && params.obj && params.obj.types == 'incident' && get(state).players.some(p => (p.captain == 'Q' && p.bot && !canBurn()) || ongoingPlayer(p).includes('noburn_incident_discard'))){
        let doIt;
        if(get(state).commons.incidents.length == 0){
            doIt = true;
            if(p.bot){
                logText(`Unable to take an incident because none available, but Burn not triggered because of special rule`);
                throw 'uncompleted'; //
            }
        }else if(!p.bot){
            doIt = await choose(`You may meet [[incident]] costs by discarding card(s) instead. Do you want to?`, ['Yes', 'No']);
            if(doIt != 'Yes') doIt = false;
        }
        if(doIt){
            logText(`Discarding card(s) instead of taking [[incident]] costs`);
            //await parsedAction('discard', {num: 1, obj: {num: obj.num, card: 'card'}});
            // Just simply replace
            verb = 'discard';
            params = {num: 1, obj: {num: params.obj.num, card: params.obj.num == 1 ? 'card' : 'cards'}};
            // ... and just carry on like this! See if it works
        }
    }

    let origObj = clone(params.obj); // In case you need to look back at any details later (see below)

    // HERE is where to allow you to mix/match resource gain
    
    /*if(params.seqObj){
        params.obj = [...params.seqObj];
    }else */if(params.obj){
        console.log('before')
        
        params.obj = await resolveObject(params.obj, verb, params, p);
        
        console.log('after')
        if(!Array.isArray(params.obj)) params.obj = [params.obj];

    }else{
        noObj = true;
        params.obj = [null]
    }

    // Possible log replacement for cards saying 'if X would be logged, log Y instead'
    if(get(state).replaceLog && (verb == 'log' || verb == 'destroy' && get(state).replaceLog.orDestroy)){
        let replacementObj = [];
        for(let o of params.obj){
            let rep = get(state).replaceLog.find(l => l.orig == o)
            if(rep){
                let r = rep.replacement;
                //let r = await resolveObject(rep.replacement, verb, params, p);
                //if(!Array.isArray(r)) r = [r];
                if(!rep.optional || await choose(`About to ${verb} ${cc(o)}: would you like to ${rep.verb} ${r.map(r => cc(r)).join(' and ')} instead?`, ['Yes', 'No']) == 'Yes'){
                    replacementObj.push(...r);
                    verb = rep.verb;
                    logText(`Would $ ${cc(o)}, so will ${rep.verb} ${r.map(r => cc(r)).join(' and ')} instead`);
                    if(rep.stop){
                        // Stop further operations!
                        state.update(s => {
                            s.stopDuplicating = true;
                            return s;
                        })
                    }
                }else{
                    replacementObj.push(o);
                }
            }else{
                replacementObj.push(o);
            }
        }
        params.obj = replacementObj;
    }
    
    let savedCO, savedCV;
    if(get(state).cache){
        savedCO = get(state).cache.current_obj;
        savedCV =  get(state).cache.current_verb;
    }


    // NB this was above object resolution... trying it here
    state.update(s => {
        //console.log('cache current obj', clone(s.cache));
        if(!s.cache) s.cache = {};
        //console.log('current obj not there', verb)
        s.cache.current_obj = params.obj; // TODO this is a bodge which will probably come back to haunt me later aaargh
        s.cache.current_verb = {verb, obj: params.obj};
        return s;
    })


    /*if(p.bot && verb == 'return'){ // Workaround, only works for single card at a time, but it's something
        let o = params.obj;
        if(Array.isArray(o)) o = o[0];
        if(typeof o == 'number') o = getCard(o);
        if(o.suits.includes('incident') && o.deck == 'Khan'){
            console.log(`Giving to other player instead`);
            logText(`Giving incident to other player instead of returning it`);
            verb = 'give';
        }
    }*/

    console.log('parsedAction: checking reactions before', verb, params);
    /*if(params.auto)*/ await checkForReactions(p, verb, {...params/*, auto: true*/}, 'before');
    let preAfter = await checkForReactions(p, verb, {...params}, 'after', true);
    console.log('preafter check', preAfter);
    
    state.update(s => {
        if(!s.cache) s.cache = {};
        delete s.cache.current_obj;
        delete s.cache.current_verb;
        if(savedCO) s.cache.current_obj = savedCO;
        if(savedCV) s.cache.current_verb = savedCV; 
        return s;
    })

    if(get(state).cache.replacedOriginal && get(state).cache.replacedOriginal != params.card){ 
        // Jan 2026: reinstated params.card check because otherwise multiple replace effects,
        // such as BQ log replacement, give up part-way through. Q card has been changed anyway
        // so that's ok
        // May 2025: removed check on params.card so that Q's Unknown Possibilities of Existence
        // can replace location logging with destruction on itself.
        // Why did we want to prevent actions replacing actions on their own cards?
        // I can see why we don't want this for an attack, but I'm not sure whether 
        // this is an abstract possibility or a specific card caused this issue.
        // For now leaving it as a check in attack cancellation, but not for general replacement
        console.log('parsedAction: abandoning original since reaction triggered', getCard(get(state).cache.replacedOriginal), getCard(params.card), get(state).cache);
        state.update(s => {
            s.cache.replacedOriginal = false;
            s.cache.cancelled = true;
            return s;
        })
        return;  // Because it's been replaced
    }

    if(params.attack && get(state).cache.attackCancelled && params.card != get(state).cache.attackCancelled){
        console.log("Attack effects cancelled")
        if(get(state).payingCost == params.card || get(state).cache.throwUncompleted == params.card) throw 'uncompleted'; // To prevent resultant effect
        // NB don't remove the tag because it'll skip past all attack effects in the current card
        /*state.update(s => {
            s.cache.cancelled = true;
            return s;
        })*/ // NB remove the cancelled bit because it should still log as successful
        return; // because it's been cancelled
    }



    // end NB

    for(let pr of preps){
        if(params.hasOwnProperty(pr) && params[pr] && !params[pr+'_resolved']){
            console.log('resolving preposition', pr, params[pr]);
            params[pr+'_name'] = params[pr]
            params[pr] = await resolveObject(params[pr], verb, params, p, pr) 
        }
    }

    //console.log(params, verb);
    if(params.obj.some(o => o && o.separator == 'or')){
        // These are alternatives rather than all/and!
        let options = [];
        let current = [];
        for(let o of params.obj){
            if(o.separator == 'or'){
                // close previous current and start a new one
                options = [...options, current];
                current = [];
            }
            current = [...current, o];
        }
        options = [...options, current];
        let optionNames = options.map(o => {
            return {
                option: o,
                text: o.map(o => {
                    if(o.specific){
                        return Array.isArray(o.specific) ? o.specific.map(t =>`[[${t}]]`).join('/') : `[[${o.specific}]]`
                    }else if (o.types){
                        return Array.isArray(o.types) ? o.types.map(t =>`[[${t}]]`).join('/') : `[[${o.types}]]`
                    }else if(o.card && o.card.card){
                        return o.card.card;
                    }else if(typeof o == 'string'){
                        return o;
                    }else if(Array.isArray(o) && o.every(s => typeof s == 'string')){
                        return o.join('/');
                    }
                }).join(', ') // 
            }
        })
        let choice = await choose(`Choose which to ${humanReadableAction(verb)}:`, optionNames.map(o => o.text));
        choice = optionNames.find(o => o.text == choice);
        if(!choice) throw 'cancelled';
        choice = choice.option;
        params.obj = choice;
    }


    /*if((params.obj.length == 1 && !params.obj[0] || params.obj.length == 0) && ['give', 'take'].includes(verb) && origObj.types == 'incident' && get(state).players.some(p => ongoingPlayer(p).includes('noburn_incident_discard'))){
        logText(`Discarding a card instead of [[incident]] cost`);   
        await parsedAction('discard', {num: 1, obj: {num: 1, card: 'card'}});
        throw 'completed';
    } */
   
    // Jun 2026: removed below blocker code, as there's already (params.obj.length == 0) handling and atLeast handling
    // for costs, so more shouldn't be needed
    /*if((params.obj.length == 1 && !params.obj[0] || params.obj.length == 0) && !noObj && get(state).payingCost == params.card){
        // In this case there are no legitimate cards for a cost, so the cost should fail
        // This is a copy of the code below... why?
        if(origObj && origObj.num == 'all' || origObj && origObj.num == 'any'){
            console.log(`no object, but number is 'all/any' so allowing to fall through as an empty object`);
        }else{
            console.log('impossible cost')
            throw 'uncompleted';
        }
    }*/

    if((verb == 'look at' || verb == 'reveal' || verb == 'enlist' || verb == 'duty' || verb == 'choose' || verb == 'shuffle_deck_draw' || verb == 'shuffle_back') && Array.isArray(params.obj) && params.obj.length > 0) params.obj = [ params.obj ]; // It looks at multiple cards at once. Same for enlist, duty

    let action = allActions.find(ac => ac.type == verb);
    if(!action){
        console.log('No action corresponding to '+verb, params);
        await info('Complete the action '+verb);
        return
    }

    if(origObj && origObj.num == 'all' && origObj.atLeast && params.obj.filter(o => o).length < origObj.atLeast){
        logText(`Not enough objects to complete action, so abandoning`);
        throw 'uncompleted'
    }

    if(params.obj.length == 0){
        console.log('no object for this action');
        // TODO should we wipe previous objects at this point? Maybe not...? Mekleth is the problem
        // Oct 2025: don't throw if the number was 'all', just allow it to run through
        // (possible issue here of course is what happens with prev_obj, but let's see)

        if(origObj && origObj.num == 'all' || origObj && origObj.num == 'any'){
            console.log(`no object, but number is 'all/any' so allowing to fall through as an empty object`);
        }else{
            throw 'uncompleted';
        }
        
    }

    let emptyPrevVerbs = clone(get(state).cache.prevVerbs || []);
    let verbsToAdd = [];

    let objToAdd = [];

    

    for(let o of params.obj){
        let objToCopy = o;
        if(o && typeof o == 'object' && !Array.isArray(o)) objToCopy = {...o, num: o.num ? await resolveNum(o.num) : o.num};
        let copyParams = clone({...params, obj: objToCopy, auto: true});
       //console.log('prev_obj', get(state).cache.prev_obj)
        if(params.setTarget){
            let obj = await resolveObject(params.setTarget.target, params.setTarget.action, {obj: params.setTarget.target}, p);
            state.update(s => {
                s.targetAction = params.setTarget.action;
                s.target = obj;
                return s;
            })
        }
        
        if(typeof o == 'number'){
            let card = getCard(o);
            if(card && cardOwner(card) && cardOwner(card) != get(state).players[get(ui).viewing]){
                // change view
                changeView(getPlayerIndex(cardOwner(card)));
            }

            // Log location of it for future stuff
            state.update(s => {
                if(!s.cache) s.cache = {};
                s.cache.lastObjectInfo = clone(s.cardLog[o]);
                return s;
            })
        }

        

        await doAction(p, verb, copyParams);


        //console.log('copyParams, params', copyParams, params)

        let obj =  copyParams.result || copyParams.obj;
        console.log(`final obj`, obj)
        if(!Array.isArray(obj)) obj = [obj];
        //collatedObj = [...collatedObj, ...obj];

        objToAdd.push(...obj);

       console.log('parsedAction: checking reactions after', verb, params);
        verbsToAdd.push(verb);

        /*if(params.auto)*/ let after =  await checkForReactions(p, verb, {...copyParams,/* ...params, auto: true*/}, 'after', true); // ...copyParams to ensure anything new gets there, but we could revert to params or do both if need be
        if(after.length > 0){
            after = after.filter(a => !preAfter.some(pa => pa.card == a.card && pa.text == a.text));
            await freeOrderActions(after);
        }

        if(params.seqVerbs){
            let mainVerb = verb;
            for(let v of params.seqVerbs){
                let verb = v.verb;
                verbsToAdd.push(verb);
                // Feb 2026: gave up on cleaner rewrite and simply went for 
                // more specific (verb-specific) prevObj, hoping that does it
                // If not then proper refactor
                await parsedAction(verb, {obj: {defaultNum: true, num: 1, card: {type: 'prev_obj', prevType: 'card', prevVerb: {verb: mainVerb}, num: 'all'}}});
                // Feb 2026: replaced {obj: {defaultNum: true, num: 'last', card: {type: 'prev_obj'}}}
                // with actual reference to real obj
                /*let seqParams = {...params, verb};
                delete seqParams.seqVerbs;
                if(typeof objToCopy == 'number'){
                    await parsedAction(verb, {...seqParams, seqObj: objToCopy}); 
                }else{
                    await parsedAction(verb, {...params, obj: objToCopy}); 
                }*/

                
            }
        }

        await doActionPause();
    }

    // April 2025 moved out of loop to avoid repeated preAfter effects
    // So there will be reactions to individual elements and also to general sets
    if(preAfter.length > 0){
        await freeOrderActions(preAfter);
    }

    console.log('action done '+verb);
    
    // Consolidate new verbs
    let adding = [];
    if(get(state).cache.prevVerbs){
        let newCount = get(state).cache.prevVerbs.length - emptyPrevVerbs.length;
        let newVerbs = get(state).cache.prevVerbs.slice(0, newCount);
        for(let v of newVerbs){
            let a = adding.find(a => a.verb == v.verb && (!a.to || a.to == v.to));
            if(a){
                a.obj = [...possArray(a.obj), ...possArray(v.obj)];
                a.num += v.num;
            }else{
                adding.push(v);
            }
        }
    }
    

    // Set prev_obj here so that they are grouped
    state.update(s => {
        if(!s.cache) s.cache = {};
        if(!s.cache.thisCards) s.cache.thisCards = [];
        if(s.cache.interimPrev){
            s.cache.prev_obj = s.cache.interimPrev;
            if(!s.cache.allPrev) s.cache.allPrev = [];
            s.cache.allPrev = [s.cache.prev_obj, ...s.cache.allPrev];
            s.cache.interimPrev = [];
        }
        s.cache.prevVerbs = [...adding, ...emptyPrevVerbs]; // So that multiples get consolidated
        console.log('cache at end of parsedAction', s.cache);
        return s;
    })



    if(params.replace){
        console.log('flagging replacement');
        state.update(s => {
            if(!s.cache) s.cache = {};
            s.cache.replacedOriginal = params.card; // To stop the card cancelling itself
            return s;
        })
    }

}

function checkCombined(verb, obj, params){
    if(!params.obj || !Array.isArray(params.obj)) return false;
    if(!params.obj.every(o => o.types) || params.obj.some(o => o.separator && o.separator != 'and')){
        alert('Unimplemented combination '+verb, params.obj);
        return;
    }
    if(!Array.isArray(obj)) obj = [obj];
    for(let u of params.obj.map(o => o.types)){
        let met = false;
        for(let o of obj){
            let c = o;
            if(typeof c == 'number') c = getCard(c);
            if(matches(c, u)) met = true;
        }
        if(!met) return false; // something unmet, so give up
    }
    return true;
}


export function missionComplete(m, p){
    if(m.complete) return 'complete';
    //if(!get(state).cardLog[m.uniqueID].player) return false;
    //let p = get(state).players[get(state).cardLog[m.uniqueID].player];
    //if(!p) return false;

    if(getCardEffect(m, 'goal').length > 0){
        if(m.status && m.status.complete) return 'ready';
       // if(checkMission(p, m).complete) return 'ready';
        return 'waiting';
    }

    let goal = manualGoals[m.name.toLowerCase().replace('$', '').trim()];
    if(!goal) return false;
    
    // TODO check integrity first – i.e. that card text hasn't changed since it was coded

    // Then check completeness
    if(goal.check(p, m)){
        return 'ready';
    }else{
        return 'waiting';
    }
}


async function resolvePrep(prep, value, params){
    // For locations etc.
}

export function resolvePrevGoal(type){
    let poss = get(state).missionContributors;
    if(!poss || poss.length == 0) throw 'uncompleted';
    poss = poss.map(c => getCard(c));
    poss = poss.filter(c => matches(c, type));
    return poss;
}

export function resolveVisiting(card, specific){
    if(!card.whereAmI) return [];
    let visited = getCard(card.whereAmI);
    if(specific == 'Market'){
        if(!getMarketCards().some(cd => cd.uniqueID == visited.uniqueID)) return [];
    }
    return [visited];
}

export function resolveExactCard(obj, action, p = null){
    let cardNames;
    if(typeof obj == 'string'){
        cardNames = obj;
    }else if(obj.card && obj.card.card){
        cardNames = obj.card.card;
    }else if (obj.card){
        cardNames = obj.card;
    }else{
        console.log('no obj!', obj)
        throw 'uncompleted';
    }
    //console.log('resolving exact name', cardName, getCard(get(state).resolvingFrom)?.name)
    if(!Array.isArray(cardNames)) cardNames = [cardNames];
    let ret = [];
    for(let cardName of cardNames){
        if(get(state).cache && get(state).resolvingFrom){
            let cardFrom = getCard(get(state).resolvingFrom);
            if(matches(cardFrom, cardName)){
                cardName = getCard(get(state).resolvingTo).name;
            }
        }
        cardName = cardName.replaceAll('^', ''); // Remove any emphasis
        let possible = allCards().filter(c => matches(c, cardName));
        let exactNames = possible.filter(c => c.name.toLowerCase().trim() == cardName.toLowerCase().trim());
        
        if(exactNames.length > 0) possible = exactNames; // Don't be fuzzy if you can be precise
        if(p){
            possible = possible.sort((a,b) => {
                if(cardOwner(a) == p && cardOwner(b) != p) return -1;
                if(cardOwner(b) == p && cardOwner(a) != p) return 1;
                return 0;
            })
        }
        if(action == 'play' || action == 'freeplay' || action == 'discard'){
            possible = possible.filter(c => {
                // isInPlay(c)); // You can only freeplay something that is in hand
                let owner = cardOwner(c);
                if(p && owner != p) return false;
                if(owner && owner.decks && owner.decks.hand && owner.decks.hand.some(cd => cd.uniqueID == c.uniqueID)) return true;
                return false;
            });
        } // !! TODO beaming to should be only possible for cards in play, which means adding prep 
        if(action == 'warp'){
            possible = possible.filter(c => isInPlay(c) || getNeutralZone().some(cd => cd.uniqueID == c.uniqueID));
        }
        if(obj.status == 'beamed') possible = possible.filter(c => isBeamed(c));
        if(obj.status == 'deployed') possible = possible.filter(c => c && get(state).cardLog[c.uniqueID] && get(state).cardLog[c.uniqueID].deck == 'fleet');
        if(possible.length > 1){
            // Filter by matches
            if(obj.card && obj.card.specific) possible = possible.filter(p => matches(p, obj.card.specific))
            if(p && possible.filter(c => cardOwner(c) == p).length > 0) possible = possible.filter(c => cardOwner(c) == p);
            possible = possible.sort((a,b) => {
                if(a.name.toLowerCase().startsWith(cardName.toLowerCase()) || a.name.toLowerCase().endsWith(cardName.toLowerCase())){
                    return -1;
                }else if(b.name.toLowerCase().startsWith(cardName.toLowerCase()) || b.name.toLowerCase().endsWith(cardName.toLowerCase())){
                    return 1;
                }
            })
            if(obj.defaultNum || !obj.num){
                // if there's a number of possibilities and text says 'a X' rather than e.g. 'the X'
                // then we don't filter down
                possible = possible.slice(0, 1); // First one otherwise
            }
            
        }
        ret.push(...possible.map(c => c.uniqueID).filter(c => !ret.some(cd => cd == c)));
    }
   return ret; 
}

function humanReadableAction(action, params, prep = false){
    if(action == 'top') return `put on top of your ${params.place} deck`;
    if(action == 'choose') return 'select';
    if(action == 'discard_dismiss') return 'discard or dismiss';
    if(action == 'resolve') return 'duplicate';
    if(action == 'send_murf') return 'send [[murf]] to'
    if(action == 'send_murf_at') return 'send [[murf]]/[[away team]] to'
    if(action == 'away'){
        if(params.obj && params.obj.types == 'drone' || Array.isArray(params.obj) && params.obj.some(o => o.types == 'drone')) return `send [[drone]](s) to`;
        return `send [[away team]]s to`;
    } 
    if(action == 'remove_away'){
        if(params.obj && params.obj.types == 'drone' || Array.isArray(params.obj) && params.obj.some(o => o.types == 'drone')) return `remove [[drone]](s) from`;
        return `remove [[away team]]s from`;
    } 
    if(action == 'duty') return `promote to Duty Officer`;
    if(action == 'freeplay') return `free play`;
    if(action == 'control') return 'trigger its control effect';
    if(action == 'force_take') return 'force other player to take';
    if(action == 'beam'){
        if(prep == 'to') return `beam to`;
    }
    if(action == 'mark_collected') return 'mark a trait as collected';
    if(action == 'select_trait') return 'select a trait from'
    let ret = action;
    if(prep) ret += ` ${prep}`;
    return ret;
}

function practiceOpponent(p){
    if(get(state).practice && getPlayerIndex(p) == 1) return true;
    return false;
}

export function cardsAtLocation(c, p = -1){
    if(!c) return [];
    let cards = [c]; // a card is at itself
    if(c.beamed) cards = [...cards, ...c.beamed]; // !! If beamed cards are not 'at' a location then remove this
    if(c.orbiting){
        let orb = c.orbiting.filter(o => p == -1  || o.sourcePlayer == getPlayerIndex(p)).map(o => getCard(o.card));
        cards = [...cards, ...orb, ...orb.filter(o => o.beamed).flatMap(o => o.beamed)];
    }
    if(c.visiting && (p == -1 || p.captain == 'Q')){
        cards = [...cards, ...c.visiting.map(c => getCard(c))];
    }
    return cards;
}

export function shipsAtLocation(c, p = -1){
    if(!c) return [];
    if(c.orbiting){
        return c.orbiting.filter(o => p == -1 || o.sourcePlayer == getPlayerIndex(p)).map(o => getCard(o.card));
    }
    return [];
}

export function resolvePlace(p, place, action, async = false, numPlaces = 1, countContext = false){
    let entries = [];
    let chooseTypes = false;
    let asyncPossibilities = [];
    let reshuffleActions = ['log', 'assimilate', 'destroy', 'junk', 'discard', 'resolve', 'bot_resolve']
    let noReshuffleActions = ['put', 'take', 'gain']
    let top = false;
    p = getP(p);
    if(place && place.top){
        if(typeof place.top != 'number') throw 'misformed number in resolvePlace!';
        top = place.top; // !!! NB won't handle misformed Nums
        place = place.place;
    }
    if(typeof place == 'string') place = place.toLowerCase();
    if(!p) p = activePlayer(); // just as fallback
    if(p.bot) console.log('place state', get(state))
    //if(practiceOpponent(p)) throw 'completed'; // Just for general practice mode?
    if(((p.bot || practiceOpponent(p))) && (place == 'hand' || ((place == 'discard' || action == 'find' || action == 'select') && get(state).currentPlayer != get(state).activePlayer && get(state).players[get(state).activePlayer].bot) )){
        if(async && get(state).players.some(p => !p.bot)){
            /*return new Promise((resolve, reject) => {
                choose(`Action involving bot hand: do you want it to succeed or fail?`, ['Succeed', 'Fail']).then(choice => {
                    if(choice == 'Succeed') throw 'completed';
                    else throw 'uncompleted';
                })
            })*/
            state.update(s => {
                s.cache.involvesBotHand = true;
                s.cache.botHandAttack = action == 'find' || action == 'select';
                return s;
            })
            return []; // Nothing from here
            /*if(confirm(`Action involving bot hand: press OK to succeed, Cancel to fail`)){
                throw 'completed';
            }else{
                throw 'uncompleted';
            }*/
        }else{
            // Automatically judged to succeed
            throw 'completed';
        }   
    }
    if(place == 'deck' && action == 'gain'){
        // means market deck
        entries = [];
        for(let k of Object.keys(get(res).marketTypes)){
            let market = get(state).commons[get(res).marketTypes[k]];
            if(market[1]) entries.push(market[1]);
        }
        
    }else if(place == 'deck' && !noReshuffleActions.includes(action) /*&& reshuffleActions.includes(action) || p.captain == 'Rebner' && action == 'type_match'*/){
        if(async && /*!p.bot &&*/p.decks.deck.length == 0 && (numPlaces < 2 || confirm('About to potentially interact with the top of the deck: reshuffle?'))){
            // April 2025: removed blocker on bot doing this - why was it ever there??
            // The bot should auto-reshuffle too...
            // Trigger reshuffle if need be
            logText(`Deck empty, so triggering reshuffle`);
            return new Promise((resolve, reject) => {
                //resolveEffects(params.card || {uniqueID: -1}, {type: 'action', verb: 'reshuffle_poss_enlist', text: 'Reshuffle deck'}, false).
                if(isMe(p)){
                    reshuffleDeck(p, {}).then(() => {
                        resolve(p.decks.deck);
                    });
                }else{
                    let pIndex = get(state).players.findIndex(pl => pl.captain == p.captain);
                    offerEffect(p, otherPlayer(p), {uniqueID: -1}, {type: 'action', verb: 'reshuffle_poss_enlist'}, false).then(() => {
                        console.log('after offer', p, get(state).players, get(state).players[pIndex]);
                        resolve(get(state).players[pIndex].decks.deck);
                    })
                }
                
            });
        }else{
            entries = [...p.decks.deck];
        }
   /* }else if(place == 'captain_duty'){
        entries = [...p.decks.captain, ...p.decks.duty];*/
    }else if(place == 'encounter'){
        entries = [...get(state).commons.encounters];
    }else if(place == 'location'){
        entries = [...get(state).commons.locations];
    }else if(place == 'junk'){
        if(p.bot){
            entries = [...get(state).commons.junk];
            shuffle(entries) // To randomise
        }else{
            entries = [...get(state).commons.junk];
        }
    }else if(place == 'market'){
        entries = [...getMarketCards()];
    }else if(place == 'top_market'){
        // restriction should happen later
        entries = [];
        for(let t of Object.values(get(res).marketTypes)){
            if(get(state).commons[t].length > 1) entries = [...entries, get(state).commons[t][1]];
        }
    }else if(place == 'incident'){
        entries = [...get(state).commons.incidents];
    }else if(place == 'action_area'){
        entries.push(...p.decks.play);
    }else if(place == 'play'){
        entries.push(...cardsInPlay(p, true, false));
        if(countContext && ongoingPlayer(p).includes('count_traits_on_visited_cards')){
            entries.push(...visitedCards(p));
        }
    }else if(place == 'play_no_beamed'){
        entries.push(...cardsInPlay(p, false, false));
    }else if(place == 'play_no_action'){
        entries.push(...cardsInPlay(p, true, false).filter(c => !p.decks.play.some(cd => cd.uniqueID == c.uniqueID)));
    }else if(Object.keys(get(res).marketTypes).includes(place)){
        entries.push(...get(state).commons[get(res).marketTypes[place]].map(c => c.uniqueID));
    }else if(place == 'duty' || place == 'captain_duty'){
        let set = [...p.decks.duty];
        if(place == 'captain_duty') set = [...set, ...p.decks.captain];
        // Below makes Tribbles and other 'all' effects fail – selection should surely happen elsewhere
        /*if(async && set.length > 1 && action && action != 'scoring'){ // (action == 'dismiss' || action == 'recall' || action == 'log' || action == 'junk' || 'beam' || 'resolve')){
            // Select one!
            let wrapperFunction = async (a, s) => {
                let choice = await chooseCards(`Select a card to ${a}`, s);
                return choice;
            }
            return new Promise((resolve, reject) => {
                wrapperFunction(action, set).then((choice) => {
                    if(choice == 'cancelled') throw 'cancelled';
                    entries = [...entries, choice];
                    resolve(entries);
                })
            })
        }else{*/
            entries.push(...set);
        //}
    }else if(place == 'any_market'){
        if(async){
            asyncPossibilities = Object.values(get(res).marketTypes);
            chooseTypes = true;
        }else{
            // Bodge really but hey
            // Not the face-up card: with separate decks [0] is in the offer
            let skip = get(prefs).separateMarkets ? 1 : 0;
            entries = [...Object.values(get(res).marketTypes).flatMap(t => (get(state).commons[t] || []).slice(skip))];
        }
    }else if(place.types){
        let types = place.types;
        // TODO looking at different decks?
        /*if(action == 'look at' && Array.isArray(types)){
            let chosen = await choose(`Choose a deck to look at:`, types.map(t => `[[${t}]]`));
            types = types.find(t => chosen == `[[${t}]]`);
        }*/
        if(!Array.isArray(types)) types = [types];
        entries = [];

        for(let t of types){
            if(t == 'location') t = 'locations';
            if(t == 'encounter') t = 'encounters';
            if(t == 'incident') t = 'incidents';
            
            let marketDeck = false;
            if(get(res).marketTypes[t]){
                t = get(res).marketTypes[t];
                marketDeck = true;
            }
            //console.log(t, get(state).commons[t]);
            if(async && types.length > 1){
                asyncPossibilities = types;
                chooseTypes = true;
            }else{
                if(t == 'mission'){
                    // your mission cards
                    // nb in future will need to handle mission deck I guess
                    if(p.captain == 'Q'){
                        entries = [...entries, ...p.decks.continuum];
                        continue;
                    }
                }else if(marketDeck){
                    // Not face-up card
                    entries = [...entries, ...get(state).commons[t].slice(1)];
                }else{
                    entries = [...entries, ...get(state).commons[t]];
                }
                
            }
            
        }
    }else if(place.deck == 'top_discard'){
        let eligible = p.decks.discard;
        if(place.type) eligible = eligible.filter(c => matches(c, place.type));
        entries = eligible.slice(0, 1);
    }else if(typeof place == 'string' && p.decks[place]){
        entries = p.decks[place];
        for(let e  of entries){
            if(e.beamed) entries = [...entries, ...e.beamed]; // For 'in Fleet Area', for example
        }
    }else if(typeof place == 'string' && place.endsWith('_all') && p.decks[place.slice(0, -4)]){
        let pl = place.slice(0, -4);
        entries = [];
        for(let p of get(state).players){
            entries = [...entries, ...p.decks[pl]];
        }
    }else if(typeof place == 'string' && get(state).commons[place]){
        entries = get(state).commons[place];
    }else if(typeof place == 'string' && get(state).commons[`${place}s`]){
        entries = get(state).commons[`${place}s`];
    }
    if(top) entries = entries.slice(0, top);
    if(chooseTypes){
        return new Promise((resolve, reject) => {
            choose(`Choose a deck`, asyncPossibilities.map(t => `[[${t}]]`)).then((choice) => {
                let t = asyncPossibilities.find(t => choice == `[[${t}]]`);
                if(t == 'location') t = 'locations';
                if(t == 'encounter') t = 'encounters';
                if(t == 'mission'){
                    // your mission cards
                    if(p.captain == 'Q'){
                        entries = [...entries, ...p.decks.continuum];;
                    }
                }else if(get(prefs).separateMarkets && Object.values(get(res).marketTypes).includes(t)){
                    // Not face-up card
                    entries = [...entries, ...get(state).commons[t].slice(1)];
                }else{
                    entries = [...entries, ...get(state).commons[t]];
                }
                if(top) entries = entries.slice(0, top);
                resolve(entries);
            })
        })
    }else{
        return entries;
    }
   
}

export function shipLocation(s){
    if(!s) throw 'no card!'
    if(!s.ships) return false;
    let ship = s.ships[0]; // What about multiples? Don't worry for now...
    if(!s.orbitingCard) return false;
    let loc  = s.orbitingCard[ship];
    if(loc) return getCard(loc);
    return false;
}

export function otherPlayer(p){
    return get(state).players.find(pl => pl.captain != p.captain);
}

export function visitedCards(p){
    let visited = [];
    for(let c of allScoreableCards(p)){
        if(c.whereAmI) visited.push(getCard(c.whereAmI));
    }
    return visited;
}

// Locations a 'there' marker's parse-time binding names (see bind_prev.js recogniseMarkers).
function boundThere(bind){
    if(!bind || bind.kind != 'slot') return [];
    let ids = resolveFrameBinding({kind: 'slot', slot: bind.slot, part: bind.part});
    return (ids || []).map(c => getCard(c)).filter(c => c)
        .map(c => matches(c, 'location') ? c : getCard(locationOfCard(c)))
        .filter(c => c && matches(c, 'location'));
}

export function resolveLocCondition(card, loc, p, eligible, obj = {}, action = '', countContext = false){
    if(!Array.isArray(loc)) loc = [loc];
    let list = [];
    let filterbyOwner = true;
    let savedEligible = allCards();
    // What is the point of passing eligible here? It doesn't seem to use it...
    /*if(loc.length > 1 && action == 'draw'){
        // Could add for others too
        let chosen = await choose(`Choose place to draw from: `)
    }*/
    for(let l of loc){
        let pointer = null; // a card the text names directly ('here'): never filtered out for ownership
        if(l.location){
            eligible = resolveLocCondition(card, l.location, p, eligible, obj, action, countContext)
        }else if(l.place){
            if(l.owner){
                p = resolveOwner(card, l.owner);
            }
            eligible = resolvePlace(p, l.place, action, false);
            if(l.opp){
                // 'or opponent'
                let opp = get(state).players.find(pl => pl.captain != p.captain);
                eligible = [...eligible, ...resolvePlace(opp, l.place, '', false)];
            }
        }else if(l == 'beamed_here'){
            // TODO don't think the below works without specific card!
            //eligible = savedEligible.filter(e => get(state).cardLog[e.uniqueID].area == 'beamed' && get(state).cardLog[e.uniqueID].deck == card.uniqueID);
            if(!card || !card.beamed){
                eligible = [];
            }else{
                eligible = savedEligible.filter(e => card.beamed && card.beamed.some(c => c.uniqueID == e.uniqueID));
            }
           
        }else if(l == 'all_beamed'){
            eligible = allBeamed(p); // TODO check – not for other players?
        }else if(l == 'visited_cards'){
            eligible = allCards().filter(c => c.visiting && c.visiting.length > 0);
        }else if(l == 'bot'){
            let bot;
            if(get(state).players.some(p => !p.bot)){
                bot = get(state).players.find(p => p.bot);
            }else{
                bot = p; // Presume current player
            }
            eligible = [...getNeutralZone(), ...p.decks.locations, ...otherPlayer(p).decks.locations];
            if(obj.locType == 'neutral') eligible = [...getNeutralZone()];
            //if(obj.locType == 'controlled') eligible = [...getNeutralZone()];
            if(obj.types == 'ship'){
                eligible = eligible.filter(e => shipsAtLocation(e, bot).length > 0);
                eligible = eligible.flatMap(e => shipsAtLocation(e));
                //eligible = eligible.flatMap(e => shipsAtLocation(e, bot));
            }else if(obj.types == 'away'){
                eligible = eligible.filter(e => myAway(bot, e));
            }else if(obj.types == 'drone'){
                eligible = eligible.filter(e => e.drones && e.drones[bot.captain]);
            }
        }else if(l == 'opp'){
            let opp = otherPlayer(p);
            eligible = [...getNeutralZone(), ...p.decks.locations, ...otherPlayer(p).decks.locations];
            if(obj.locType == 'neutral') eligible = [...getNeutralZone()];
            //if(obj.locType == 'controlled') eligible = [...getNeutralZone()];
            if(obj.types == 'ship'){
                eligible = eligible.filter(e => shipsAtLocation(e, opp).length > 0);
                eligible = eligible.flatMap(e => shipsAtLocation(e));
                //eligible = eligible.flatMap(e => shipsAtLocation(e, bot));
            }else if(obj.types == 'away'){
                eligible = eligible.filter(e => myAway(opp, e));
            }else if(obj.types == 'drone'){
                eligible = eligible.filter(e => e.drones && e.drones[opp.captain]);
            }
        }else if(l == 'card_loc' || l == 'same'){
            let possible;
            if(l == 'card_loc'){
                // Jan 2026 replaced resolveExactCard with resolveSpecificCard
                // so that prev objs etc. work (USS Phoenix)
                // will it break stuff? Let's see!
            
               possible = resolveSpecificCard(p, obj, {card: card.uniqueID}, action); //resolveExactCard(obj);
            }else{
                possible = resolvePrevObj(obj, 1, 'at_location', action)
            }
            //console.log('card_loc', possible)
            if(possible.length == 0) return [];
            if(obj.card && obj.card.locFilter) possible = possible.filter(c => locationOfCard(getCard(c)) && matches(locationOfCard(getCard(c)), `${obj.card.locFilter} location`));
            let cardForLoc = possible[0];
            // Should only be one...
            // !!TODO now exact cards can have or, should handle plural
            //console.log('card_loc', cardForLoc)
            if(!cardForLoc){
                console.log('card not found!', obj.card.card || obj.card);
                throw `Card ${obj.card.card || obj.card} not found!`;
            }
            cardForLoc = getCard(cardForLoc);
            let loc;
            if(obj.card_itself){
                loc = cardForLoc.uniqueID;
            }else{
                // April: added beamer, since we rule that X's location means this
                /*let info = get(state).cardLog[cardForLoc.uniqueID];
                if(info.area == 'beamed'){
                    loc = parseInt(info.deck);
                }else{
                    if(!cardForLoc.ships || cardForLoc.ships.length == 0){
                        eligible = [];
                        continue;
                        //throw `No ships on ${cardForLoc.name}, so can't use its location!`;
                    }
                    // Location means where the ship is warped to
                    let ship = cardForLoc.ships[0]; // What about multiples? Don't worry for now...
                    if(!cardForLoc.orbitingCard){
                        //throw 'uncompleted';
                        // No location!
                        eligible = [];
                        continue;
                    }
                    loc = cardForLoc.orbitingCard[ship];
                }*/
               loc = locationOfCard(cardForLoc);
            }
            let c = getCard(loc);
            pointer = c;
            eligible = [c]; // Include ships at the location too
            if(c.orbiting){
                // April 2025: at location means all cards beamed to ships too
                let ships = c.orbiting.map(c => getCard(c.card));
                for(let s of ships){
                    eligible = [...eligible, s];
                    if(s.beamed){
                        eligible = [...eligible, ...s.beamed];
                    }
                }
            }
            // April 2025: add beamed cards for location too
            if(c.beamed) eligible = [...eligible, ...c.beamed];
        }else if(l == 'here'){
            // 
           /* eligible = savedEligible.filter(e => {
                if(get(state).cardLog[e.uniqueID].area == 'beamed' && get(state).cardLog[e.uniqueID].deck == card.uniqueID) return true;
                if(e.orbitingCard && e.ships && e.ships.length > 0 && e.ships.some(s => e.orbitingCard[s] == card.uniqueID)) return true;
                return false;
            });*/
            //console.log('looking here', card)
            if(card.id && card.id.includes('_passives_')){
                // It's a dashboard passive, so 'here' should be the first passive card, to capture
                // any tokens etc.
                eligible = [cardOwner(card).dashboard.passives[0]];
            }else{
                eligible = cardsAtLocation(card, p);
                pointer = card;
            }
            
            
            /*if(card.suits.includes('mission')){
                eligible = committed(card);
            }else{
                eligible = [card];
            } 
            if(matches(card, 'location') && action != 'beam'){
                if(card.orbiting) eligible = [card, ...card.orbiting.map(o => getCard(o.card))];
            }*/
            //if(card.beamed) eligible = [...eligible, ...card.beamed];
            //console.log('here', eligible);
        }else if(l == 'from_here'){
            if(action == 'warp' && card.orbiting){
                eligible = [card, ...card.orbiting.map(c => getCard(c.card))]
            }else{
                eligible = [card];
            }
        }else if(l == 'same_place'){
            // Same pile/deck
            if(get(state).cache && get(state).cache.lastObjectInfo){
                let {area, deck, player} = get(state).cache.lastObjectInfo;
                eligible = getDeck(get(state), area, deck, player);
            }else{
                throw 'uncompleted';
            }
        }else if(l == 'prev_obj'){
            // Try the below? Tie to location – don't think there are cards using 'there' without being locations
            // June correction: should mean beamed, so allow anything (no longer type = 'location')
            let prevType = 'card';
            if(['away', 'remove_away'].includes(action)){
                prevType = 'location';
            }
            let prevCards = resolvePrevObj({onTable: true}, 1, prevType, action);
            // "Warp a [[ship]] to a [[location]] ... for each of your [[away team]] there": 'there'
            // names the warped ship, and [[away team]] are only ever at locations, so count at the one
            // location that ship is now at. A location-typed lookup instead returns every location in
            // the history, which also misleads a later "that [[location]]".
            if(countContext && obj && possArray(obj.types).includes('away')){
                let places = prevCards.map(e => matches(e, 'location') ? e : locationOfCard(e)).filter(e => e);
                if(places.length == 0) places = resolvePrevObj({onTable: true}, 1, 'location', action);
                prevCards = places.slice(0, 1);
            }

            // The scan's card has left the table ("recall a [[ship]] from the same [[location]].
            // ... 2+ token there"): fall back to the location the binder pinned 'there' to.
            if(!prevCards.some(e => matches(e, 'location') || locationOfCard(e))){
                let bound = boundThere(obj && obj.locationBind);
                if(bound.length) prevCards = bound;
            }

            eligible = prevCards.flatMap(e => {
                let ret = [e];
                if(matches(e, 'location') && action != 'beam'){
                    if(e.orbiting) ret.push(...e.orbiting.map(o => getCard(o.card))); 
                }
                if(e.beamed) ret.push(...e.beamed);
                return ret;
            }); 
            filterbyOwner = false;
        }else if(l == 'prev_beamed'){
            // Try the below?
            eligible = resolvePrevObj({}, 1, 'card', action).flatMap(e => {
                let ret = [];
                if(e.beamed) ret.push(...e.beamed);
                return ret;
            }); 
            filterbyOwner = false;
        }else if(l == 'prev_beamed_ship'){
            // Try the below?
            eligible = resolvePrevObj({}, 1, 'ship', action).flatMap(e => {
                let ret = [];
                if(e.beamed) ret.push(...e.beamed);
                return ret;
            }); 
            filterbyOwner = false;
        }else if(l == 'ship'){
            eligible = savedEligible.filter(e => get(state).cardLog[e.uniqueID].area == 'beamed' && cardOwner(getCard(get(state).cardLog[e.uniqueID].deck)).captain == p.captain && matches(getCard(get(state).cardLog[e.uniqueID].deck),'ship'))
        }else if(l == 'assigned'){
            let missions = [...p.decks.missions, ...p.dashboard.missions];
            eligible = savedEligible.filter(e => missions.some(m => committed(m).includes(e)));
        }else if(l == 'action_area'){
            eligible = savedEligible.filter(c => p.decks.play.some(cd => cd.uniqueID == c.uniqueID));
        }else if(l == 'play'){
            eligible = savedEligible.filter(c => cardsInPlay(p, true, false).some(cd => cd.uniqueID == c.uniqueID));//(c => isInPlay(c));
            // April: add exceptions for Q traits on visited cards being in play
            if(countContext && ongoingPlayer(p).includes('count_traits_on_visited_cards')){
                eligible = [...eligible, ...visitedCards(p)]
            }
        }else if(l == 'duty'){
            // NB before the generic deck branch, so 'staging_duty' can widen it
            let staging = hasStagingDuty(p);
            // By uniqueID: scoring passes a cloned player, whose decks hold copies of the cards
            let ids = new Set(p.decks.duty.map(c => c.uniqueID));
            let playIDs = new Set(staging ? p.decks.play.map(c => c.uniqueID) : []);
            eligible = savedEligible.filter(c => ids.has(c.uniqueID) || (playIDs.has(c.uniqueID) && matches(c, 'person')));
        }else if(Object.keys(p.decks).includes(l)){
            let ids = new Set(p.decks[l].map(c => c.uniqueID));
            eligible = savedEligible.filter(c => ids.has(c.uniqueID));
        }else if(l == 'market'){
            eligible = savedEligible.filter(c => getMarketCards().includes(c));
        }else if(l == 'junk'){
            eligible = savedEligible.filter(c => get(state).commons.junk.includes(c));
        }else if(l == 'deployed'){
            eligible = savedEligible.filter(c => p.decks.fleet.includes(c));
        }else if(l.beamed_to){
            eligible = savedEligible.filter(c => {
                let info = get(state).cardLog[c.uniqueID];
                if(!info) return false;
                if(info.area != 'beamed') return false;
                let b = getCard(info.deck);
                if(!b) return false;
                if(!cardOwner(b) || cardOwner(b).captain != p.captain) return false; // Only your own ships!!
                let t = l.beamed_to;
                if(!Array.isArray(t)) t = [t];
                for(let type of t){
                    let f = l.beamed_filter;
                    let some = true;
                    if(f){
                        some = false;
                        if(!Array.isArray(f)) f = [f];
                        for(let filter of f){
                            if(matches(b, filter)) some = true;
                        }
                        if(!some) return false;
                    }
                    if(matches(b, type)) return true;
                }
                return false;
            });
            // Happy to filter by owner because ships already filtered
        }else if(l.beamed_specific){
            let c = resolveExactCard(l.beamed_specific, action, p);
            if(!Array.isArray(c)) c = [c];
            c = c.filter(c => cardOwner(c) && cardOwner(c).captain == p.captain);
            eligible = [];
            for(let cd of c){
                if(typeof cd == 'number') cd = getCard(cd);
                if(cd.beamed) eligible = [...eligible, ...cd.beamed];
            }
            // !DO want to filter by owner, because there could be enemy ships
        }else if(l == 'beamed_to_same_ship'){
            let max = {
                count: 0,
                cards: [],
                ship: false
            }
            for(let c of p.decks.fleet){
                if(!c.beamed || !Array.isArray(c.beamed)) continue;
                let b = [...c.beamed];
                if(obj && obj.types){
                    b = b.filter(c => matches(c, obj.types)); // TODO may need more detail in future
                }
                if(b.length > max.count){
                    max.count = b.length;
                    max.cards = [...b];
                    max.ship = c;
                }
            }
            eligible = max.cards; // So it's the ship with the most beamed that counts
            if(max.ship){
                addCardsToCache(max.ship, 'beamed_to_same_ship', {card: possID(card)}); // for 'its neutral location'
            }
            filterbyOwner = false;
        }else if(l.loc_at){
            // Presume it's a list of types, and thus it represents things at or beamed to types
            let possLocs = savedEligible.filter(c => matches(c, l.loc_at));
            eligible = [];
            
            // !! TODO l.num may give us a test for how many locations we should include here.
            // If need be, we may need to make a heuristic guess at whether to min or max 
            // where numbers are limited.

            for(let card of possLocs){
                let toAdd = [];
                // April 2025: added beamed cards too
                if(card && card.beamed){
                    toAdd = [...card.beamed];
                }

                toAdd.push(card); // April 2025: yes, the location is 'at' itself for the purpose of eg traits
                
                if(card.suits.includes('mission')){
                    toAdd.push(...committed(card));
                }

                // !! TODO replace with cardsAtLocation including handling of obj.owner == 'any'
                if(card.orbiting){
                    let ships = card.orbiting.filter(o => obj && obj.owner == 'any' || o.sourcePlayer == getPlayerIndex(p)).map(c => getCard(c.card)); // Just player's ships unless owner == 'any'
                    if(l.diff){
                        toAdd.push(ships[0]);
                    }else{
                        toAdd.push(...ships);
                    }
                }
                
                /*if(obj && (obj.types == 'token' || obj.types == 'away' || Array.isArray(obj.types) && obj.types.some(t => t == 'token' || t == 'away'))){
                    // Add your away teams here too!
                    // TODO not sure how to handle this for  counting...
                }*/

                
                eligible = [...eligible, ...toAdd];
            }
            // !! DO want to filter by owner, because there could be enemy ships
        }else if(l == 'on_captain'){
            eligible = [...p.decks.captain];
        }else if(l == 'on_bot_captain'){
            let bot = get(state).players.find(p => p.bot);
            if(!get(state).players.some(p => !p.bot)){
                bot = currentPlayer();
            }
            eligible = [...bot.decks.captain];
        }else if(l.loc_on){
            // Supplying the locations themselves, because this is away teams
            eligible = savedEligible.filter(c => matches(c, l.loc_on));   
            if(l.loc_filter){
                eligible = eligible.filter(c => matches(c, l.loc_filter));
            }
            filterbyOwner = false;
        }else if(l.loc_on_ship){
            // Now looking for a location where a ship at that location has the necessary types
            eligible = savedEligible.filter(c => {
                if(!c || !c.orbiting) return false;
                let orb = c.orbiting.filter(o => o.sourcePlayer == getPlayerIndex(p)).map(o => getCard(o.card));
                let total = 0;
                for(let s of orb){
                    for(let b of s.beamed){
                        total += matches(b, l.loc_on_ship.types)
                    }
                }
                if(testNum(l.loc_on_ship.num, total)) return true;
                return false;
            })
            // !DO want to filter by owner, because there could be enemy ships
        }
        if(obj.owner && filterbyOwner){ // filterByOwner stops it filtering out away teams on neutral locations, for Devastated Ceti Alpha VI
            eligible = eligible.filter(c => pointer && c.uniqueID == pointer.uniqueID || cardOwner(c) && resolveOwner(card, obj.owner) && cardOwner(c).captain == resolveOwner(card, obj.owner).captain);
        }
        list.push(...eligible);
    }
    return Array.from(new Set(list));
}

async function resolveType(t, p){ 
    // Dec 2025: p here to handle skill-conversion
    console.log('resolving type', t);
    if(p && ongoingPlayer(p).includes('skill_conversion')){
        t = Array.from(new Set(possArray(t).map(type => expandSkills(p, type)))); // expand it out to full list
        if(t.length == 1) t = t[0]; //...and collapse back down if there's no choice to be made
        // ...and now the below
    }
    if(Array.isArray(t)){
        if(t.some(e => e == 'wild' || e == 'wild-skill')){
            t = [...t, 'spec-res', 'spec-inf', 'spec-mil'];
            t = t.filter(t => t != 'wild' && t != 'wild-skill');
        }
        
        let types = [];
        for(let e of t){
            types.push(await resolveType(e, p));
        }
        types = Array.from(new Set(types));
        if(types.length == 1) return types[0]; // no choice
        let chosen = await choose(`Select track type for card effect`, types.map(t => `[[${t}]]`));
        return types.find(t => chosen == `[[${t}]]`);
    }
    if(t == 'spec-res' || t == 'res-guard' || t == 'res-focus' || t == 'res-skill') return 'research';
    if(t == 'spec-inf' || t == 'inf-guard' || t == 'inf-focus' || t == 'inf-skill') return 'influence';
    if(t == 'spec-mil' || t == 'mil-guard'  || t == 'mil-focus' || t == 'mil-skill') return 'military';
    if(t == 'spec-tre' || t == 'tre-guard'  || t == 'tre-focus' || t == 'tre-skill') return 'treachery';
    if(t == 'wild' || t == 'wild-skill'){
        let chosen = await choose(`Select track type for wildcard`, get(res).trackTypes.map(t => `[[${t}]]`));
        return get(res).trackTypes.find(t => chosen == `[[${t}]]`);
    }
    return t;
}

function sameCard(c1, c2){
    if(!c1 || !c2) return false;
    if(typeof c1 == 'object') c1 = c1.uniqueID;
    if(typeof c2 == 'object') c2 = c2.uniqueID;
    return c1 == c2;
}

export async function getPrevTypes(p){
    //let cache = get(state).savedCache || get(state).cache;
    let types;
    let cache = [];
    
    if(get(state).cache){
        cache = [get(state).cache];
    }
    if(get(state).savedCache){
        cache = [...cache, ...possArray(get(state).savedCache)];
    }
    // Do it as a sequence like an array?
    for(let i = cache.length - 1; i >= 0; i--){
        let s = cache[i];
        if(s.current_obj && s.current_obj.types){
            types = await resolveType(s.current_obj.types, p);
        }else if(s.current_obj && typeof s.current_obj == 'number' || Array.isArray(s.current_obj) && s.current_obj.every(c => typeof c == 'number')){
            if(Array.isArray(s.current_obj)){
                types = Array.from(new Set(s.current_obj.flatMap(c => getCard(c).suits)));
            }else{
                types = getCard(s.current_obj).suits;
            }
        }else{
            let list = [];
            if(s.interimPrev) list = [...s.interimPrev];
            if(s.allPrev) list = [...list, ...s.allPrev];
            for(let prev of list){
                if(prev.types){
                    types = await resolveType(prev.types, p);
                    break;
                }else if(typeof prev == 'number' || Array.isArray(prev) && prev.some(c => typeof c == 'number')){
                    if(Array.isArray(prev)){
                        types = Array.from(new Set(prev.filter(c => typeof c == 'number').flatMap(c => getCard(c).suits)));
                    }else{
                        types = getCard(prev).suits;
                    }
                    break;
                }
            }
        }
    }

    return types;
}

function awayAction(a){
    return ['away', 'send_murf', 'send_murf_at'].includes(a)
}

function filterOutLog(cards, action){
    let exceptionActions = ['type_match', 'trait_count', 'value_count', 'trait_check', 'prev', 'resolve'];
    if(exceptionActions.includes(action)) return cards;
    cards = cards.filter(c => {
        if(typeof c == 'number') c = getCard(c);
        let info = get(state).cardLog[c.uniqueID];
        if(info.deck == 'log'){
            let prevSelect = getPrevVerbs('select');
            if(prevSelect.some(v => v.obj == c.uniqueID)) return true; // If it was selected before then that's fine
            // A card explicitly duplicated from the Log (Anti-Time) can still be "that card"
            if(getPrevVerbs('resolve').some(v => v.obj == c.uniqueID)) return true;
            return false;
        }
        return true;
    })
    return cards;
} 

export async function resolveObject(objects, action, params, p, prep = null, justAssess = false){
    if(action == 'log_assimilate'){
        action = captainLogVerb(p);
        params = {...params, verb: action};
    }
    // TODO make some way of logging things chosen for back referencing!
    let num = 1;
    let ret = [];
    let fromDeck = false;

    if(objects.main && objects.conditional){
        // A conditional choice between two possibilities (but chosen automatically, not by player)
        let should = await resolveCondition(p, params.card, objects.conditional.condition, params.attack);
        if(should){
            objects = objects.conditional.obj;
        }else{
            objects = objects.main;
        }
    }

    if(objects.either_or){
        // Choose
        let choices = [...objects.either_or];
        let successful = true;
        do{
            let obj = choices[0];
            if(choices.length > 1 && !justAssess){
                let choice = await choose('Choose what you want to '+action, choices.map(o => o.text));
                if(!choice || choice == 'cancelled') throw 'cancelled';
                obj = choices.find(o => o.text == choice);
            }
            try {
                let o = await resolveObject(obj.obj, action, params, /*p*/ origP /* is this right?? */, prep, justAssess);
                return o;
            }catch(e){
                if(choices.length == 1){
                    if(justAssess) return [];
                    throw e;
                }
                if(!justAssess) await pause('That choice is impossible: try another');
                successful = false;
                choices = choices.filter(c => c.text != obj.text);
            }
        }while(choices.length > 0 && successful == false);
        throw 'uncompleted';
    }

    if(params.with && params.with.location){
        let obj = objects;
        if(!Array.isArray(obj)) obj = [obj];
        for(let o of obj){
            o.location = params.with.location;
        }
        console.log('replaced', obj);
        delete params.with.location;
    }

    if(action == 'regenerate'){
        // Just return...
        return objects;
    }

    if(action == 'gain_card_tokens' && objects == 'market'){
        // Select in action
        return objects;
    }

    if(['find','find_recall','scan_of', 'gain_lowest', 'gain_highest', 'choose', 'swap_junk'].includes(action) && !prep){
        console.log('just returning item', action, objects)
        if(action == 'find' && objects.num == 'any') objects.num = 1; // for 'find any card'
        if(objects.types == 'same_suit' || objects.types == 'same_track'){
            console.log('same', get(state));
            let types = await getPrevTypes(p);
            if(types){
                return {...objects, types};
            }else{
                return [];
            }
            
        }
        return objects;
    }

    if(action == 'remove_away' && prep == 'from') justAssess = false; // You have to pick a location to remove Away Teams from
    if(awayAction(action) && ['at','on','to'].includes(prep)) justAssess = false; // Likewise for adding to

    if(!Array.isArray(objects)) objects = [ objects ]; // Presume multiple;

    if(prep){
        params[prep+'_resolved'] = true; // To stop repeats
    }

    if(action == 'scan_for'){
        if(objects.some(o => o.card && o.card.card)){
            /*if(Array.isArray(objects[0].card.card)){
                let chosen = await choose(`Choose card to scan for:`, objects[0].card.card);
                if(!chosen || chosen == 'cancelled') throw 'cancelled';
                return chosen
            }*/
           return objects[0].card.card; // Let the scan routine sort it out!
        }else{
            if(objects.length == 1){
                if(objects[0].types == 'prev_species'){
                    let prev = await resolveObject(objects[0].prev, 'prev', params, p);
                    if(Array.isArray(prev)) prev = prev[0];
                    prev = getCard(prev);
                    if(prev && prev.traits){
                        let poss = get(res).species.filter(s => prev.traits.includes(s));
                        //console.log(poss);
                        return [poss];
                    }else{
                        await pause('No discarded card to get traits from');
                        throw 'uncompleted';
                    }
                }else{
                    return [objects[0].types];
                }
                
            }
            //console.log(objects);
            if(params.scan_different && get(state).cache && get(state).cache.scanForTypes){
                objects = possArray(objects).filter(t => !get(state).cache.scanForTypes.includes(t.types));
            }
            if(justAssess) return [objects[0]]; // to stop it asking in tests
            let chosen = await choose(`Choose type to scan for:`, objects.map(o => `[[${o.types}]] ${o.types}`));
            if(!chosen || chosen == 'cancelled') throw 'cancelled';
            return [objects.find(o => chosen == `[[${o.types}]] ${o.types}`).types];
        }
        
    }
    let origP = p;

    if(objects.some(o => o.separator == 'or') && objects.every(o => o.types && typeOfGain(o.types) == 'card')){
        // Something of a bodge because of not handling 'and' – TODO generalise
        let types = [];
        let newObj = {};
        for(let o of objects){
            types = [...types, o.types];
            newObj = {...newObj, ...o};
        }
        newObj.types = types;
        objects = [newObj];
        console.log(objects);
    }

    if(action == 'draw' || action == 'draw_reveal'){
        if(prep == 'from' && objects.length > 1){
            let choice = await choose(`Choose place to draw from:`, objects.map(p => upperInitial(p.place)));
            if(choice == 'Deck') return ['deck']; // to make it trigger drawCard
            objects = [objects.find(o => choice == upperInitial(o.place))];
        }
    }
    

    for(let obj of objects){
        //obj = clone(obj); //{...obj}; // 
        let types = obj.types;

        if(params.extra_num){
            // currently not matching params.extra_num.types
            if(obj.num){
                obj.num += params.extra_num.num;
            }else if(obj.card && obj.card.num){
                obj.card.num += params.extra_num.num;
            }
            
        }

        if(types == 'same_suit' || types == 'same_track'){    
            // For 'do X with same suit' etc.
            console.log('same', types, obj, get(state).cache, get(state).savedCache)
            let key = 'suits';
            if(types == 'same_track') key = ['stripe','values'];
            if(get(state).savedCache && Array.isArray(get(state).savedCache)){
                for(let i = get(state).savedCache.length - 1; i >= 0; i--){
                    let s = get(state).savedCache[i];
                    if(s.current_obj && s.current_obj.types){
                        types = await resolveType(s.current_obj.types, p);
                    }else if(s.current_obj && typeof s.current_obj == 'number' || Array.isArray(s.current_obj) && s.current_obj.every(c => typeof c == 'number')){
                        if(Array.isArray(s.current_obj)){
                            types = Array.from(new Set(s.current_obj.flatMap(c => {
                                c = getCard(c);
                                let t = [];
                                for(let k of possArray(key)){
                                    if(c[k]) t = [...t, ...possArray(c[k])];
                                }
                                return t;
                            })));
                        }else{
                            let t = [];
                            let c =  getCard(s.current_obj);
                            for(let k of possArray(key)){
                                if(c[k]) t = [...t, ...possArray(c[k])];
                            }
                            if(types == 'same_track'){
                                types = await resolveType(t, p);
                            }else{
                                types = t;
                            }
                        }
                    }
                }
            }else if(get(state).cache && get(state).cache.allPrev){
                for(let pr of get(state).cache.allPrev.flat(2)){
                    if(pr.types){
                        types = await resolveType(pr.types, p);
                        break;
                    }
                    if(typeof pr == 'number'){
                        let c = getCard(pr);
                        if(c){
                            let t = [];
                            for(let k of possArray(key)){
                                if(c[k]) t = [...t, ...possArray(c[k])];
                            }
                            if(types == 'same_track'){
                                types = await resolveType(t, p);
                            }else{
                                types = t;
                            }
                            break;
                        }
                    }
                }
            }else{
                return []; // Nothing to be got
            }
        }

        p = origP;
        if(obj.owner) p = resolveOwner(getCard(params.card), obj.owner);
        //if(params.actor) p = 
        if(typeof types == 'string' && types.includes('opponent')){ // We are specifically looking for things belonging to our opponent
            // Jun 2026: noting that this is pretty iffy for Array types
            p = get(state).players.find(o => o.captain != p.captain);
        }
        if(obj == 'this card' || obj == 'this ship' || obj == 'this'){
            ret.push(params.card);
            continue;
        }
        if(obj.num) num = await resolveNum(obj.num, action);
        let eligible = p.decks.hand;
        //if(get(state).cache && get(state).cache.setupActions) eligible = [...allCards()]
        // The Bot has no hand: an opponent's effect forcing it to discard 'a card' (e.g. Bassen Rift)
        // must not reach into the cards it has drawn into play, even on the Bot's own turn
        let botHandDiscard = p.bot && action == 'discard' && (get(state).currentPlayer != get(state).activePlayer || params.card !== undefined && getCard(params.card) && !cardOwner(getCard(params.card)).bot);
        if(botHandDiscard){
            state.update(s => {
                s.cache.involvesBotHand = true;
                s.cache.botHandAttack = true;
                return s;
            })
        }
        if(p.bot) eligible = botHandDiscard ? [] : p.decks.play; // Just for 'this ship' etc.?
        let logFromPlay = botLogsFromPlay(p, action, obj, params, prep);
        if(logFromPlay) eligible = cardsInPlay(p);
        if(action == 'put' && !params.from && p.bot) eligible = [...p.decks.discard]; // Presume it's 'return from discard'
        if(action == 'loc_test') eligible =  [...allCards()]; // So you have all available cards to check for location - see if it works
        if(awayAction(action)){
            eligible = [...p.decks.locations.filter(c => matches(c, 'location'))];
            if(!obj.owner || prep != 'from') eligible = [...getNeutralZone(), ...eligible];
            if((obj.num && obj.num.any) || (obj.qualifier && obj.qualifier.type == 'have') || ((obj.types == 'drone' || prep == 'to' && obj.types == 'location' && possArray(params.obj).some(o => o && o.type == 'drone')) && p.captain == 'Borg Queen' && !p.bot)){
                // April: added opponent locations on qualifier so you can warp for BQ when opponent ships on location
                // Also added 'any' handling for Borg Spatial Trajector and similar
                // The BQ bot only gets opponent locations when explicitly told to ('any', a qualifier, or
                // an 'opponent' owner, which swaps p above): a bare 'send a drone to a location' is neutral only
                eligible = [...eligible, ...otherPlayer(p).decks.locations.filter(c => matches(c, 'location'))];
            }
            eligible = eligible.filter(c => canBeamTo(p, c, params));
            if(params.not_badlands) eligible = eligible.filter(c => !isBadlands(c));
        }
        
        if(action == 'exhaust') eligible = [...cardsInPlay(p, false)].filter(c => !c.activated);
        if(action == 'refresh') eligible = [...cardsInPlay(p, false)].filter(c => c.activated);
        if(action == 'dismiss') eligible = [...p.decks.duty, ...p.decks.fleet, ...p.decks.missions, ...allBeamed(p)].filter(c => !ongoingEffects(c).includes('cannot_dismiss') && !ongoingEffects(beamedHost(c)).includes('no_mission_dismissal')); //  ...p.decks.play
        if(action == 'discard_dismiss') eligible = [...p.decks.hand.filter(c => !ongoingEffects(c).includes('cannot_discard')), ...[...p.decks.duty, ...p.decks.fleet, ...p.decks.missions, ...allBeamed(p)].filter(c => !ongoingEffects(c).includes('cannot_dismiss') && !ongoingEffects(beamedHost(c)).includes('no_mission_dismissal'))];
        if(action == 'dismiss' && prep == 'from'){ // include oppponent too
            eligible = [...p.decks.duty, ...p.decks.fleet, ...p.decks.locations, ...getNeutralZone(), ...allBeamed(p), ...p.decks.missions].filter(c => !ongoingEffects(c).includes('cannot_dismiss') && !ongoingEffects(beamedHost(c)).includes('no_mission_dismissal')); // ...p.decks.play
            if(obj.num && obj.num.any){
                let o  = otherPlayer(p);
                eligible = [...eligible, ...o.decks.fleet, ...o.decks.locations, ...allBeamed(o)].filter(c => !ongoingEffects(c).includes('cannot_dismiss') && !ongoingEffects(beamedHost(c)).includes('no_mission_dismissal'));
            }
            /*if(obj.types && obj.types == 'ship'){
                eligible = eligible.filter(e => shipsAtLocation(e).length > 0);
                //if(obj.another) eligible =
            }*/
           if(types == 'neutral location'){
                eligible = eligible.filter(e => shipsAtLocation(e).length > 0);
           }
        }
        if(action == 'recall'){
            // Dec 2025: added staging area back in (and thus the separate version below is no longer necessary)
            eligible = [...p.decks.duty, ...p.decks.locations, ...p.decks.fleet, ...p.decks.missions, ...allBeamed(p)].filter(c => !ongoingEffects(c).includes('cannot_recall') && !ongoingEffects(beamedHost(c)).includes('no_mission_dismissal')); //...p.decks.play
            eligible = [...eligible, ...p.decks.play.filter(c => !ongoingEffects(c).includes('cannot_recall') && !ongoingEffects(c).includes('cannot_recall_from_staging'))]
            
        }
        /*if(action == 'recall' && prep == 'from'){
            eligible = [...p.decks.duty, ...p.decks.locations, ...p.decks.fleet, ...p.decks.missions, ...allBeamed(p), ...p.decks.play].filter(c => !ongoingEffects(c).includes('cannot_recall') && !ongoingEffects(beamedHost(c)).includes('no_mission_dismissal')); //...p.decks.play
        }*/
        if(action == 'beam' && prep){
            eligible = [...p.decks.fleet, ...p.decks.locations];
            if(possArray(obj.types).includes('neutral location')) eligible = [...eligible, ...getNeutralZone()];
        }
        
        if(action == 'control') eligible = [...p.decks.locations, ...getNeutralZone()];
        if(action == 'gain_control') eligible = [...getNeutralZone()];
        if(action == 'accept'){
            if(p.decks.missions.filter(m => !m.complete).length >= 2) throw 'uncompleted'; // Cannot accept more than 2 at once
            eligible = eligible.filter(e => matches(e, 'mission'));
        }
        if(action == 'select' && !prep){
            eligible = [...p.decks.hand, ...cardsInPlay(p)];
            if(p.captain != get(state).players[get(state).activePlayer].captain){
                eligible = [...cardsInPlay(p)];
            }
            if(obj.types && obj.types.endsWith && obj.types.endsWith('location') 
            || Array.isArray(obj.types) && obj.types.some(o => o.endsWith && o.endsWith('location'))){
                eligible = [...eligible, ...getNeutralZone()];
                if(params.not_badlands) eligible = eligible.filter(c => !isBadlands(c));
            }
        }
        if(['log', 'recall', 'assimilate'].includes(action) && !prep){
            for(let t of possArray(types)){
                if(typeof t == 'string' && t.includes('location')){
                    if(t.includes('opponent controlled')){
                        eligible = [...eligible, ...otherPlayer(p).decks.locations];
                    }else if(t.includes('neutral')){
                        eligible = [...eligible, ...getNeutralZone()];
                    }else{
                        // Presume controlled
                        eligible = [...eligible, ...p.decks.locations];
                    }
                }else if(typeof t == 'string' && t.includes('ship') && (action == 'recall' || t.includes('deployed'))){
                    // Feb 2026: why is this here?? You can't normally log
                    // from play, can you??
                    // ...so added recall filter
                    eligible = [...eligible, ...p.decks.fleet, ...allBeamed(p)];
                }
            }
        }
        if(action == 'evaluate') eligible = [...getNeutralZone()];
        if(action == 'force_take'){
            let num = obj.num || 1;
            if(typeof obj.num != 'number'){
                let min = num.min || 0;
                let max = num.max || num.min;
                if(min || max){
                    let options = [];
                    for(let i = min; i <= max; i++){
                        options.push(`${i}`);
                    }
                    let choice = await choose(`How many [[${obj.types}]] to force opponent to take?`, options);
                    num = parseInt(choice);
                }else{
                    num = 1; // TODO fallback
                }
            }
            eligible = [...get(state).commons.incidents.slice(0, num)];
            ret.push(...eligible.map(c => c.uniqueID));
            continue;
        }
        //if(action == 'gain' && types == 'encounter') action = 'take'; // For now!
        if(action == 'gain' && !params.from){
            eligible = [...getMarketCards()];
            // Dec 2025: added ability to block via passives
            // ...then removed because of face-up deck
            /*if(ongoingPlayer(p).includes('ignore_gain_types')){
                let types = ongoingPlayer(p, 'ignore_gain_types').flat(2);
                eligible = eligible.filter(c => !matches(c, types, false));
            }*/

            // May 2025: added filter
            eligible = await resolveFilters(p, obj, params, eligible, action);
            fromDeck = true;
            // Top of the market deck can't have anything visiting it (e.g. Vash: 'gain a cargo with a qsuit visiting')
            if(JSON.stringify([obj.qualifier, obj.subcondition]).includes('visiting')) fromDeck = false;
            if(types == 'incident'){
                fromDeck = false;
                let n = 1;
                if(typeof num == 'number') n = num;
                eligible = [...get(state).commons.incidents.slice(0, n)];
                ret.push(...eligible.map(c => c.uniqueID));
                continue; // Specifically for bot gaining incident
            }
        }else if(action == 'take' && !params.from){ // to allow 'take incident from Bot discard
            let n = 1;
            if(typeof num == 'number') n = num;
            if(obj.card && obj.card.type != 'prev_obj' && !types) types = obj.card.type;
            if(types == 'incident'){
                fromDeck = false;
                eligible = [...get(state).commons.incidents.slice(0, n)];
                ret.push(...eligible.map(c => c.uniqueID));
                continue; // Take always goes for the top one
            }else if(types == 'encounter'){
                fromDeck = false;
                eligible = [...get(state).commons.encounters.slice(0, n)]; // What if num isn't a number?
                ret.push(...eligible.map(c => c.uniqueID));
                continue; // Take always goes for the top one
            }else if(obj.card && obj.card.card == 'redshirt'){
                console.log('taking redshirt');
                fromDeck = false;
                eligible = [...get(state).commons.redshirts.slice(0, n)];
                ret.push(...eligible.map(c => c.uniqueID));
                console.log(ret);
                continue; // Take always goes for the top one
            }else if(obj.card && obj.card.type == 'prev_obj'){
                // What to do here...?
            }else if(p.bot){
                // Taking from top of respective deck for bot
                console.log('taking from market');
                eligible = [...getMarketCards()];
                // May 2025: added filter
                eligible = await resolveFilters(p, obj, params, eligible, action);

                /*fromDeck = false;
                eligible = [...get(state).commons[get(res).marketTypes[types]].slice(0, n)];
                ret.push(...eligible.map(c => c.uniqueID));
                console.log(ret);
                continue; // Take always goes for the top one*/
            }
            
        }
        if(action == 'teleport'){
            if(prep){
                // where can we teleport it to
                
                if(p.bot){
                    // more restricted
                    eligible = [ ...getNeutralZone(), ...getMarketCards()];
                }else{
                    eligible = [...cardsInPlay(p), ...cardsInPlay(otherPlayer(p)), ...getNeutralZone(), ...getMarketCards()];
                }
            }else{
                eligible = [...p.decks.captain, ...p.decks.fleet.filter(c => matches(c, 'qsuit'))];//[...cardsInPlay(p)].filter(c => matches(c, 'qsuit'));
                if(ongoingPlayer(p).includes('only_self_teleport')){
                    // only by effects on their own cards
                    eligible = eligible.filter(e => e.uniqueID == params.card);
                }
            }
        }
        if(action == 'warp'){
            if(prep){
                eligible = [...p.decks.locations, ...getNeutralZone(), ...p.decks.missions, ...p.decks.fleet.filter(c => ongoingEffects(c).includes('can_warp_here'))];
                let opp = get(state).players.find(pl => pl.captain != p.captain);
                if(params.including_to_opp_loc){ 
                    
                    // Include opponent controlled locations too
                    
                    eligible = [...eligible, ...opp.decks.locations];
                }
                if(ongoingPlayer(p).includes('only_warp_by_types')){
                    let owt = ongoingPlayer(p, 'only_warp_by_types');
                    let card = getCard(params.card);
                    if(!matches(card, owt)) return [];
                }
                /*let allRestrictions = get(state).players.flatMap(p => ongoingPlayer(p, 'only_types_warp_ship_location'));
                if(allRestrictions.some(r => !matches(getCard(params.card), r))){
                    let excluded = [];
                    outer: for(let l of eligible){
                        let ships = shipsAtLocation(l, opp);
                        for(let s of ships){
                            let ot = ongoingEffects(s, 'only_types_warp_ship_location');
                            if(ot.length > 0){
                                ot = ot[0];
                                if(!matches(getCard(params.card), ot)){
                                    excluded.push(l);
                                    break outer;
                                }
                            }
                        }
                    }
                    eligible = eligible.filter(l => excluded.some(e => e.uniqueID != l.uniqueID));
                }*/
                //justAssess = true; // Why would we justassess?
            }else{
                eligible = p.decks.fleet.filter(c => !ongoingEffects(c).includes('cannot_warp'));
                if(ongoingPlayer(p).includes('only_warp_by_types')){
                    let owt = ongoingPlayer(p, 'only_warp_by_types');
                    let card = getCard(params.card);
                    if(!matches(card, owt)) return [];
                }
            }    
            if(params.not_badlands) eligible = eligible.filter(c => !isBadlands(c));
        }
        if(action == 'duty'){
            eligible = eligible.filter(c => !ongoingEffects(c).includes('cannot_promote'))
        }
        if(action == 'scoring') eligible = allScoreableCards(p);
        
        if(prep == 'with'){
            eligible = allCards(); // Because we'll be doing the intersection later...
            justAssess = true;
        }
        if(types == 'duty' || Array.isArray(types) && types.includes('duty')){
            eligible = [...eligible, ...p.decks.duty];
        }
        if(!prep && params && params.from){
            if(!params.from_resolved){
                if(params.from.from) params.from = params.from.from;
                //params.from_name = params.from;
                params.from = await resolveObject(params.from, action, params, /* p */ origP /* is this right? */, 'from', false); // TODO do we want the just_assess at the end?
                params.from_resolved = true;
                if(params.from.length > 0 && params.from[0] == 'deck') return objects; // just return orig
            }
            //console.log(prep, params.from);
            eligible = params.from.flat(2).map(c => getCard(c)); // TODO cheap fix...
            if(action == 'gain' && !eligible.some(c => getMarketCards().includes(c))) fromDeck = false;
            if(obj && (possArray(types).some(t => typeof t == 'string' && (t.endsWith('ship') || t.endsWith('ships'))))){
                // Expand it now so that it can include the original places if need be (i.e. so that both 'log a ship from hand' and 'log a ship from a neutral location' work)
                eligible = [...eligible, ...eligible.flatMap(c => c.orbiting && c.orbiting.length > 0 ? c.orbiting.map(o => getCard(o.card)) : [])];
                if(obj.owner){
                    console.log(resolveOwner(getCard(params.card), obj.owner))
                    eligible = eligible.filter(c => resolveOwner(getCard(params.card), obj.owner) == cardOwner(c));
                }else if(action == 'warp'){
                    // You can only warp your own ships unless the card names another owner
                    eligible = eligible.filter(c => !matches(c, 'ship') || cardOwner(c) == origP);
                }
            }
        }

        if(action == 'remove_away'){
            let owner = p;
                if(params.obj.types == 'opp_away'){
                    owner = otherPlayer(p);
                }else if(params.obj.owner){
                    owner = resolveOwner(getCard(params.card), params.obj.owner); 
                }
            if(prep == 'from'){

                // The below probs needs rewriting tbh...
                
                eligible = [...owner.decks.locations.filter(c => matches(c, 'location')), ...otherPlayer(owner).decks.locations.filter(c => matches(c, 'location')),  ...getNeutralZone()];
                if(params.obj.types == 'drone'){
                    eligible = eligible.filter(c => allDrones(c));
                }else if(params.obj.types){
                    eligible = eligible.filter(c => possArray(params.obj.types).some(t => countSpecificTokens(c, 'all', t)));
                }else{
                    eligible = eligible.filter(c => allAway(c, action));
                }
                if(obj.card && obj.card.place == 'captain'){
                    if(params.obj.types == 'drone'){
                        eligible = [...owner.decks.captain.filter(c => c.drones && c.drones[owner.captain])];
                    }else{
                        eligible = [...owner.decks.captain.filter(c => myAway(owner, c))];
                    }
                    if(ongoingPlayer(p).includes('mimic_captain')){
                        eligible = [...eligible, ...ongoingPlayerWithCards(p).filter(o => o.effects.includes('mimic_captain')).map(o => o.card)];
                    }
                    ret.push(...eligible.map(c => c.uniqueID));
                    continue; // No need to go and select
                }else if(params.obj.num == 'all' || params.obj.num && params.obj.num.any){
                    eligible = eligible.filter(c => allAway(c, action));
                }else if(params.obj.types != 'drone'){
                    eligible = eligible.filter(c => countPlayerTokens(c, owner));
                }
                
            }else if(!params.from){
                // If there is a params.from then eligible is already sorted by this point
                // Otherwise, we presume you only include your own locations
                eligible = [...owner.decks.locations.filter(c => matches(c, 'location')), ...getNeutralZone()];
            }

            // Drones are away teams but protected: only an ATTACK naming a [[drone]] removes one.
            // Drop targets holding nothing this effect may actually take, so it whiffs cleanly
            // instead of prompting for a pick that removeAwayTeam() would then throw on.
            let ownerSpecific = params.obj.types == 'opp_away' || params.obj.owner;
            eligible = eligible.filter(c => ownerSpecific
                ? removableAway(p, owner, c, params) > 0
                : get(state).players.some(pl => removableAway(p, pl, c, params) > 0));
            
            /*if(obj.num && obj.num.any){
                let o  = otherPlayer(owner);
                eligible = Array.from(new Set([...eligible, ...o.decks.locations])); // To avoid duplication 
            }
    
            if(obj.num == 'all' || prep == 'from'){
                eligible = eligible.filter(c => allAway(c, action));
            }else{
                eligible = eligible.filter(c => myAway(owner, c, action));
            }

            if(prep == 'from'){
                ret.push(...eligible.map(c => c.uniqueID));
                continue; // Select in the main object resolution function, not when resolving params.from
            }
            */
            /*if(params.from && params.from.card && params.from.card.place == 'captain'){
                eligible = [...p.decks.captain.filter(c => myAway(p, c))];
                ret.push(...eligible.map(c => c.uniqueID));
                continue; // No need to go and select
            }*/
            //if(eligible.length == 0) throw 'uncompleted'; // Can't remove if none there
        }

        if(action == 'duty' && ongoingPlayer(p).includes('no_attack')) eligible = eligible.filter(c => !c.suits.includes('attack'));
        if(action == 'beam' && !prep) eligible = eligible.filter(c => !matches(c, 'location') && !ongoingEffects(c).includes('cannot_beam'));
        if(['put', 'draw'].includes(action)){
            eligible = eligible.filter(e => get(state).cardLog[e.uniqueID].deck != 'log' || !matches(e, 'mission')) // not from log
        }
        if(action){

            eligible = eligible.filter(c => !ongoingEffects(c, 'ongoing').includes('cannot_'+action) && (!ongoingEffects(c, 'ongoing').includes('cannot_'+action+'_except_own') || params.card == c.uniqueID));
            if(ongoingPlayer(p).includes('verb_restrictions')){
                let restrictions = ongoingPlayer(p, 'verb_restrictions');
                for(let r of restrictions){
                    console.log('filtering out cards because of player restrictions', r);
                    if(r.verbs.includes(action)) eligible = eligible.filter(c => !matches(c, r.types));
                }
            }
        }
        if(action == 'recall'){
            eligible = eligible.filter(c => !ongoingEffects(c, 'ongoing').includes('cannot_recall_from_staging') || get(state).cardLog[c.uniqueID].deck != 'play')
            
            // Unless there's explicit 'opponent' or 'any' wording, restrict only to your own ships
            if(obj.owner != 'any' ){
                eligible = eligible.filter(c => cardOwner(c).captain == p.captain);
            }
        }
        if(action == 'enlist' && params.free){
            eligible = [...p.decks.dev];
        }
        if(action == 'dismiss'){
            // no_opponent_dismiss ships can't be dismissed by not their owners
            eligible = eligible.filter(c => !ongoingEffects(c).includes('no_opponent_dismiss') || !cardOwner(c) || cardOwner(c).captain == origP.captain);
            //console.log(get(state).cachedPlayer);
            
            // Unless there's explicit 'opponent' or 'any' wording, restrict only to your own ships
            if(obj.owner != 'any' ){
                eligible = eligible.filter(c => cardOwner(c).captain == p.captain);
            }
        }

        // This has to go after the from effect because the ongoing effect specifically includes cards which limit to hand
        if((action == 'return' || action == 'freeplay' || action == 'find' || action == 'find_recall') && (params.obj.types == 'incident' || Array.isArray(params.obj.types) && params.obj.types.includes('incident')) && (!params.from || params.from.place == 'hand' || Array.isArray(params.from) && params.from.some(f => f.place == 'hand')) && ongoingPlayer(p).includes('can_target_log_incidents')){
            // Add any from log too
            eligible = [...eligible, ...p.decks.log.filter(c => matches(c, 'incident'))];
        }

        //console.log(eligible);

        let entry = {num};
        if(obj.location && !['put'].includes(action)){
            eligible = resolveLocCondition(getCard(params.card), obj.location, p, eligible, obj, action);
        }

        // so 'beam here' doesn't beam to a beamed card
        if(action == 'beam' && prep == 'to'){
            eligible = eligible.filter(c => 
                !isBeamed(c)
                && isInPlayMarketNZ(c)
                && (!ongoingEffects(c).includes('no_beaming_here') || params.card == c.uniqueID)
            );
        }

        if(action == 'resolve'){
            let newE = [];
            for(let e of eligible){
                let type = params.effectType || 'play';
                type = type.toLowerCase();
                let h = getHints(e, type, true);
                console.log(h);
                if(!h || h.length == 0 && type == 'play') h = getHints(e, 'freeplay', true); // So play effect includes freeplay
                if(h && h.length > 0) newE.push(e);
            }
            eligible = newE;
            eligible = eligible.filter(c => c.uniqueID != params.card); // Can't resolve self
        }


        if(obj.orderedTypes){
            // Bot is looking for one and otherwise for other
            for(let o of obj.orderedTypes){
                let tier = eligible.filter(e => matches(e, o));
                if(tier.length == 0) continue; // no match
                if(p.bot && (awayAction(action) || action == 'warp')){
                    // Narrowing to a tier the bot's own destination filters then reject
                    // loses the later tiers entirely, and the action fails silently.
                    // So skip a tier it can't actually use and fall through to the next.
                    let usable = action == 'warp' ? bestShipDestinations(tier, getCard(params.card), false, namesBadlands(o)) : bestAwayDestinations(tier, o, params);
                    if(!usable || usable.length == 0) continue;
                }
                types = o;
                eligible = tier;
                if(eligible.length < 2) break; // only keep going if more than one match
                /*if(eligible.some(e => matches(e, o))){
                    types = o;
                    break;
                }*/
            }
            if(!types){
                continue; // Nothing to return
            }
            // could probably just return here...?
        }
        if(types){
            if(Array.isArray(types)){
                if(!types.every(t => typeOfGain(t) == 'card')){
                    if(types.includes('murf') && !hasMurf(p)) types = types.filter(t => t != 'murf'); // only D&G have one to send
                    let chosen = types[0];
                    if(!chosen) throw 'cancelled';
                    if(types.length > 1){
                        chosen = await choose(`Which would you like to ${humanReadableAction(action, params, prep)}? ${obj.num > 1 ? '(Mixing and matching not currently supported – fix manually for now)' : ''}`, types.map(t => `${obj.num} [[${t}]]`), {cancellable: true});
                        if(!chosen || chosen == 'cancelled') throw 'cancelled';
                        chosen = types.find(t => chosen == `${obj.num} [[${t}]]`);
                    }
                    entry.type = typeOfGain(chosen);
                    //console.log(chosen);
                    if(entry.type == 'card' || action == 'look at'){
                        // Choose the specific one
                        if(justAssess || action == 'look at'){ // Because you look/enlist at all of the cards
                            // added filtering May 2025
                            eligible = await resolveFilters(p, obj, params, eligible, action);
                            ret.push(...eligible.map(c => c.uniqueID))
                        }else{
                            ret.push(...await resolveCards(origP, eligible.filter(c => !ret.some(cd => sameCard(c, cd))), num, obj, chosen, params, fromDeck, action, prep))
                        }
                    }else{
                        entry.specific = chosen.toLowerCase();
                        if(entry.specific == 'action') entry.specific = 'actions';
                        if(obj.owner) entry.owner = obj.owner;
                        if(action == 'remove_away' && !params.from && obj.location){
                            entry.from = eligible.map(c => c.uniqueID);
                        }else if(awayAction(action) && !params.to && obj.location && eligible.length > 0){
                            entry.toCard = eligible[0].uniqueID;
                        }
                        if(obj.location && eligible.length > 0){
                            entry.fromCard = eligible[0].uniqueID;
                        }else if(obj.from && obj.from_resolved && obj.from.length > 0){
                            entry.fromCard = obj.from[0];
                        }else if(params.from && params.from_resolved && params.from.length > 0){
                            // first check that we're not in a list of things that includes resources

                            if(!Array.isArray(objects) || !objects.some(o => o.types == 'resource')){
                                // Just so that general resources override individual resources
                                entry.fromCard = params.from[0];
                            }
                        }
                        ret.push(entry);
                        continue;
                    }
                }else{
                    // Just cards so can just let them pick
                    let fdCards = ['encounter', 'incident'];
                    if(fdCards.some(t => types.includes(t)) && action == 'junk'){ // Really? !! TODO could cut??
                        for(let t of types){
                            if(t == 'incident') t = 'incidents';
                            if(get(state).commons[t]) eligible = [...eligible, ...get(state).commons[t]];
                        }
                    }
                    if(justAssess || action == 'look at'){
                        // May 2025 added filtering
                        eligible = await resolveFilters(p, obj, params, eligible, action);
                        ret.push(...eligible.filter(c => matches(c, types)).map(c => c.uniqueID));
                    }else{
                        ret.push(...await resolveCards(origP, eligible.filter(c => !ret.some(cd => sameCard(c, cd))), num, obj, types, params, fromDeck, action, prep))
                    }
                }
            }else{
                entry.type = typeOfGain(types);
                if(entry.type == 'card'){
                    if(justAssess || action == 'look at'){
                        // May 2025: added filter
                        eligible = await resolveFilters(p, obj, params, eligible, action);
                        if(action == 'look at' && obj.num && obj.num != 'all'){
                            
                            // Take N ones (possibly random)
                            let toAdd = eligible.filter(c => matches(c, types)).map(c => c.uniqueID);
                            if(obj.random) shuffle(toAdd);
                            ret.push(...toAdd.slice(0, num));
                        }else{
                            ret.push(...eligible.filter(c => matches(c, types)).map(c => c.uniqueID));
                        } 
                    }else{
                        if(params.with){
                
                            let poss = await resolveObject(params.with, action, params, p, 'with', true);
                            console.log(poss);
                            //eligible = params.with.flat(2); // TODO cheap fix...
                            console.log(poss, poss.flat(2));
                            eligible = eligible.filter(e => poss.flat(2).some(c => c == e.uniqueID || c.uniqueID == e.uniqueID)); // intersection
                            params.with_resolved = true;
                        }
                        ret.push(...await resolveCards(origP, eligible.filter(c => !ret.some(cd => sameCard(c, cd))), num, obj, types, params, fromDeck, action, prep))
                    }       
                    if(params.can_combine){
                        if(checkCombined(action, ret, params)){
                            //logText(`All action conditions satisfied, so no more to ${action}`);
                            break;
                        }
                    }
                    continue;
                }else if((types == 'away' || types == 'opp_away' || types == 'away team') && prep){
                    //console.log('checking away', num, p, obj.owner);
                    let pp = p; // TODO check if they is misused here
                    if(types == 'opp_away' || obj.owner == 'opponent' || (obj.owner == 'they' && get(state).cache.player != 'you')) pp = get(state).players.find(o => o.captain != p.captain);
                    eligible = eligible.filter(e => {
                        let at = myAway(pp, e); // includes drones
                        if(typeof num == 'number') return at == num;
                        if(num.hasOwnProperty('min') && at < num.min) return false;
                        if(num.max && at > num.max) return false;
                        return true;
                    })
                    console.log(`after away`, eligible)
                }else if(types == 'drone' && prep){
                    console.log('checking drone', num, p, obj.owner);
                    let pp = p; // TODO check if they is misused here
                    if(types == 'opp_away' || obj.owner == 'opponent' || (obj.owner == 'they' && get(state).cache.player != 'you')) pp = get(state).players.find(o => o.captain != p.captain);
                    eligible = eligible.filter(e => {
                        if(typeof num == 'number'){
                            if(e.drones && e.drones[pp.captain] == num) return true;
                            return false;
                        }
                        if(num.hasOwnProperty('min')){
                            if(!e.drones || e.drones[pp.captain] < num.min) return false;
                        }
                        if(num.max){
                            if(!e.drones || e.drones[pp.captain] > num.max) return false;
                        } 
                        return true;
                    })
                    console.log(`after drone`, eligible)
                }else{
                    entry.specific = types;
                    if(entry.specific == 'action') entry.specific = 'actions';
                    if(obj.owner) entry.owner = obj.owner;
                    if(obj.separator) entry.separator = obj.separator;
                    if(action == 'remove_away' && !params.from && obj.location){
                        entry.from = eligible.map(c => c.uniqueID);
                    }else if(awayAction(action) && !params.to && obj.location && eligible.length > 0){
                        entry.toCard = eligible[0].uniqueID;
                    }else if(obj.location && eligible.length > 0){
                        entry.fromCard = eligible[0].uniqueID;
                    }else if(obj.from && obj.from_resolved && obj.from.length > 0){
                        entry.fromCard = obj.from[0];
                    }else if(params.from && params.from_resolved && params.from.length > 0){
                        if(!Array.isArray(objects) || !objects.some(o => o.types == 'resource')){
                            // Just so that general resources override individual resources
                            entry.fromCard = params.from[0];
                        }
                    }
                    if(obj.supply){
                        entry.fromSupply = true; // from the supply
                    }
                    // !!! TODO only single fromCard at present
                    ret.push(entry);
                    continue;
                } 
            }
        }else if(obj.card || !types && !obj.type && !prep && !(obj.place && !obj.num)){
            // Cards are the default (fixes Data)
            // NB a bare place ('your discard pile') means the whole pile, so it drops
            // through to the obj.place branch below rather than prompting for a card
            //console.log(obj.card)
            if(obj.card){
                if(obj.card.num && obj.defaultNum){
                    obj.num = obj.card.num;
                    num = await resolveNum(obj.num, action);
                }
                if(obj.card == 'same_suit'){
                    params.limit_suits = true; // For The Nexus duplicate play operation
                    if(action == 'gain_top'){
                        let types = await getPrevTypes(p);
                        if(!types) throw 'uncompleted';
                        for(let k of Object.keys(get(res).marketTypes).filter(t => types.includes(t))){
                            let t = get(res).marketTypes[k];
                            if(get(state).commons[t].length > 1) ret.push(get(state).commons[t][1].uniqueID);
                        }
                        continue; // That's it!
                    }
                    if(params.from && params.from_resolved){
                        let types = await getPrevTypes(p);
                        if(!types) throw 'uncompleted';
                        eligible = params.from.filter(c => matches(c, types));
                        //ret.push(...params.from.filter(c => matches(c, types)));
                        //continue; // Not continue so you will choose
                    }
                }
                if(obj.card.owner){
                    p = resolveOwner(getCard(params.card), obj.card.owner);
                    console.log('card owner:', p, obj.card.owner, origP);
                }
                if(obj.card == 'this card' || obj.card == 'this ship'){
                    ret.push(params.card); // 
                    continue;
                }else if(obj.card == 'market_best'){
                    ret.push(...botFavouriteCards(p, getMarketCards().filter(c => c)).slice(0, 1).map(c => c.uniqueID));
                    continue;
                }else if(obj.card == 'target'){
                    if(get(state).resolvingFrom){
                        ret.push(...possArray(get(state).resolvingFrom));
                        continue;
                    }
                }else if(obj.card == 'your_board'){
                    ret.push(p.dashboard.passives[0].uniqueID);
                    continue;
                }else if(obj.card == 'last_visiting'){
                    // Basically resolve prevObj and then get the Q on it
                    let card = possArray(resolvePrevObj({prevType: 'visited'}));
                    if(card.length > 0){
                        card = card[0];
                        if(card.visiting.length == 1){
                            ret.push(card.visiting[0]);
                            continue;
                        }else{
                            eligible = card.visiting.map(v => getCard(v)); // Choose which
                        }
                    }
                }else if(obj.card == 'reserve'){
                    if(obj.num == 'all'){
                        ret.push(...p.decks.reserve.map(c => c.uniqueID));
                    }else{
                        ret.push(...p.decks.reserve.slice(0, obj.num || 1).map(c => c.uniqueID));
                    }
                    continue;
                /*}else if(obj.card == 'dynasty'){
                    ret.push(...p.decks.dynasty.slice(0, obj.num || 1).map(c => c.uniqueID));
                    continue;*/
                }else if(obj.card == 'development'){
                    let dev = p.decks.dev;
                    if(params.off_deck){
                        // Select from deck not in play
                        dev = await getOffDeckDevs(p,params);
                    }
                    if(action == 'enlist'){
                        //ret.push(...dev.map(c => c.uniqueID));
                        ret.push(...await resolveCards(origP, dev.filter(c => !ret.some(cd => sameCard(c, cd))), num, obj, null, params, fromDeck, action, prep));
                        continue; 
                    }else{
                        // otherwise pick
                        eligible = [...dev] 
                    }
                    
                }else if(obj.card.type == 'prev_obj'){
                    let type = 'card';
                    if(action == 'gain_control' || action == 'control') type = 'location'
                    eligible = [...resolvePrevObj(obj.card, num, type, action)].filter(c => c);
                    if(!params.from) eligible = filterOutLog(eligible, action);
                    console.log(eligible);
                }else if(obj.card.type == 'not_taken'){
                    // Doing an action to the thing that was not chosen in the last round (if there is one)
                    if(!get(state).cache || !get(state).cache.notTaken) throw 'uncompleted';
                    ret.push(...possArray(get(state).cache.notTaken));
                    continue;
                }else if(obj.card_itself == true && !obj.location){
                    // Sep 2025: fudge! Need to rethink this whole card-itself thing.
                    // The 'obj.location' check is to stop Badlands being logged by Caretaker's Array
                    eligible = resolveExactCard(obj, action, p);
                }else if(obj.card.type == 'prev_goal'){
                    eligible = resolvePrevGoal(obj.card.prevType);
                }else if(obj.card.type == 'visiting_card'){
                    eligible = resolveVisiting(getCard(params.card), obj.card.specific)
                }else if(obj.card.type == 'card_loc' || obj.card.type == 'same' || obj.card.type == 'prev_loc'){
                    let possible;
                    if(['this card', 'this ship', 'this [[ship]]'].includes(obj.card.card)){
                        possible = [params.card];
                    }else if(obj.card.type == 'card_loc'){
                        // Jan 2026 replaced resolveExactCard with resolveSpecificCard
                        // so that prev objs etc. work (USS Phoenix)
                        // will it break stuff? Let's see!
                        // End of Jan 2026: yes it broke stuff
                        // Reverted here but not in resolveLocation
                        // Because resolveSpecificCard is a subset of this anyway lol
                        possible = resolveExactCard(obj);// resolveSpecificCard(p, obj, params, action); //
                    }else{
                        // !! NB TODO if you are dismissing cards beamed to a ship to take control of its location,
                        // if one of those cards is a ship it will be returned instead of the ship itself.
                        // so we need in the future maybe to add a prev_obj option for filtering out cards
                        // that are at a location?
                        // Jan 2026: switched {} for obj so numbers carry across
                        possible = resolvePrevObj(obj/*{}*/, 1, obj.card.type == 'prev_loc' ? 'at_location' : false, action)
                    }
                    console.log('card_loc', possible)
                    if(possible.length == 0) continue;
                    let cardForLoc = possible[0];
                    // Should only be one...
                    cardForLoc = getCard(cardForLoc);
                    if(!cardForLoc){
                        console.log('card not found!', obj.card.card);
                        throw `Card ${obj.card.card} not found!`;
                    }
                    if(obj.card.card_itself == true || matches(cardForLoc, 'location') && !matches(cardForLoc, 'ship')){ // if it's not a ship!
                        // Not ship but card itself
                        ret.push(cardForLoc.uniqueID);
                        // !!TODO prep added below to stop arbitrary bundling in of ship, but it may fail
                        if(cardForLoc.orbiting && prep) ret.push(...cardForLoc.orbiting.map(o => o.card));
                        //console.log(ret);
                        return [];
                        continue;
                    }
                    /*
                    if(!cardForLoc.ships || cardForLoc.ships.length == 0){
                        //throw `No ships on ${cardForLoc.name}, so can't use its location!`;
                        return [];
                        continue;
                    }
                    // Location means where the ship is warped to
                    let ship = cardForLoc.ships[0]; // What about multiples? Don't worry for now...
                    if(!cardForLoc.orbitingCard){
                        //throw 'uncompleted';
                        // No location!
                        return [];
                        continue;
                    }
                    let loc = cardForLoc.orbitingCard[ship];*/
                    let loc = locationOfCard(cardForLoc);
                    if(loc && (!obj.card.locFilter || matches(loc, `${obj.card.locFilter} location`))){
                        ret.push(loc.uniqueID); // Is already uniqueID
                    }else{
                        // Not found, so give up, presuming all must be fulfilled
                        return [];
                    }
                    continue;
                }else if(obj.card.card){
                    // Exact card name
                    if(obj.card.card == 'redshirt' && !params.from){ // Only when gaining!
                        if(get(state).commons.redshirts.length == 0){
                            logText(`Unable to gain Redshirt: none left;`)
                            throw 'uncompleted'; // TODO what to do?
                        }
                        //console.log('gaining redshirt!')
                        ret.push(get(state).commons.redshirts[0].uniqueID); // TODO check whether should be card or ID!
                        continue;
                    }
                    let cards = resolveExactCard(obj, action, cardOwner(getCard(params.card)));
                    if(!prep && params.from && params.from_resolved){
                        cards = cards.filter(cd => params.from.some(c => getCard(c).uniqueID == cd));
                    }
                    //ret.push(...await resolveCards(origP, cards.filter(c => !ret.some(cd => sameCard(c, cd))), num, obj, null, params, fromDeck, action, prep))
                    //ret.push(...cards);
                    eligible = cards.map(c => getCard(c));
                    //continue;
                }else if(obj.card == 'beamed_here'){
                    if(getCard(params.card) && getCard(params.card).beamed){
                        eligible = getCard(params.card).beamed;
                    }else{
                        logText(`No cards beamed in ${cc(params.card)}`);
                        return [];
                    }
                    //logText(`No cards beamed in ${cc(params.card)}`);
                    //continue; // TODO what if it's empty?
                    //throw 'cancelled'; // Better?
                }else if(obj.card == 'ship_here'){
                    if(getCard(params.card) && getCard(params.card).orbiting){
                        eligible = getCard(params.card).orbiting.map(c => getCard(c.card));
                    }else{
                        logText(`No cards beamed in ${cc(params.card)}`);
                        return [];
                    }
                }else if (obj.card.place){    
                    console.log('resolving place', obj.card.place, p);     
                    if(Array.isArray(obj.card.place) && obj.card.place.some(l => l.separator == 'or')){
                        alert('Choices in "top card of X or Y deck" not currently implemented: flag this for implementation');
                    }
                    let finalEntries = [];
                    for(let l of possArray(obj.card.place)){
                        let entries = await resolvePlace(p, l, action, true); //await resolvePlace(p, obj.card.place, action, true)
                        if(obj.card.type) entries = entries.filter(c => matches(c, obj.card.type));
                        if(obj.card.placement == 'top'){
                            let num = obj.card.num || 1;
                            if(entries.length > 0) {
                                let info = get(state).cardLog[entries[0].uniqueID];
                                if(info.deck == 'deck' && !['put'].includes(action)  && /*action == 'look at' && */faceupDraw(p) && p.decks.deck.length > num){
                                    // Choose card(s)!
                                    entries = await chooseCards(`Choose ${num} card(s) to ${action}`, entries, {number: num, lookSpecific: true});
                                }else{
                                    entries = entries.slice(0, num);
                                    let deckP = cardOwner(entries[0]);
                                    if(entries.length < num && info.deck == 'deck' && deckP.decks.deck[0]?.uniqueID == entries[0].uniqueID && !['put', 'take', 'gain', 'look at'].includes(action) && (deckP.bot || isMe(deckP))){
                                        // Deck runs out partway: cycle beneath the remaining cards so the rest come from the new deck
                                        logText(`Deck runs out, so cycling`);
                                        await reshuffleDeck(deckP, {keepTop: entries.length});
                                        entries = deckP.decks.deck.slice(0, num);
                                    }
                                }
                            }
                        }else if(obj.card.placement == 'bottom'){
                            let num = obj.card.num || 1;
                            entries = entries.slice(-num);
                        }
                        finalEntries = [...finalEntries, ...entries];
                    }
                    // !TODO reinstated the below to allow for bot reshuffling... check it doesn't break owt          
                    
                   
                    if((obj.defaultNum || obj.num >= (obj.card.num || 1)) && obj.card.place != 'duty' && obj.card.place != 'captain' && obj.card.place != 'captain_duty'){
                        ret.push(...finalEntries.map(c => c.uniqueID));
                        continue; 
                    }else{
                        eligible = finalEntries; // These are individual cards so choose between them
                    }
                }else if(action == 'draw' || action == 'draw_reveal'){
                    // TODO handle cases such as top location card etc.
                    // TODO from?
                    if(prep == 'from'){
                        // filters to handle 'another'
                        entry = await resolveFilters(origP, obj, params, entry, action);
                        ret.push(entry.map(c => c.uniqueID));
                        continue;
                    }else{
                        // Just object
                        return objects;
                    }
                }
            }

            // Extra filtering with 'with'
            if(params.with){
                
                let poss = await resolveObject(params.with, action, params, p, 'with', true);
                console.log(poss);
                //eligible = params.with.flat(2); // TODO cheap fix...
                console.log(poss, poss.flat(2));
                eligible = eligible.filter(e => poss.flat(2).some(c => c == e.uniqueID || c.uniqueID == e.uniqueID)); // intersection
                params.with_resolved = true;
            }

            // Fall-through: choose
            //console.log(obj, eligible, prep

            if(action && ['assimilate', 'log', 'recall', 'dismiss', 'junk', 'duty', 'discard', 'play'].includes(action)){
                eligible = eligible.filter(c => !origP.decks.captain.some(cd => cd.uniqueID == c.uniqueID)); // you don't do it to your OWN captain generally (but 'A State of Perfection' assimilates the opponent's)
            }
            // Named card lookup can replace eligible, so apply the default source
            // there too instead of reaching into the bot's deck or discard pile.
            if(logFromPlay){
                let inPlay = new Set(cardsInPlay(p).map(c => c.uniqueID));
                eligible = eligible.filter(c => inPlay.has(c.uniqueID));
            }
            // BQ: log restrictions
            if(action == 'log' && ongoingPlayer(otherPlayer(p)).includes('no_log_drone_locations')){
                eligible = eligible.filter(c => !drones(otherPlayer(p), c));
            }
            if(action == 'log' && !params.attack){
               // console.log('logging', eligible, eligible.find(c => ongoingEffects(c).includes('cannot_log')))
                eligible = eligible.filter(c => !ongoingEffects(c).includes('cannot_log') && !isBadlands(c)) // can't log Badlands
            }else if(action){
                eligible = eligible.filter(c => !ongoingEffects(c, 'ongoing').includes('cannot_'+action) && (!ongoingEffects(c, 'ongoing').includes('cannot_'+action+'_except_own') || params.card == c.uniqueID));
                if(action == 'deploy' && ongoingPlayer(p).includes('only_deploy_types')){
                    let odt = ongoingPlayer(p, 'only_deploy_types')
                    eligible = eligible.filter(c => {
                        let types = odt.filter(o => matches(c, o.relevant)).flatMap(o => o.types);
                        for(let t of types){
                            if(!matches(c, t)) return false;
                        }
                        return true;
                    });
                }
                if(action == 'warp' && ongoingPlayer(p).includes('only_warp_by_types')){
                    let owt = ongoingPlayer(p, 'only_warp_by_types');
                    let card = getCard(params.card);
                    if(!matches(card, owt)) return [];
                }
            }
            if(awayAction(action)){
                eligible = eligible.filter(c => canBeamTo(p, c, params));
                //eligible = eligible.filter(c => !ongoingEffects(c).includes('no_other_away') || params.card == c.uniqueID)
            }
            

            let chosen;
            if((num == 'all' || obj.num == 'all') && !obj.filter || justAssess || action == 'look at'){
                // May 2025: added filter
                eligible = await resolveFilters(origP, obj, params, eligible, action);
                chosen = eligible.map(c => c.uniqueID);
            }else if(eligible.length == 0){
                // Nothing to return
                // If this is part of a cost, it should fall through
                if(!obj.optional && (typeof num == 'number' && num > 0 || num.hasOwnProperty('min') && num.min > 0)){
                    if(obj.exactly || num.hasOwnProperty('min')) throw 'uncompleted'; // Should prevent costs from firing
                    if(get(state).payingCost == params.card) throw 'uncompleted';
                }
                chosen = [];
            }else if(action == 'type_match'){// && eligible[0]){
                //chosen = [eligible[0].uniqueID];
                // May 2025: added filter
                eligible = await resolveFilters(origP, obj, params, eligible, action);
                chosen = eligible.map(c => c.uniqueID);
            }else{
                chosen = await resolveCards(origP, eligible.filter(c => !ret.some(cd => sameCard(c, cd))), num, obj, null, params, fromDeck, action, prep);
            }
            
            state.update(s => {
                s.cache.previousNums = chosen.length;
                return s;
            })
            ret.push(...chosen);
        }else if(obj.place){
            let place = obj.place;
            if(!Array.isArray(place)) place = [ place ];
            for(let l of place){
                //ret.push(...resolvePlace(p, place, action));

                let entries = await resolvePlace(p, l, action, true, objects.length)
                if(obj.type) entries = entries.filter(c => matches(c, obj.type));
                // May 2025: added filter
                entries = await resolveFilters(p, obj, params, entries, action);
                ret.push(...entries.map(c => c.uniqueID));
                if(l == 'hand' && (action == 'find' || action == 'find_recall' || action == 'return' || action == 'freeplay') && (params.obj.types == 'incident' || Array.isArray(params.obj.types) && params.obj.types.some(t => t == 'incident')) && ongoingPlayer(p).includes('can_target_log_incidents')){
                    ret.push(...p.decks.log.filter(c => matches(c, 'incident')).map(c => c.uniqueID));
                }
                continue;
            }
            
            
        }else if(obj.type == 'prev_obj'){
            let type = 'card';
            if(action == 'gain_control' || action == 'control' || awayAction(action) || action == 'remove_away') type = 'location';
            let po = resolvePrevObj(obj, 1, type, action).map(c => c.uniqueID ? c.uniqueID : c)
            if(!params.from) po = filterOutLog(po, action);
            if(awayAction(action) || action == 'remove_away'){
                po = po.filter(c => {
                    let info = get(state).cardLog[c];
                    if(info.deck == 'neutral_zone' || info.area == 'players' && info.deck == 'locations') return true;
                    return false;
                })
            }
            if(prep == 'to' && (action == 'warp' || action == 'beam')){
                po = po.filter(c => {
                    let info = get(state).cardLog[c];
                    if(ongoingEffects(c).includes('no_beaming_here') && params.card == c.uniqueID) return false;
                    if(info.deck == 'neutral_zone' || info.area == 'players' && info.deck == 'locations') return true;
                    return false;
                })
            }
            if(po.length > 0){
                ret.push(...po); // In case of non-card objects 
            }else if(obj.same){
                if(p.bot && currentPlayer().bot && activePlayer().bot) throw 'uncompleted'; // Bot will never use 'the same X' meaning just 'a single'
                // 'the same X' 
                // So the filter is actually the object in this case?
                // !!! NB to handle Travis Mayweather we need nuance here
                // (and find a counterexample where it just means 'an X')
                ret.push(...await resolveObject(obj.filter, action, params, p, prep, justAssess));
            }
        }else if(obj.card && obj.card.type == 'not_taken'){
            // Doing an action to the thing that was not chosen in the last round (if there is one)
            if(!get(state).cache || !get(state).cache.notTaken) throw 'uncompleted';
            ret.push(...possArray(get(state).cache.notTaken));
        }else if(eligible){
            // Just put them across, if there's nothing else
            // May 2025: added filter
            eligible = await resolveFilters(p, obj, params, eligible, action);
            ret.push(...eligible.map(c => c.uniqueID ? c.uniqueID : c));
        }

        // Possibly exit out if can_combine satisfied
        if(params.can_combine){
            if(checkCombined(action, ret, params)){
                //logText(`All action conditions satisfied, so no more to ${action}`);
                break;
            }
        }
    }
    console.log('resolveObject', ret, prep)
    return ret;
}

function inPlayerArea(c, p){
    let info = get(state).cardLog[c.uniqueID];
    if(info.area == 'beamed'){
        info = get(state).cardLog[info.deck];
        
    }
    // 'player_dashboards' is a player's area too: dashboard missions live there, so without it
    // 'you have 2 completed [[mission]]' counts nothing (70,000 Light-years from Home).
    return ['players', 'player_dashboards'].includes(info?.area) && info?.player == getPlayerIndex(p);
}

function ownedBy(c, p, o){
    if(o == 'they') o = get(state).cache.player || 'opponent';
    
    if(o == 'bot'){
        let bot = get(state).players.find(p => p.bot);
        if(!get(state).players.some(p => !p.bot)) bot = activePlayer(); // presume executing their card
        return inPlayerArea(c, bot);
    }
    if((o == 'player' || o == 'you') && !p.bot) return inPlayerArea(c, p);
    if(o == 'opponent'){
        let opps = get(state).players.filter(o => o != p);
        for(let opp of opps){
            if(inPlayerArea(c, opp)) return true;//if(allScoreableCards(o).some(cd => cd.uniqueID == c.uniqueID)) return true;
        }
        return false;
    }
    if(o == 'neutral'){
        if([...getMarketCards(), ...getNeutralZone()].some(cd => cd.uniqueID == c.uniqueID)) return true;
    }
    if(o == 'all'){
        for(let pl of get(state).players){
            if(inPlayerArea(c, pl)) return true;
        }
        return false;
    }
    return false;
}

export function resolveOwner(c, o){
    let p = cardOwner(c);
    if(c && get(state).cache && get(state).cache.cardOwner && get(state).cache.cardOwner.hasOwnProperty(c.uniqueID)) p = get(state).players[get(state).cache.cardOwner[c.uniqueID]]; // Just in case card has been given over
    if(o == 'they'){
        if(get(state).cache.player){
            o = get(state).cache.player;
        }else if(p.bot){
            o = p;
        }else{
            o = 'opponent';
        }
    }
    if(o == 'card_owner') return p;
    if(o == 'player' || o == 'you'){
        if(!p.bot) return p;
        return get(state).players.find(pl => !pl.bot) || get(state).players.find(pl => pl.captain != p.captain);
        // Fallback is so that BvB works
    }
    if(o == 'opponent') return get(state).players.find(pl => pl.captain != p.captain);
    if(o == 'neutral') return p;
    if(o == 'bot'){
        if(!get(state).players.some(p => !p.bot)){
            // BvB, so make it card owner
            return p;
        }
        let pl = get(state).players.find(pl => pl.bot);
        if(!pl){
            console.warn(`Warning: no bot player. Returning first player, but probably indicates parsing error`);
            return activePlayer();
        }
        return pl;
    }
    if(o == 'any'){
        // Help! I think basically construct a fake deck, since this ought only to happen in resolveObject
        let decks = {};
        let missions = [];
        for(let p of get(state).players){
            for(let k  of Object.keys(p.decks)){
                if(!decks[k]) decks[k] = [];
                decks[k] = [...decks[k], ...p.decks[k]];
            }
            missions = [...missions, ...p.dashboard.missions];
        }
        return {decks, dashboard: {missions}};
    }
    console.log('help - player not defined!', o);
    //throw 'undefined player'
    return p;
}

// "non-[[x]]" alone parses with no positive type, so the exclusion is the test itself
function matchesTypeClause(c, type){
    if(type.types == null) return !matches(c, type.exclude, false, false);
    return matches(c, type.types);
}

export function resolveExclude(card, eligible, exclude, p, co = false){
    if(Array.isArray(exclude)){
        for(let e of exclude){
            eligible = resolveExclude(card, eligible, e, p); // Iteratively cut them out
        }
        return eligible;
    }
    if(exclude == 'this' && card) return eligible.filter(e => e.uniqueID != card.uniqueID);
    if(exclude.card){
        if(exclude.card_itself == true){
            exclude = exclude.card; 
            // TODO may need to handle location etc. here, in which case perhaps fold out into function?
        }
    }
    /*if(exclude == 'captain_traits'){
        let pl = co || cardOwner(card) || p;
        return eligible.filter(e => !e.traits.some(t => pl.decks.captain.some(c => c.traits.includes(t))));
    }*/
    /*if(exclude == 'your_play'){
        return eligible.filter(c => !cardsInPlay(p.some(cd => cd.uniqueID == c.uniqueID));
    }*/
    // Add locations
    if(exclude.type == 'card'){
        let card = resolveSpecificCard(exclude);
        return eligible.filter(e => !card.some(c => c == e.uniqueID));
    }
    if(exclude.location){
        let loc = resolveLocCondition(card, exclude.location, p, eligible);
        return eligible.filter(c => !loc.some(l => l.uniqueID == c.uniqueID));
    }
    if(exclude.types){
        eligible = eligible.filter(c => !matches(c, exclude.types, false)); // !!NB the false here may not work if there are negative counting effects
    }
    return eligible.filter(e => !matches(e, exclude, false, false));
}

export function captainTraits(p){
    let traits = [];
    for(let c of p.decks.captain){
        for(let t of c.traits){
            if(!traits.includes(t)) traits.push(t);
        }
    }
    return traits;
}

export function countMatches(p, cards, t, wildCards = true, toFill = [], addedWildCards = [], each_diff = [], separate_cards = false, exclude = false){
    if(t == 'different-species' || t == 'different species'){
        let species = [];
        let num = 0;
        let excludeCaptain = false;
        if(exclude){
            for(let e of possArray(exclude)){
                if(e == 'captain_traits') excludeCaptain = true;
            }
        }
        for(let c of cards){
            for(let t of currentTraits(c)){
                if(excludeCaptain && captainTraits(p).includes(t)){
                    continue; // Skip captain traits
                }else if(get(res).species.includes(t) && (!species.includes(t) || each_diff.includes(t))){
                    species.push(t);
                    num++;
                    toFill.push(c);
                }else if(wildCards && ['wildcard', 'any species'].includes(t)){
                    if(wildCards.hasOwnProperty('wildcardsLeft')){
                        if(wildCards.wildcardsLeft <= addedWildCards.length) continue;
                    }
                    num++;
                    toFill.push(c);
                    addedWildCards.push(c);
                }else if(wildCards && t.startsWith('any species') && t.includes('!')){
                    if(wildCards.hasOwnProperty('wildcardsLeft')){
                        if(wildCards.wildcardsLeft <= addedWildCards.length) continue;
                    }
                    num++;
                    toFill.push(c);
                    addedWildCards.push(c);
                }
            }
        }
        if(wildCards){
            if(typeof wildCards == 'boolean') wildCards = {};
            if(!wildCards.wildcardsUsed) wildCards.wildcardsUsed = 0;
            wildCards.wildcardsUsed += addedWildCards.length;
        }
        // !!! NB below added to try and fix WC issue, but not sure if it's the right way 
        /*if(wildCards.wildcardsLeft < addedWildCards.length){
            let diff = addedWildCards.length - wildCards.wildcardsLeft;
            //addedWildCards = addedWildcards.slice(0, wildCards.wildCrads)
            num -= diff;
            wildCards.wildcardsUsed += wildCards.wildcardsLeft;
            wildCards.wildcardsLeft = 0;
        }*/
        return num;
    }else{
        let num = 0;
        for(let c of cards){
            let toAdd = matches(c, t, wildCards);
            if(separate_cards){
                // Each card only counts ocne
                if(toAdd) num++;
            }else{
                num += toAdd;
            }
            if(toAdd > 0){
                if(matches(c, t, false) == 0){
                    if(wildCards.hasOwnProperty('wildcardsLeft')){
                        if(wildCards.wildcardsLeft <= addedWildCards.length) continue;
                    }
                    addedWildCards.push(c);
                }
                toFill.push(c);
            }
        }
        // !!! NB below added to try and fix WC issue, but not sure if it's the right way 
        /*if(wildCards.wildcardsLeft < addedWildCards.length){
            let diff = addedWildCards.length - wildCards.wildcardsLeft;
            //addedWildCards = addedWildcards.slice(0, wildCards.wildCrads)
            num -= diff;
            wildCards.wildcardsUsed += wildCards.wildcardsLeft;
            wildCards.wildcardsLeft = 0;
        }*/
        if(wildCards){
            if(typeof wildCards == 'boolean') wildCards = {};
            if(!wildCards.wildcardsUsed) wildCards.wildcardsUsed = 0;
            wildCards.wildcardsUsed += addedWildCards.length;
            if(wildCards.hasOwnProperty('wildcardsLeft')){
                if(wildCards.wildcardsLeft < addedWildCards.length){
                    console.log('Help! Wrong number of wildcards');

                }else{
                    wildCards.wildcardsLeft -= addedWildCards.length;
                }
            }
        }
        return num;
    }
}

function countSingleType(p, obj, eligible, type){
    if(type == 'action') type = 'actions';
    if(type == 'resource'){
        let count = 0;
        for(let t of allTokenTypes()){
            count += countSingleType(p, obj, eligible, t);
        }
        return count;
    }
    if(obj.location){
        // in this case it'll be in the eligible places
        return eligible.reduce((a,c) => {
            if([...allLocationTokenTypes, 'token'].includes(type)){
                return a + countSpecificTokens(c, p, type);
            }else{
                return a + (c[type] || 0)
            }
        }, 0);
    }else{
        return p[type]; // || 0; // Dec 2025: removed fallback so that types not on p return undefined
    }
}

function countTypes(p, obj, eligible){
    let types = possArray(obj.types);
    let count = 0;
    for(let t of types){
        let toAdd = countSingleType(p, obj, eligible, t);
        if(toAdd === undefined && types.length == 1) return undefined; // if there are multiple options then allow fallback
        count += toAdd || 0;
    }
    return count;
}

function isBeamed(c){
    if(!c) return false
    let info = get(state).cardLog[c.uniqueID];
    if(!info) return false;
    if(info.area == 'beamed') return true;
    return false;
}

export function resolveCountTypes(p, card, obj, action, params, toFill = false, cache = {}, forceEligible = false){ 
    let origP = p;
    if(obj.owner == 'any'){
        let count = 0;
        for(let pl of get(state).players){
            count += resolveCountTypes(pl, card, {...obj, owner: undefined}, action, params, toFill, cache, forceEligible);
        }
        return count;
    }else if(obj.owner){
        p = resolveOwner(card, obj.owner);
    }
    if(p.captain == origP.captain) p = origP; // For copying stuff for Worf... a bodge Jan 2026
    let eligible = allScoreableCards(p); // Commons cards don't contribute to scores
    // allScoreableCards leaves decks.missions out so mission VP isn't counted twice while scoring.
    // A 'you have' test is not scoring: an accepted mission is in play and counts, same as a
    // dashboard one. Same idiom as ongoingPlayer's [...allScoreableCards(p), ...p.decks.missions].
    // Without it 'The Journey, not the Destination' can never see its 5 completed [[journey]]
    // missions, since two of them (Year of Hell, The Void) are accepted into decks.missions.
    if(action == 'ownership' && p.decks && p.decks.missions) eligible = [...eligible, ...p.decks.missions];
    // Feb 2026: added forceEligible to below so that anything listed anywhere visible counts too
    if(forceEligible || ['away', 'drone', 'q', 'murf', 'secured neutral location'].some(t => possArray(obj.types).includes(t))){
        eligible = [...eligible, ...getMarketCards(), ...get(state).commons.junk, ...getNeutralZone()]; // Jun 2025 to fix Boimler mission issue – see if it breaks other things
    }
    
    if(Array.isArray(obj)) return obj.flatMap(o => resolveCountTypes(p, card, o, action, params)).length; // flatMap?
    if(obj.location){
        eligible = resolveLocCondition(card, obj.location, p, eligible, obj, action, true); 
        if(obj.location == 'same' && !eligible){
            // possible failed prev_obj situation
            alert(`Failed 'same location' check: report this for investigation`);
        }
    }else if(obj.card == 'beamed_here'){
        if(card && card.beamed){
            eligible = [...card.beamed];
        }else{
            eligible = [];
        }
    }else if(obj.card == 'ship_here'){
        if(card && card.orbiting){
            eligible = card.orbiting.map(c => getCard(c.card));
        }else{
            eligible = [];
        }
    }

    // May 2025: add intersection
    // Not sure why this wasn't done before tbh
    if(forceEligible) eligible = eligible.filter(e => forceEligible.some(el => el.uniqueID == e.uniqueID)); // require intersection

    if(obj.completed){
        eligible = eligible.filter(c => c.complete);
    }

    if(params.exclude || obj.exclude){
        eligible = resolveExclude(card, eligible, params.exclude || obj.exclude, p);
        /*let types = params.exclude || obj.exclude;
        if(types == 'this'){
            eligible = eligible.filter(c => c.uniqueID != card.uniqueID);
        }else{
            if(types.card){
                if(types.card_itself == true){
                    types = types.card; 
                    // TODO may need to handle location etc. here, in which case perhaps fold out into function?
                }
            }
            if(!Array.isArray(types)) types = [types];
            for(let t of types){
                if(t == 'this'){
                    eligible = eligible.filter(c => c.uniqueID != card.uniqueID);
                }else if(t.types){
                    eligible = eligible.filter(c => !matches(c, t.types, false)); // !!NB the false here may not work if there are negative counting effects
                }else if(t.location){
                    let loc = resolveLocCondition(card, t.location, p, eligible, obj, action);
                    eligible = eligible.filter(e => !loc.includes(e));
                }else{
                    eligible = eligible.filter(c => !matches(c, t, false));
                }
                
            }
        }*/   
    }

    if(obj.owner && !['away', 'drone', 'q', 'murf', 'token', 'platoon', 'swarm', 'secured neutral location'].some(t => possArray(obj.types).includes(t))){ 
        // !!! for Devastated CAV – is this the best way? Not sure what the reason is/was...
        //console.log('counting owner', action, p, eligible, allScoreableCards(p), obj.owner);
        //let owner = p.bot ? 'bot' : 'you';
        if(obj.owner == 'neutral'){
            eligible = eligible.filter(c => [...getMarketCards(), ...getNeutralZone()].some(cd => cd.uniqueID == c.uniqueID));
        }else if(p.bot){
            // April 2026: do we need to add Bot ownership too?
            eligible = eligible.filter(c => allScoreableCards(p).some(cd => cd.uniqueID == c.uniqueID)); // To allow for current bot
        }else{
            eligible = eligible.filter(c => ownedBy(c, p, 'you')); // Because we already set it up before
        }
       
        //p = resolveOwner(card, obj.owner);
        //console.log('after owner', eligible);
    }

    if(params.card && params.card.place){
        // TODO probably generalise this
        let placeEntries = resolvePlace(p, params.card.place, action, false, 1, true);
        eligible = eligible.filter(e => placeEntries.some(c => c.uniqueID == e.uniqueID));
    }
    if(obj.place){
        let placeEntries = resolvePlace(p, obj.place, action, false, 1, true);
        eligible = eligible.filter(e => placeEntries.some(c => c.uniqueID == e.uniqueID));
    }
    if(params.subcondition){
        // Securing is about tokens, so a [[location]] you have secured can be neutral or the opponent's
        // (Queenship: "each [[location]] you have secured (including opponent)"); eligible only holds
        // the player's own cards by default, which is why that Resupply never counted anything.
        let subs = possArray(params.subcondition);
        if(subs.some(s => s && s.secured) && possArray(obj.types).includes('location')){
            let opp = get(state).players.find(pl => pl.captain != p.captain);
            let extra = [...getNeutralZone(), ...(opp ? opp.decks.locations : [])];
            eligible = [...eligible, ...extra.filter(c => !eligible.some(e => e.uniqueID == c.uniqueID))];
        }
        eligible = resolveSubCondition(p, params.subcondition, eligible, params, card);
    }
    if(obj.beamed_only){
        eligible = eligible.filter(c => isBeamed(c));
    }
    //if(action != 'scoring') console.log('count types', eligible);
    // !!!TODO below should be unnecessary now
    if(params.opponent_unsecured){
        let opp = get(state).players.find(pl => pl.captain != p.captain);
        eligible = eligible.filter(e => !canControlLocation(opp, e))
    }
    if(params.secured){
        eligible = eligible.filter(e => canControlLocation(p, e))
    }
    if(params.human_or_you_unsecured){
        if(p.bot){
            let opp = get(state).players.find(pl => pl.captain != p.captain);
            eligible = eligible.filter(e => !canControlLocation(opp, e))
        }else{
            eligible = eligible.filter(e => !canControlLocation(p, e))
        }
    }

    if(params.with_filter){
        let num = params.with_filter.num;
        eligible = eligible.filter(e => testNum(num, matches(e, params.with_filter.types)));
    }

    if(params.with_beamed && params.with_beamed.types){
        let num = params.with_beamed.num;
        if(params.with_beamed.types == 'away'){
            eligible = eligible.filter(e => {
                let count = allAway(e); // includes drones
                if(!count){
                    if(num == 0) return true;
                    return false;
                }
                if(typeof num == 'number'){
                    if(count == num) return true;
                    return false;
                }
                if(num.hasOwnProperty('min')){
                    if(count < num.min) return false;
                }
                if(num.max){
                    if(count > num.max) return false;
                } 
                return true;
            })
        }else{
            eligible = eligible.filter(e => {
                if(!e.beamed){
                    if(num == 0) return true;
                    return false;
                }
                let count = countMatches(p, e.beamed, params.with_beamed.types, (action == 'scoring'? false : (cache || true))); //e.beamed.reduce((a,c) => a + matches(c, params.with_beamed.types), 0);
                if(typeof num == 'number'){
                    if(count >= num) return true;
                    return false;
                }
                if(num.hasOwnProperty('min')){
                    if(count < num.min) return false;
                }
                if(num.max){
                    if(count > num.max) return false;
                } 
                return true;
            })
        }
        
    }

    
    /// to here

    if(obj.specific){
        eligible = eligible.filter(c => matches(c, obj.specific));
    }
    if(obj.filter){
        /*let compositeResolved = false;
        if(obj.filter.types && obj.types){
            // March 2026: added so that 'X that has Y' are resolved
            // not via filtration (which auto-adds wildcard)
            // but via a+b mechanics so that wildcard tests later fire (I think)
            compositeResolved = true;
            let composite = [];
            for(let t1 of possArray(obj.types)){
                if(typeof t1 != 'string'){
                    compositeResolved = false;
                    break;
                }
                for(let t2 of possArray(obj.filter.types)){
                    if(typeof t2 != 'string') compositeResolved = false;
                    composite.push(`${t1}+${t2}`);
                }
                if(!compositeResolved) break;
            }
        }
        if(compositeResolved){
            let newObj = {...obj};
            newObj.types = compositeResolved;
            if(Object.keys(obj.filter).some(f => f != 'types')){
                delete newObj.filter.types;
            }else{
                delete newObj.filter;
            }
            obj = newObj; //{...obj, types: compositeResolved, filter: false}; // 
        }else{*/
            eligible = eligible.filter(c => testFilterTypes(c, obj.filter));
        /*}*/
        
    }
    
    if(obj.another){
        eligible = eligible.filter(c => c.uniqueID != card.uniqueID)
    }
    if(obj.logged == 1){
        // only logged cards
        eligible = eligible.filter(c => get(state).cardLog[c.uniqueID].deck == 'log')
    }else if(obj.logged == -1){
        eligible = eligible.filter(c => get(state).cardLog[c.uniqueID].deck != 'log')
    }

    //if(obj.card_itself == true) console.log(eligible);
    let prevCache = {...(cache || {})};

    let count = 0;
    if(obj.types){
        let nonCardTypes = possArray(obj.types).filter(t => t == 'away' || t == 'opp_away' || t == 'drone'|| t == 'murf' || t && typeOfGain(t) != 'card');
        
        let cardTypes = possArray(obj.types).filter(t => !nonCardTypes.includes(t));
        // '[[away team]]/[[drone]]' wording: 'away' already includes drones, so counting both double-counts
        if(nonCardTypes.includes('drone') && (nonCardTypes.includes('away') || nonCardTypes.includes('opp_away'))){
            nonCardTypes = nonCardTypes.filter(t => t != 'drone');
        }
        // likewise Murf
        if(nonCardTypes.includes('murf') && (nonCardTypes.includes('away') || nonCardTypes.includes('opp_away'))){
            nonCardTypes = nonCardTypes.filter(t => t != 'murf');
        }
        if(possArray(obj.types).includes('traits')) cardTypes = get(res).traits.filter(t => !['wildcard', 'any species'].includes(t)); // April 2025 for handling 'X different traits' in a mission
        //if(!['scoring', 'mission'].includes(action)) console.log('rct', nonCardTypes, cardTypes);
        for(let t of nonCardTypes){
            if(t == 'away'){
                for(let c of eligible){
                    let toAdd = myAway(p, c) //+ theirAway(p, c);
                    count += toAdd;
                    if(toAdd && action != 'mission'){
                        // Add to cache for cards that test it
                        state.update(s => {
                            if(!s.cache) s.cache = {};
                            if(!s.cache.allPrev) s.cache.allPrev = [];
                            s.cache.allPrev = [c.uniqueID, ...s.cache.allPrev];
                            return s;
                        })
                    }
                }
            }else if(t == 'opp_away'){
                for(let c of eligible){
                    let toAdd = myAway(otherPlayer(p), c) //+ theirAway(p, c);
                    count += toAdd;
                    if(toAdd){
                        // Add to cache for cards that test it
                        state.update(s => {
                            if(!s.cache) s.cache = {};
                            if(!s.cache.allPrev) s.cache.allPrev = [];
                            s.cache.allPrev = [c.uniqueID, ...s.cache.allPrev];
                            return s;
                        })
                    }
                }
            }else if(t == 'drone'){
                for(let c of eligible){
                    count += drones(p, c);
                }
            }else if(t == 'murf'){
                for(let c of eligible){
                    if(c.murf && hasMurf(p)) count++;
                }
            }else if(t && typeOfGain(t) != 'card'){
                // Then it's probably a straight-up token test
                count += countTypes(p, {...obj, types: t}, eligible);
            }
            //if(!['scoring', 'mission'].includes(action)) console.log('so far', eligible, t, count);
        }

        if(cardTypes.length > 0){
            let finalEligible = [];
            let addedWildCards = [];
    
            let types = cardTypes;
            if(!Array.isArray(types)) types = [types];
            types = types.flat(2);
    
            let pwc = possibleWildCards(types);
    
            if(!cache.hasOwnProperty('wildcardsLeft')){
                let wcl = eligible.filter(c => c.traits).reduce((a,c) => a + c.traits.filter(t => pwc.includes(t) || pwc.some(p => t.startsWith(p)) && t.includes('!') && types.some(ty => t.split('!')[1] != ty)).length, 0)
                if(wcl > 0) cache.wildcardsLeft = wcl;
            }
        
            if(!cache.hasOwnProperty('wildcardsUsed')){
                cache.wildcardsUsed = 0;
            }
    
            if(types.every(t => typeOfGain(t) == 'card')){
                
                /*for(let t of types){
                    for(let e of eligible){
                        let toAdd = matches(e, t);
                        count += toAdd;
                        if(toAdd > 0) finalEligible.push(e);
                        //if(matches(e,t) > 0) console.log('matches found!', t, e);
                    }
                }
                //if(action != 'scoring') console.log('count completed', eligible, count);
                if(toFill) toFill.eligible = finalEligible;*/
                if(obj.diff == 'different'){
                    // Handle separately and manage
                    // NB this is where to handle if we decide to duplicate
                    eligible = eligible.sort((a,b) => {
                        let numMatches = {
                            a: 0,
                            b: 0
                        };
                        for(let t of types){
                            numMatches.a += matches(a, t, false);
                            numMatches.b += matches(b, t, false);
                        }
                        return numMatches.a - numMatches.b;
                    })
                    let matchedTypes = [];
                    for(let t of types){
                        for(let e of eligible){
                            if(matches(e, t, false)){
                                if(obj.separate_cards || params.diffCards){
                                    if(!matchedTypes.includes(e.uniqueID)){
                                        count++;
                                        matchedTypes.push(e.uniqueID);
                                        finalEligible.push(e);
                                    }
                                }else{
                                    if(!matchedTypes.includes(t)){
                                        count++;
                                        matchedTypes.push(t);
                                        finalEligible.push(e);
                                    }
                                    
                                    //break; // i.e. each trait only counts once
                                }
                                
                            }
                        }
                    }
                    let unmatchedTypes = types.filter(t => !matchedTypes.includes(t));
                    let wcCardsAlreadyThere = countWildcards(finalEligible, types);
                    let possibleWC = countWildcards(eligible, types);
                    if(obj.separate_cards || params.diff_cards) possibleWC -= wcCardsAlreadyThere;
                    let wcToAdd = Math.min(unmatchedTypes.length, cache.wildcardsLeft || 0, possibleWC);
                    cache.wildcardsUsed += wcToAdd;
                    cache.wildcardsLeft -= wcToAdd;
                    count += wcToAdd;
                    addedWildCards = eligible.filter(e => !finalEligible.includes(e) && e.traits.some(t => pwc.includes(t) || pwc.some(p => t.startsWith(p)) && t.includes('!') && unmatchedTypes.some(ty => t.split('!')[1] != ty)));
                    finalEligible.push(...addedWildCards); // !! should I do this?
                }else{
                    count += countMatches(p, eligible, types, (action == 'scoring' ? false : (cache || true)), finalEligible, addedWildCards, [], obj.separate_cards || params.diffCards, params.exclude);
                }

                let newWCused = ((cache || {}).wildcardsUsed || 0) - (prevCache.wildcardsUsed || 0);
                
                if(action != 'scoring' && newWCused > 0){
                    let wildCards = eligible.reduce((a, c) => a + c.traits.filter(t => pwc.includes(t) || pwc.some(p => t.startsWith(p)) && t.includes('!') && types.some(ty => t.split('!')[1] != ty)).length, 0);
                    // April 2025: the below logic doesn't make sense,
                    // because the code shouldn't allow you to use more wildcards than you have
                    // So commenting out, 
                    if(wildCards < newWCused){
                        let diff = newWCused - wildCards;
                        count -= diff; // reduce number
                        cache.wildcardsUsed -= diff; // Reset to the actual number used
                        cache.wildcardsLeft = 0;
                    }
                    if(cache.target && count > cache.target && wildCards && newWCused){
                        // Reduce number of WC to bring to target
                        let diff = Math.min(wildCards, count - cache.target);
                        cache.wildcardsUsed -= diff;
                        cache.wildcardsLeft += diff;
                        count -= diff;
                        addedWildCards = addedWildCards.slice(0, wildCards - diff);
                    }
                }
                if(toFill){
                    if(Array.isArray(toFill)){
                        toFill.push(...finalEligible);
                    }else{
                        toFill.eligible = finalEligible;
                        toFill.addedWildCards = addedWildCards;
                    }
                    
                    //toFill.addedWildCards = addedWildCards;
                }
                //if(action != 'scoring') console.log('count completed', eligible, count);
            }else{
                // Presume all sth else...
                // Does below even need to be here now given separation of cardTypes and nonCardTypes?
                for(let t of types){
                    count += p[t];
                }
                //if(action != 'scoring') console.log('count completed', eligible, count);
            }
            if(action != 'scoring' && action != 'mission' && action != 'nocache'){
                state.update(s => {
                    if(!s.cache) s.cache = {};
                    s.cache.countResults = finalEligible.map(c => c.uniqueID);
                    return s;
                })
            }
        }

    }else if(obj.card && obj.card.card){
        // for card names
        // TODO handle more stuff here
        if(obj.card.card_itself == true){
            for(let e of eligible){
                if(matches(e, obj.card.card)){
                    count++;
                    if(toFill) toFill.push(e);
                }
            }
        }
        if(toFill && action != 'scoring' && action != 'mission' && action != 'nocache'){
            state.update(s => {
                if(!s.cache) s.cache = {};
                s.cache.countResults = toFill.map(c => c.uniqueID);
                return s;
            })
        }
    }else if(obj.card && typeof obj.card == 'string' && obj.card_itself == true){
        for(let e of eligible){
            if(matches(e, obj.card)){
                count++;
                if(toFill) toFill.push(e);
            }
        }
        if(toFill && action != 'scoring' && action != 'mission' && action != 'nocache'){
            state.update(s => {
                if(!s.cache) s.cache = {};
                s.cache.countResults = toFill.map(c => c.uniqueID);
                return s;
            })
        }
    }else{
        count = eligible.length;
        if(toFill) toFill.push(...eligible); //toFill/*.eligible*/ = eligible;
        if(toFill && action != 'scoring' && action != 'mission' && action != 'nocache'){
            state.update(s => {
                if(!s.cache) s.cache = {};
                s.cache.countResults = toFill.map(c => c.uniqueID);
                return s;
            })
        }
    }

    
    let div = params.div;
    if(!div && obj.num && typeof obj.num == 'number') div = obj.num;

    if(div){
        count = count / div;
        if(params.round == 'down'){
            count = Math.floor(count);
        }else if(params.round == 'up'){
            count = Math.ceil(count);
        }else{
            // Presume down
            count = Math.floor(count);
        }
    }
    
    /*if(obj.num && typeof obj.num == 'number'){
        // Num is divisor
        count = count / obj.num;
        if(params.round == 'down'){
            count = Math.floor(count);
        }else if(params.round == 'up'){
            count = Math.ceil(count);
        }else{
            // Presume down
            count = Math.floor(count);
        }
    }*/

    if(get(state).practice && getPlayerIndex(p) == 1){
        return 1; // Only 1 of everything in practice mode
    }

    return count;
    

    // is there a 'cards with' to count? i.e. obj.card.types
    console.log('no types')
    return eligible.length;
}

function possibleWildCards(test){
    let wildcardTraits = ['wildcard'];
    if(possArray(test).some(t => [...get(res).species, 'different species', 'any species', 'different-species'].includes(t))){
        wildcardTraits.push('any species');
    }
    return wildcardTraits;
}

export function cardWCs(c, test){
    if(!c) return 0;
    // A wildcard can't be treated as a utility trait
    let tested = possArray(test).filter(t => typeof t == 'string');
    if(tested.length && tested.every(t => isUtilityTrait(t))) return 0;
    let wildcardTraits = possibleWildCards(test);
    let count = 0;
    if(get(state).cache && get(state).cache.cardWCs && get(state).cache.cardWCs[c.uniqueID]){
        count = c.traits.filter(t => wildcardTraits.includes(t)).length - Object.keys(get(state).cache.cardWCs[c.uniqueID]).length;
    }else{
        count = c.traits.filter(t => wildcardTraits.includes(t)).length;
    }
    let partials = c.traits.filter(t => wildcardTraits.some(w => t.startsWith(w)) && t.includes('!'));
    for(let p of partials){
        // Handle any species/wildcard except X
        let except = p.split('!')[1];
        if(possArray(test).some(t => t != except)) count++; // As long as there's some non-matching there
    }
    return count;
}

function countWildcards(cards, test){
    return cards.reduce((a,c) => a + cardWCs(c, test), 0);
}

function resolvePrevCount(verb, type = false){
    if(!get(state).cache || !get(state).cache.allPrev){
        console.log('no cache/previous object', get(state))
        return [];
    }
    let possiblePrev = get(state).cache.allPrev;
    let possibleVerbs = get(state).cache.prevVerbs || [];

    if(get(state).cache.interimPrev){
        console.log('interim prev obj')
        possiblePrev = [...get(state).cache.interimPrev.flat(2), ...possiblePrev]; // TODO hope it doesn't break others!
    }

    console.log('1', possiblePrev)

    if(get(state).cache.current_obj){ // TODO fudge! 
        console.log('possible current obj')
        possiblePrev = [get(state).cache.current_obj, ...possiblePrev];
        possibleVerbs = [get(state).cache.current_verb, ...possibleVerbs];
    }

    if(verb){
        if(!Array.isArray(verb)) verb = [verb];
        possiblePrev = [];
        //console.log(verb, possibleVerbs);
        for(let v of verb){
            if(synonyms[v]) v = synonyms[v];
            let pv = possibleVerbs.filter(pv => pv.verb == v || v == 'gain' && (pv.verb.startsWith('gain')));  
            pv = pv.filter(v => v.verb != 'gain'); // To avoid double-counting gained tokens BODGE     
            possiblePrev = [...possiblePrev, ...pv.map(pv => Array.isArray(pv.obj) ? pv.obj : [pv.obj]).flat(2)];
            if(type){
                possiblePrev = possiblePrev.filter(p => {
                    for(let t of possArray(type)){
                        if(p.specific && p.specific == t) return true;
                        if(p.types && p.types == t) return true;
                        if(typeof p == 'number' && matches(getCard(p), t)) return true;
                    }
                    
            });
            }
            //console.log(possiblePrev);
        }
        if(possiblePrev.length > 0) state.update(s => {
            s.cache.allPrev = [...possiblePrev, ...s.cache.allPrev]; // For 'if the discarded card... X; if it ... Y type scenarios
            return s;
        })
        // !!! At this point, possiblePrev has the consolidated result of all matches for this verb.
        // So return them!
        // !! TODO if this breaks other stuff, revert it (i.e. remove below line)
        // !! The thing to do in that case would be to scan possibleVerbs from 0 until the verb changes,
        // and composite all those
        if(possiblePrev.some(p => p.num)) return possiblePrev.reduce((a, p) => p.num ? a + p.num : a, 0); // To handle counts too
        return possiblePrev.length;
        //console.log('Specific verb - not handled at present', obj.prevVerb, possiblePrev, possibleVerbs);
        //let verb = obj.prevVerb;
        //if(synonyms[verb]) verb = synonyms[verb];
        //possiblePrev = possiblePrev.filter((p, i) => {possibleVerbs[i] == verb || possibleVerbs[i] == synonyms[verb]});
    }
    let last = possibleVerbs[0];
    if(last){
        if(last.obj){
            if(Array.isArray(last.obj)) return last.obj.length;
            if(last.obj.num) return last.obj.num;
        }else{
            if(last.num) return last.num;
        }
    }
    return 0;
}

export function currentCard(){
    if(get(state).cache) return get(state).cache.cardID
}

function someMatches(c, m){
    if(Array.isArray(c)) return c.flat(2).some(cd => someMatches(cd, m));
    if(typeof c == 'number') c = getCard(c);
    if(typeof m == 'function'){
        return m(c);
    }else{
        return matches(c, m);
    }
}

function allMatches(c, m){
    if(Array.isArray(c)) return c.flat(2).every(cd => someMatches(cd, m));
    if(typeof c == 'number') c = getCard(c);
    if(typeof m == 'function'){
        return m(c);
    }else{
        return matches(c, m);
    }
}

function filterToMatches(list, m){
    return list.filter(c => someMatches(c, m)).map(c => !Array.isArray(c) ? c : c.flat(2).filter(c => typeof m == 'function' ? m(c) : matches(c, m) ))
}

function locationOfCard(c){
    if(typeof c == 'number') c = getCard(c);
    if(!c) return false;
    let info = get(state).cardLog[c.uniqueID];
    if(!info) return false;
    if((matches(c, 'ship') && info.deck == 'fleet') && c.orbitingCard){
        if(!c.ships || c.ships.length == 0) return false;
        let card = getCard(c.orbitingCard[c.ships[0]]);
        if(matches(card, 'location')) return card;
    }else if(info.area == 'beamed'){
        let beamer = getCard(info.deck);
        return locationOfCard(beamer);
    }
    return false;
}

function filterBasedOnAction(c, action){
    if(Array.isArray(c)){
        return c.map(cd => filterBasedOnAction(cd, action)).some(r => r);
    }
    if(typeof c == 'number') c = getCard(c);
    if(action == 'take'){
        // filter to takeable things: you can only take cards from the market
        if(!(c.uniqueID && get(state).cardLog[c.uniqueID] && get(state).cardLog[c.uniqueID].area == 'commons')) return false;
    }

    if(action == 'warp'){
        // filter to ships that can be warped
        if(!(c.uniqueID && get(state).cardLog[c.uniqueID] && get(state).cardLog[c.uniqueID].deck == 'fleet' && matches(c, 'ship'))) return false;
    }

    if(action && ['recall', 'dismiss', 'refresh'].includes(action)){
        //let p = get(state).players[get(state).activePlayer];
        if(!c || !c.uniqueID) return false;
        if(!isInPlay(c)) return false;
    }

    if(action && ['log', 'recall', 'dismiss', 'junk', 'duty', 'discard', 'play'].includes(action)){
        if(!c || !c.uniqueID) return false;
        if(c.suits.includes('captain')) return false; // You'll never do these things to your Captain card
    }
    return true;
}

// Parse-time backreferences (docs/prev-obj-static-binding-plan.md). The binder stamps a `bind`
// on every prev_obj node and a `slot` on every action; frames.js records what each slot
// produced. These three helpers turn that into an answer, or decline and let the legacy scan
// below take over.

// off    – never consult bindings (the shipping default)
// shadow – compute both answers, log where they differ, return the legacy one
// live   – return the bound answer for the shapes that are enabled
export function bindingMode(){
    let m = get(prefs).useParseBindings;
    if(m === true) return 'live';   // the old boolean pref
    if(m === 'shadow' || m === 'live') return m;
    return 'off';
}

// Phase 3 flips the cutover one descriptor shape at a time; each stays independently
// revertable from Options -> Debug without giving up the others.
export function bindingShape(obj){
    if(!obj) return 'bare';
    if(obj.bind && obj.bind.kind == 'count') return 'count';
    if(obj.prevPrep) return 'prep';
    if(obj.prevVerb) return 'prevVerb';
    if(obj.it) return 'it';
    if(obj.num !== undefined && obj.num !== null) return 'num';
    return 'bare';
}

function shapeEnabled(obj){
    let shapes = get(prefs).parseBindingShapes;
    if(!shapes) return true;
    let s = bindingShape(obj);
    return shapes[s] !== false;
}

// "If you gained 3 or more": the binder marks these {kind:'count', slot}, and the frame knows
// exactly how many that slot produced. Returns the scan's own answer unless a binding can do
// better, so the caller needs no mode handling of its own.
export function countWithBindings(a, scanned){
    if(bindingMode() == 'off') return scanned;
    for(let d of [a && a.obj && a.obj.card, a && a.obj]){
        if(!d || !d.bind || d.bind.kind != 'count') continue;
        let n = resolveFrameCount(d.bind);
        if(n === null) continue;
        if(bindingMode() == 'live' && shapeEnabled(d)) return n;
        if(n !== scanned){
            divergences++;
            let card = currentCard();
            console.warn('[bind divergence]', {card: card ? card.name : '?', shape: 'count',
                bind: d.bind, bound: n, legacy: scanned, reason: 'different count', total: divergences});
        }
        return scanned;
    }
    return scanned;
}

// Turn the frame answer (uniqueIDs) into what the scan returns (cards), applying the filters
// that genuinely belong at runtime. Returns null when the frames cannot answer at all.
function resolveBoundPrevObj(obj, num, cardType, atLocation, action){
    let bound = resolveFrameBinding(obj.bind);
    if(bound === null) return null;
    let ids = bound.filter(c => typeof c == 'number');
    if(obj.deckFilter) ids = ids.filter(c => get(state).cardLog[c] && get(state).cardLog[c].deck == obj.deckFilter);
    // The scan hands back *cards*, and callers depend on that: resolveObject's type_match
    // branch does `eligible.map(c => c.uniqueID)`, 'last_visiting' reads `card.visiting`.
    // A bound answer must be indistinguishable from a scanned one.
    let cards = ids.map(c => getCard(c)).filter(c => c);
    if(cardType) cards = cards.filter(c => matches(c, cardType));
    if(obj.prevType && obj.prevType != 'card' && obj.prevType != 'cards') cards = cards.filter(c => matches(c, obj.prevType));
    if(obj.unexhausted) cards = cards.filter(c => !c.activated);
    if(obj.onTable) cards = cards.filter(c => tableEffectsActive(c) || getNeutralZone().some(n => n.uniqueID == c.uniqueID));
    if(atLocation) cards = cards.filter(c => locationOfCard(c)); // "there"/"its location"
    // A card of the right kind that the verb cannot act on at all (taking a card that is not in
    // the Market, recalling one not in play) means the binding named the wrong producer, not that
    // the effect whiffed: decline, so the scan answers as it did before bindings existed.
    // (A card of the wrong kind is a real "nothing": "play the discarded [[person]]" after
    // discarding a ship must not reach back to an older person.)
    let reachable = cards.filter(c => filterBasedOnAction(c, action));
    if(cards.length && !reachable.length){
        console.warn('[bind] bound card cannot be acted on, falling back to scan', {bind: obj.bind, action, cards: cards.map(c => c.uniqueID)});
        return null;
    }
    // dedupe by uniqueID, not object identity: a slot accumulates one entry per object of a
    // multi-object action, and "it" below counts what is left
    cards = Array.from(new Map(reachable.map(c => [c.uniqueID, c])).values());
    // "it" (num 1) is a single specific card; everything else ("them", "one of them", "both",
    // bare) returns the whole referenced pool and lets the caller pick/limit, exactly as the
    // scan does - slicing here would skip the player's choice.
    if(obj.it && (obj.num === 1 || obj.num == null)) return cards.slice(0, 1);
    return cards;
}

let divergences = 0;

// Shadow mode's whole point: make a wrong bound answer countable instead of silent. Compares
// by uniqueID *and* by shape, so returning ids where the scan returns cards is a divergence
// rather than something that only shows up as a broken card three hours into a game.
function logDivergence(obj, bound, legacy, action){
    let ids = v => (Array.isArray(v) ? v : [v]).filter(c => c).map(c => (c && c.uniqueID !== undefined) ? c.uniqueID : c);
    let shapeOf = v => (Array.isArray(v) ? v : [v]).filter(c => c).every(c => c && c.uniqueID !== undefined) ? 'cards' : 'ids';
    let bi = ids(bound), li = ids(legacy);
    let same = bi.length == li.length && bi.every((c, i) => c == li[i]);
    let sameShape = bi.length == 0 || li.length == 0 || shapeOf(bound) == shapeOf(legacy);
    if(same && sameShape) return false;
    divergences++;
    let card = currentCard();
    console.warn('[bind divergence]', {
        card: card ? card.name : '?',
        shape: bindingShape(obj),
        bind: obj.bind,
        action,
        bound: bi,
        legacy: li,
        reason: same ? `shape: bound=${shapeOf(bound)} legacy=${shapeOf(legacy)}` : 'different cards',
        total: divergences
    });
    return true;
}

export function bindingDivergenceCount(){
    return divergences;
}

// Resolve "it" / "the card you drew" / "both of them". Consults the parse-time binding first
// when the pref asks for it, and otherwise scans the runtime history (resolvePrevObjScan).
export function resolvePrevObj(obj, num = 1, type = 'card', action = false){
    let mode = bindingMode();
    if(obj && obj.bind && obj.bind.forced){
        // Replacement "it" (see bind_prev.js bindReplacementIt): the trigger, whatever the mode
        let bound = resolveBoundPrevObj({...obj, it: false}, num, false, false, action);
        if(bound && obj.bind.types) bound = bound.filter(c => matches(c, obj.bind.types));
        if(bound && bound.length) return bound.slice(-1); // reactionObj stacks: latest is what fired
    }
    // Singular pronouns name one producer, even with the experimental wider binding
    // rollout disabled. In particular, an if-condition's Ally beats an earlier Ship,
    // and a gained Ship beats a card junked before it. Never scan unrelated history
    // when that producer ran but returned nothing.
    if(obj?.it && !obj.prevVerb && !obj.bind?.loose &&
        ['slot', 'slots', 'self', 'loop', 'trigger'].includes(obj.bind?.kind)){
        let cardType = type == 'ship' || type == 'location' ? type : action == 'return' ? 'incident' : false;
        let bound = resolveBoundPrevObj(obj, num, cardType, type == 'at_location' || type == 'same_location', action);
        if(bound !== null){
            // live whatever the mode, so shadow must still say where it differs from the scan
            // (no prevVerb here, so the scan does not touch allPrev)
            if(mode == 'shadow') logDivergence(obj, bound, resolvePrevObjScan(obj, num, type, action), action);
            return bound;
        }
    }
    if(mode == 'off' || !obj || !obj.bind) return resolvePrevObjScan(obj, num, type, action);

    // Derive the same type flags the scan derives, so both answers are filtered alike.
    let cardType = false, atLocation = false;
    if(type == 'location') cardType = 'location';
    if(type == 'ship') cardType = 'ship';
    if(action == 'return') cardType = 'incident';
    if(type == 'at_location' || type == 'same_location') atLocation = true;

    // Bound answer first: the scan mutates cache.allPrev as it goes.
    let bound = resolveBoundPrevObj(obj, num, cardType, atLocation, action);
    if(bound === null) return resolvePrevObjScan(obj, num, type, action);

    if(mode == 'live' && shapeEnabled(obj)){
        console.log('resolvePrevObj via bindings', obj.bind, bound);
        return bound;
    }
    let legacy = resolvePrevObjScan(obj, num, type, action);
    logDivergence(obj, bound, legacy, action);
    return legacy;
}

function resolvePrevObjScan(obj, num = 1, type = 'card', action = false){
    
    /*let prev = get(state).cache.prev_obj;
    console.log(`Previous object`, prev)
    if(!prev || prev.length == 0) return []; // Can't do this action I guess...
    if(typeof prev != 'number' || (Array.isArray(prev) && !prev.every(e => typeof e == 'number'))){
        // Find a more appropriate obj
        for(let j = get(state).cache.allPrev.length - 1; j >= 0; j--){
            let p = get(state).cache.allPrev[j];
            if(typeof p == 'number' || Array.isArray(p) && p.every(e => typeof e == 'number')){
                prev = p;
                break;
            }
        }
    }*/

    let cardType = false;
    let atLocation = false;

    if(type == 'location'){
        type = 'card';
        cardType = 'location';
    }
    if(type == 'ship'){
        type = 'card';
        cardType = 'ship';
    }
    if(action == 'return'){
        type = 'card';
        cardType = 'incident';
    }

    if(type == 'at_location'){
        atLocation = true;
        type = 'card';
    }

    if(type == 'same_location'){
        atLocation = true;
        type = 'card';
    }

    if(!get(state).cache || !get(state).cache.allPrev){
        console.log('no cache/previous object', get(state))
        return [];
    }
    let possiblePrev = get(state).cache.allPrev;
    let possibleVerbs = get(state).cache.prevVerbs || [];

    let alwaysPrev = [];
   

    if(get(state).cache.interimPrev){
        console.log('interim prev obj')
        alwaysPrev = [...get(state).cache.interimPrev.flat(2)];
        possiblePrev = [...get(state).cache.interimPrev.flat(2), ...possiblePrev]; // TODO hope it doesn't break others!
    }

    

    console.log('cache', get(state).cache);

    console.log('1', possiblePrev)

    if(get(state).cache.current_obj){ // TODO fudge! 
        console.log('possible current obj')
        alwaysPrev = [get(state).cache.current_obj, ...alwaysPrev];
        possiblePrev = [get(state).cache.current_obj, ...possiblePrev];
        possibleVerbs = [get(state).cache.current_verb, ...possibleVerbs];
    }

    // Jan 2026: moved reactionObj below current_obj
    // on the basis that reactionObj should interrupt. Right...?
    // NB reaction obj currently only for 'due to the effect of'
    // which we maybe should ask to be reworded?

    if(get(state).cache.reactionObj){
        console.log("adding reaction obj");
        alwaysPrev = [...get(state).cache.reactionObj, ...alwaysPrev];
        possiblePrev = [...get(state).cache.reactionObj, ...possiblePrev];
    }

     console.log('1a', possiblePrev);

    let definitelySucceeded = false;

    // Filter out prepositions that weren't in the text, since we are not in this branch (unlike the prevVerb one)
    // dealing with card text that looks specifically for prepositions

    if(atLocation){
        // for now, just filter to beamed cards and/or ships (Jan 2026)
        // for future, could actually check they are at a location
        // This is to fix Lursa btw
        // Jan 2026: also wondering whether we want 
        // 'its location' to cover beamed cards or not
        // for now reverting to just ships, because if it includes beamed as well
        // then card_loc needs changing too
        possiblePrev = filterToMatches(possiblePrev, (c) => {
            //let info = get(state).cardLog[c.uniqueID];
            for(let o of possArray(c)){
                if(typeof o != 'number' && !o.uniqueID) continue;
                return locationOfCard(o); //matches(c, 'ship') && info.deck == 'fleet' //|| info.area == 'beamed';
            }
        })
        possibleVerbs = filterToMatches(possibleVerbs, (v) => {
            for(let o of possArray(v.obj)){
                if(typeof o != 'number' && !o.uniqueID) continue;
                return locationOfCard(o);
                //let info = get(state).cardLog[c.uniqueID];
                //if((matches(c, 'ship') && info.deck == 'fleet') || info.area == 'beamed' &&return true
            }
        })
    }


    if(obj.num == 'last' || (!obj.num && !obj.it && !obj.prevVerb && !get(state).cache.reactionObj && possibleVerbs.length > 0 && !cardType && !obj.prevType && !obj.filter && !obj.deckFilter && !obj.unexhausted)){ // !!! TODO check that this doesn't break owt. Fallback for avoiding multiple objects
        // being munged together when it's 'them' not 'it'
        // Restrict to last verb
        // !cardType is a bodge !!! TODO may need to expand if something else breaks (but then, this whole routine is a total mess..!!!)
        
        // Below is added to filter out type_match for the purposes of e.g. Georgiou Kelpien planet
        // But really what we probably need is separate tracks for card and non-card prev objects
        // But probably too late for that...
        possibleVerbs=  possibleVerbs.filter(v => typeof v.obj == 'number' || Array.isArray(v.obj) && v.obj.some(o => typeof o == 'number'))

        // Now filter to verbs where at least one card fits the action
        possibleVerbs = possibleVerbs.filter(v => filterBasedOnAction(v.obj, action));
        
        let verb = possibleVerbs[0];
        //if(!verb) throw 'uncompleted'; // No last verb
        if(!verb) return [];
        possibleVerbs = [verb];
        possiblePrev = [...possArray(verb.obj)];
        /*if(verb.to){
            possiblePrev = [...possiblePrev, ...possArray(verb.)]
        }*/
    }

    if(obj.prevVerb){
        let verb = obj.prevVerb.verb;
        if(!Array.isArray(verb)) verb = [verb];
        possiblePrev = [];
        if(obj.num == 1) obj.it = true;
        //console.log(verb, possibleVerbs);
        for(let v of verb){
            if(synonyms[v]) v = synonyms[v];
            let pv = possibleVerbs.filter(pv => verbMatches(pv.verb, v));      
            let type = obj.prevPrep || 'obj';    
            possiblePrev = [...possiblePrev, ...pv.map(pv => Array.isArray(pv[type]) ? pv[type] : [pv[type]]).flat(2).filter(o => typeof o == 'number' || type != 'card')];
            //console.log(possiblePrev);
        }
        if(possiblePrev.length > 0){
                state.update(s => {
                    s.cache.allPrev = [...possiblePrev, ...s.cache.allPrev]; // For 'if the discarded card... X; if it ... Y type scenarios
                    return s;
                })
            definitelySucceeded = true; // So that 'you may discard drawn card; you may log drawn card;'-type effects don't domino-fail if the first does
        }
        //console.log('Specific verb - not handled at present', obj.prevVerb, possiblePrev, possibleVerbs);
        //let verb = obj.prevVerb;
        //if(synonyms[verb]) verb = synonyms[verb];
        //possiblePrev = possiblePrev.filter((p, i) => {possibleVerbs[i] == verb || possibleVerbs[i] == synonyms[verb]});
    }
    console.log('2', possiblePrev)
    possiblePrev = possiblePrev.filter(p => p);
    
    


    if((!get(state).cache.did_previous || currentCard() && !get(state).cache.did_previous[currentCard()]) && !get(state).overrideDidPrevious && !definitelySucceeded){ // so otherwise should work...
        console.log('previous failed', get(state).cache, currentCard());
        if(possiblePrev.length == 0) return [];
        possiblePrev = alwaysPrev.filter(p => p); // So just do the current stuff
        if(possiblePrev.length == 0) return [];
        //possiblePrev = []; // So only new things can work
        //possibleVerbs = []; // So only new things can work
        //throw 'uncompleted'; // This action shouldn't complete if the previous doesn't – TODO check this doesn't break everything!
    }
    console.log('3', possiblePrev)
    if(obj.unexhausted) possiblePrev = possiblePrev.filter(c => typeof c == 'number' && !getCard(c).activated);
    if(obj.filter){
        if(obj.filter.card == 'card' || obj.filter.card == 'cards'){
            possiblePrev = possiblePrev.filter(c => typeof c == 'number' || Array.isArray(c) && c.flat(2).every(c => typeof c == 'number'));
        }else if(obj.filter.types == 'track'){
            console.log(possiblePrev);
            possiblePrev = possiblePrev.flat(2).filter(c => c.types && typeOfGain(c.types) == 'track' || Array.isArray(c) && c.every(c => c.types && typeOfGain(c.types) == 'track'));
            return [possiblePrev[0]].map(p => { return {num, type: 'track', specific: p.types} }); // TODO num is a bit of a fudge to be fair

        }else if(obj.filter.types == 'resource' || obj.filter.types == 'tokens'){
            possiblePrev = possiblePrev.flat(2).filter(c => c.types && typeOfGain(c.types) == 'tokens' || Array.isArray(c) && c.every(c => c.types && typeOfGain(c.types) == 'tokens'))
            return [possiblePrev[0]].map(p => { return {num, type: 'tokens', specific: p.types} });
        }else{
            possiblePrev = possiblePrev.flat(2).filter(c => typeof c == 'number' && testFilterTypes(getCard(c), obj.filter));
            //possiblePrev = possiblePrev[0].map(c => getCard(c));
        }
        
    }else{
        // By default filter to cards
        // TODO is this right??
        possiblePrev = [...possiblePrev].filter(c => typeof c == 'number' || Array.isArray(c) && c.flat(2).some(c => typeof c == 'number')).map(c => Array.isArray(c) && c.flat(2).filter(c => typeof c == 'number').map(c => getCard(c)) || getCard(c));
        //if(!Array.isArray(possiblePrev)) possiblePrev = [possiblePrev];
        if(obj.prevType && obj.prevType != 'card' && obj.prevType != 'cards'){
            possiblePrev = possiblePrev.filter(c => !Array.isArray(c) && matches(c, obj.prevType) || Array.isArray(c) && c.flat(2).some(c => matches(c, obj.prevType))).map(c => !Array.isArray(c) ? c : c.flat(2).filter(c => matches(c, obj.prevType) ))
        }
        
        

        if(cardType){
            possiblePrev = possiblePrev.filter(c => !Array.isArray(c) && matches(c, cardType) || Array.isArray(c) && c.flat(2).some(c => matches(c, cardType))).map(c => !Array.isArray(c) ? c : c.flat(2).filter(c => matches(c, cardType) ))
        }

        console.log('4', possiblePrev)
    }

    if(obj.deckFilter){
        possiblePrev = possiblePrev.flat(2).filter(c => get(state).cardLog[c.uniqueID] && get(state).cardLog[c.uniqueID].deck == obj.deckFilter)
    }
    if(obj.onTable){
        possiblePrev = possiblePrev.flat(2).filter(c => tableEffectsActive(c) || getNeutralZone().some(n => n.uniqueID == c.uniqueID));
    }
    /*if(obj.it && action == 'type_match'){
        // Added Jan 2026 so 'Infighting' works:
        // references to 'it' cannot be targeting the card being played, as it would say 'this card'
        // postponed: I think some cards might do this actually
        
        possiblePrev = possiblePrev.flat(2).filter(c => !currentCard() || currentCard().uniqueID != c.uniqueID);
    }*/

    if(!obj.same){
        // only for non-same because of 'the same location'
        possiblePrev = possiblePrev.flat(2).filter(c => filterBasedOnAction(c, action));
    }
    
    /*if(action == 'take'){
        // filter to takeable things: you can only take cards from the market
        possiblePrev = possiblePrev.flat(2).filter(c => c.uniqueID && get(state).cardLog[c.uniqueID] && get(state).cardLog[c.uniqueID].area == 'commons');
    }

    if(action == 'warp'){
        // filter to ships that can be warped
        possiblePrev = possiblePrev.flat(2).filter(c => c.uniqueID && get(state).cardLog[c.uniqueID] && get(state).cardLog[c.uniqueID].deck == 'fleet' && matches(c, 'ship'));
    }

    if(action && ['recall', 'dismiss', 'refresh'].includes(action)){
        //let p = get(state).players[get(state).activePlayer];
        possiblePrev = possiblePrev.flat(2).filter(c => isInPlay(c) || getNeutralZone().some(l => l.uniqueID == c.uniqueID));
    }

    if(action && ['assimilate', 'log', 'recall', 'dismiss', 'junk', 'duty', 'discard', 'play'].includes(action)){
        possiblePrev = possiblePrev.flat(2).filter(c => !c.suits.includes('captain')); // You'll never do these things to your Captain card
    }*/
    
    let toReturn = possiblePrev[0];
    if(!Array.isArray(toReturn)){
        // April 2025: replacing the below with this, because I really don't understand
        // why we just took one part of possiblePrev...
        // test with 'both of them', '1 of them', '2 of them', etc.
        toReturn = possiblePrev.flat(2).map(c => getCard(c));
        
        // before it was this:
        //if(typeof toReturn == 'number') toReturn = getCard(toReturn);
        //toReturn = [toReturn];
    }else{
        toReturn = Array.from(new Set(toReturn.flat(2))).map(c => getCard(c));
    }
    
    console.log('resolving prev_obj', num, obj, toReturn, possiblePrev, get(state).cache.allPrev);

    if(obj.num == 1 && obj.it){
       // if(toReturn.some(c => c != currentCard())) toReturn = toReturn.filter(c => c != currentCard()); // 'it' refers generally to the object of a card rather than 'this card'... I think??
       return toReturn.slice(0, 1); // For specific 'do X and do it'
    }
    if(num && num > toReturn.length){
        let fullSet = Array.from(new Set(possiblePrev.flat(2)));
        return fullSet.slice(0, num).flat(2).map(c => getCard(c)); // TODO check this works... it's a bit of a fudge for situations like 'both of them'
    }
    //if(num == 'all') return possiblePrev[0]
    if(obj.num && typeof obj.num == 'number' && toReturn.length < obj.num){
        let fullSet = Array.from(new Set(possiblePrev.flat(2)));
        return fullSet.slice(0, obj.num).flat(2).map(c => getCard(c));
    }
    if(obj.num == 'all' || obj.num == 'any' || num == 'all' || (!obj.num && !obj.it)){
        console.log('warning: all cards...!')
        return Array.from(new Set(possiblePrev.flat(2))); //.map(c => getCard(c));
    }


    return Array.from(new Set(possiblePrev.flat(2)));//toReturn.flat(2).filter(c => c);

     // Because otherwise placeholder actions such as gain_card break the system TODO alternative could be to have a 'placeholder action' marker in card_actions
    
    
    if(possiblePrev.length == 0) return [];
    if(Array.isArray(possiblePrev[0])) possiblePrev = possiblePrev.flat(2);
    possiblePrev = Array.from(new Set(possiblePrev));
    console.log(possiblePrev, obj)
    if(obj.num && typeof obj.num == 'number') return possiblePrev.slice(0, obj.num);
    //console.log('prev obj results', possiblePrev, num);
   // if(num == 'all') return possiblePrev;
    //if(typeof num == 'number') return possiblePrev.slice(num);
    // TODO what about if there is a min/max situ?
    return possiblePrev;
   // return prev;
    /*if(Array.isArray(prev)){
        eligible = prev.map(c => getCard(c));
        if(prev.length == 1){
            return prev.map(c => c.uniqueID)
        }
        // Filter stuff here?
    }else{
        return [prev];
    }*/
}

function junkAction(action){
    if(action == 'gain_card' || action == 'gain' || action == 'scan' || action == 'scan_for' || action == 'scan_of') return true;
    return false;
}

async function getOffDeckDevs(p, params){
    let devs = [];
    let suit = false;
    if(params.limit_suits){
        suit = await getPrevTypes(p);
    }
    if(get(state).commons.off_deck_devs) return get(state).commons.off_deck_devs;
    for(let c of get(res).cards.filter(c => c.area == 'Development')){
        if(get(state).players.some(p => c.deck == p.captain)) continue; // Only off-deck ones
        let card = genCard(c);
        devs.push(card);
        state.update(s => {
            if(!s.commons.off_deck_devs) s.commons.off_deck_devs = []
            s.commons.off_deck_devs.push(card);
            s.cardLog[card.uniqueID] = {
                area: 'commons',
                deck: 'off_deck_devs'
            };
            return s;
        })
    }
    if(suit) devs = devs.filter(d => matches(d, suit));
    return devs;
}

function resolveSpecificCard(p, obj, params = {}, action){
    let ret = [];
    if(obj.card){
        if(obj.card.num && obj.defaultNum){
            obj.num = obj.card.num;
            //num = obj.num; // !!! TODO imperfect fix because I want this to be async //await resolveNum(obj.num, action);
        }
        if(obj.card.owner){
            p = resolveOwner(getCard(params.card), obj.card.owner);
            console.log('card owner:', p, params.card, getCard(params.card), obj.card.owner);
        }
        if(obj.card == 'this card' || obj.card == 'this ship'){
            ret.push(params.card); // 
        }else if(obj.card == 'market_best'){
            ret.push(...botFavouriteCards(p, getMarketCards().filter(c => c)).slice(0, 1).map(c => c.uniqueID));
        }else if(obj.card == 'target'){
            if(get(state).resolvingFrom){
                ret.push(...possArray(get(state).resolvingFrom));
            }
        }else if(obj.card == 'reserve'){
            if(obj.num == 'all'){
                ret.push(...p.decks.reserve.map(c => c.uniqueID));
            }else{
                ret.push(...p.decks.reserve.slice(0, obj.num || 1).map(c => c.uniqueID));
            }
        /*}else if(obj.card == 'dynasty'){
            ret.push(...p.decks.dynasty.slice(0, obj.num || 1).map(c => c.uniqueID));
            continue;*/
        }else if(obj.card == 'development'){
            let dev = p.decks.dev;
            /*if(params.off_deck){
                // Select from deck not in play
                dev = getOffDeckDevs(params);
            }
            ret.push(...dev.map(c => c.uniqueID));*/
        }else if(obj.card.type == 'prev_obj'){
            let type = 'card';
            if(action == 'gain_control' || action == 'control') type = 'location'
            ret = [...resolvePrevObj(obj.card, obj.num, type, action)].filter(c => c);
            ret = filterOutLog(ret, action);
        }else if(obj.card.type == 'not_taken'){
            // Doing an action to the thing that was not chosen in the last round (if there is one)
            if(!get(state).cache || !get(state).cache.notTaken) throw 'uncompleted';
            ret = get(state).cache.notTaken;
        }else if(obj.card_itself == true){ 
            // Caretaker's array: check
            ret = resolveExactCard(obj, action, p);
        }else if(obj.card.type == 'prev_goal'){
            ret = resolvePrevGoal(obj.card.prevType);
        }else if(obj.card.type == 'card_loc' || obj.card.type == 'same' || obj.card.type == 'prev_loc'){
            let possible;
            if(['this card', 'this ship', 'this [[ship]]'].includes(obj.card.card)){
                possible = [params.card];
            }else if(obj.card.type == 'card_loc'){
                possible = resolveExactCard(obj);
            }else{
                // Jan 2026: switched {} for obj so numbers carry across
                possible = resolvePrevObj(obj/*{}*/, 1, obj.card.type == 'prev_loc' ? 'at_location' : false, action)
            }
            console.log('card_loc', possible)
            if(possible.length == 0) return ret;
            let cardForLoc = possible[0];
            // Should only be one...
            cardForLoc = getCard(cardForLoc);
            if(!cardForLoc){
                console.log('card not found!', obj.card.card);
                throw `Card ${obj.card.card} not found!`;
            }
            if(obj.card.card_itself == true || matches(cardForLoc, 'location') && !matches(cardForLoc, 'ship')){ // if it's not a ship!
                // Not ship but card itself
                ret.push(cardForLoc.uniqueID);
                // !!TODO prep added below to stop arbitrary bundling in of ship, but it may fail
                // !!! NB prep removed as not in this func!!
                if(cardForLoc.orbiting /*&& prep*/) ret.push(...cardForLoc.orbiting.map(o => o.card));
                //console.log(ret);
                return ret;
            }


            /*if(!cardForLoc.ships || cardForLoc.ships.length == 0){
                return [];
                //throw `No ships on ${cardForLoc.name}, so can't use its location!`;
            }
            // Location means where the ship is warped to
            let ship = cardForLoc.ships[0]; // What about multiples? Don't worry for now...
            if(!cardForLoc.orbitingCard){
                return [];
                //throw 'uncompleted';
                // No location!
            }
            let loc = cardForLoc.orbitingCard[ship];*/
            let loc = locationOfCard(cardForLoc);


            if(!obj.card.locFilter || matches(getCard(loc), `${obj.card.locFilter} location`)){
                ret.push(loc); // Is already uniqueID
            }
            return ret;
        }else if(obj.card.card){
            // Exact card name
            let cards = resolveExactCard(obj, action, cardOwner(getCard(params.card)));
            // !!! TODO !prep below because it doesn't exist in this function!
            if(/*!prep && */params.from && params.from_resolved){
                cards = cards.filter(cd => params.from.some(c => getCard(c).uniqueID == cd));
            }
            //ret.push(...await resolveCards(origP, cards.filter(c => !ret.some(cd => sameCard(c, cd))), num, obj, null, params, fromDeck, action, prep))
            //ret.push(...cards);
            ret = cards.map(c => getCard(c));
            //continue;
        }else if(obj.card == 'beamed_here'){
            if(getCard(params.card) && getCard(params.card).beamed){
                ret = getCard(params.card).beamed;
            }else{
                logText(`No cards beamed in ${cc(params.card)}`);
                return [];
            }
            //logText(`No cards beamed in ${cc(params.card)}`);
            //continue; // TODO what if it's empty?
            //throw 'cancelled'; // Better?
        }else if(obj.card == 'ship_here'){
            if(getCard(params.card) && getCard(params.card).orbiting){
                ret = getCard(params.card).orbiting.map(c => getCard(c.card));
            }else{
                logText(`No cards beamed in ${cc(params.card)}`);
                return [];
            }
        }else if (obj.card.place){    
            console.log('resolving place', obj.card.place, p);                
            let entries = resolvePlace(p, obj.card.place, action, false)
            if(obj.card.type) entries = entries.filter(c => matches(c, obj.card.type));
            if(obj.card.placement == 'top'){ // corresponding Market deck is already dealt with
                let num = obj.card.num || 1;
                if(entries.length > 0) {
                    let info = get(state).cardLog[entries[0].uniqueID];
                    /*if(info.deck == 'deck' && action == 'look at' && faceupDraw(p) && p.decks.deck.length > num){
                        // Choose card(s)!
                        entries = await chooseCards(`Choose ${num} card(s) to look at`, entries, {number: num, lookSpecific: true});
                    }else{
                        */entries = entries.slice(0, num); // Riker can't have a choice in this function, soz
                    //}
                }
            }else if(obj.card.placement == 'bottom'){
                let num = obj.card.num || 1;
                entries = entries.slice(-num);
            }
           
            if((obj.defaultNum || obj.num >= (obj.card.num || 1)) && obj.card.place != 'duty' && obj.card.place != 'captain' && obj.card.place != 'captain_duty'){
                ret.push(...entries.map(c => c.uniqueID));
                return ret;
            }else{
                ret = entries; // These are individual cards so choose between them
            }
        }
    }else if(obj.place){
        ret = resolvePlace(p, obj.place, action, {}, false);
    }
    return ret;
}

export function resolveSubCondition(p, sub, eligible, params, card){
    if(Array.isArray(sub)){
        for(let s of sub){
            eligible = resolveSubCondition(p, s, eligible, params, card); // progressive filtration
        }
        return eligible;
    }
    if(!sub) return eligible;
    if(sub.secured){
        eligible = eligible.filter(c => canControlLocation(p, c));
    }
    if(sub.shared_traits){
        let card = resolveSpecificCard(p, {card: sub.shared_traits.card}, params, 'type_match'); //await resolveObject({card:sub.shared_traits.card}, 'type_match', params, p);
        eligible = eligible.filter(c => {
            let count = matchTraits(card, c.uniqueID, 'any traits');
            return testNum(sub.shared_traits.num, count);
        })
    }
    if(sub.opponent_unsecured){
        let opp = get(state).players.find(pl => pl.captain != p.captain);
        eligible = eligible.filter(e => !canControlLocation(opp, e))
    }
    if(sub.human_or_you_unsecured){
        if(p.bot){
            let opp = get(state).players.find(pl => pl.captain != p.captain);
            eligible = eligible.filter(e => !canControlLocation(opp, e))
        }else{
            eligible = eligible.filter(e => !canControlLocation(p, e))
        }
    }
    if(sub.with_on){
        let num = sub.with_on.num;
        eligible = eligible.filter(e => {
            let count = countTypes(p, {...sub.with_on, location: true}, [e]); //e.beamed.reduce((a,c) => a + matches(c, params.with_beamed.types), 0);
            return testNum(num, count);
        })
    }
    if(sub.name_includes){
        eligible = eligible.filter(e => e.name.toLowerCase().includes(sub.name_includes));
    }
    if(sub.non_negative){
        eligible = eligible.filter(e => !e.vp || e.vp > 0);
    }
    if(sub.negative){
        eligible = eligible.filter(e => e.vp < 0);
    }
    if(sub.with_visiting){
        let num = sub.with_visiting.num;
        eligible = eligible.filter(e => {
            if(!e.visiting) return false;
            let count = 0;
            for(let v of e.visiting){
                let c = getCard(v);
                count += matches(c, sub.with_visiting.types);
            }
            return testNum(num, count);
        })
    }
    if(sub.visiting_filter){
        // Now we are filtering the qsuits by what they are visiting
        eligible = eligible.filter(e => {
            if(!e.whereAmI) return false;
            let c = getCard(e.whereAmI);
            return matches(c, sub.visiting_filter); // Of the right type
        })
    }
    if(sub.without_visiting){
        let num = sub.without_visiting.num;
        eligible = eligible.filter(e => {
            if(!e.visiting) return true;
            let count = 0;
            for(let v of e.visiting){
                let c = getCard(v);
                count += matches(c, sub.without_visiting.types);
            }
            return !testNum(num, count);
        })
    }

    if(sub.with_filter){
        let num = sub.with_filter.num;
        if(sub.with_filter.present){
            eligible = eligible.filter(e => {
                let count = 0;
                for(let c of cardsAtLocation(e, p)){
                    count += matches(c, sub.with_filter.types)
                }
                return testNum(num, count);
            });
        }else{
            eligible = eligible.filter(e => testNum(num, matches(e, sub.with_filter.types)));
        }
        
    }

    if(sub.with_beamed && sub.with_beamed.types){
        let num = sub.with_beamed.num;
        if(sub.with_beamed.types == 'away'){
            eligible = eligible.filter(e => {
                let count = allAway(e); // includes drones
                if(!count){
                    if(num == 0) return true;
                    return false;
                }
                return testNum(num, count);
            })
        }else{
            eligible = eligible.filter(e => {
                if(!e.beamed){
                    if(num == 0) return true;
                    return false;
                }
                let count = countMatches(p, e.beamed, sub.with_beamed.types, true); //e.beamed.reduce((a,c) => a + matches(c, params.with_beamed.types), 0);
                return testNum(num, count);
            })
        }
        
    }

    if(sub.exclude ){
        eligible = resolveExclude(card, eligible, sub.exclude, p);
        /*let types = sub.exclude || obj.exclude;
        if(types == 'this'){
            eligible = eligible.filter(c => c.uniqueID != card.uniqueID);
        }else{
            if(types.card){
                if(types.card_itself == true){
                    types = types.card; 
                    // TODO may need to handle location etc. here, in which case perhaps fold out into function?
                }
            }
            if(!Array.isArray(types)) types = [types];
            for(let t of types){
                if(t == 'this'){
                    eligible = eligible.filter(c => c.uniqueID != card.uniqueID);
                }else{
                    eligible = eligible.filter(c => !matches(c, t, false));
                }
                
            }
        } */      
    }
    return eligible;
}

export async function resolveAnother(eligible, action = false){
    let toAvoid = resolvePrevObj({num: 1, it: true}, 1, false, action);
    if(!Array.isArray(toAvoid)) toAvoid = [toAvoid];
    for(let a of toAvoid){
        eligible = eligible.filter(c => c.uniqueID != a.uniqueID);
    }
    return eligible;
}

function testFilterTypes(c, filter){
    if(filter.num){
        return testNum(filter.num, matches(c, filter.types || filter));
    }else{
        return matches(c, filter.types || filter);
    }
}

export async function resolveQualifier(p, qual, params, eligible, co = false){
    if(qual.type == 'multiple'){
        for(let q of qual.elements){
            eligible = await resolveQualifier(p, q, params, eligible, co);
        }
    }
    if(qual == 'not_this'){
        console.log('not this!', params, eligible)
        eligible = eligible.filter(c => c.uniqueID != params.card);
    }else if(qual.type == 'subcondition'){
        eligible = resolveSubCondition(p, qual.condition, eligible, params, getCard(params.card));
    }else{
        let owner = 'you';
        if(p.bot && get(state).players.some(p => !p.bot)) owner = 'bot';
        if(qual.owner) owner = qual.owner;
        if(!co) co = cardOwner(getCard(params.card));
        if(owner == 'they') owner = get(state).cache.player || 'opponent';
        if(owner == 'bot'){
            if(get(state).players.some(p => !p.bot)){
                owner = get(state).players.find(p => p.bot);
            }else{
                owner = get(state).players[get(state).currentPlayer];
            }
        }
        if(owner == 'player' || owner == 'you'){
            if(p.bot){
                owner = get(state).players.find(p => !p.bot);
                if(!owner) owner = get(state).players.find((p, i) => i != get(state).currentPlayer); // for BvB
            }else{
                owner = co;
            }
        }
        if(owner == 'opponent') owner = get(state).players.find(pl => pl.captain != co.captain); // TODO multiplayer: more opponents
        if(qual.type == 'have'){
            if(qual.types){
                for(let q of possArray(qual.types)){
                    let types = q.types; // with more time, replace with possArray
                    let num = await resolveNum(q.num, params.verb) || 1;
                    let func;

                    // !! TODO with the below, we might be able to ditch the other stuff!
                    //
                    if(Array.isArray(types)){
                        // '[[away team]]/[[drone]]': 'away' already includes drones, don't count them twice
                        if(types.includes('drone') && (types.includes('away') || types.includes('opp_away'))){
                            types = types.filter(t => t != 'drone');
                        }
                        func = (c) => {
                            let num = 0;
                            for(let t of types){
                                if(t == 'away' || t == 'opp_away' || t == 'drone' || t == 'ship' || t == 'token'){
                                    if(t == 'opp_away'){
                                        num += countSpecificTokens(c, otherPlayer(co), 'away');
                                    }
                                    if(qual.owner == 'you') num += countSpecificTokens(c, co, t);
                                    if(qual.owner == 'opponent') num += countSpecificTokens(c, otherPlayer(co), t);
                                    if(qual.owner == 'all' || qual.owner == 'any') num += countSpecificTokens(c, 'all', t);
                                    if(qual.owner == 'bot'){
                                        let bot;
                                        if(get(state).players.some(p => !p.bot)){
                                            bot = get(state).players.find(p => p.bot);
                                        }else{
                                            // BvB so current player
                                            bot = currentPlayer();
                                        }
                                        num += countSpecificTokens(c, bot, t);
                                    }
                                }else{
                                    alert('Unrecognised type of counting token: report as a bug');
                                    throw 'uncompleted';
                                }
                            }
                            return num;
                        }
                    }else if(types == 'away' && qual.owner == 'you'){
                    func = (c) => {
                            return myAway(co, c);
                        /* if(!c.away_teams) return 0;
                            if(!c.away_teams[owner.captain]) return 0;
                            return c.away_teams[owner.captain];*/
                        }
                    }else if(types == 'opp_away' || types == 'away' && qual.owner == 'opponent'){
                        func = (c) => {
                            //let o = get(state).players.find(p => p.captain != co.captain)
                            return theirAway(co, c);
                            /* if(!c.away_teams) return 0;
                            if(!c.away_teams[o.captain]) return 0;
                            return c.away_teams[o.captain];*/
                        }
                    }else if(types == 'away' && (qual.owner == 'any' || qual.owner == 'all')){
                        func = (c) => {
                            return allAway(c);
                            /* if(!c.away_teams) return 0;
                            if(!c.away_teams[o.captain]) return 0;
                            return c.away_teams[o.captain];*/
                        }
                    }else if(qual.types.types == 'ship'){
                        console.log('counting ships!');
                        func = (c) => {
                            return myOrbiting(owner, c); // instead of co
                        }
                    }else if(types == 'drone'){
                        let ps = [p];

                        if(qual.owner == 'opponent') ps = [otherPlayer(p)];
                        if(qual.owner == 'bot'){
                            let bot;
                            if(get(state).players.some(p => !p.bot)){
                                bot = get(state).players.find(p => p.bot);
                            }else{
                                // BvB so current player
                                bot = currentPlayer();
                            }
                            ps = [bot];
                        }
                        if(qual.owner == 'all' || qual.owner == 'any') ps = [p, otherPlayer(p)];

                        func = (c) => ps.reduce((a,p) => a + drones(p, c), 0);
                        
                        //func = (c) => drones(c); // if any card comes out targetting opponent drones, adapt to owner
                    }else if(types == 'token'){
                        if(qual.owner == 'opponent'){
                            func = (c) => countPlayerTokens(c, otherPlayer(co));
                        }else if(qual.owner == 'all' || qual.owner == 'any'){
                            func = (c) => countAllTokens(c);
                        }else{
                            func = (c) => countPlayerTokens(c, co);
                        }
                    }else{
                        console.log('New type of have in action...')
                        // Jan 2026: this is where to add 'where you have X', i.e. counting cards at location potentially
                        // was just matches(c, qual.types.types)
                        func = (c) => {
                            let count = 0;
                            for(let card of cardsAtLocation(c, owner)){
                                count += matches(card, types);
                            }
                            return count;
                        }
                    }

                    if(typeof num == 'number'){
                        eligible = eligible.filter(c => func(c) >= num);
                    }else if(num.hasOwnProperty('min')){
                        eligible = eligible.filter(c => func(c) >= num.min);
                    }else if(num.max){
                        eligible = eligible.filter(c => func(c) <= num.max);
                    }else{
                        eligible = eligible.filter(c => testNum(num, func(c))); // Really could replace above I think
                    }
                }
                
            }
        }else if(qual.type == 'sharing_trait'){
            let cards = possArray(await resolveObject(qual.traitee, 'trait_check', params, p, null, true)).filter(c => c);
            eligible = eligible.filter(e => cards.some(c => matchTraits(c, e)));
        }else if(qual.type == 'different_suits'){
           // oneOffMessage(p, `NB: "of different suits" is not currently implemented, because I'm still figuring out how to do it. Don't cheat :-)`)
           let numPoss = Array.from(new Set(eligible.flatMap(c => c.suits)));
           if(numPoss < params.obj.num){
            eligible = []; // impossible
           }
        }
    }
    return eligible;
}

export async function resolveFilters(p, obj, params, eligible, action, co = false){
    if(obj.qualifier){
        let qual = obj.qualifier;
        eligible = await resolveQualifier(p, qual, params, eligible, co);
    }
    if(obj.exclude){
        eligible = resolveExclude(getCard(params.card), eligible, obj.exclude, p, co);
    }
    if(obj.beamed_only){
        eligible = eligible.filter(c => isBeamed(c));
    }
    if(obj.subcondition){
        eligible = resolveSubCondition(p, obj.subcondition, eligible, params, getCard(params.card));
    }
    if(obj.filter){
        eligible = eligible.filter(c => testFilterTypes(c, obj.filter));
    }
    if(obj.specific){
        eligible = eligible.filter(c => matches(c, obj.specific));
    }
    if(obj.unexhausted){
        eligible = eligible.filter(c => !c.activated);
    }
    if(obj.owner == 'opponent'){
        eligible = eligible.filter(c => cardOwner(c)?.captain == otherPlayer(p).captain);
    }

    if(obj.owner == 'you'){
        eligible = eligible.filter(c => cardOwner(c)?.captain == p.captain);
    }

    if(obj.matching_trait){
        // You need to match at least 1 trait of previous object
        let prev = await resolveObject(obj.matching_trait, 'trait_check', {}, p);
        if(!Array.isArray(prev)) prev = [prev];
        prev = prev.filter(c => typeof c == 'number' || c && c.traits);
        prev = prev.map(c => typeof c== 'number' ? getCard(c) : c);
        eligible = eligible.filter(e => e.traits && e.traits.some(t => prev.some(c => c.traits.includes(t))));
    }
    if(obj.matching_selected_trait){
        if(!get(state).cache || !get(state).cache.selectedTrait) throw 'uncompleted';
        let trait = get(state).cache.selectedTrait;
        eligible = eligible.filter(e => e.traits && e.traits.includes(trait));
    }
    
    if(params.or_badlands && badlands() && params.or_badlands == 'all'){
        eligible = [...eligible, badlands()];
    }

    if(obj.another){
        // Not original one
       if(params.card){
        eligible = eligible.filter(e => e.uniqueID != params.card);
       }else{
        eligible = await resolveAnother(eligible, action);
       }
    }
    return eligible;
}

async function resolveCards(p, eligible, num, obj, type, params, fromDeck, action, prep = ''){
    let fromJunk = false;

    /*// Recall returns YOUR card. Only an explicit 'opponent' qualifier reaches across the table,
    // so a targeted recall is limited to the acting player's cards - otherwise a location-scoped
    // recall ('recall a deployed [[ship]] from the same [[location]]', and the same when forced on
    // the opponent) offers up every ship there, including the other player's.
    // 'all' is left alone: 'recall all cards beamed here' clears the place for both players.
    // Same guard 'dismiss' already carries (see the action == 'dismiss' block in resolveObject),
    // sited at the selection choke point so the location-scoped paths get it too.
    if(action == 'recall' && !obj.owner && obj.num != 'all'){
        eligible = eligible.filter(c => {
            let o = cardOwner(typeof c == 'number' ? getCard(c) : c);
            return !o || o.captain == p.captain;
        });
    }*/

    if(get(state).target && get(state).targetAction == action){
        // for 'targeting X' 
        let obj = get(state).target;//await resolveObject(get(state).target, action, params, p, null, true);
        if(!obj) throw 'uncompleted';
        obj = possArray(obj);
        obj = obj.map(c => getCard(c)).filter(c => eligible.some(e => typeof e == 'number' && e == c.uniqueID || e.uniqueID == c.uniqueID));
        state.update(s => {
            delete s.target;
            delete s.targetAction;
            return s;
        })
        if(obj.length == 0) throw 'uncompleted';
        //if(!eligible.includes(c)) throw 'uncompleted'; // Has to be eligible anyway 
        if(obj.length == 1){
            state.update(s => {
                s.cache.previousNums = 1;
                return s;
            })
            return [obj[0].uniqueID];
        }
    }

    if(get(state).cache && get(state).cache.from_junk_next){
        params.junk = true;
        clearCacheItem('from_junk_next');
    }

    if(params.junk){
        fromJunk = true;
        eligible = [...eligible, ...get(state).commons.junk];
    }
    if(params.limit_suits){
        let types = await getPrevTypes(p);
        if(types){
            eligible = eligible.filter(c => types.some(t => matches(c, t)));
        }else{
            return [];
        }
    }
    if(junkAction(action) && !params.junk && !eligible.some(e => get(state).commons.junk.some(cd => cd.uniqueID == e.uniqueID)) && (p.from_junk || badlands() || hasNeutralJunkAccess(p) || ongoingPlayer(p).includes('from_junk'))){
        if(type && await checkFromJunk(p, type)){
            fromJunk = true;
            eligible = [...eligible, ...get(state).commons.junk];
        }
    }
    eligible = eligible.map(e => { if(typeof e == 'number') return getCard(e); else return e;});
    if(type) eligible = eligible.filter(c => matches(c, type));
    if(type == 'neutral location' && eligible.length == 0) eligible = [...getNeutralZone()];

    if(action == 'mark_collected') eligible = eligible.filter(c => c.traits && collectableTraits(c.traits, get(state).players[get(state).activePlayer], get(state).players.find(o => o.captain != get(state).players[get(state).activePlayer].captain)).length > 0)

    if(num <= 0) return [];

    if(action == 'junk'){
        //console.log('filtering by junkable', eligible);
        eligible = eligible.filter(c => canJunk(c));
    }
    /*if(obj.qualifier){
        let qual = obj.qualifier;
        eligible = await resolveQualifier(p, qual, params, eligible);
    }
    if(obj.exclude){
        eligible = resolveExclude(getCard(params.card), eligible, obj.exclude, p);
    }

    if(obj.filter){
        if(obj.filter.types){
            eligible = eligible.filter(c => testFilterTypes(c, obj.filter));
        } 
    }
    if(obj.specific){
        eligible = eligible.filter(c => matches(c, obj.specific));
    }
    if(obj.unexhausted){
        eligible = eligible.filter(c => !c.activated);
    }

    if(obj.matching_trait){
        // You need to match at least 1 trait of previous object
        let prev = await resolveObject(obj.matching_trait, 'trait_check', {}, p);
        if(!Array.isArray(prev)) prev = [prev];
        prev = prev.filter(c => typeof c == 'number' || c && c.traits);
        prev = prev.map(c => typeof c== 'number' ? getCard(c) : c);
        eligible = eligible.filter(e => e.traits && e.traits.some(t => prev.some(c => c.traits.includes(t))));
    }
    if(obj.matching_selected_trait){
        if(!get(state).cache || !get(state).cache.selectedTrait) throw 'uncompleted';
        let trait = get(state).cache.selectedTrait;
        eligible = eligible.filter(e => e.traits && e.traits.includes(trait));
    }
    
    if(params.or_badlands && badlands() && (params.or_badlands == prep || params.or_badlands == 'all')){
        eligible = [...eligible, badlands()];
    }

    if(obj.another){
        // Not original one
       if(params.card) eligible = eligible.filter(e => e.uniqueID != params.card);
       eligible = await resolveAnother(eligible, action);
    }*/
   eligible = await resolveFilters(p, obj, params, eligible, action);

    if(action == 'enlist'){
        if(eligible.every(c => getLocation(getCard(c)).deck == 'dev')) return eligible.map(c => c.uniqueID); // Don't choose before dev stage
    }

    

    if(typeof num == 'string' && num.startsWith('all_bar_')){
        let sub = parseInt(num.slice('all_bar_'.length));
        num = eligible.length - sub;
        console.log(num, sub);
        if(num <= 0) return [];
    }
    
    let extras = [];
    let options = {number: num, cancellable: true}; // Add optional element?
    if(fromDeck){
        //console.log(type, get(res).marketTypes[type]);
        let deckTypes = type;
        if(!Array.isArray(deckTypes)) deckTypes = [deckTypes];
        for(let type of deckTypes){
            let deck = get(res).marketTypes[type];
            if(deck && get(state).commons[deck].length > 1){
                extras.push({name: `From [[${type}]] deck`, value: get(state).commons[deck][1], condition: (ui, state) => state.commons[deck].length > 1})     
                
            }
        }
        options.extraChoices = extras;
    }
    let card;

    let blockedSome = false;

    if(action == 'gain' && ongoingPlayer(p).includes('ignore_gain_types')){
        let blockTypes = ongoingPlayer(p, 'ignore_gain_types').flat(2);
        let countBefore = eligible.length;
        eligible = eligible.filter(e => !matches(e, blockTypes, false) || ![...getMarketCards()].some(c => c.uniqueID == e.uniqueID))
        if(eligible.length < countBefore) blockedSome = true;
    }

    eligible = Array.from(new Set(eligible));

    //console.log(num, type, fromDeck)
    if(num == eligible.length && !(obj.optional || options.optional) && (get(prefs).autoChoose || action == 'gain' || (obj.type && obj.type == 'prev_obj' || obj.card && obj.card.type && obj.card.type == 'prev_obj') || (action == 'beam' && prep == 'to' && obj.location == 'here')) && !fromDeck || num == 'all'){
        card = eligible;
    }else if(obj.defaultNum && obj.card && (!obj.card.place || obj.card.place != 'duty' && obj.card.place != 'captain' && obj.card.place != 'captain_duty') && !obj.card.num && !(obj.card.card && Array.isArray(obj.card.card) && obj.card.card.length > 1)){ // Specifically just where it's cards without a number (for)
        card = eligible;
    }else{
        // TODO get something to bring up deck if need be – i.e. if all are in the same deck?
        let deck = null;
        let area = null;
        let allSame = true;
        for(let e of eligible){
            let info = get(state).cardLog[e.uniqueID];
            if(!info){
                console.log('not a card', e, info)
                alert('not a card!')
            }
            if(!deck) deck = info.deck;
            if(!area) area = info.area;
            if(info.deck != deck) allSame = false;
            if(info.area != area) allSame = false;
            if(info.area == 'beamed' || info.deck == 'log' || info.deck == 'encounters' || info.deck == 'incidents' || info.deck == 'missions' || (info.area == 'commons' && info.deck == 'locations')){
                allSame = true;
                break;
                // These areas are not automatically shown, so it's essential we can look at them
            }
            if(['hand','play','fleet','locations','missions', 'neutral_zone', ...Object.values(get(res).marketTypes)].includes(info.deck)) allSame = false;
        }
        if(allSame) options.lookSpecific = true;

        // Add checker for different_suits if need be
        if(obj.qualifier && (obj.qualifier == 'different_suits' || obj.qualifier.type == 'multiple' && obj.qualifier.elements.includes('different_suits'))){
            options.specialCondition = (ui, state) => {
                let selected = ui.multiSelection;
                // If there are fewer total suits than cards, fail
                if(Array.from(new Set(selected.flatMap(s => s.suits))).length < selected.length) return false;
                return true;
            }
        }
        // Check it's possible
        if(!obj.optional && !fromDeck && (typeof num == 'number' && eligible.length < num || num.hasOwnProperty('min') && eligible.length < num.min)){
            // Impossible!
            if(obj.exactly || num.hasOwnProperty('min')) throw 'uncompleted'; // Should prevent costs from firing
            if(get(state).payingCost == params.card) throw 'uncompleted';
            
            //Otherwise redefine num to the available number
            num = eligible.length;
        }
        // Map them in case of duplicates (though not sure why there would be...)
        if(p.bot && get(state).activePlayer == getPlayerIndex(p)){
            // Do bot evaluation
            console.log('Bot choices', action, params, eligible, options);
            if(awayAction(action)){
                let types = 'away';
                if(params.obj) types = possArray(params.obj).filter(o => o?.types || o?.type).map(o => o?.types || o?.type)[0] || 'away';
                eligible = bestAwayDestinations(eligible, types, params);
            }else if(action == 'warp'){
                eligible = bestShipDestinations(eligible, getCard(params.card), false, namesBadlands(type));
            }else if(['dismiss', 'discard', 'log', 'top', 'bottom'].includes(action)){
                eligible = eligible; // Don't sort, just go for top one
            }else if(action == 'junk'){
                // Junks your favourite card
                let opp = get(state).players.find(pl => pl.captain != p.captain);
                eligible = botFavouriteCards(opp, eligible);
            }else{
                eligible = botFavouriteCards(p, eligible); // eligible.sort((a,b) => botValue(b, p) - botValue(a, p));
            }

            if(!eligible) throw 'uncompleted';
            
            // Bot order thing needs dealing with
            let resolvedNum = num;
            if(num.max) resolvedNum = num.max;
            if(num.hasOwnProperty('min')) resolvedNum = num.min;
            if(num == 'any') resolvedNum = 1;
            if(num == 'all') resolvedNum = eligible.length;
            card = eligible.slice(0, resolvedNum); // Presuming there won't be max/min on num?
        }else if(obj.random){
            // They are supposed to be chosen at random
            shuffle(eligible);
            let resolvedNum = await resolveNum(num, action);
            card = eligible.slice(0, resolvedNum); 
        }else if(obj.card && obj.card.place && obj.card.place == 'captain' && eligible.length == 1){
            card = eligible[0]; // If you have only one captain, you never need to confirm things on them
        }else{
            let someAreLogged = eligible.some(c => p.decks.log && p.decks.log.some(cd => cd.uniqueID == (c.uniqueID || c))) && eligible.some(c => p.decks.log && !p.decks.log.some(cd => cd.uniqueID == (c.uniqueID || c))) 
            card = await chooseCards(`Choose ${cn(num)} card${num == 1 ? '' : 's'} to ${humanReadableAction(action, params, prep)}${fromJunk ? '(including from junk)' : ''}.${someAreLogged ? ' This includes cards in your Log: to view them click on your Captain card and select View Log.' : ''}${blockedSome ? ' (Note: some cards in the Market have been blocked due to Passives in effect for you.)': ''}`, 
                eligible, {...options, optional: options.optional || obj.optional});
            if(!options.optional && !obj.optional && (!card || card.length == 0)){
                if(get(state).payingCost == params.card) throw 'uncompleted';
                return [];
            }
            if(card == 'cancelled') throw 'cancelled'; // TODO generalise this!
            //console.log(card);
        }
    
        // Note if you took any from Junk
        let gainedFromJunk = []
        for(let c of possArray(card)){
            let id = c.uniqueID ? c.uniqueID : c
            let info = get(state).cardLog[id]
            if(info && info.deck == 'junk') gainedFromJunk.push(id);
        }
        if(gainedFromJunk.length > 0){
            state.update(s => {
                if(!s.cache) s.cache = {};
                if(!s.cache.fromJunk) s.cache.fromJunk = {};
                if(!s.cache.fromJunk[action]) s.cache.fromJunk[action] = [];
                s.cache.fromJunk[action].push(gainedFromJunk);
                return s;
            })
        }

        // Log unchosen cards if told to. !! NB now always log this, so that Haley resupply works, and why not do this hey?
        let unselected = false;
        //if(action == 'keep' || params.noteUnselected){
            unselected = eligible.filter(c => !possArray(card).some(cd => cd.uniqueID == c.uniqueID));
        //}
        state.update(s => {
            s.cache.notTaken = unselected.map(c => c.uniqueID);
            return s;
        })
    }
    if(!Array.isArray(card)){
        state.update(s => {
            s.cache.previousNums = 1;
            return s;
        })
        return [card.uniqueID];
    }else if(card.length == 1){
        state.update(s => {
            s.cache.previousNums = card.length;
            return s;
        })
        return [card[0].uniqueID];
    }else{
        state.update(s => {
            s.cache.previousNums = card.length;
            return s;
        })
        return card.map(c => c.uniqueID);
    }
}
